import React, { useState, useEffect, useRef, useCallback } from "react";
import splashImg from './splash_bluelife.png';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

(function(){
  const nativeStringify=JSON.stringify;
  JSON.stringify=function(value,replacer,space){
    if(typeof replacer==="function"||Array.isArray(replacer)){
      try{return nativeStringify(value,replacer,space);}
      catch(e){return nativeStringify(String(value));}
    }
    const seen=new WeakSet();
    const safeReplacer=(key,val)=>{
      if(typeof val==="object"&&val!==null){
        if(seen.has(val))return "[Circular]";
        seen.add(val);
      }
      return val;
    };
    try{
      return nativeStringify(value,safeReplacer,space);
    }catch(e){
      return nativeStringify(String(value));
    }
  };
})();

const SUPABASE_URL = "https://dozesbnushgqabbsjrgv.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI";
let _currentUserToken = null;
let _currentRefreshToken = null;
const SUPABASE_EDGE_URL = "https://dozesbnushgqabbsjrgv.supabase.co/functions/v1";

async function sendPushNotification({type, receiver, sender, postId, message, data={}}){
  if(!receiver || receiver===sender) return;
  try{
    await fetch(SUPABASE_EDGE_URL+"/send-notification",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI"
      },
      body:JSON.stringify({type,receiver,sender,postId,message,data})
    });
  }catch(e){
    console.warn("Push notification failed:",e.message);
  }
}

async function saveFcmToken(username, token){
  if(!username||!token) return;
  try{
    await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/profiles?username=eq."+encodeURIComponent(username),{
      method:"PATCH",
      headers:{
        "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
        "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
        "Content-Type":"application/json",
        "Prefer":"return=minimal"
      },
      body:JSON.stringify({fcm_token:token})
    });
  }catch(e){console.warn("FCM token save failed:",e);}
}

const CLOUDINARY_CLOUD = "djzdzzazg";
const CLOUDINARY_PRESET = "pixagram";

const C = {
  navy:"#ffffff",navy2:"#f7f9fc",navy3:"#eef2f7",
  accent:"#2563eb",accent2:"#3b82f6",light:"#60a5fa",
  white:"#0a0a0a",w2:"rgba(10,10,10,0.85)",w3:"rgba(10,10,10,0.55)",
  w4:"rgba(10,10,10,0.1)",w5:"rgba(10,10,10,0.045)",
  border:"rgba(10,10,10,0.12)",border2:"rgba(37,99,235,0.3)",
  red:"#ef4444",green:"#22c55e",purple:"#8b5cf6",orange:"#f97316",
};

const WORLD_COUNTRIES = [
  "Cameroun","Nigeria","Ghana","Côte d'Ivoire","Sénégal","Mali","Burkina Faso","Niger","Tchad",
  "République démocratique du Congo","Congo","Gabon","Togo","Bénin","Guinée","Guinée-Bissau",
  "Sierra Leone","Liberia","Mauritanie","Maroc","Algérie","Tunisie","Égypte","Libye","Soudan",
  "Éthiopie","Kenya","Tanzanie","Ouganda","Rwanda","Burundi","Zambie","Zimbabwe","Mozambique",
  "Malawi","Angola","Namibie","Botswana","Afrique du Sud","Lesotho","Eswatini","Madagascar",
  "Maurice","Comores","Seychelles","Djibouti","Somalie","Érythrée","Centrafrique","Guinée équatoriale",
  "Cap-Vert","Gambie","Soudan du Sud",
  "France","Belgique","Suisse","Canada","États-Unis","Royaume-Uni","Allemagne","Irlande",
  "Espagne","Italie","Portugal","Pays-Bas","Luxembourg","Autriche","Suède","Norvège","Danemark",
  "Finlande","Islande","Pologne","République tchèque","Slovaquie","Hongrie","Roumanie","Bulgarie",
  "Grèce","Croatie","Serbie","Bosnie-Herzégovine","Slovénie","Macédoine du Nord","Monténégro",
  "Albanie","Kosovo","Ukraine","Biélorussie","Moldavie","Lituanie","Lettonie","Estonie",
  "Chypre","Malte","Andorre","Monaco","Liechtenstein","Saint-Marin","Vatican",
  "Brésil","Argentine","Chili","Colombie","Pérou","Venezuela","Équateur","Bolivie","Paraguay",
  "Uruguay","Guyana","Suriname","Panama","Costa Rica","Nicaragua","Honduras","Salvador",
  "Guatemala","Belize","Cuba","République dominicaine","Haïti","Jamaïque","Trinité-et-Tobago",
  "Bahamas","Barbade","Chine","Japon","Corée du Sud","Corée du Nord","Inde","Pakistan",
  "Bangladesh","Sri Lanka","Népal","Bhoutan","Myanmar","Thaïlande","Vietnam","Cambodge","Laos",
  "Philippines","Indonésie","Malaisie","Singapour","Brunei","Timor oriental","Mongolie",
  "Kazakhstan","Ouzbékistan","Turkménistan","Tadjikistan","Kirghizistan","Afghanistan",
  "Émirats arabes unis","Arabie saoudite","Qatar","Turquie","Russie","Israël","Palestine",
  "Jordanie","Liban","Syrie","Irak","Iran","Koweït","Bahreïn","Oman","Yémen","Géorgie",
  "Arménie","Azerbaïdjan","Australie","Nouvelle-Zélande","Papouasie-Nouvelle-Guinée","Fidji",
  "Mexique","Taïwan","Autre"
];

const AFRICAN_COUNTRY_NAMES = new Set([
  "Cameroun","Nigeria","Ghana","Côte d'Ivoire","Sénégal","Mali","Burkina Faso","Niger","Tchad",
  "République démocratique du Congo","Congo","Gabon","Togo","Bénin","Guinée","Guinée-Bissau",
  "Sierra Leone","Liberia","Mauritanie","Maroc","Algérie","Tunisie","Égypte","Libye","Soudan",
  "Éthiopie","Kenya","Tanzanie","Ouganda","Rwanda","Burundi","Zambie","Zimbabwe","Mozambique",
  "Malawi","Angola","Namibie","Botswana","Afrique du Sud","Lesotho","Eswatini","Madagascar",
  "Maurice","Comores","Seychelles","Djibouti","Somalie","Érythrée","Centrafrique","Guinée équatoriale",
  "Cap-Vert","Gambie"
]);

// ISO 3166-1 alpha-2 codes for the same set - used to check the phone's
// real-time detected location (IP/network, GPS), since those come back
// as codes/English names, not the French names typed on the profile.
const AFRICAN_COUNTRY_CODES = new Set([
  "CM","NG","GH","CI","SN","ML","BF","NE","TD","CD","CG","GA","TG","BJ","GN","GW",
  "SL","LR","MR","MA","DZ","TN","EG","LY","SD","SS","ET","KE","TZ","UG","RW","BI",
  "ZM","ZW","MZ","MW","AO","NA","BW","ZA","LS","SZ","MG","MU","KM","SC","DJ","SO",
  "ER","CF","GQ","CV","GM"
]);

const AFRICAN_DIAL_CODES = new Set([
  "+213","+244","+229","+267","+226","+257","+238","+237","+236","+235","+269",
  "+242","+243","+253","+20","+240","+291","+251","+241","+220","+233","+224",
  "+245","+254","+266","+231","+218","+261","+265","+223","+222","+230","+212",
  "+258","+264","+227","+234","+250","+239","+221","+248","+232","+252","+27",
  "+211","+249","+268","+255","+228","+216","+256","+260","+263"
]);

const COUNTRY_CODES = [
  {f:"🇨🇲",c:"+237"},{f:"🇫🇷",c:"+33"},{f:"🇺🇸",c:"+1"},{f:"🇬🇧",c:"+44"},
  {f:"🇩🇪",c:"+49"},{f:"🇪🇸",c:"+34"},{f:"🇮🇹",c:"+39"},{f:"🇵🇹",c:"+351"},
  {f:"🇧🇪",c:"+32"},{f:"🇨🇭",c:"+41"},{f:"🇨🇦",c:"+1"},{f:"🇲🇦",c:"+212"},
  {f:"🇩🇿",c:"+213"},{f:"🇹🇳",c:"+216"},{f:"🇸🇳",c:"+221"},{f:"🇨🇮",c:"+225"},
  {f:"🇬🇭",c:"+233"},{f:"🇳🇬",c:"+234"},{f:"🇰🇪",c:"+254"},{f:"🇿🇦",c:"+27"},
  {f:"🇨🇩",c:"+243"},{f:"🇨🇬",c:"+242"},{f:"🇬🇦",c:"+241"},{f:"🇹🇬",c:"+228"},
  {f:"🇧🇯",c:"+229"},{f:"🇧🇫",c:"+226"},{f:"🇲🇱",c:"+223"},{f:"🇳🇪",c:"+227"},
  {f:"🇹🇩",c:"+235"},{f:"🇨🇫",c:"+236"},{f:"🇬🇶",c:"+240"},{f:"🇬🇼",c:"+245"},
  {f:"🇬🇳",c:"+224"},{f:"🇸🇱",c:"+232"},{f:"🇱🇷",c:"+231"},{f:"🇬🇲",c:"+220"},
  {f:"🇨🇻",c:"+238"},{f:"🇲🇷",c:"+222"},{f:"🇸🇹",c:"+239"},{f:"🇧🇷",c:"+55"},
  {f:"🇲🇽",c:"+52"},{f:"🇦🇷",c:"+54"},{f:"🇨🇴",c:"+57"},{f:"🇨🇱",c:"+56"},
  {f:"🇵🇪",c:"+51"},{f:"🇻🇪",c:"+58"},{f:"🇪🇨",c:"+593"},{f:"🇧🇴",c:"+591"},
  {f:"🇵🇾",c:"+595"},{f:"🇺🇾",c:"+598"},{f:"🇬🇾",c:"+592"},{f:"🇸🇷",c:"+597"},
  {f:"🇨🇺",c:"+53"},{f:"🇩🇴",c:"+1"},{f:"🇭🇹",c:"+509"},{f:"🇯🇲",c:"+1"},
  {f:"🇹🇹",c:"+1"},{f:"🇵🇦",c:"+507"},{f:"🇨🇷",c:"+506"},{f:"🇳🇮",c:"+505"},
  {f:"🇭🇳",c:"+504"},{f:"🇸🇻",c:"+503"},{f:"🇬🇹",c:"+502"},{f:"🇧🇿",c:"+501"},
  {f:"🇨🇳",c:"+86"},{f:"🇯🇵",c:"+81"},{f:"🇰🇷",c:"+82"},{f:"🇮🇳",c:"+91"},
  {f:"🇵🇰",c:"+92"},{f:"🇧🇩",c:"+880"},{f:"🇱🇰",c:"+94"},{f:"🇳🇵",c:"+977"},
  {f:"🇲🇲",c:"+95"},{f:"🇹🇭",c:"+66"},{f:"🇻🇳",c:"+84"},{f:"🇰🇭",c:"+855"},
  {f:"🇱🇦",c:"+856"},{f:"🇵🇭",c:"+63"},{f:"🇮🇩",c:"+62"},{f:"🇲🇾",c:"+60"},
  {f:"🇸🇬",c:"+65"},{f:"🇧🇳",c:"+673"},{f:"🇹🇱",c:"+670"},{f:"🇲🇳",c:"+976"},
  {f:"🇰🇿",c:"+7"},{f:"🇺🇿",c:"+998"},{f:"🇹🇲",c:"+993"},{f:"🇹🇯",c:"+992"},
  {f:"🇰🇬",c:"+996"},{f:"🇦🇫",c:"+93"},{f:"🇧🇹",c:"+975"},{f:"🇲🇻",c:"+960"},
  {f:"🇸🇦",c:"+966"},{f:"🇦🇪",c:"+971"},{f:"🇶🇦",c:"+974"},{f:"🇰🇼",c:"+965"},
  {f:"🇧🇭",c:"+973"},{f:"🇴🇲",c:"+968"},{f:"🇾🇪",c:"+967"},{f:"🇯🇴",c:"+962"},
  {f:"🇱🇧",c:"+961"},{f:"🇸🇾",c:"+963"},{f:"🇮🇶",c:"+964"},{f:"🇮🇷",c:"+98"},
  {f:"🇮🇱",c:"+972"},{f:"🇵🇸",c:"+970"},{f:"🇹🇷",c:"+90"},{f:"🇨🇾",c:"+357"},
  {f:"🇷🇺",c:"+7"},{f:"🇺🇦",c:"+380"},{f:"🇧🇾",c:"+375"},{f:"🇲🇩",c:"+373"},
  {f:"🇬🇪",c:"+995"},{f:"🇦🇲",c:"+374"},{f:"🇦🇿",c:"+994"},{f:"🇵🇱",c:"+48"},
  {f:"🇨🇿",c:"+420"},{f:"🇸🇰",c:"+421"},{f:"🇭🇺",c:"+36"},{f:"🇷🇴",c:"+40"},
  {f:"🇧🇬",c:"+359"},{f:"🇬🇷",c:"+30"},{f:"🇦🇱",c:"+355"},{f:"🇷🇸",c:"+381"},
  {f:"🇭🇷",c:"+385"},{f:"🇧🇦",c:"+387"},{f:"🇸🇮",c:"+386"},{f:"🇲🇰",c:"+389"},
  {f:"🇲🇪",c:"+382"},{f:"🇽🇰",c:"+383"},{f:"🇳🇱",c:"+31"},{f:"🇸🇪",c:"+46"},
  {f:"🇳🇴",c:"+47"},{f:"🇩🇰",c:"+45"},{f:"🇫🇮",c:"+358"},{f:"🇮🇸",c:"+354"},
  {f:"🇮🇪",c:"+353"},{f:"🇦🇹",c:"+43"},{f:"🇱🇺",c:"+352"},{f:"🇲🇹",c:"+356"},
  {f:"🇪🇪",c:"+372"},{f:"🇱🇻",c:"+371"},{f:"🇱🇹",c:"+370"},{f:"🇦🇩",c:"+376"},
  {f:"🇲🇨",c:"+377"},{f:"🇱🇮",c:"+423"},{f:"🇸🇲",c:"+378"},{f:"🇻🇦",c:"+379"},
  {f:"🇪🇬",c:"+20"},{f:"🇱🇾",c:"+218"},{f:"🇸🇩",c:"+249"},{f:"🇸🇸",c:"+211"},
  {f:"🇪🇹",c:"+251"},{f:"🇪🇷",c:"+291"},{f:"🇩🇯",c:"+253"},{f:"🇸🇴",c:"+252"},
  {f:"🇺🇬",c:"+256"},{f:"🇹🇿",c:"+255"},{f:"🇷🇼",c:"+250"},{f:"🇧🇮",c:"+257"},
  {f:"🇲🇿",c:"+258"},{f:"🇿🇲",c:"+260"},{f:"🇿🇼",c:"+263"},{f:"🇲🇼",c:"+265"},
  {f:"🇦🇴",c:"+244"},{f:"🇳🇦",c:"+264"},{f:"🇧🇼",c:"+267"},{f:"🇱🇸",c:"+266"},
  {f:"🇸🇿",c:"+268"},{f:"🇲🇬",c:"+261"},{f:"🇲🇺",c:"+230"},{f:"🇸🇨",c:"+248"},
  {f:"🇰🇲",c:"+269"},{f:"🇦🇺",c:"+61"},{f:"🇳🇿",c:"+64"},{f:"🇫🇯",c:"+679"},
  {f:"🇵🇬",c:"+675"},{f:"🇸🇧",c:"+677"},{f:"🇻🇺",c:"+678"},{f:"🇼🇸",c:"+685"},
  {f:"🇹🇴",c:"+676"},{f:"🇰🇮",c:"+686"},{f:"🇫🇲",c:"+691"},{f:"🇵🇼",c:"+680"},
  {f:"🇲🇭",c:"+692"},{f:"🇳🇷",c:"+674"},{f:"🇹🇻",c:"+688"},
];

function fmt(n){if(n>=1000000)return(n/1000000).toFixed(1)+"M";if(n>=1000)return(n/1000).toFixed(1)+"k";return String(n||0);}
// A restriction set by the control tool is "active" if the flag is set
// AND (no expiry was given, i.e. permanent, OR the expiry hasn't passed
// yet) - this is what makes a timed restriction lift itself automatically
// without needing any background job.
function isRestricted(user,flagField,untilField){
  if(!user||!user[flagField])return false;
  if(!user[untilField])return true;
  return new Date(user[untilField]).getTime()>Date.now();
}
async function getPostLocation(){
  try{
    const d=await fetch("https://ipapi.co/json/").then(r=>r.json());
    return d&&d.country_name?{post_country:d.country_name,post_city:d.city||null}:{post_country:null,post_city:null};
  }catch{
    return{post_country:null,post_city:null};
  }
}
function ago(d){const s=(Date.now()-new Date(d))/1000;if(s<60)return"maintenant";if(s<3600)return Math.floor(s/60)+"min";if(s<86400)return Math.floor(s/3600)+"h";return Math.floor(s/86400)+"j";}
function initials(name){return(name||"?")[0].toUpperCase();}

function notifIcon(type){
  return {like:"❤️",comment:"💬",follow:"👤",boost_confirmed:"🚀",certification_confirmed:"✅",certification_reminder:"⏰",page_admin_invite:"🛡️",group_admin_added:"🛡️",group_approved:"👥",group_invite:"👥"}[type]||"🔔";
}
function notifText(n){
  if(n.message)return n.message;
  if(n.type==="like")return "@"+n.sender+" a aimé ta publication";
  if(n.type==="comment")return "@"+n.sender+" a commenté ta publication";
  if(n.type==="follow")return "@"+n.sender+" a commencé à te suivre";
  return "Nouvelle notification";
}
// Groups notifications the way Instagram/Facebook do: several likes on the
// same post (or several new follows) collapse into one line - "X et Y
// autres personnes ont aimé ta publication" - instead of one row each.
// Types with a custom `message` (receipts like boost/certification
// confirmations) are left ungrouped since each one is a distinct event.
const GROUPABLE_NOTIF_TYPES=new Set(["like","comment","follow","gift"]);
function groupNotifications(notifs){
  const groups=[];
  const indexByKey={};
  notifs.forEach(n=>{
    if(!GROUPABLE_NOTIF_TYPES.has(n.type)||n.message){
      groups.push({type:n.type,items:[n]});
      return;
    }
    const key=n.type+"_"+(n.post_id||"none");
    if(indexByKey[key]===undefined){
      indexByKey[key]=groups.length;
      groups.push({type:n.type,post_id:n.post_id,items:[n]});
    }else{
      groups[indexByKey[key]].items.push(n);
    }
  });
  return groups;
}
function groupedNotifText(g){
  if(g.items.length===1)return notifText(g.items[0]);
  const first=g.items[0];
  const others=g.items.length-1;
  const verb={like:"ont aimé ta publication",comment:"ont commenté ta publication",follow:"ont commencé à te suivre",gift:"t'ont envoyé un cadeau"}[g.type]||"ont interagi avec toi";
  return "@"+first.sender+" et "+others+" autre"+(others>1?"s":"")+" personne"+(others>1?"s":"")+" "+verb;
}

function isBadgeActive(u){
  if(!u||!u.verified)return false;
  if(!u.verified_until)return true;
  return new Date(u.verified_until).getTime()>Date.now();
}
function isCurrentlyBoosted(post){
  if(!post||!post.sponsored)return false;
  if(!post.sponsored_until)return true;
  return new Date(post.sponsored_until).getTime()>Date.now();
}
function cloudinaryVideoThumbnail(videoUrl){
  if(!videoUrl)return videoUrl;
  return videoUrl.replace("/video/upload/","/video/upload/so_0/").replace(/\.(mp4|mov|webm|avi|mkv)(\?.*)?$/i,".jpg$2");
}
function addMonths(date,months){
  const d=new Date(date);
  d.setMonth(d.getMonth()+months);
  return d;
}

function safeStringify(obj){
  try{
    return JSON.stringify(obj);
  }catch(e){
    return "[impossible à afficher: "+e.message+"]";
  }
}

let _refreshInFlight=null;
async function refreshAccessToken(){
  if(!_currentRefreshToken)return false;
  if(_refreshInFlight)return _refreshInFlight;
  _refreshInFlight=(async()=>{
    try{
      const d=await authCall("/token?grant_type=refresh_token",{refresh_token:_currentRefreshToken});
      if(!d||!d.access_token)return false;
      _currentUserToken=d.access_token;
      _currentRefreshToken=d.refresh_token||_currentRefreshToken;
      try{
        const stored=JSON.parse(localStorage.getItem("bl_auth_v3")||"null");
        if(stored){
          stored.token=d.access_token;
          stored.refreshToken=d.refresh_token||stored.refreshToken;
          localStorage.setItem("bl_auth_v3",JSON.stringify(stored));
          try{
            const remembered=JSON.parse(localStorage.getItem("bl_remembered_accounts")||"[]");
            const updatedRemembered=remembered.map(a=>a.username===stored.username?{...a,refreshToken:d.refresh_token||a.refreshToken}:a);
            localStorage.setItem("bl_remembered_accounts",JSON.stringify(updatedRemembered));
          }catch{}
          try{
            const multi=JSON.parse(localStorage.getItem("bl_multi_accounts")||"[]");
            const updatedMulti=multi.map(a=>a.username===stored.username?{...a,token:d.access_token,refreshToken:d.refresh_token||a.refreshToken}:a);
            localStorage.setItem("bl_multi_accounts",JSON.stringify(updatedMulti));
          }catch{}
        }
      }catch{}
      return true;
    }catch{return false;}
  })();
  const result=await _refreshInFlight;
  _refreshInFlight=null;
  return result;
}

// Wraps a raw fetch to Supabase with the same "refresh the JWT and retry
// once on expiry" behavior db() already has - for the handful of call
// sites (like follow/unfollow) that need the full Response object instead
// of db()'s parsed-JSON shortcut, and so were missing that resilience.
async function authedFetch(url,opts={}){
  const doFetch=()=>fetch(url,{
    ...opts,
    headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),...(opts.headers||{})}
  });
  let r=await doFetch();
  if(r.status===401){
    const text=await r.clone().text().catch(()=>"");
    if(text.includes("JWT expired")){
      const refreshed=_currentRefreshToken?await refreshAccessToken():false;
      if(refreshed)r=await doFetch();
      else _onSessionExpired&&_onSessionExpired();
    }
  }
  return r;
}

let _onSessionExpired=null;
async function db(path,opts={}){
  const controller=new AbortController();
  const timeoutId=setTimeout(()=>controller.abort(),15000);
  try{
    const {headers:extraHeaders,...restOpts}=opts;
    const doFetch=()=>fetch(SUPABASE_URL+"/rest/v1"+path,{
      headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json","Prefer":"return=representation",...(extraHeaders||{})},
      signal:controller.signal,
      ...restOpts
    });
    let r=await doFetch();
    let t=await r.text();
    if(!r.ok&&t.includes("JWT expired")){
      const refreshed=_currentRefreshToken?await refreshAccessToken():false;
      if(refreshed){
        r=await doFetch();
        t=await r.text();
      }else{
        // The access token expired and there's no way to silently recover -
        // either there's no refresh token, or refreshing itself failed
        // (its own token has expired too). Every screen would otherwise
        // keep showing this same cryptic error forever, so sign the person
        // out cleanly and let them log back in instead.
        _onSessionExpired&&_onSessionExpired();
      }
    }
    clearTimeout(timeoutId);
    if(!r.ok){
      console.error("DB request failed ("+ (opts.method||"GET") +" "+path+", status "+r.status+"): "+t);
    }
    return t?JSON.parse(t):null;
  }catch(e){
    clearTimeout(timeoutId);
    if(e.name==="AbortError")console.error("DB request timed out (15s): "+path);
    else console.warn("DB:",path,e.message);
    return null;
  }
}

// Calls a secured Postgres function (RPC) instead of writing balance
// columns directly - the server validates and computes the new
// balance itself, so the client can never fabricate its own solde.
// Errors here carry the SQL function's own message (e.g. "Solde insuffisant").
async function callRpc(fnName,params){
  const res=await fetch(SUPABASE_URL+"/rest/v1/rpc/"+fnName,{
    method:"POST",
    headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json"},
    body:JSON.stringify(params)
  });
  const data=await res.json().catch(()=>({}));
  if(!res.ok){
    throw new Error((data&&data.message)||"Échec de l'opération");
  }
  return data;
}

function persistPostChange(postId,changes){
  try{
    const cached=localStorage.getItem("bl_posts_cache");
    if(!cached)return;
    const parsed=JSON.parse(cached);
    if(!Array.isArray(parsed))return;
    const updated=parsed.map(p=>String(p.id)===String(postId)?{...p,...changes}:p);
    localStorage.setItem("bl_posts_cache",JSON.stringify(updated));
  }catch{}
}

function persistLocalComment(postId,comment){
  if(postId===undefined||postId===null||postId==="")return;
  try{
    const key="bl_comments_cache_"+String(postId);
    const cached=localStorage.getItem(key);
    const list=cached?JSON.parse(cached):[];
    list.push(comment);
    localStorage.setItem(key,JSON.stringify(list));
  }catch{}
}
function getLocalComments(postId){
  if(postId===undefined||postId===null||postId==="")return [];
  try{
    const cached=localStorage.getItem("bl_comments_cache_"+String(postId));
    return cached?JSON.parse(cached):[];
  }catch{return [];}
}

function persistLikedState(postId,username,isLiked){
  try{
    const key="bl_liked_by_"+username;
    const cached=localStorage.getItem(key);
    const set=new Set(cached?JSON.parse(cached):[]);
    if(isLiked)set.add(String(postId));else set.delete(String(postId));
    localStorage.setItem(key,JSON.stringify([...set]));
  }catch{}
}
function hasLikedLocally(postId,username){
  if(!username)return false;
  try{
    const cached=localStorage.getItem("bl_liked_by_"+encodeURIComponent(username));
    if(!cached)return false;
    const set=new Set(JSON.parse(cached));
    return set.has(String(postId));
  }catch{return false;}
}

async function sharePost(data,showToast){
  const text=data.text||data.title||"Blue Life";
  const url=data.url||window.location.href;
  try{
    if(navigator.share){
      await navigator.share(data);
      return true;
    }
  }catch(e){
    if(e&&e.name==="AbortError")return false;
  }
  try{
    if(navigator.clipboard&&navigator.clipboard.writeText){
      await navigator.clipboard.writeText(url);
      showToast&&showToast("🔗 Lien copié !");
      return true;
    }
  }catch{}
  try{
    const ta=document.createElement("textarea");
    ta.value=url;ta.style.position="fixed";ta.style.opacity="0";
    document.body.appendChild(ta);ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
    showToast&&showToast("🔗 Lien copié !");
    return true;
  }catch{
    showToast&&showToast("⚠️ Impossible de copier automatiquement ici");
    return false;
  }
}

function getSavedPosts(username){
  if(!username)return [];
  try{
    const cached=localStorage.getItem("bl_saved_by_"+encodeURIComponent(username));
    return cached?JSON.parse(cached):[];
  }catch{return [];}
}
function toggleSavedPost(username,post){
  if(!username)return false;
  try{
    const key="bl_saved_by_"+username;
    const cached=localStorage.getItem(key);
    const list=cached?JSON.parse(cached):[];
    const exists=list.some(p=>String(p.id)===String(post.id));
    const updated=exists?list.filter(p=>String(p.id)!==String(post.id)):[post,...list];
    localStorage.setItem(key,JSON.stringify(updated));
    return !exists;
  }catch{return false;}
}
function isPostSaved(username,postId){
  if(!username)return false;
  try{
    const cached=localStorage.getItem("bl_saved_by_"+encodeURIComponent(username));
    if(!cached)return false;
    const list=JSON.parse(cached);
    return list.some(p=>String(p.id)===String(postId));
  }catch{return false;}
}

function getSeenStories(username){
  if(!username)return new Set();
  try{
    const cached=localStorage.getItem("bl_seen_stories_"+encodeURIComponent(username));
    return new Set(cached?JSON.parse(cached):[]);
  }catch{return new Set();}
}
function markStorySeen(username,storyId){
  if(!username||storyId===undefined||storyId===null)return;
  try{
    const key="bl_seen_stories_"+username;
    const cached=localStorage.getItem(key);
    const set=new Set(cached?JSON.parse(cached):[]);
    set.add(String(storyId));
    localStorage.setItem(key,JSON.stringify([...set]));
  }catch{}
}

function getCachedPostField(postId,field,fallback){
  if(postId===undefined||postId===null)return fallback;
  try{
    const cached=localStorage.getItem("bl_posts_cache");
    if(!cached)return fallback;
    const parsed=JSON.parse(cached);
    if(!Array.isArray(parsed))return fallback;
    const found=parsed.find(p=>String(p.id)===String(postId));
    return found&&found[field]!==undefined?found[field]:fallback;
  }catch{return fallback;}
}

async function authCall(path,body){
  const controller=new AbortController();
  const timeoutId=setTimeout(()=>controller.abort(),15000);
  try{
    const r=await fetch(SUPABASE_URL+"/auth/v1"+path,{method:"POST",headers:{apikey:SUPABASE_ANON_KEY,"Content-Type":"application/json"},body:JSON.stringify(body),signal:controller.signal});
    clearTimeout(timeoutId);
    const d=await r.json();
    if(!r.ok)throw new Error(d.error_description||d.msg||"Erreur");
    return d;
  }catch(e){
    clearTimeout(timeoutId);
    if(e.name==="AbortError")throw new Error("La connexion a pris trop de temps (15s). Vérifie ta connexion internet et réessaie.");
    throw e;
  }
}

async function sendVerificationCode(email){
  console.error("OTP: sending code to "+email);
  const r=await fetch(SUPABASE_URL+"/auth/v1/otp",{
    method:"POST",headers:{apikey:SUPABASE_ANON_KEY,"Content-Type":"application/json"},
    body:JSON.stringify({email,create_user:false})
  });
  console.error("OTP: send response status="+r.status);
  if(!r.ok){
    const d=await r.json().catch(()=>({}));
    console.error("OTP: send failed body="+JSON.stringify(d));
    throw new Error(d.error_description||d.msg||"Échec de l'envoi du code");
  }
}
async function verifyCode(email,code){
  console.error("OTP: verifying code for "+email);
  const r=await fetch(SUPABASE_URL+"/auth/v1/verify",{
    method:"POST",headers:{apikey:SUPABASE_ANON_KEY,"Content-Type":"application/json"},
    body:JSON.stringify({email,token:code,type:"email"})
  });
  console.error("OTP: verify response status="+r.status);
  const d=await r.json().catch(()=>({}));
  if(!r.ok){
    console.error("OTP: verify failed body="+JSON.stringify(d));
    throw new Error(d.error_description||d.msg||"Code invalide ou expiré");
  }
  return d;
}

async function finalizeAccountDeletion(username){
  const headers={apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),Prefer:"return=minimal"};
  const base=SUPABASE_URL+"/rest/v1/";
  const calls=[
    "Posts?username=eq."+encodeURIComponent(username),
    "Comments?username=eq."+encodeURIComponent(username),
    "Follows?follower=eq."+encodeURIComponent(username),
    "Follows?following=eq."+encodeURIComponent(username),
    "notifications?receiver=eq."+encodeURIComponent(username),
    "notifications?sender=eq."+encodeURIComponent(username),
    "messages?sender=eq."+encodeURIComponent(username),
    "messages?receiver=eq."+encodeURIComponent(username),
    "stories?author=eq."+encodeURIComponent(username),
    "sponsored_posts?username=eq."+encodeURIComponent(username),
    "profiles?username=eq."+encodeURIComponent(username),
  ];
  for(const path of calls){
    try{ await fetch(base+path,{method:"DELETE",headers}); }
    catch(e){ console.warn("account deletion cascade failed for",path,e); }
  }
}

async function upload(file){
  const fd=new FormData();
  fd.append("file",file);
  fd.append("upload_preset",CLOUDINARY_PRESET);
  const type=file.type.startsWith("video")?"video":"image";
  const r=await fetch("https://api.cloudinary.com/v1_1/"+CLOUDINARY_CLOUD+"/"+type+"/upload",{method:"POST",body:fd});
  const d=await r.json();
  if(d.error)throw new Error(d.error.message);
  return{url:d.secure_url,type};
}

function getVideoDuration(file){
  return new Promise((resolve)=>{
    try{
      const videoEl=document.createElement("video");
      videoEl.preload="metadata";
      videoEl.onloadedmetadata=()=>{
        const d=videoEl.duration;
        URL.revokeObjectURL(videoEl.src);
        resolve(isFinite(d)?d:0);
      };
      videoEl.onerror=()=>resolve(0);
      videoEl.src=URL.createObjectURL(file);
    }catch{resolve(0);}
  });
}

const I={
  Home:(p)=><svg width="26" height="26" viewBox="0 0 24 24" fill={p.a?"currentColor":"none"} stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  Search:(p)=><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={p.a?2.5:2}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  Plus:()=><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="4"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>,
  Play:(p)=><svg width="26" height="26" viewBox="0 0 24 24" fill={p.a?"currentColor":"none"} stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="4"/><polygon points="10 8 16 12 10 16 10 8" fill="currentColor"/></svg>,
  Bell:(p)=><svg width="26" height="26" viewBox="0 0 24 24" fill={p.a?"currentColor":"none"} stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  User:(p)=><svg width="26" height="26" viewBox="0 0 24 24" fill={p.a?"currentColor":"none"} stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  Heart:(p)=><svg width="24" height="24" viewBox="0 0 24 24" fill={p.a?"#ef4444":"none"} stroke={p.a?"#ef4444":"currentColor"} strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>,
  Chat:()=><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  Send:()=><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  Save:(p)=><svg width="24" height="24" viewBox="0 0 24 24" fill={p.a?"currentColor":"none"} stroke="currentColor" strokeWidth="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>,
  Back:()=><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>,
  Eye:(p)=>p.on?<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><line x1="1" y1="1" x2="23" y2="23"/></svg>,
  Img:()=><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>,
  Vid:()=><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>,
  Gear:()=><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  Edit:()=><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  Out:()=><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  Rocket:()=><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/></svg>,
  Bar:()=><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  Msg:(p)=><svg width="26" height="26" viewBox="0 0 24 24" fill={p.a?"currentColor":"none"} stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  Spin:()=><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{animation:"spin 1s linear infinite"}}><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/></svg>,
  Share:()=><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>,
  Grid:()=><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>,
  X:()=><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
};

function Avatar({src,name,size=40,border=C.accent}){
  const [loaded,setLoaded]=useState(false);
  useEffect(()=>{setLoaded(false);},[src]);
  if(src) return (
    <div style={{position:"relative",width:size,height:size,flexShrink:0}}>
      {!loaded&&<div style={{position:"absolute",inset:0,borderRadius:"50%",background:C.w5,border:"2px solid "+border,animation:"avatarPulse 1.2s ease-in-out infinite"}}/>}
      <img src={src} alt="" onLoad={()=>setLoaded(true)} style={{width:size,height:size,borderRadius:"50%",objectFit:"cover",border:"2px solid "+border,position:"absolute",inset:0,opacity:loaded?1:0,transition:"opacity 0.25s"}}/>
    </div>
  );
  return <div style={{width:size,height:size,borderRadius:"50%",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",border:"2px solid "+border,display:"flex",alignItems:"center",justifyContent:"center",fontSize:size*0.4,color:"#fff",fontWeight:800,flexShrink:0}}>{initials(name)}</div>;
}

function GridThumbnail({src}){
  const [loaded,setLoaded]=useState(false);
  useEffect(()=>{setLoaded(false);},[src]);
  return (
    <>
      {!loaded&&<div style={{position:"absolute",inset:0,background:C.w5,animation:"avatarPulse 1.2s ease-in-out infinite"}}/>}
      <img src={src} alt="" onLoad={()=>setLoaded(true)} style={{width:"100%",height:"100%",objectFit:"cover",display:"block",position:"absolute",inset:0,opacity:loaded?1:0,transition:"opacity 0.25s"}}/>
    </>
  );
}

// Shared behavior for a bottom sheet the person can drag (or tap the
// handle) to expand to full screen, or drag back down to its default
// half-height - used by the sound sheet and by chat.
function useDragSheet(threshold=60){
  const [expanded,setExpanded]=useState(false);
  const startY=useRef(null);
  const delta=useRef(0);
  function onDragStart(e){startY.current=(e.touches?e.touches[0].clientY:e.clientY);}
  function onDragMove(e){
    if(startY.current===null)return;
    const y=(e.touches?e.touches[0].clientY:e.clientY);
    delta.current=y-startY.current;
  }
  function onDragEnd(){
    if(startY.current===null)return;
    if(!expanded&&delta.current<-threshold)setExpanded(true);
    else if(expanded&&delta.current>threshold)setExpanded(false);
    startY.current=null;delta.current=0;
  }
  return {expanded,setExpanded,onDragStart,onDragMove,onDragEnd};
}

function Toast({msg}){
  if(!msg) return null;
  return <div style={{position:"fixed",top:20,left:"50%",transform:"translateX(-50%)",background:"rgba(20,20,20,0.95)",color:"#fff",padding:"10px 20px",borderRadius:24,zIndex:9999,fontSize:13,fontWeight:700,animation:"fadeIn 0.3s",whiteSpace:"nowrap",border:"1px solid rgba(255,255,255,0.15)",boxShadow:"0 4px 20px rgba(0,0,0,0.4)"}}>{msg}</div>;
}

async function copyText(text,showToast){
  try{
    if(navigator.clipboard&&navigator.clipboard.writeText){
      await navigator.clipboard.writeText(text);
    }else{
      const ta=document.createElement("textarea");
      ta.value=text;ta.style.position="fixed";ta.style.opacity="0";
      document.body.appendChild(ta);ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    showToast&&showToast("📋 Copié !");
  }catch{showToast&&showToast("⚠️ Impossible de copier");}
}

function CaptionText({text,maxChars=140,maxLines=3,style}){
  const [expanded,setExpanded]=useState(false);
  if(!text)return null;
  const isLong=text.length>maxChars;
  return(
    <div style={style}>
      <div style={isLong&&!expanded?{display:"-webkit-box",WebkitLineClamp:maxLines,WebkitBoxOrient:"vertical",overflow:"hidden",wordBreak:"break-word"}:{wordBreak:"break-word"}}>
        {text}
      </div>
      {isLong&&(
        <span onClick={()=>setExpanded(e=>!e)} style={{color:C.w3,cursor:"pointer",fontWeight:700,fontSize:13}}>
          {expanded?"Voir moins":"Voir plus"}
        </span>
      )}
    </div>
  );
}

function CommentsPanel({post,user,onClose,showToast}){
  const safeUser=user||{username:"",isGuest:true};
  const [comments,setComments]=useState([]);
  const [text,setText]=useState("");
  const [loading,setLoading]=useState(true);
  const [sending,setSending]=useState(false);
  const [optionsFor,setOptionsFor]=useState(null);
  const [authorBadges,setAuthorBadges]=useState({});
  const bottom=useRef(null);
  const inputRef=useRef(null);

  useEffect(()=>{
    const authors=[...new Set(comments.map(c=>c.author).filter(Boolean))].filter(a=>!(a in authorBadges));
    if(authors.length===0)return;
    db("/profiles?username=in.("+authors.join(",")+")&select=username,display_name,verified,verified_until").then(d=>{
      if(!Array.isArray(d))return;
      setAuthorBadges(prev=>{
        const next={...prev};
        authors.forEach(a=>{next[a]=null;});
        d.forEach(p=>{next[p.username]={verified:p.verified,verified_until:p.verified_until,displayName:p.display_name};});
        return next;
      });
    }).catch(()=>{});
  },[comments]);

  async function load(){
    const localOnes=getLocalComments(post.id);
    if(localOnes.length>0) setComments(localOnes);

    if(!post||!post.id||String(post.id).startsWith("local_")){setLoading(false);return;}
    try{
      const d=await db("/Comments?post_id=eq."+post.id+"&order=created_at.asc");
      if(Array.isArray(d)){
        const serverIds=new Set(d.map(c=>String(c.id)));
        const localOnly=localOnes.filter(c=>String(c.id).startsWith("local_")&&!serverIds.has(String(c.id)));
        const merged=[...d,...localOnly].sort((a,b)=>new Date(a.created_at)-new Date(b.created_at));
        setComments(merged);
        try{localStorage.setItem("bl_comments_cache_"+post.id,JSON.stringify(merged));}catch{}
      }
    }catch(e){console.warn("comments load:",e);}
    setLoading(false);
  }
  useEffect(()=>{load();},[post&&post.id]);

  useEffect(()=>{bottom.current&&bottom.current.scrollIntoView({behavior:"smooth"});},[comments]);

  async function sendCommentObject(localComment){
    try{
      const res=await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/Comments",{
        method:"POST",
        headers:{
          "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Content-Type":"application/json",
          "Prefer":"return=representation"
        },
        body:JSON.stringify({post_id:post.id,author:localComment.author,text:localComment.text})
      });
      if(res.ok){
        const saved=await res.json();
        if(Array.isArray(saved)&&saved[0]){
          setComments(c=>c.map(cm=>cm.id===localComment.id?saved[0]:cm));
          try{
            const key="bl_comments_cache_"+post.id;
            const cached=localStorage.getItem(key);
            const list=cached?JSON.parse(cached):[];
            const updated=list.map(cm=>cm.id===localComment.id?saved[0]:cm);
            localStorage.setItem(key,JSON.stringify(updated));
          }catch{}
        }
        return true;
      }else{
        const errTxt=await res.text();
        console.warn("comment POST failed:",res.status,errTxt);
        showToast&&showToast("⚠️ Commentaire non sauvegardé (code "+res.status+")");
        return false;
      }
    }catch(e){
      console.warn("comment send err:",e);
      showToast&&showToast("⚠️ Commentaire non sauvegardé (connexion)");
      return false;
    }
  }

  async function send(){
    if(!text.trim()||sending)return;
    if(!safeUser.username||safeUser.isGuest)return;
    setSending(true);
    const t=text;setText("");
    const localComment={id:"local_"+Date.now(),post_id:post.id,author:safeUser.username,text:t,created_at:new Date().toISOString()};
    setComments(c=>[...c,localComment]);
    persistLocalComment(post.id,localComment);

    if(!post.id||String(post.id).startsWith("local_")){
      setSending(false);
      return;
    }
    const ok=await sendCommentObject(localComment);
    const currentCount=getLocalComments(post.id).length;
    persistPostChange(post.id,{comments_count:currentCount});
    if(ok)db("/notifications",{method:"POST",body:JSON.stringify({receiver:post.username,sender:safeUser.username,type:"comment",post_id:post.id,seen:false})}).catch(()=>{});
    setSending(false);
  }

  async function resendComment(c){
    showToast&&showToast("Renvoi en cours...");
    const ok=await sendCommentObject(c);
    if(ok)showToast&&showToast("✅ Commentaire envoyé");
  }

  function deleteComment(c){
    setComments(cs=>cs.filter(x=>x.id!==c.id));
    try{
      const key="bl_comments_cache_"+post.id;
      const cached=localStorage.getItem(key);
      const list=cached?JSON.parse(cached):[];
      localStorage.setItem(key,JSON.stringify(list.filter(x=>x.id!==c.id)));
    }catch{}
    persistPostChange(post.id,{comments_count:Math.max(0,comments.length-1)});
    if(!String(c.id).startsWith("local_")){
      fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/Comments?id=eq."+c.id,{
        method:"DELETE",
        headers:{
          "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Prefer":"return=minimal"
        }
      }).catch(()=>{});
    }
    showToast&&showToast("Commentaire supprimé");
  }

  return(
    <div style={{position:"fixed",inset:0,zIndex:800,display:"flex",flexDirection:"column",justifyContent:"flex-end"}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.7)",backdropFilter:"blur(4px)"}}/>
      <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",maxHeight:"80vh",display:"flex",flexDirection:"column",maxWidth:480,width:"100%",margin:"0 auto",border:"1px solid "+C.border}}>
        <div style={{padding:"10px 20px 10px",borderBottom:"1px solid "+C.border,display:"flex",alignItems:"center"}}>
          <span style={{fontWeight:700,fontSize:16,color:C.white,flex:1}}>💬 Commentaires</span>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.w3,cursor:"pointer",padding:4}}><I.X/></button>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"12px 16px"}}>
          {loading?<div style={{textAlign:"center",padding:30,color:C.w3}}>⏳</div>:
          comments.length===0?<div style={{textAlign:"center",padding:30,color:C.w3}}>Aucun commentaire encore. Sois le premier !</div>:
          comments.map((c,i)=>(
            <div key={i} style={{display:"flex",gap:10,marginBottom:14}}>
              <Avatar src={c.avatar||""} name={c.author} size={34}/>
              <div style={{flex:1}}>
                <div style={{background:C.w5,borderRadius:"4px 14px 14px 14px",padding:"8px 12px",border:"1px solid "+C.border}}>
                  <span style={{fontWeight:700,fontSize:13,color:C.accent2}}>{(authorBadges[c.author]&&authorBadges[c.author].displayName)||c.author}</span>
                  {isBadgeActive(authorBadges[c.author])&&(
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="#3897f0" style={{flexShrink:0,verticalAlign:"middle",margin:"0 2px"}}>
                      <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
                      <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                  <span> </span>
                  <span style={{fontSize:13,color:C.w2}}>{c.text}</span>
                </div>
                <div style={{fontSize:10,color:C.w3,marginTop:2,paddingLeft:4}}>{ago(c.created_at)}{String(c.id).startsWith("local_")&&" · en attente"}</div>
              </div>
              {safeUser.username&&(
                <button onClick={()=>setOptionsFor(c)} style={{background:"none",border:"none",color:C.w3,cursor:"pointer",padding:4,flexShrink:0,alignSelf:"flex-start",display:"flex"}}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="12" cy="19" r="1.6"/></svg>
                </button>
              )}
            </div>
          ))}
          <div ref={bottom}/>
        </div>
        <div style={{padding:"10px 14px 24px",borderTop:"1px solid "+C.border,display:"flex",gap:8}}>
          <Avatar src={user.avatar||""} name={user.username} size={32}/>
          <div style={{flex:1,display:"flex",background:C.w5,borderRadius:24,padding:"8px 14px",border:"1px solid "+C.border,alignItems:"center",gap:6}}>
            <input ref={inputRef} value={text} onChange={e=>setText(e.target.value)} onKeyDown={e=>e.key==="Enter"&&send()} placeholder="Ajouter un commentaire..." style={{flex:1,background:"none",border:"none",outline:"none",fontSize:14,color:C.white}}/>
          </div>
          <button onClick={send} style={{width:38,height:38,borderRadius:"50%",border:"none",background:text?"linear-gradient(135deg,"+C.accent+",#1e4d8c)":"transparent",color:"#fff",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            <I.Send/>
          </button>
        </div>
      </div>

      {optionsFor&&(()=>{
        const isOwner=optionsFor.author===safeUser.username;
        const isPostOwner=post.username===safeUser.username;
        const isFailed=String(optionsFor.id).startsWith("local_");
        const opts=isOwner?[
          {ic:"📋",label:"Copier",action:()=>copyText(optionsFor.text,showToast)},
          ...(isFailed?[{ic:"🔁",label:"Renvoyer",action:()=>resendComment(optionsFor)}]:[]),
          {ic:"🗑️",label:"Supprimer",action:()=>deleteComment(optionsFor),danger:true},
        ]:[
          {ic:"📋",label:"Copier",action:()=>copyText(optionsFor.text,showToast)},
          {ic:"↩️",label:"Répondre",action:()=>{setText("@"+optionsFor.author+" ");setTimeout(()=>inputRef.current&&inputRef.current.focus(),50);}},
          ...(isPostOwner?[{ic:"🗑️",label:"Supprimer",action:()=>deleteComment(optionsFor),danger:true}]:[]),
        ];
        return(
          <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
            <div onClick={()=>setOptionsFor(null)} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
            <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"10px 16px 32px",border:"1px solid "+C.border}}>
              <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"6px auto 16px"}}/>
              {opts.map((o,i)=>(
                <button key={i} onClick={()=>{o.action();setOptionsFor(null);}} style={{width:"100%",display:"flex",alignItems:"center",gap:14,padding:"13px 8px",background:"none",border:"none",borderBottom:i<opts.length-1?"1px solid "+C.border:"none",cursor:"pointer",textAlign:"left"}}>
                  <span style={{fontSize:20,width:26,textAlign:"center"}}>{o.ic}</span>
                  <span style={{fontSize:15,color:o.danger?C.red:C.white,fontWeight:600}}>{o.label}</span>
                </button>
              ))}
            </div>
          </div>
        );
      })()}
    </div>
  );
}

function ShareSheet({link,shareText,storyImage,storyCaption,repost,currentUser,onClose,showToast,onRequireAuth}){
  const safeUser=currentUser||{username:"",isGuest:true};
  const [sending,setSending]=useState(false);
  const [showPicker,setShowPicker]=useState(false);
  const [followingList,setFollowingList]=useState(null);
  const [showGroupPicker,setShowGroupPicker]=useState(false);
  const [myGroupsList,setMyGroupsList]=useState(null);
  const [selectedGroups,setSelectedGroups]=useState([]);

  async function shareToStory(){
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("login");onClose();return;}
    setSending(true);
    try{
      const res=await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/stories",{
        method:"POST",
        headers:{
          "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Content-Type":"application/json",
          "Prefer":"return=minimal"
        },
        body:JSON.stringify({
          author:safeUser.username,display_name:safeUser.displayName||safeUser.username,avatar:safeUser.avatar||"",
          image:storyImage,caption:storyCaption||"",
          expires_at:new Date(Date.now()+86400000).toISOString(),created_at:new Date().toISOString()
        })
      });
      showToast&&showToast(res.ok?"✅ Ajouté à ta story":"⚠️ Échec de l'ajout à la story");
    }catch{showToast&&showToast("⚠️ Échec de l'ajout à la story");}
    setSending(false);onClose();
  }

  async function shareToFeed(){
    if(!repost)return;
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("login");onClose();return;}
    setSending(true);
    try{
      const res=await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/Posts",{
        method:"POST",
        headers:{
          "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Content-Type":"application/json",
          "Prefer":"return=minimal"
        },
        body:JSON.stringify({
          username:safeUser.username,display_name:safeUser.displayName||safeUser.username,avatar:safeUser.avatar||"",
          caption:"🔁 via @"+repost.originalUsername+(repost.caption?" — "+repost.caption:""),
          image:repost.image,images:repost.images||null,type:repost.type||"image",
          likes_count:0,sponsored:false,created_at:new Date().toISOString()
        })
      });
      showToast&&showToast(res.ok?"✅ Repartagé sur ton profil":"⚠️ Échec du partage");
      if(res.ok){
        sendPushNotification({
          type:"repost",
          receiver:repost.originalUsername,
          sender:safeUser.username,
          message:"a republié ta publication"
        });
      }
    }catch{showToast&&showToast("⚠️ Échec du partage");}
    setSending(false);onClose();
  }

  async function openMessagePicker(){
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("login");onClose();return;}
    setShowPicker(true);
    if(followingList===null){
      const d=await db("/Follows?follower=eq."+encodeURIComponent(safeUser.username));
      setFollowingList(Array.isArray(d)?d.map(f=>f.following):[]);
    }
  }

  async function sendAsMessage(receiver){
    if(receiver===safeUser.username)return;
    setSending(true);
    try{
      await db("/messages",{method:"POST",body:JSON.stringify({sender:safeUser.username,receiver,text:(shareText?shareText+" ":"")+link})});
      sendPushNotification({type:"message",receiver,sender:safeUser.username,message:shareText||"Regarde ça !"});
      showToast&&showToast("✅ Envoyé à @"+receiver);
    }catch{showToast&&showToast("⚠️ Échec de l'envoi");}
    setSending(false);onClose();
  }

  async function openGroupPicker(){
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("login");onClose();return;}
    if(!repost&&!link){return;}
    setShowGroupPicker(true);
    if(myGroupsList===null){
      const memberRows=await db("/group_members?username=eq."+encodeURIComponent(safeUser.username)+"&status=eq.member").catch(()=>[]);
      if(!Array.isArray(memberRows)||memberRows.length===0){setMyGroupsList([]);return;}
      const ids=memberRows.map(r=>r.group_id);
      const rows=await db("/groups?id=in.("+ids.join(",")+")&select=id,name,avatar").catch(()=>[]);
      setMyGroupsList(Array.isArray(rows)?rows:[]);
    }
  }

  function toggleGroupSelect(id){
    setSelectedGroups(sel=>sel.includes(id)?sel.filter(g=>g!==id):[...sel,id]);
  }

  async function shareToGroups(){
    if(selectedGroups.length===0||!repost)return;
    setSending(true);
    try{
      await Promise.all(selectedGroups.map(groupId=>{
        const g=(myGroupsList||[]).find(x=>x.id===groupId);
        return fetch(SUPABASE_URL+"/rest/v1/Posts",{
          method:"POST",
          headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
          body:JSON.stringify({
            username:safeUser.username,display_name:safeUser.displayName||safeUser.username,avatar:safeUser.avatar||"",
            caption:"🔁 via @"+repost.originalUsername+(repost.caption?" — "+repost.caption:""),
            image:repost.image,images:repost.images||null,type:repost.type||"image",
            group_id:groupId,group_name:g?g.name:null,shared_post_id:repost.originalPostId||null,
            likes_count:0,sponsored:false
          })
        });
      }));
      showToast&&showToast("✅ Partagé dans "+selectedGroups.length+" groupe"+(selectedGroups.length>1?"s":""));
    }catch{showToast&&showToast("⚠️ Échec du partage");}
    setSending(false);onClose();
  }

  function shareOutside(){
    sharePost({title:"Blue Life",text:shareText||"Regarde ça sur Blue Life !",url:link},showToast);
    onClose();
  }

  const options=[
    {ic:"💬",label:"Envoyer en message",action:openMessagePicker},
    {ic:"📖",label:"Ajouter à ta story",action:shareToStory},
    ...(repost?[{ic:"🔁",label:"Partager sur ton profil",action:shareToFeed}]:[]),
    ...(repost?[{ic:"👥",label:"Partager dans des groupes",action:openGroupPicker}]:[]),
    {ic:"↗️",label:"Partager hors de l'application",action:shareOutside},
  ];

  return(
    <div style={{position:"fixed",inset:0,zIndex:950,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
      <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"10px 16px 32px",border:"1px solid "+C.border}}>
        <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"6px auto 16px"}}/>
        {!showPicker&&!showGroupPicker?(
          <>
            <div style={{fontWeight:700,fontSize:15,color:C.white,marginBottom:6,textAlign:"center"}}>Partager</div>
            {options.map((o,i)=>(
              <button key={i} onClick={o.action} disabled={sending} style={{width:"100%",display:"flex",alignItems:"center",gap:14,padding:"13px 8px",background:"none",border:"none",borderBottom:i<options.length-1?"1px solid "+C.border:"none",cursor:sending?"not-allowed":"pointer",textAlign:"left"}}>
                <span style={{fontSize:22,width:28,textAlign:"center"}}>{o.ic}</span>
                <span style={{fontSize:15,color:C.white,fontWeight:600}}>{o.label}</span>
              </button>
            ))}
          </>
        ):showGroupPicker?(
          <>
            <div style={{display:"flex",alignItems:"center",marginBottom:14}}>
              <button onClick={()=>{setShowGroupPicker(false);setSelectedGroups([]);}} style={{background:"none",border:"none",color:C.white,cursor:"pointer",marginRight:8,display:"flex"}}><I.Back/></button>
              <span style={{fontWeight:700,fontSize:15,color:C.white,flex:1}}>Partager dans...</span>
            </div>
            <div style={{maxHeight:280,overflowY:"auto",marginBottom:14}}>
              {myGroupsList===null?(
                <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
              ):myGroupsList.length===0?(
                <div style={{textAlign:"center",padding:20,color:C.w3,fontSize:13}}>Tu ne fais partie d'aucun groupe pour l'instant</div>
              ):(
                myGroupsList.map((g,i)=>(
                  <div key={i} onClick={()=>toggleGroupSelect(g.id)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 4px",cursor:sending?"not-allowed":"pointer"}}>
                    <Avatar src={g.avatar||""} name={g.name} size={40}/>
                    <span style={{flex:1,fontSize:14,color:C.white,fontWeight:600}}>{g.name}</span>
                    <div style={{width:22,height:22,borderRadius:"50%",border:"2px solid "+(selectedGroups.includes(g.id)?C.accent:C.border),background:selectedGroups.includes(g.id)?C.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:12,flexShrink:0}}>{selectedGroups.includes(g.id)?"✓":""}</div>
                  </div>
                ))
              )}
            </div>
            {myGroupsList&&myGroupsList.length>0&&(
              <button onClick={shareToGroups} disabled={sending||selectedGroups.length===0} style={{width:"100%",padding:"13px",borderRadius:12,border:"none",background:selectedGroups.length>0?"linear-gradient(135deg,"+C.accent+",#1e4d8c)":C.w4,color:"#fff",fontWeight:700,fontSize:14,cursor:selectedGroups.length>0?"pointer":"not-allowed"}}>
                {sending?"...":"Partager"+(selectedGroups.length>0?" ("+selectedGroups.length+")":"")}
              </button>
            )}
          </>
        ):(
          <>
            <div style={{display:"flex",alignItems:"center",marginBottom:14}}>
              <button onClick={()=>setShowPicker(false)} style={{background:"none",border:"none",color:C.white,cursor:"pointer",marginRight:8,display:"flex"}}><I.Back/></button>
              <span style={{fontWeight:700,fontSize:15,color:C.white}}>Envoyer à...</span>
            </div>
            <div style={{maxHeight:280,overflowY:"auto"}}>
              {followingList===null?(
                <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
              ):followingList.length===0?(
                <div style={{textAlign:"center",padding:20,color:C.w3,fontSize:13}}>Suis des gens pour leur envoyer ça</div>
              ):(
                followingList.map((u,i)=>(
                  <div key={i} onClick={()=>sendAsMessage(u)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 4px",cursor:sending?"not-allowed":"pointer"}}>
                    <Avatar src="" name={u} size={40}/>
                    <span style={{fontSize:14,color:C.white,fontWeight:600}}>{u}</span>
                  </div>
                ))
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function PostOptionsSheet({post,isOwner,currentUser,onClose,showToast,onRequireAuth,onDeleted,onCaptionUpdated,onPinToggled}){
  const [view,setView]=useState("menu");
  const [captionText,setCaptionText]=useState(post.caption||"");
  const [busy,setBusy]=useState(false);
  const [aboutInfo,setAboutInfo]=useState(null);
  const safeUser=currentUser||{username:"",isGuest:true};
  const link=window.location.origin+window.location.pathname+"?post="+post.id;

  async function copyLink(){
    try{
      if(navigator.clipboard&&navigator.clipboard.writeText){
        await navigator.clipboard.writeText(link);
      }else{
        const ta=document.createElement("textarea");
        ta.value=link;ta.style.position="fixed";ta.style.opacity="0";
        document.body.appendChild(ta);ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      showToast&&showToast("🔗 Lien copié !");
    }catch{showToast&&showToast("⚠️ Impossible de copier le lien");}
    onClose();
  }

  async function submitPostReport(reason){
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("report");return;}
    setBusy(true);
    try{
      await fetch(SUPABASE_URL+"/rest/v1/reports",{
        method:"POST",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({reporter:safeUser.username,reported_username:post.username,reported_post_id:String(post.id),reason})
      });
      showToast&&showToast("Signalement envoyé, merci");
    }catch(e){
      showToast&&showToast("⚠️ Échec de l'envoi");
    }
    setBusy(false);
    onClose();
  }

  function withVideoWatermark(url,brand,handle){
    if(!url)return url;
    const marker="/upload/";
    const i=url.indexOf(marker);
    if(i===-1)return url;
    const at=i+marker.length;
    const line1=encodeURIComponent(brand||"Blue Life");
    const line2=encodeURIComponent("@"+(handle||""));
    const transform=
      "l_text:Arial_34_bold:"+line1+",co_white/fl_layer_apply,g_east,x_22,y_10/"+
      "l_text:Arial_24:"+line2+",co_white/fl_layer_apply,g_east,x_22,y_50/";
    return url.slice(0,at)+transform+url.slice(at);
  }

  async function downloadToGallery(){
    const isVideo=post.type==="video";
    const watermarkedUrl=isVideo?withVideoWatermark(post.image,"Blue Life",post.username):post.image;
    const filename=(post.username||"blue-life")+"-"+(post.id||Date.now())+(isVideo?".mp4":".jpg");
    try{
      let res=await fetch(watermarkedUrl,{mode:"cors"});
      if(!res.ok&&isVideo)res=await fetch(post.image,{mode:"cors"});
      if(!res.ok)throw new Error("fetch failed: "+res.status);
      const blob=await res.blob();
      const file=new File([blob],filename,{type:blob.type||(isVideo?"video/mp4":"image/jpeg")});

      if(navigator.canShare&&navigator.canShare({files:[file]})){
        await navigator.share({files:[file]});
        onClose();
        return;
      }

      const blobUrl=URL.createObjectURL(blob);
      const a=document.createElement("a");
      a.href=blobUrl;
      a.download=filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(()=>URL.revokeObjectURL(blobUrl),4000);
      showToast&&showToast("⬇️ Téléchargé dans les téléchargements du navigateur (pas directement dans Photos sur ce téléphone)");
    }catch(e){
      if(e&&e.name==="AbortError"){onClose();return;}
      window.open(post.image,"_blank");
      showToast&&showToast("⚠️ Téléchargement direct impossible ici, ouverture dans un nouvel onglet");
    }
    onClose();
  }

  async function confirmDelete(){
    setBusy(true);
    try{
      const res=await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/Posts?id=eq."+post.id,{
        method:"DELETE",
        headers:{
          "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Prefer":"return=minimal"
        }
      });
      if(res.ok){
        showToast&&showToast("🗑️ Publication supprimée");
        onDeleted&&onDeleted();
        onClose();
      }else{
        showToast&&showToast("⚠️ Échec de la suppression (code "+res.status+")");
      }
    }catch{showToast&&showToast("⚠️ Échec de la suppression");}
    setBusy(false);
  }

  async function saveCaption(){
    setBusy(true);
    try{
      const res=await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/Posts?id=eq."+post.id,{
        method:"PATCH",
        headers:{
          "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Content-Type":"application/json",
          "Prefer":"return=minimal"
        },
        body:JSON.stringify({caption:captionText})
      });
      if(res.ok){
        showToast&&showToast("✅ Légende mise à jour");
        onCaptionUpdated&&onCaptionUpdated(captionText);
        onClose();
      }else{
        showToast&&showToast("⚠️ Échec de la mise à jour (code "+res.status+")");
      }
    }catch{showToast&&showToast("⚠️ Échec de la mise à jour");}
    setBusy(false);
  }

  async function togglePin(){
    setBusy(true);
    const newPinned=!post.pinned;
    try{
      const res=await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/Posts?id=eq."+post.id,{
        method:"PATCH",
        headers:{
          "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Content-Type":"application/json",
          "Prefer":"return=minimal"
        },
        body:JSON.stringify({pinned:newPinned})
      });
      if(res.ok){
        showToast&&showToast(newPinned?"📌 Épinglé sur ton profil":"Désépinglé");
        onPinToggled&&onPinToggled(newPinned);
      }else{
        showToast&&showToast("⚠️ Échec (code "+res.status+")");
      }
    }catch{showToast&&showToast("⚠️ Échec");}
    setBusy(false);
    onClose();
  }

  async function loadAbout(){
    setView("about");
    if(aboutInfo!==null)return;
    const d=await db("/profiles?username=eq."+encodeURIComponent(post.username)+"&limit=1");
    setAboutInfo(Array.isArray(d)&&d[0]?d[0]:{});
  }

  async function unfollow(){
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("login");onClose();return;}
    setBusy(true);
    try{
      await db("/Follows?follower=eq."+encodeURIComponent(safeUser.username)+"&following=eq."+encodeURIComponent(post.username),{method:"DELETE"});
      showToast&&showToast("Tu ne suis plus @"+encodeURIComponent(post.username));
    }catch{showToast&&showToast("⚠️ Échec");}
    setBusy(false);
    onClose();
  }

  function toggleSave(){
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("login");onClose();return;}
    const nowSaved=toggleSavedPost(safeUser.username,post);
    showToast&&showToast(nowSaved?"🔖 Enregistré":"Retiré des enregistrements");
    onClose();
  }

  const ownerOptions=[
    {ic:"✏️",label:"Modifier la légende",action:()=>setView("editCaption")},
    {ic:post.pinned?"📌":"📍",label:post.pinned?"Désépingler":"Épingler sur mon profil",action:togglePin},
    {ic:"🔗",label:"Copier le lien",action:copyLink},
    {ic:"⬇️",label:"Télécharger dans ma galerie",action:downloadToGallery},
    {ic:"🗑️",label:"Supprimer",action:()=>setView("confirmDelete"),danger:true},
  ];
  const visitorOptions=[
    {ic:"🔖",label:"Enregistrer",action:toggleSave},
    {ic:"🔗",label:"Copier le lien",action:copyLink},
    {ic:"⬇️",label:"Télécharger dans ma galerie",action:downloadToGallery},
    {ic:"ℹ️",label:"À propos de ce compte",action:loadAbout},
    {ic:"🚩",label:"Signaler ce post",action:()=>setView("reportReason"),danger:true},
    {ic:"🚫",label:"Ne plus suivre",action:unfollow,danger:true},
  ];
  const options=isOwner?ownerOptions:visitorOptions;

  return(
    <div style={{position:"fixed",inset:0,zIndex:960,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
      <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"10px 16px 32px",border:"1px solid "+C.border}}>
        <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"6px auto 16px"}}/>

        {view==="menu"&&options.map((o,i)=>(
          <button key={i} onClick={o.action} disabled={busy} style={{width:"100%",display:"flex",alignItems:"center",gap:14,padding:"13px 8px",background:"none",border:"none",borderBottom:i<options.length-1?"1px solid "+C.border:"none",cursor:busy?"not-allowed":"pointer",textAlign:"left"}}>
            <span style={{fontSize:20,width:26,textAlign:"center"}}>{o.ic}</span>
            <span style={{fontSize:15,color:o.danger?C.red:C.white,fontWeight:600}}>{o.label}</span>
          </button>
        ))}

        {view==="editCaption"&&(
          <>
            <div style={{fontWeight:700,fontSize:15,color:C.white,marginBottom:12,textAlign:"center"}}>Modifier la légende</div>
            <textarea value={captionText} onChange={e=>setCaptionText(e.target.value)} rows={3} style={{width:"100%",padding:"12px 14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",resize:"none",fontFamily:"inherit",marginBottom:12,boxSizing:"border-box"}}/>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setView("menu")} style={{flex:1,padding:"12px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:700,cursor:"pointer"}}>Annuler</button>
              <button onClick={saveCaption} disabled={busy} style={{flex:1,padding:"12px",borderRadius:12,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:busy?"not-allowed":"pointer"}}>{busy?"...":"Enregistrer"}</button>
            </div>
          </>
        )}

        {view==="confirmDelete"&&(
          <>
            <div style={{fontWeight:700,fontSize:16,color:C.white,marginBottom:8,textAlign:"center"}}>Supprimer cette publication ?</div>
            <div style={{fontSize:13,color:C.w3,marginBottom:18,textAlign:"center"}}>Cette action est définitive.</div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setView("menu")} style={{flex:1,padding:"12px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:700,cursor:"pointer"}}>Annuler</button>
              <button onClick={confirmDelete} disabled={busy} style={{flex:1,padding:"12px",borderRadius:12,border:"none",background:C.red,color:"#fff",fontWeight:700,cursor:busy?"not-allowed":"pointer"}}>{busy?"...":"Supprimer"}</button>
            </div>
          </>
        )}

        {view==="about"&&(
          <>
            <div style={{display:"flex",alignItems:"center",marginBottom:14}}>
              <button onClick={()=>setView("menu")} style={{background:"none",border:"none",color:C.white,cursor:"pointer",marginRight:8,display:"flex"}}><I.Back/></button>
              <span style={{fontWeight:700,fontSize:15,color:C.white}}>À propos de @{post.username}</span>
            </div>
            {aboutInfo===null?(
              <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
            ):(
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <Avatar src={aboutInfo.avatar||post.avatar||""} name={post.username} size={48}/>
                  <div>
                    <div style={{fontWeight:700,fontSize:15,color:C.white}}>{aboutInfo.display_name||post.username}</div>
                    <div style={{fontSize:12,color:C.w3}}>@{post.username}</div>
                  </div>
                </div>
                {aboutInfo.bio&&<div style={{fontSize:13,color:C.w2}}>{aboutInfo.bio}</div>}
                <div style={{fontSize:12,color:C.w3}}>{aboutInfo.created_at?"Compte créé "+ago(aboutInfo.created_at):"Date de création inconnue"}</div>
                <div style={{fontSize:12,color:C.w3}}>{fmt(aboutInfo.followers_count||0)} abonnés</div>
              </div>
            )}
          </>
        )}

        {view==="reportReason"&&(
          <>
            <div style={{display:"flex",alignItems:"center",marginBottom:14}}>
              <button onClick={()=>setView("menu")} style={{background:"none",border:"none",color:C.white,cursor:"pointer",marginRight:8,display:"flex"}}><I.Back/></button>
              <span style={{fontWeight:700,fontSize:15,color:C.white}}>Pourquoi signales-tu ce post ?</span>
            </div>
            {["Spam","Contenu inapproprié","Harcèlement ou intimidation","Faux compte / usurpation","Autre"].map(reason=>(
              <button key={reason} disabled={busy} onClick={()=>submitPostReport(reason)} style={{width:"100%",padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:600,textAlign:"left",marginBottom:10,cursor:busy?"not-allowed":"pointer"}}>{reason}</button>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

const WALLET_TIERS=[500,1000,2500,5000,10000,50000,100000,150000];
const COIN_RATE=70/500;
const ADMIN_USERNAME="fofoupatrick1";
const GIFT_TIERS=[
  {coins:10,icon:"🌹",label:"Rose"},
  {coins:50,icon:"❤️",label:"Coeur"},
  {coins:100,icon:"👑",label:"Couronne"},
  {coins:500,icon:"🚀",label:"Fusée"},
  {coins:1000,icon:"💎",label:"Diamant"},
  {coins:2000,icon:"🦁",label:"Lion"},
  {coins:5000,icon:"🎬",label:"Oscar"},
  {coins:8000,icon:"⚽",label:"Ballon d'Or"},
  {coins:15000,icon:"🎙️",label:"Grammy Award"},
  {coins:34999,icon:"🌌",label:"Univers"},
];

function CoinIcon({size=16}){
  return(
    <svg width={size} height={size} viewBox="0 0 24 24" style={{flexShrink:0,display:"inline-block",verticalAlign:"middle"}}>
      <circle cx="12" cy="12" r="11" fill="#FFD700" stroke="#B8860B" strokeWidth="1.2"/>
      <circle cx="12" cy="12" r="7.8" fill="none" stroke="#B8860B" strokeWidth="1"/>
      <text x="12" y="16.5" textAnchor="middle" fontSize="10" fontWeight="800" fill="#B8860B" fontFamily="Arial,sans-serif">B</text>
    </svg>
  );
}

function txLabel(type){
  const labels={
    recharge:"Recharge du portefeuille",
    buy_coins:"Achat de Blue Coins",
    spend_service:"Achat de service",
    send_gift:"Cadeau envoyé",
    receive_gift:"Cadeau reçu",
    convert_coins:"Conversion en solde",
    withdraw_request:"Retrait demandé"
  };
  return labels[type]||type;
}

function GiftSheet({post,user,onClose,showToast,onGiftSent,onRequireAuth,targetTable="Posts"}){
  const [sending,setSending]=useState(false);
  const [coinsBalance,setCoinsBalance]=useState(null);

  useEffect(()=>{
    if(!user||!user.username)return;
    console.error("GiftSheet loading coins_balance for username: ["+encodeURIComponent(user.username)+"]");
    db("/profiles?username=eq."+encodeURIComponent(user.username)+"&select=coins_balance&limit=1").then(d=>{
      console.error("GiftSheet coins_balance response: "+JSON.stringify(d));
      if(Array.isArray(d)&&d[0]){
        setCoinsBalance(d[0].coins_balance||0);
      }else{
        setCoinsBalance(0);
      }
    }).catch((e)=>{
      console.error("Network error loading coins_balance: "+e.message);
      setCoinsBalance(0);
    });
  },[]);

  async function sendGift(tier){
    if(!user||!user.username||user.isGuest){onRequireAuth&&onRequireAuth("gift");onClose();return;}
    if(user.username===post.username){showToast&&showToast("Tu ne peux pas t'envoyer un cadeau à toi-même");return;}
    if(sending)return;
    if(coinsBalance===null){showToast&&showToast("⏳ Chargement en cours, réessaie dans un instant");return;}
    if(coinsBalance<tier.coins){
      showToast&&showToast("🪙 Pas assez de Blue Coins pour ce cadeau");
      onClose();
      window.__blOpenWallet&&window.__blOpenWallet();
      return;
    }
    setSending(true);
    try{
      await callRpc("send_gift",{
        p_receiver:post.username,
        p_gift_coins:tier.coins,
        p_gift_label:tier.icon+" "+tier.label,
        p_credit_receiver:!post.is_detected_copy,
        p_target_table:targetTable,
        p_target_id:String(post.id),
        p_sender_username:user.username
      });
      const newSenderCoins=coinsBalance-tier.coins;
      setCoinsBalance(newSenderCoins);
      const newGiftsTotal=post.is_detected_copy?(post.gifts_received||0):(post.gifts_received||0)+tier.coins;

      showToast&&showToast(tier.icon+" Cadeau envoyé !");
      onGiftSent&&onGiftSent(newGiftsTotal);
      onClose();
    }catch(e){
      showToast&&showToast("⚠️ "+(e.message||"Échec de l'envoi du cadeau"));
    }
    setSending(false);
  }

  const isOwnPost = user && user.username && user.username===post.username;

  return(
    <div style={{position:"fixed",inset:0,zIndex:960,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
      <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"16px 16px 32px",border:"1px solid "+C.border}}>
        <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"6px auto 16px"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <span style={{fontWeight:700,fontSize:15,color:C.white}}>🎁 Envoyer un cadeau</span>
          {!isOwnPost&&<span style={{color:"#f0b90b",fontSize:13,fontWeight:700,display:"flex",alignItems:"center",gap:5}}><CoinIcon size={15}/> {coinsBalance===null?"...":fmt(coinsBalance)}</span>}
        </div>
        {isOwnPost?(
          <div style={{textAlign:"center",padding:"20px 10px",color:C.w3,fontSize:14}}>
            🚫 Tu ne peux pas envoyer de cadeau sur ton propre contenu.<br/>Ça marche uniquement sur les publications d'autres utilisateurs.
          </div>
        ):(
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10}}>
          {GIFT_TIERS.map((t,i)=>(
            <button key={i} onClick={()=>sendGift(t)} disabled={sending} style={{padding:"14px 8px",borderRadius:14,border:"1px solid "+C.border,background:C.w5,cursor:sending?"not-allowed":"pointer",textAlign:"center"}}>
              <div style={{fontSize:26,marginBottom:6}}>{t.icon}</div>
              <div style={{color:C.white,fontSize:12,fontWeight:600}}>{t.label}</div>
              <div style={{color:"#f0b90b",fontSize:11,marginTop:2,display:"flex",alignItems:"center",justifyContent:"center",gap:4}}><CoinIcon size={12}/> {t.coins}</div>
            </button>
          ))}
        </div>
        )}
      </div>
    </div>
  );
}

function RechargeWallet({user,currentBalance,onClose,onSuccess,showToast}){
  const [amount,setAmount]=useState(WALLET_TIERS[0]);
  const [customAmount,setCustomAmount]=useState("");
  const [payStep,setPayStep]=useState("form");
  const [payError,setPayError]=useState("");
  const [notchpayRef,setNotchpayRef]=useState("");
  const [momoChannel,setMomoChannel]=useState("cm.mtn");
  const [momoPhone,setMomoPhone]=useState("");
  const [charging,setCharging]=useState(false);
  const [cmSelected,setCmSelected]=useState(false);
  const [paying,setPaying]=useState(false);
  const [showOtherMethods,setShowOtherMethods]=useState(false);

  const finalAmount=customAmount?Math.round((parseInt(customAmount,10)||0)*_xafPerUsd):amount;

  async function processRecharge(){
    if(finalAmount<500){setPayError("Montant minimum : "+fmtUSD(500));return;}
    setPaying(true);setPayError("");setPayStep("processing");
    const ref="wallet_"+encodeURIComponent(user.username)+"_"+Date.now();
    try{
      const res=await fetch(BLUELIFE_BACKEND_URL+"/api/pay-initiate",{
        method:"POST",cache:"no-store",
        headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({
          amount:finalAmount,currency:"XAF",
          email:user.email||user.username+"@bluelife.app",
          description:"Recharge du portefeuille Blue Life - @"+user.username
        })
      });
      let data={};
      try{const t=await res.text();data=t?JSON.parse(t):{};}catch{
        setPayStep("error");setPayError("Le serveur de paiement n'a pas répondu correctement. Réessaie.");setPaying(false);return;
      }
      if(!res.ok||!data.transaction?.reference){
        console.error("Backend raw response (status "+res.status+"): "+JSON.stringify(data));
        const reason=data?.error||data?.message||"Impossible d'initialiser le paiement";
        setPayStep("error");setPayError(reason+" (code "+res.status+")");setPaying(false);return;
      }
      setNotchpayRef(data.transaction.reference);
      setPayStep("selectMethod");
      setPaying(false);
    }catch(e){
      setPayStep("error");
      const isNetwork=e.message&&e.message.toLowerCase().includes("fetch");
      setPayError(isNetwork?"Connexion au serveur de paiement impossible. Réessaie.":("Erreur: "+e.message));
      setPaying(false);
    }
  }

  const [cardBusy,setCardBusy]=useState(false);
  const [cardError,setCardError]=useState("");
  async function payCardViaPaddle(){
    setCardError("");
    setCardBusy(true);
    await payViaCamerPay(
      "recharge",(user.username||"").trim(),finalAmount,null,user.email,{},
      async ()=>{
        showToast&&showToast("⏳ Confirmation du paiement...");
        const startBalance=currentBalance||0;
        for(let i=0;i<15;i++){
          await new Promise(r=>setTimeout(r,2000));
          const res=await db("/profiles?username=eq."+encodeURIComponent(user.username)+"&select=wallet_balance").catch(()=>null);
          const freshBalance=res&&res[0]&&res[0].wallet_balance;
          if(freshBalance!==undefined&&freshBalance>startBalance){
            showToast&&showToast("✅ Portefeuille rechargé !");
            onSuccess&&onSuccess(freshBalance);
            setCardBusy(false);
            return;
          }
        }
        setCardError("Paiement confirmé mais pas encore synchronisé côté Blue Life. Réessaie de vérifier ton solde dans un instant.");
        setCardBusy(false);
      },
      (msg)=>{setCardError(msg);setCardBusy(false);}
    );
  }

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:900,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12}}>
        <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>💳 Recharger</span>
      </div>

      {payStep==="form"&&(
        <div style={{padding:20}}>
          <div style={{color:C.w3,fontSize:13,marginBottom:10,fontWeight:600}}>Choisis un montant ($)</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10,marginBottom:16}}>
            {WALLET_TIERS.map(t=>(
              <button key={t} onClick={()=>{setAmount(t);setCustomAmount("");}} style={{padding:"14px 10px",borderRadius:12,border:(!customAmount&&amount===t)?"2px solid "+C.accent:"1px solid "+C.border,background:(!customAmount&&amount===t)?C.accent+"22":C.w5,color:C.white,fontWeight:700,fontSize:15,cursor:"pointer"}}>{fmtUSD(t)}</button>
            ))}
          </div>
          <div style={{color:C.w3,fontSize:12,marginBottom:6}}>Ou montant personnalisé (min. {fmtUSD(500)})</div>
          <input value={customAmount} onChange={e=>setCustomAmount(e.target.value.replace(/[^0-9]/g,""))} placeholder="Montant en $" inputMode="numeric" style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",marginBottom:18,boxSizing:"border-box"}}/>

          {payError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{payError}</div>}

          <button onClick={()=>setPayStep("selectMethod")} disabled={finalAmount<500} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:finalAmount<500?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:finalAmount<500?"not-allowed":"pointer"}}>
            Continuer vers le paiement
          </button>
        </div>
      )}

      {payStep==="processing"&&(
        <div style={{padding:20,textAlign:"center",paddingTop:60}}>
          <div style={{fontSize:48,marginBottom:16,animation:"spin 1s linear infinite",display:"inline-block"}}>⏳</div>
          <div style={{fontWeight:700,fontSize:18,color:C.white}}>Initialisation du paiement...</div>
        </div>
      )}

      {payStep==="selectMethod"&&(
        <div style={{padding:20}}>
          <div style={{background:C.accent+"22",borderRadius:16,padding:16,marginBottom:20,border:"1px solid "+C.border2,textAlign:"center"}}>
            <div style={{fontSize:28,fontWeight:800,color:C.white}}>{fmtUSD(finalAmount)}</div>
            <div style={{color:C.w3,fontSize:13}}>Recharge du portefeuille</div>
            <div style={{color:C.w3,fontSize:12,marginTop:6}}>Débité comme {finalAmount.toLocaleString()} XAF</div>
          </div>
          {cardError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{cardError}</div>}
          <button onClick={cardBusy?undefined:payCardViaPaddle} disabled={cardBusy} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:cardBusy?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:cardBusy?"not-allowed":"pointer"}}>
            {cardBusy?"⏳ Confirmation en cours...":"Payer "+fmtUSD(finalAmount)}
          </button>
          <div style={{color:C.w3,fontSize:12,textAlign:"center",marginTop:12}}>Mobile Money (Orange, MTN), carte bancaire ou PayPal — choisis sur l'écran suivant.</div>
        </div>
      )}

      {payStep==="error"&&(
        <div style={{padding:20,textAlign:"center",paddingTop:40}}>
          <div style={{fontSize:56,marginBottom:16}}>❌</div>
          <div style={{fontWeight:800,fontSize:19,color:C.white,marginBottom:10}}>Paiement échoué</div>
          <div style={{color:"#f87171",fontSize:13,marginBottom:24}}>{payError}</div>
          <button onClick={()=>setPayStep("form")} style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:"pointer"}}>Réessayer</button>
        </div>
      )}
    </div>
  );
}

function BuyCoinsScreen({user,walletBalance,coinsBalance,onClose,onSuccess,showToast}){
  const [amount,setAmount]=useState(WALLET_TIERS[0]);
  const [busy,setBusy]=useState(false);
  const [err,setErr]=useState("");

  const coinsForAmount=(xaf)=>Math.round(xaf*COIN_RATE);

  async function buyCoins(){
    if(amount>walletBalance){setErr("Solde insuffisant. Recharge ton portefeuille d'abord.");return;}
    setBusy(true);setErr("");
    try{
      const result=await callRpc("buy_coins",{p_amount_xaf:amount,p_target_username:user.username});
      const coinsToAdd=result.coins_added;
      const newWallet=walletBalance-amount;
      const newCoins=coinsBalance+coinsToAdd;
      showToast&&showToast("✅ "+coinsToAdd+" Blue Coins ajoutés !");
      onSuccess&&onSuccess(newWallet,newCoins);
    }catch(e){
      setErr(e.message||"Échec de l'achat. Réessaie.");
    }
    setBusy(false);
  }

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:900,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12}}>
        <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1,display:"flex",alignItems:"center",gap:8}}><CoinIcon size={19}/> Obtenir des Blue Coins</span>
      </div>
      <div style={{padding:20}}>
        <div style={{background:C.w5,borderRadius:14,padding:16,border:"1px solid "+C.border,marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{color:C.w3,fontSize:12}}>Solde du portefeuille</div>
            <div style={{color:C.white,fontWeight:700,fontSize:16}}>{fmtUSD(walletBalance)}</div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{color:C.w3,fontSize:12}}>Blue Coins actuels</div>
            <div style={{color:"#f0b90b",fontWeight:700,fontSize:16,display:"flex",alignItems:"center",gap:5}}><CoinIcon size={16}/> {fmt(coinsBalance)}</div>
          </div>
        </div>

        <div style={{color:C.w3,fontSize:13,marginBottom:10,fontWeight:600}}>Choisis un montant à convertir</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10,marginBottom:18}}>
          {WALLET_TIERS.map(t=>(
            <button key={t} onClick={()=>setAmount(t)} style={{padding:"14px 10px",borderRadius:12,border:amount===t?"2px solid "+C.accent:"1px solid "+C.border,background:amount===t?C.accent+"22":C.w5,color:C.white,fontWeight:700,cursor:"pointer",textAlign:"center"}}>
              <div style={{fontSize:15,display:"flex",alignItems:"center",justifyContent:"center",gap:5}}><CoinIcon size={15}/> {fmt(coinsForAmount(t))}</div>
              <div style={{fontSize:11,color:C.w3,marginTop:2}}>{fmtUSD(t)}</div>
            </button>
          ))}
        </div>

        {err&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{err}</div>}

        <button onClick={buyCoins} disabled={busy} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:busy?"rgba(10,10,10,0.15)":"linear-gradient(135deg,#f0b90b,#d4a000)",color:"#000",fontWeight:800,fontSize:16,cursor:busy?"not-allowed":"pointer"}}>
          {busy?"...":"Obtenir "+fmt(coinsForAmount(amount))+" Blue Coins"}
        </button>
        <div style={{textAlign:"center",color:C.w3,fontSize:12,marginTop:10}}>Payé directement depuis ton solde — pas de nouveau paiement Mobile Money</div>
      </div>
    </div>
  );
}

function ConvertGiftCoins({user,giftCoinsBalance,onClose,onSuccess,showToast}){
  const [busy,setBusy]=useState(false);
  const fee=Math.round(giftCoinsBalance*0.30);
  const netCoins=giftCoinsBalance-fee;
  const netXaf=Math.round(netCoins/COIN_RATE);

  async function convert(){
    if(giftCoinsBalance<=0)return;
    setBusy(true);
    try{
      const result=await callRpc("convert_gift_coins",{p_target_username:user.username});
      showToast&&showToast("✅ "+fmtUSD(result.earnings_added)+" ajoutés à tes gains");
      onSuccess&&onSuccess(result.earnings_added);
      onClose();
    }catch(e){
      showToast&&showToast("⚠️ "+(e.message||"Échec de la conversion"));
    }
    setBusy(false);
  }

  return(
    <div style={{position:"fixed",inset:0,zIndex:960,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
      <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"20px 20px 32px",border:"1px solid "+C.border}}>
        <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"6px auto 18px"}}/>
        <div style={{textAlign:"center",marginBottom:18}}>
          <div style={{fontSize:36,marginBottom:8}}>🎁 → 💰</div>
          <div style={{fontWeight:700,fontSize:16,color:C.white}}>Convertir tes cadeaux reçus</div>
        </div>
        <div style={{background:C.w5,borderRadius:12,padding:14,marginBottom:16}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{color:C.w3,fontSize:13}}>Coins reçus en cadeaux</span><span style={{color:"#f0b90b",fontSize:13,display:"flex",alignItems:"center",gap:4}}><CoinIcon size={13}/> {fmt(giftCoinsBalance)}</span></div>
          <div style={{display:"flex",justifyContent:"space-between",paddingTop:8,borderTop:"1px solid "+C.border}}><span style={{color:C.white,fontWeight:700,fontSize:14}}>Ajouté à tes gains</span><span style={{color:C.accent2,fontWeight:800,fontSize:16}}>{fmtUSD(netXaf)}</span></div>
        </div>
        <button onClick={convert} disabled={busy||giftCoinsBalance<=0} style={{width:"100%",padding:"15px",borderRadius:14,border:"none",background:busy||giftCoinsBalance<=0?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:15,cursor:busy||giftCoinsBalance<=0?"not-allowed":"pointer"}}>
          {busy?"...":"Convertir maintenant"}
        </button>
      </div>
    </div>
  );
}

function ConvertPurchasedCoins({user,coinsBalance,onClose,onSuccess,showToast}){
  const [busy,setBusy]=useState(false);
  const fee=Math.round(coinsBalance*0.15);
  const netCoins=coinsBalance-fee;
  const netXaf=Math.round(netCoins/COIN_RATE);

  async function convert(){
    if(coinsBalance<=0)return;
    setBusy(true);
    try{
      const result=await callRpc("convert_purchased_coins",{p_target_username:user.username});
      showToast&&showToast("✅ "+fmtUSD(result.wallet_added)+" ajoutés à ton solde");
      onSuccess&&onSuccess(result.wallet_added);
      onClose();
    }catch(e){
      showToast&&showToast("⚠️ "+(e.message||"Échec de la conversion"));
    }
    setBusy(false);
  }

  return(
    <div style={{position:"fixed",inset:0,zIndex:960,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
      <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"20px 20px 32px",border:"1px solid "+C.border}}>
        <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"6px auto 18px"}}/>
        <div style={{textAlign:"center",marginBottom:18}}>
          <div style={{fontSize:36,marginBottom:8}}>🪙 → 💼</div>
          <div style={{fontWeight:700,fontSize:16,color:C.white}}>Reconvertir tes Blue Coins</div>
          <div style={{color:C.w3,fontSize:12,marginTop:4}}>Retour dans ton solde, moins les frais</div>
        </div>
        <div style={{background:C.w5,borderRadius:12,padding:14,marginBottom:16}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{color:C.w3,fontSize:13}}>Blue Coins achetés</span><span style={{color:"#f0b90b",fontSize:13,display:"flex",alignItems:"center",gap:4}}><CoinIcon size={13}/> {fmt(coinsBalance)}</span></div>
          <div style={{display:"flex",justifyContent:"space-between",paddingTop:8,borderTop:"1px solid "+C.border}}><span style={{color:C.white,fontWeight:700,fontSize:14}}>Ajouté à ton solde</span><span style={{color:C.accent2,fontWeight:800,fontSize:16}}>{fmtUSD(netXaf)}</span></div>
        </div>
        <button onClick={convert} disabled={busy||coinsBalance<=0} style={{width:"100%",padding:"15px",borderRadius:14,border:"none",background:busy||coinsBalance<=0?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:15,cursor:busy||coinsBalance<=0?"not-allowed":"pointer"}}>
          {busy?"...":"Reconvertir maintenant"}
        </button>
      </div>
    </div>
  );
}

function WithdrawEarnings({user,walletBalance,earningsBalance,onClose,onSuccess,showToast}){
  const [amount,setAmount]=useState("");
  const [momoChannel,setMomoChannel]=useState("cm.mtn");
  const [momoPhone,setMomoPhone]=useState("");
  const [busy,setBusy]=useState(false);
  const [err,setErr]=useState("");
  const [done,setDone]=useState(false);

  const totalAvailable=earningsBalance||0;
  const amountNum=Math.round((parseInt(amount,10)||0)*_xafPerUsd);
  const fee=Math.round(amountNum*0.05);
  const netAmount=amountNum-fee;

  async function submitWithdraw(){
    const minXaf=Math.round(1*_xafPerUsd);
    if(amountNum<minXaf){setErr("Montant minimum : "+fmtUSD(minXaf));return;}
    if(amountNum>totalAvailable){setErr("Solde insuffisant");return;}
    if(!momoPhone.trim()){setErr("Entre ton numéro Mobile Money");return;}
    setBusy(true);setErr("");
    let deducted=false;
    try{
      // The server decides how much comes from earnings vs wallet, checks
      // the balance is sufficient, and deducts atomically — the amount
      // below is only for display until the RPC confirms it.
      await callRpc("request_withdrawal",{p_amount_xaf:amountNum,p_phone:momoPhone.trim(),p_method:momoChannel,p_target_username:user.username});
      deducted=true;

      const payoutRes=await fetch(BLUELIFE_BACKEND_URL+"/api/camerpay-payout",{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({username:user.username,phone:momoPhone.trim(),amountXaf:netAmount,method:momoChannel})
      });
      const payoutData=await payoutRes.json().catch(()=>({}));
      if(!payoutRes.ok||!payoutData.success){
        await callRpc("reverse_withdrawal",{p_amount_xaf:amountNum,p_target_username:user.username}).catch(()=>{});
        setErr(payoutData.error||"Échec de la demande de retrait. Ton solde a été remis à son état initial.");
        setBusy(false);
        return;
      }
      setDone(true);
      onSuccess&&onSuccess(walletBalance||0,(earningsBalance||0)-amountNum);
    }catch(e){
      setErr(e.message||"Échec de la demande. Réessaie.");
    }
    setBusy(false);
  }

  if(done)return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:900,display:"flex",alignItems:"center",justifyContent:"center",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{textAlign:"center",padding:30}}>
        <div style={{fontSize:56,marginBottom:16}}>✅</div>
        <div style={{fontWeight:800,fontSize:19,color:C.white,marginBottom:10}}>Demande reçue</div>
        <div style={{color:C.w3,fontSize:14,lineHeight:1.6,marginBottom:24}}>Ta demande de retrait de {fmtUSD(netAmount)} vers ton {momoChannel==="cm.mtn"?"MTN MoMo":"Orange Money"} ({momoPhone}) a bien été envoyée. Chaque retrait passe par une vérification de sécurité qui prend généralement jusqu'à 24h, puis l'argent arrive sur ton compte en quelques minutes. Si c'est ton tout premier retrait, un délai de 7 jours supplémentaire s'applique, une seule fois.</div>
        <div style={{color:C.w3,fontSize:12,marginBottom:24}}>Frais de retrait (5%) déjà déduits du montant ci-dessus.</div>
        <button onClick={onClose} style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:"pointer"}}>Terminé</button>
      </div>
    </div>
  );

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:900,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12}}>
        <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>Retirer mon argent</span>
      </div>
      <div style={{padding:20}}>
        <div style={{background:C.w5,borderRadius:14,padding:16,border:"1px solid "+C.border,marginBottom:20,textAlign:"center"}}>
          <div style={{color:C.w3,fontSize:12,marginBottom:4}}>Gains disponibles pour retrait</div>
          <div style={{color:C.accent2,fontWeight:800,fontSize:24}}>{fmtUSD(totalAvailable)}</div>
          <div style={{color:C.w4,fontSize:11,marginTop:6}}>L'argent rechargé dans ton portefeuille n'est pas retirable — seuls tes gains le sont.</div>
        </div>

        <div style={{color:C.w3,fontSize:13,marginBottom:6,fontWeight:600}}>Montant à retirer</div>
        <input value={amount} onChange={e=>setAmount(e.target.value.replace(/[^0-9]/g,""))} placeholder="Montant en $" inputMode="numeric" style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>

        {amountNum>0&&(
          <div style={{background:C.accent+"11",borderRadius:12,padding:14,marginBottom:16}}>
            <div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:C.white,fontWeight:700,fontSize:14}}>Tu recevras</span><span style={{color:C.accent2,fontWeight:800,fontSize:16}}>{fmtUSD(netAmount)}</span></div>
          </div>
        )}

        <div style={{color:C.w3,fontSize:13,marginBottom:8,fontWeight:600}}>Recevoir sur</div>
        <div style={{display:"flex",gap:10,marginBottom:14}}>
          <button onClick={()=>setMomoChannel("cm.mtn")} style={{flex:1,padding:"14px 10px",borderRadius:12,border:momoChannel==="cm.mtn"?"2px solid "+C.accent:"1px solid "+C.border,background:momoChannel==="cm.mtn"?C.accent+"22":C.w5,color:C.white,fontWeight:700,cursor:"pointer",textAlign:"center"}}>MTN MoMo</button>
          <button onClick={()=>setMomoChannel("cm.orange")} style={{flex:1,padding:"14px 10px",borderRadius:12,border:momoChannel==="cm.orange"?"2px solid "+C.accent:"1px solid "+C.border,background:momoChannel==="cm.orange"?C.accent+"22":C.w5,color:C.white,fontWeight:700,cursor:"pointer",textAlign:"center"}}>Orange Money</button>
        </div>
        <input value={momoPhone} onChange={e=>setMomoPhone(e.target.value)} placeholder="+237 6xx xx xx xx" inputMode="tel" style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",marginBottom:18,boxSizing:"border-box"}}/>

        {err&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{err}</div>}

        <button onClick={submitWithdraw} disabled={busy} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:busy?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:busy?"not-allowed":"pointer"}}>
          {busy?"...":"Demander le retrait"}
        </button>
      </div>
    </div>
  );
}

function AdminFinanceScreen({onClose,username}){
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const [err,setErr]=useState("");

  useEffect(()=>{
    (async()=>{
      try{
        const res=await fetch(BLUELIFE_BACKEND_URL+"/api/admin-finance-summary?username="+encodeURIComponent(username));
        const rows=await res.json().catch(()=>null);
        if(Array.isArray(rows)&&rows[0])setData(rows[0]);
        else setErr("Aucune donnée — as-tu bien créé la vue platform_balance_summary ?");
      }catch(e){
        setErr("Impossible de charger les données financières");
      }
      setLoading(false);
    })();
  },[]);

  const xafPerCoin=500/70;
  const totalWallet=data?.total_wallet_xaf||0;
  const totalCoinsXaf=(data?.total_coins||0)*xafPerCoin;
  const totalGiftCoinsXaf=(data?.total_gift_coins||0)*xafPerCoin;
  const totalEarnings=data?.total_earnings_xaf||0;
  const totalOwedToUsers=totalWallet+totalCoinsXaf+totalGiftCoinsXaf+totalEarnings;
  const totalRecharged=data?.total_recharged_xaf||0;
  const totalWithdrawn=data?.total_withdrawn_xaf||0;
  const companyRevenue=totalRecharged-totalWithdrawn-totalOwedToUsers;

  const Row=({label,val,color,bold})=>(
    <div style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:"1px solid "+C.border}}>
      <span style={{color:bold?C.white:C.w3,fontSize:14,fontWeight:bold?700:400}}>{label}</span>
      <span style={{color:color||C.white,fontSize:14,fontWeight:bold?800:600}}>{fmtUSD(Math.round(val))}</span>
    </div>
  );

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:850,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12}}>
        <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>🏦 Finances de la plateforme</span>
      </div>

      <div style={{padding:20}}>
        {loading&&<div style={{textAlign:"center",color:C.w3,padding:30}}>⏳ Chargement...</div>}
        {err&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:14,color:"#f87171",fontSize:13}}>{err}</div>}

        {!loading&&!err&&data&&(
          <>
            <div style={{background:"rgba(46,204,113,0.1)",border:"1px solid rgba(46,204,113,0.3)",borderRadius:16,padding:18,marginBottom:20,textAlign:"center"}}>
              <div style={{color:C.w3,fontSize:12,marginBottom:6}}>Revenu de l'entreprise (estimé)</div>
              <div style={{fontWeight:800,fontSize:30,color:"#2ecc71"}}>{fmtUSD(Math.round(companyRevenue))}</div>
              <div style={{color:C.w3,fontSize:11,marginTop:6}}>Recharges − Retraits − Ce qui appartient encore aux utilisateurs</div>
            </div>

            <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:8}}>Appartient aux utilisateurs</div>
            <div style={{background:C.w5,borderRadius:14,padding:"4px 16px",marginBottom:20}}>
              <Row label="Solde portefeuille (non dépensé)" val={totalWallet}/>
              <Row label={<span style={{display:"flex",alignItems:"center",gap:5}}>Blue Coins achetés <CoinIcon size={12}/></span>} val={totalCoinsXaf}/>
              <Row label={<span style={{display:"flex",alignItems:"center",gap:5}}>Coins reçus en cadeaux <CoinIcon size={12}/></span>} val={totalGiftCoinsXaf}/>
              <Row label="Gains convertis (retirables)" val={totalEarnings}/>
              <Row label="Total détenu par les utilisateurs" val={totalOwedToUsers} color={C.accent2} bold/>
            </div>

            <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:8}}>Mouvements globaux (historique)</div>
            <div style={{background:C.w5,borderRadius:14,padding:"4px 16px",marginBottom:20}}>
              <Row label="Total rechargé (tout temps)" val={totalRecharged}/>
              <Row label="Total retiré (tout temps)" val={totalWithdrawn} color="#f87171"/>
            </div>

            <div style={{color:C.w3,fontSize:11,lineHeight:1.6,padding:"0 4px"}}>
              💡 Le solde réel sur ton compte Notchpay devrait correspondre à peu près à : Total rechargé − Total retiré. Ce qui n'appartient pas aux utilisateurs dans ce total, c'est ton revenu.
            </div>
          </>
        )}
      </div>
    </div>
  );
}


const BLUELIFE_BACKEND_URL = "https://blue-life-backend-production.up.railway.app";

let _xafPerUsd = 610;
let _rateLoaded = false;
async function loadDisplayRate(){
  try{
    const res=await fetch("https://open.er-api.com/v6/latest/USD");
    const data=await res.json();
    if(data && data.rates && data.rates.XAF){
      _xafPerUsd=data.rates.XAF;
      _rateLoaded=true;
    }
  }catch(e){
  }
}
function fmtUSD(xafAmount){
  const usd=(xafAmount||0)/_xafPerUsd;
  if(usd<1)return "$"+usd.toFixed(2);
  return "$"+usd.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2});
}

async function payViaCamerPay(kind,username,amountXaf,phone,email,extraData,onSuccess,onError){
  try{
    const res=await fetch(BLUELIFE_BACKEND_URL+"/api/camerpay-charge",{
      method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({kind,username,amountXaf,phone,email,extraData})
    });
    const data=await res.json().catch(()=>({}));
    if(!res.ok||!data.pay_url||!data.transaction_uuid){
      onError&&onError(data.error||"Échec de la création du paiement");
      return;
    }
    if(Capacitor.isNativePlatform()){
      await Browser.open({url:data.pay_url});
    }else{
      const paymentWindow=window.open(data.pay_url,"_blank");
      if(!paymentWindow){
        onError&&onError("Le navigateur a bloqué la fenêtre de paiement. Autorise les pop-ups pour Blue Life et réessaie.");
        return;
      }
    }
    for(let i=0;i<60;i++){
      await new Promise(r=>setTimeout(r,3000));
      const statusRes=await fetch(BLUELIFE_BACKEND_URL+"/api/camerpay-status/"+data.transaction_uuid).catch(()=>null);
      const statusData=statusRes?await statusRes.json().catch(()=>({})):{};
      if(statusData.status==="completed"){
        onSuccess&&onSuccess();
        return;
      }
      if(statusData.status==="failed"||statusData.status==="cancelled"){
        onError&&onError("Paiement annulé ou refusé.");
        return;
      }
    }
    onError&&onError("Paiement non confirmé après 3 minutes. S'il a bien été effectué, ton solde se mettra à jour automatiquement dès sa confirmation.");
  }catch(e){
    onError&&onError(e.message||"Erreur de connexion");
  }
}

async function fetchAgoraToken(channel,role,uid){
  const res=await fetch(BLUELIFE_BACKEND_URL+"/api/agora-token",{
    method:"POST",headers:{"Content-Type":"application/json"},
    body:JSON.stringify({channel,role,uid})
  });
  const data=await res.json().catch(()=>({}));
  if(!res.ok||!data.token)throw new Error(data.error||"Impossible d'obtenir le jeton de connexion au live");
  return data;
}

function LiveScreen({user,mode,streamUsername,onClose,showToast}){
  const [phase,setPhase]=useState("connecting");
  const [errorMsg,setErrorMsg]=useState("");
  const [viewerCount,setViewerCount]=useState(0);
  const [giftsTotal,setGiftsTotal]=useState(0);
  const [chatMessages,setChatMessages]=useState([]);
  const [chatInput,setChatInput]=useState("");
  const [showGift,setShowGift]=useState(false);
  const [streamId,setStreamId]=useState(null);
  const [muted,setMuted]=useState(false);
  const [cameraOff,setCameraOff]=useState(false);

  const localVideoRef=useRef(null);
  const remoteVideoRef=useRef(null);
  const clientRef=useRef(null);
  const tracksRef=useRef({mic:null,cam:null});
  const chatPollRef=useRef(null);
  const chatBottomRef=useRef(null);

  const channelName="bl_"+(mode==="broadcast"?user.username:streamUsername);
  const broadcaster=mode==="broadcast"?user.username:streamUsername;

  useEffect(()=>{
    let cancelled=false;
    let localStreamId=null;

    (async()=>{
      try{
        const mod=await import("agora-rtc-sdk-ng");
        const AgoraRTC=mod.default;
        const client=AgoraRTC.createClient({mode:"live",codec:"vp8"});
        clientRef.current=client;
        await client.setClientRole(mode==="broadcast"?"host":"audience");

        if(mode==="watch"){
          client.on("user-published",async(remoteUser,mediaType)=>{
            await client.subscribe(remoteUser,mediaType);
            if(mediaType==="video"&&remoteVideoRef.current)remoteUser.videoTrack.play(remoteVideoRef.current);
            if(mediaType==="audio")remoteUser.audioTrack.play();
          });
        }

        const {token,appId,uid}=await fetchAgoraToken(channelName,mode==="broadcast"?"host":"audience",0);
        if(cancelled)return;
        await client.join(appId,channelName,token,uid||null);

        if(mode==="broadcast"){
          const [micTrack,camTrack]=await AgoraRTC.createMicrophoneAndCameraTracks();
          tracksRef.current={mic:micTrack,cam:camTrack};
          if(localVideoRef.current)camTrack.play(localVideoRef.current);
          await client.publish([micTrack,camTrack]);

          const row=await db("/live_streams",{method:"POST",body:JSON.stringify({
            username:user.username,channel_name:channelName,title:"Live de @"+encodeURIComponent(user.username),status:"live"
          }),headers:{Prefer:"return=representation"}});
          if(Array.isArray(row)&&row[0]){localStreamId=row[0].id;setStreamId(row[0].id);}
        }else{
          const rows=await db("/live_streams?channel_name=eq."+channelName+"&status=eq.live&limit=1");
          if(Array.isArray(rows)&&rows[0]){
            localStreamId=rows[0].id;
            setStreamId(rows[0].id);
            setGiftsTotal(rows[0].gifts_received||0);
            const newCount=(rows[0].viewer_count||0)+1;
            setViewerCount(newCount);
            db("/live_streams?id=eq."+rows[0].id,{method:"PATCH",body:JSON.stringify({viewer_count:newCount})}).catch(()=>{});
          }else{
            if(!cancelled){setPhase("ended");}
            return;
          }
        }

        if(!cancelled)setPhase("live");
      }catch(e){
        if(!cancelled){setPhase("error");setErrorMsg(e.message||"Connexion au live impossible");}
      }
    })();

    return()=>{
      cancelled=true;
      const client=clientRef.current;
      const{mic,cam}=tracksRef.current;
      if(mic)mic.close();
      if(cam)cam.close();
      if(client)client.leave().catch(()=>{});
      if(chatPollRef.current)clearInterval(chatPollRef.current);
      if(mode==="watch"&&localStreamId){
        db("/live_streams?id=eq."+localStreamId+"&select=viewer_count&limit=1").then(rows=>{
          if(Array.isArray(rows)&&rows[0]){
            const newCount=Math.max(0,(rows[0].viewer_count||1)-1);
            db("/live_streams?id=eq."+localStreamId,{method:"PATCH",body:JSON.stringify({viewer_count:newCount})}).catch(()=>{});
          }
        }).catch(()=>{});
      }
    };
  },[]);

  useEffect(()=>{
    if(!streamId)return;
    async function poll(){
      const rows=await db("/live_chat_messages?stream_id=eq."+streamId+"&order=created_at.asc&limit=200").catch(()=>[]);
      if(Array.isArray(rows)){
        setChatMessages(rows);
        chatBottomRef.current&&chatBottomRef.current.scrollIntoView({behavior:"smooth"});
      }
    }
    poll();
    chatPollRef.current=setInterval(poll,2500);
    return()=>clearInterval(chatPollRef.current);
  },[streamId]);

  async function sendChat(){
    if(!chatInput.trim()||!streamId)return;
    const msg=chatInput.trim();
    setChatInput("");
    setChatMessages(m=>[...m,{username:user.username,message:msg,type:"chat",created_at:new Date().toISOString()}]);
    await db("/live_chat_messages",{method:"POST",body:JSON.stringify({stream_id:streamId,username:user.username,message:msg,type:"chat"})}).catch(()=>{});
  }

  async function endLive(){
    const client=clientRef.current;
    const{mic,cam}=tracksRef.current;
    if(mic)mic.close();
    if(cam)cam.close();
    if(client)await client.leave().catch(()=>{});
    if(streamId)await db("/live_streams?id=eq."+streamId,{method:"PATCH",body:JSON.stringify({status:"ended",ended_at:new Date().toISOString()})}).catch(()=>{});
    onClose&&onClose();
  }

  function toggleMute(){
    const{mic}=tracksRef.current;
    if(mic){mic.setMuted(!muted);setMuted(!muted);}
  }
  function toggleCamera(){
    const{cam}=tracksRef.current;
    if(cam){cam.setMuted(!cameraOff);setCameraOff(!cameraOff);}
  }

  return(
    <div style={{position:"fixed",inset:0,background:"#000",zIndex:970,maxWidth:480,margin:"0 auto",overflow:"hidden",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      {phase==="connecting"&&(
        <div style={{height:"100%",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column"}}>
          <div style={{fontSize:48,marginBottom:16,animation:"spin 1s linear infinite"}}>⏳</div>
          <div style={{color:"#fff",fontWeight:700}}>Connexion au live...</div>
        </div>
      )}

      {phase==="ended"&&(
        <div style={{height:"100%",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",padding:20,textAlign:"center"}}>
          <div style={{fontSize:48,marginBottom:16}}>📴</div>
          <div style={{color:"#fff",fontWeight:700,marginBottom:20}}>Ce live est terminé</div>
          <button onClick={onClose} style={{padding:"12px 24px",borderRadius:12,border:"none",background:C.accent,color:"#fff",fontWeight:700,cursor:"pointer"}}>Fermer</button>
        </div>
      )}

      {phase==="error"&&(
        <div style={{height:"100%",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",padding:20,textAlign:"center"}}>
          <div style={{fontSize:48,marginBottom:16}}>❌</div>
          <div style={{color:"#fff",fontWeight:700,marginBottom:8}}>Connexion impossible</div>
          <div style={{color:"#999",fontSize:13,marginBottom:20}}>{errorMsg}</div>
          <button onClick={onClose} style={{padding:"12px 24px",borderRadius:12,border:"none",background:C.accent,color:"#fff",fontWeight:700,cursor:"pointer"}}>Fermer</button>
        </div>
      )}

      {phase==="live"&&(
        <>
          <div ref={mode==="broadcast"?localVideoRef:remoteVideoRef} style={{position:"absolute",inset:0,background:"#111"}}/>

          <div style={{position:"absolute",top:0,left:0,right:0,padding:"16px 14px",display:"flex",alignItems:"center",gap:8,background:"linear-gradient(180deg,rgba(0,0,0,0.65),transparent)"}}>
            <div style={{display:"flex",alignItems:"center",gap:6,background:"#ff3040",borderRadius:20,padding:"4px 10px"}}>
              <div style={{width:6,height:6,borderRadius:"50%",background:"#fff"}}/>
              <span style={{color:"#fff",fontSize:12,fontWeight:800}}>LIVE</span>
            </div>
            {mode==="watch"&&<span style={{color:"#fff",fontWeight:700,fontSize:13}}>@{broadcaster}</span>}
            <div style={{display:"flex",alignItems:"center",gap:5,background:"rgba(0,0,0,0.4)",borderRadius:20,padding:"4px 10px"}}>
              <span style={{fontSize:12}}>👁️</span>
              <span style={{color:"#fff",fontSize:12,fontWeight:600}}>{fmt(viewerCount)}</span>
            </div>
            {giftsTotal>0&&(
              <div style={{display:"flex",alignItems:"center",gap:5,background:"rgba(0,0,0,0.4)",borderRadius:20,padding:"4px 10px"}}>
                <span style={{fontSize:12}}>🎁</span>
                <span style={{color:"#f0b90b",fontSize:12,fontWeight:600}}>{fmt(giftsTotal)}</span>
              </div>
            )}
            <div style={{flex:1}}/>
            <button onClick={mode==="broadcast"?endLive:onClose} style={{background:"rgba(0,0,0,0.4)",border:"none",borderRadius:20,padding:"6px 14px",color:"#fff",fontWeight:700,fontSize:12,cursor:"pointer"}}>
              {mode==="broadcast"?"Terminer":"Quitter"}
            </button>
          </div>

          <div style={{position:"absolute",bottom:0,left:0,right:0}}>
            <div style={{maxHeight:210,overflowY:"auto",padding:"8px 14px",display:"flex",flexDirection:"column",gap:6}}>
              {chatMessages.slice(-40).map((m,i)=>(
                <div key={i} style={{fontSize:13,color:"#fff",textShadow:"0 1px 3px rgba(0,0,0,0.9)"}}>
                  <span style={{fontWeight:700,color:m.type==="gift"?"#f0b90b":"#5ec2ff"}}>{m.type==="gift"?"🎁 ":""}@{m.username}</span> {m.message}
                </div>
              ))}
              <div ref={chatBottomRef}/>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:8,padding:"10px 14px 18px",background:"linear-gradient(0deg,rgba(0,0,0,0.55),transparent)"}}>
              <input value={chatInput} onChange={e=>setChatInput(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")sendChat();}} placeholder="Dire quelque chose..." style={{flex:1,padding:"10px 14px",borderRadius:20,border:"1px solid rgba(255,255,255,0.3)",background:"rgba(0,0,0,0.4)",color:"#fff",fontSize:14,outline:"none"}}/>
              {mode==="watch"&&(
                <button onClick={()=>setShowGift(true)} style={{background:"none",border:"none",cursor:"pointer",padding:0}}>
                  <span style={{fontSize:28}}>🎁</span>
                </button>
              )}
              {mode==="broadcast"&&(
                <>
                  <button onClick={toggleMute} style={{background:"rgba(0,0,0,0.4)",border:"none",borderRadius:"50%",width:38,height:38,color:"#fff",cursor:"pointer",fontSize:16}}>{muted?"🔇":"🎤"}</button>
                  <button onClick={toggleCamera} style={{background:"rgba(0,0,0,0.4)",border:"none",borderRadius:"50%",width:38,height:38,color:"#fff",cursor:"pointer",fontSize:16}}>{cameraOff?"📷":"📹"}</button>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {showGift&&streamId&&(
        <GiftSheet
          post={{id:streamId,username:broadcaster,gifts_received:giftsTotal}}
          user={user}
          targetTable="live_streams"
          onClose={()=>setShowGift(false)}
          showToast={showToast}
          onGiftSent={(newTotal)=>{
            setGiftsTotal(newTotal);
            db("/live_chat_messages",{method:"POST",body:JSON.stringify({stream_id:streamId,username:user.username,message:"a envoyé un cadeau",type:"gift"})}).catch(()=>{});
          }}
          onRequireAuth={()=>{}}
        />
      )}
    </div>
  );
}

function BoostModal({post,user,onClose,showToast}){
  const [step,setStep]=useState(1);
  const [goal,setGoal]=useState("profile");
  const [audience,setAudience]=useState("auto");
  const [budget,setBudget]=useState(2000);
  const [duration,setDuration]=useState(3);
  const [loading,setLoading]=useState(false);

  const [targetCountries,setTargetCountries]=useState([]);
  const [targetCity,setTargetCity]=useState("");
  const [countrySearch,setCountrySearch]=useState("");
  const [ageMin,setAgeMin]=useState(18);
  const [ageMax,setAgeMax]=useState(65);

  function toggleCountry(c){
    setTargetCountries(prev=>prev.includes(c)?prev.filter(x=>x!==c):[...prev,c]);
  }

  const total=budget;
  const reach=Math.floor((total/2000)*65000);

  const [showPayment,setShowPayment]=useState(false);
  const [payMethod,setPayMethod]=useState("visa");
  const [cardNumber,setCardNumber]=useState("");
  const [cardExpiry,setCardExpiry]=useState("");
  const [cardCvc,setCardCvc]=useState("");
  const [cardName,setCardName]=useState("");
  const [paying,setPaying]=useState(false);
  const [payStep,setPayStep]=useState("form");
  const [payError,setPayError]=useState("");
  const [pendingRef,setPendingRef]=useState("");
  const [notchpayRef,setNotchpayRef]=useState("");
  const [momoChannel,setMomoChannel]=useState("cm.mtn");
  const [momoPhone,setMomoPhone]=useState("");
  const [charging,setCharging]=useState(false);
  const [cmSelected,setCmSelected]=useState(false);
  const [walletBalance,setWalletBalance]=useState(null);

  useEffect(()=>{
    if(payStep!=="selectMethod"||!user||!user.username)return;
    db("/profiles?username=eq."+encodeURIComponent(user.username)+"&select=wallet_balance&limit=1").then(d=>{
      if(Array.isArray(d)&&d[0])setWalletBalance(d[0].wallet_balance||0);
    }).catch(()=>{});
  },[payStep]);

  async function payWithWallet(){
    setCharging(true);setPayError("");
    try{
      await callRpc("spend_wallet",{p_amount_xaf:total,p_description:"Boost "+duration+" jours",p_target_username:user.username});
      await finalizeBoost(pendingRef,{reference:pendingRef});
      showToast&&showToast("✅ Boost activé avec ton solde !");
    }catch(e){
      setPayError(e.message||"Échec du paiement par solde. Réessaie.");
    }
    setCharging(false);
  }

  async function handleBoost(){
    if(step===2&&audience==="custom"&&targetCountries.length===0){
      showToast&&showToast("⚠️ Choisis au moins un pays pour ton audience");
      return;
    }
    if(step<4){setStep(s=>s+1);return;}
    setShowPayment(true);
  }

  async function processPayment(){
    setPaying(true);setPayStep("processing");setPayError("");
    const ref="sponsor_"+post.id+"_"+Date.now();

    try{
      const res=await fetch(BLUELIFE_BACKEND_URL+"/api/pay-initiate",{
        method:"POST",
        cache:"no-store",
        headers:{
          "Content-Type":"application/json",
          "Accept":"application/json"
        },
        body:JSON.stringify({
          amount:total,
          currency:"XAF",
          email:user.email||user.username+"@bluelife.app",
          description:"Sponsoring Blue Life - "+duration+" jours - @"+user.username
        })
      });

      let data={};
      try{
        const rawText=await res.text();
        data=rawText?JSON.parse(rawText):{};
      }catch{
        setPayStep("error");
        setPayError("Le serveur de paiement n'a pas répondu correctement. Réessaie dans quelques instants.");
        setPaying(false);
        return;
      }

      if(!res.ok||!data.transaction?.reference){
        console.error("Notchpay raw response (status "+res.status+"): "+JSON.stringify(data));
        const reason=data?.message||data?.error||
          (res.status===401?"Clé de paiement invalide ou expirée":
           "Impossible d'initialiser le paiement");
        setPayStep("error");
        setPayError(reason+" (code "+res.status+")");
        setPaying(false);
        return;
      }

      await db("/sponsored_posts",{method:"POST",body:JSON.stringify({
        post_id:post.id,username:user.username,amount:total,
        duration_days:duration,status:"pending",reference:ref,
        expires_at:new Date(Date.now()+duration*86400000).toISOString(),
        target_countries:audience==="custom"?targetCountries.join(","):"",
        target_city:audience==="custom"?targetCity:"",
        age_min:audience==="custom"?ageMin:18,
        age_max:audience==="custom"?ageMax:65,
        target_reach:reach
      })}).catch(()=>{});

      setPendingRef(ref);
      setNotchpayRef(data.transaction.reference);
      setPayStep("selectMethod");
      setPaying(false);
    }catch(e){
      setPayStep("error");
      const isNetwork=e.message&&(e.message.toLowerCase().includes("load failed")||e.message.toLowerCase().includes("fetch")||e.message.toLowerCase().includes("network"));
      setPayError(isNetwork
        ?"Connexion au serveur de paiement impossible. Vérifie ta connexion internet et réessaie."
        :("Erreur inattendue: "+e.message));
    }
  }

  async function finalizeBoost(ref,transaction){
    await db("/sponsored_posts?reference=eq."+ref,{method:"PATCH",body:JSON.stringify({status:"active"}),headers:{Prefer:"return=minimal"}}).catch(()=>{});
    await db("/Posts?id=eq."+post.id,{method:"PATCH",body:JSON.stringify({sponsored:true,sponsor_reach_target:reach}),headers:{Prefer:"return=minimal"}});

    const targetSummary=audience==="custom"
      ?(targetCountries.join(", ")||"Tous pays")+(targetCity?(" · "+targetCity):"")+" · "+ageMin+"-"+ageMax+" ans"
      :"Audience suggérée (similaire à tes abonnés)";
    const goalLabel=goal==="profile"?"Visites de profil":goal==="website"?"Visiter votre site":goal==="message"?"Vous envoyer un message":"Mélange d'actions";
    const receipt="🎯 Objectif: "+goalLabel+"\n👥 Audience: "+targetSummary+"\n📅 Durée: "+duration+" jours\n💰 Montant débité: "+fmtUSD(total)+"\n📈 Portée estimée: "+fmt(reach)+" - "+fmt(Math.floor(reach*1.85))+" personnes\n🔖 Référence: "+ref;

    await db("/notifications",{method:"POST",body:JSON.stringify({
      receiver:user.username,sender:"Blue Life",type:"boost_confirmed",post_id:post.id,seen:false,
      message:"✅ Boost confirmé ! "+fmtUSD(total)+" débités.\n\n"+receipt
    })}).catch(()=>{});

    setPayStep("success");
  }

  const [cardBusy,setCardBusy]=useState(false);
  const [cardError,setCardError]=useState("");
  async function payCardViaPaddle(){
    setCardError("");
    setCardBusy(true);
    await payViaCamerPay(
      "boost",(user.username||"").trim(),total,null,user.email,{postId:post.id,days:String(duration),reach:String(reach)},
      async ()=>{
        showToast&&showToast("⏳ Confirmation du paiement...");
        for(let i=0;i<15;i++){
          await new Promise(r=>setTimeout(r,2000));
          const res=await db("/Posts?id=eq."+post.id+"&select=sponsored").catch(()=>null);
          if(res&&res[0]&&res[0].sponsored){
            setPayStep("success");
            setCardBusy(false);
            return;
          }
        }
        setCardError("Paiement confirmé mais pas encore synchronisé côté Blue Life. Réessaie de vérifier dans un instant.");
        setCardBusy(false);
      },
      (msg)=>{setCardError(msg);setCardBusy(false);}
    );
  }


  const goals=[
    {id:"profile",icon:"👤",title:"Visites de profil",desc:"Idéal pour gagner des abonnés"},
    {id:"website",icon:"🌐",title:"Visiter votre site",desc:"Idéal pour stimuler les ventes"},
    {id:"message",icon:"💬",title:"Vous envoyer un message",desc:"Idéal pour la relation client"},
    {id:"mix",icon:"🎯",title:"Mélange d'actions",desc:"Améliore plusieurs objectifs"},
  ];

  const audiences=[
    {id:"auto",icon:"✨",title:"Audience suggérée",desc:"Personnes similaires à vos followers"},
    {id:"custom",icon:"🎯",title:"Créer votre audience",desc:"Définissez l'âge, lieu, intérêts"},
  ];

  return(
    <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",flexDirection:"column",background:C.navy,maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"14px 16px",borderBottom:"1px solid "+C.border}}>
        <button onClick={step>1?()=>setStep(s=>s-1):onClose} style={{background:"none",border:"none",cursor:"pointer",color:C.white,marginRight:12}}>{step>1?<I.Back/>:<I.X/>}</button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>
          {step===1?"Objectif":step===2?"Audience":step===3?"Budget et durée":"Vérifier"}
        </span>
      </div>

      <div style={{display:"flex",gap:3,padding:"10px 16px"}}>
        {[1,2,3,4].map(s=>(
          <div key={s} style={{flex:1,height:3,borderRadius:2,background:s<=step?"linear-gradient(135deg,"+C.orange+","+C.purple+")":C.w4}}/>
        ))}
      </div>

      <div style={{flex:1,overflowY:"auto",padding:"16px"}}>
        {step===1&&(
          <>
            <div style={{textAlign:"center",marginBottom:24}}>
              <div style={{fontWeight:800,fontSize:20,color:C.white,marginBottom:8}}>Quelles actions voulez-vous encourager ?</div>
            </div>
            {goals.map(g=>(
              <div key={g.id} onClick={()=>setGoal(g.id)} style={{display:"flex",alignItems:"center",gap:14,padding:"14px",background:goal===g.id?C.accent+"22":C.w5,borderRadius:14,marginBottom:10,cursor:"pointer",border:"2px solid "+(goal===g.id?C.accent:C.border)}}>
                <div style={{fontSize:28}}>{g.icon}</div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,fontSize:15,color:C.white}}>{g.title}</div>
                  <div style={{fontSize:12,color:C.w3,marginTop:2}}>{g.desc}</div>
                </div>
                <div style={{width:20,height:20,borderRadius:"50%",border:"2px solid "+(goal===g.id?C.accent:C.w3),background:goal===g.id?C.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center"}}>
                  {goal===g.id&&<div style={{width:8,height:8,borderRadius:"50%",background:C.white}}/>}
                </div>
              </div>
            ))}
          </>
        )}

        {step===2&&(
          <>
            <div style={{textAlign:"center",marginBottom:24}}>
              <div style={{fontWeight:800,fontSize:20,color:C.white,marginBottom:8}}>Qui doit voir votre publicité ?</div>
            </div>
            {audiences.map(a=>(
              <div key={a.id} onClick={()=>setAudience(a.id)} style={{display:"flex",alignItems:"center",gap:14,padding:"16px",background:audience===a.id?C.accent+"22":C.w5,borderRadius:14,marginBottom:10,cursor:"pointer",border:"2px solid "+(audience===a.id?C.accent:C.border)}}>
                <div style={{fontSize:28}}>{a.icon}</div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,fontSize:15,color:C.white}}>{a.title}</div>
                  <div style={{fontSize:12,color:C.w3,marginTop:2}}>{a.desc}</div>
                </div>
                <div style={{width:20,height:20,borderRadius:"50%",border:"2px solid "+(audience===a.id?C.accent:C.w3),background:audience===a.id?C.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center"}}>
                  {audience===a.id&&<div style={{width:8,height:8,borderRadius:"50%",background:C.white}}/>}
                </div>
              </div>
            ))}

            {audience==="custom"&&(
              <div style={{marginTop:20,padding:16,background:C.w5,borderRadius:14,border:"1px solid "+C.border}}>
                <div style={{fontWeight:700,fontSize:14,color:C.white,marginBottom:12}}>🌍 Localisation</div>

                <div style={{fontSize:12,color:C.w3,marginBottom:6}}>Pays ciblés ({targetCountries.length} sélectionné{targetCountries.length>1?"s":""})</div>
                <input
                  value={countrySearch}
                  onChange={e=>setCountrySearch(e.target.value)}
                  placeholder="Rechercher un pays..."
                  style={{width:"100%",padding:"10px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:14,outline:"none",marginBottom:10,boxSizing:"border-box"}}
                />

                {targetCountries.length>0&&(
                  <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:10}}>
                    {targetCountries.map(c=>(
                      <div key={c} onClick={()=>toggleCountry(c)} style={{display:"flex",alignItems:"center",gap:6,padding:"5px 10px",background:C.accent+"33",border:"1px solid "+C.accent,borderRadius:20,fontSize:12,color:"#fff",cursor:"pointer"}}>
                        {c} <span style={{fontWeight:800}}>×</span>
                      </div>
                    ))}
                  </div>
                )}

                <div style={{maxHeight:180,overflowY:"auto",border:"1px solid "+C.border,borderRadius:10,marginBottom:14}}>
                  {WORLD_COUNTRIES
                    .filter(c=>c.toLowerCase().includes(countrySearch.toLowerCase()))
                    .slice(0,30)
                    .map(c=>(
                      <div key={c} onClick={()=>toggleCountry(c)} style={{padding:"10px 14px",borderBottom:"1px solid "+C.border,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",background:targetCountries.includes(c)?C.accent+"15":"transparent"}}>
                        <span style={{fontSize:13,color:C.white}}>{c}</span>
                        {targetCountries.includes(c)&&<span style={{color:C.accent2,fontWeight:800}}>✓</span>}
                      </div>
                    ))
                  }
                </div>

                <div style={{fontSize:12,color:C.w3,marginBottom:6}}>Ville (optionnel)</div>
                <input
                  value={targetCity}
                  onChange={e=>setTargetCity(e.target.value)}
                  placeholder="Ex: Douala, Yaoundé, Paris..."
                  style={{width:"100%",padding:"10px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:14,outline:"none",marginBottom:16,boxSizing:"border-box"}}
                />

                <div style={{fontWeight:700,fontSize:14,color:C.white,marginBottom:12}}>🎂 Tranche d'âge</div>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
                  <input type="number" value={ageMin} onChange={e=>setAgeMin(Math.max(13,Math.min(Number(e.target.value)||13,ageMax)))} style={{width:70,padding:"8px 10px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:14,outline:"none",textAlign:"center"}}/>
                  <span style={{color:C.w3,fontSize:13}}>à</span>
                  <input type="number" value={ageMax} onChange={e=>setAgeMax(Math.min(65,Math.max(Number(e.target.value)||65,ageMin)))} style={{width:70,padding:"8px 10px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:14,outline:"none",textAlign:"center"}}/>
                  <span style={{color:C.w3,fontSize:13}}>ans</span>
                </div>

                {targetCountries.length===0&&(
                  <div style={{marginTop:14,fontSize:12,color:"#f59e0b"}}>⚠️ Choisis au moins un pays pour continuer</div>
                )}
              </div>
            )}
          </>
        )}

        {step===3&&(
          <>
            <div style={{textAlign:"center",marginBottom:24}}>
              <div style={{fontWeight:800,fontSize:20,color:C.white,marginBottom:8}}>Quel est votre budget ?</div>
              <div style={{fontSize:13,color:C.w3}}>En dollars américains (USD)</div>
            </div>
            <div style={{background:C.w5,borderRadius:16,padding:20,marginBottom:16,border:"1px solid "+C.border}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <span style={{color:C.white,fontWeight:600}}>Budget total</span>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <input type="number" value={budget} onChange={e=>setBudget(Math.max(2000,parseInt(e.target.value)||2000))} style={{width:120,padding:"8px 10px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:15,fontWeight:700,outline:"none",textAlign:"center"}}/>
                  <span style={{color:C.w3,fontSize:14,fontWeight:600}}>$</span>
                </div>
              </div>
              <input type="range" min="2000" max="1500000" step="1000" value={budget} onChange={e=>setBudget(parseInt(e.target.value))} style={{width:"100%",accentColor:C.accent}}/>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:C.w3,marginTop:4}}>
                <span>{fmtUSD(2000)}</span><span>{fmtUSD(1500000)}</span>
              </div>
            </div>
            <div style={{background:C.w5,borderRadius:16,padding:20,marginBottom:16,border:"1px solid "+C.border}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <span style={{color:C.white,fontWeight:600}}>Durée (jours)</span>
                <input type="number" value={duration} onChange={e=>setDuration(Math.max(1,Math.min(30,parseInt(e.target.value)||1)))} style={{width:70,padding:"8px 10px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:16,fontWeight:700,outline:"none",textAlign:"center"}}/>
              </div>
              <input type="range" min="1" max="30" value={duration} onChange={e=>setDuration(parseInt(e.target.value))} style={{width:"100%",accentColor:C.accent}}/>
            </div>
            <div style={{background:C.accent+"11",borderRadius:14,padding:16,border:"1px solid "+C.border2}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                <span style={{color:C.w3,fontSize:14}}>Budget publicitaire</span>
                <span style={{color:C.white,fontWeight:700,fontSize:14}}>${total} sur {duration} jours</span>
              </div>
              <div style={{display:"flex",justifyContent:"space-between"}}>
                <span style={{color:C.w3,fontSize:14}}>Portée estimée</span>
                <span style={{color:C.accent2,fontWeight:700,fontSize:14}}>{fmt(reach)} - {fmt(reach*2)} personnes</span>
              </div>
            </div>
          </>
        )}

        {step===4&&(
          <>
            <div style={{textAlign:"center",marginBottom:24}}>
              <div style={{fontWeight:800,fontSize:20,color:C.white,marginBottom:8}}>Tout vous semble correct ?</div>
            </div>
            <div style={{borderRadius:14,overflow:"hidden",marginBottom:16,border:"1px solid "+C.border}}>
              <img src={post.image} alt="" style={{width:"100%",aspectRatio:"1/1",objectFit:"cover",maxHeight:200}}/>
            </div>
            {[
              ["Objectif",goals.find(g=>g.id===goal)?.title||goal],
              ["Audience",audiences.find(a=>a.id===audience)?.title||audience],
              ["Budget",fmtUSD(total)+" sur "+duration+" jours"],
              ["Portée estimée",fmt(reach)+" - "+fmt(Math.floor(reach*1.85))+" personnes"],
            ].map(([k,v],i)=>(
              <div key={i} style={{padding:"14px 0",borderBottom:"1px solid "+C.border}}>
                <div style={{color:C.w3,fontSize:13,marginBottom:4}}>{k}</div>
                <div style={{color:C.white,fontWeight:600,fontSize:15}}>{v}</div>
              </div>
            ))}
            <div style={{background:C.w5,borderRadius:14,padding:14,marginTop:16,border:"1px solid "+C.border}}>
              <div style={{color:C.w3,fontSize:13,marginBottom:4}}>Moyen de paiement</div>
              <div style={{color:C.white,fontWeight:600}}>Notchpay / Mobile Money</div>
              <div style={{color:C.w3,fontSize:12,marginTop:4}}>Les publicités sont examinées dans un délai de 24h</div>
            </div>
          </>
        )}
      </div>

      <div style={{padding:"14px 16px 32px",borderTop:"1px solid "+C.border}}>
        <button onClick={step<4?()=>setStep(s=>s+1):()=>setShowPayment(true)} disabled={loading} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:loading?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:loading?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
          {loading?<><I.Spin/> Traitement...</>:step<4?"Suivant →":(<><I.Rocket/> Lancer la publicité</>)}
        </button>
        {step===4&&<div style={{textAlign:"center",marginTop:10,fontSize:11,color:C.w3}}>En continuant, vous acceptez les conditions publicitaires Blue Life 🔒</div>}
      </div>

      {showPayment&&(
        <div style={{position:"fixed",inset:0,background:C.navy,zIndex:1000,maxWidth:480,margin:"0 auto",display:"flex",flexDirection:"column",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
          <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border}}>
            <button onClick={()=>{if(payStep==="form")setShowPayment(false);else{setPayStep("form");setPaying(false);}}} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
            <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>💳 Paiement</span>
          </div>

          <div style={{flex:1,overflowY:"auto",padding:20}}>
            {payStep==="form"&&(
              <>
                <div style={{background:C.accent+"22",borderRadius:16,padding:16,marginBottom:20,border:"1px solid "+C.border2,textAlign:"center"}}>
                  <div style={{fontSize:28,fontWeight:800,color:C.white,marginBottom:4}}>{fmtUSD(total)}</div>
                  <div style={{color:C.w3,fontSize:13}}>Boost {duration} jours · ~{fmt(reach)} à {fmt(Math.floor(reach*1.85))} personnes</div>
                </div>

                <div style={{textAlign:"center",padding:"20px 10px"}}>
                  <div style={{fontSize:44,marginBottom:14}}>🔒</div>
                  <div style={{fontWeight:700,fontSize:16,color:C.white,marginBottom:8}}>Paiement sécurisé via CamerPay</div>
                  <div style={{color:C.w3,fontSize:13,lineHeight:1.6}}>
                    Choisis Mobile Money, carte bancaire ou PayPal sur l'écran suivant. Personne — pas même Blue Life — ne voit jamais tes informations de paiement.
                  </div>
                </div>

                {payError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{payError}</div>}

                <div style={{background:C.w5,borderRadius:12,padding:14,marginBottom:16,border:"1px solid "+C.border}}>
                  <div style={{fontSize:12,color:C.w3,lineHeight:1.6}}>
                    🔒 Paiement sécurisé via CamerPay<br/>
                    📱 Mobile Money · Carte bancaire · PayPal<br/>
                    ⚡ Activation immédiate après confirmation
                  </div>
                </div>
              </>
            )}

            {payStep==="processing"&&(
              <div style={{textAlign:"center",padding:60}}>
                <div style={{fontSize:48,marginBottom:16,animation:"spin 1s linear infinite",display:"inline-block"}}>⏳</div>
                <div style={{fontWeight:700,fontSize:18,color:C.white,marginBottom:8}}>Initialisation du paiement...</div>
              </div>
            )}

            {payStep==="selectMethod"&&(
              <>
                <div style={{background:C.accent+"22",borderRadius:16,padding:16,marginBottom:20,border:"1px solid "+C.border2,textAlign:"center"}}>
                  <div style={{fontSize:28,fontWeight:800,color:C.white,marginBottom:4}}>{fmtUSD(total)}</div>
                  <div style={{color:C.w3,fontSize:13}}>Boost {duration} jours · ~{fmt(reach)} à {fmt(Math.floor(reach*1.85))} personnes</div>
                </div>

                {walletBalance!==null&&(
                  <button onClick={payWithWallet} disabled={charging||walletBalance<total} style={{width:"100%",padding:"14px",borderRadius:14,border:"1px solid "+(walletBalance>=total?C.accent:C.border),background:walletBalance>=total?C.accent+"22":C.w5,color:walletBalance>=total?C.white:C.w3,fontWeight:700,fontSize:14,cursor:(charging||walletBalance<total)?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:14}}>
                    💼 Payer avec mon solde ({fmtUSD(walletBalance)})
                  </button>
                )}
                <div style={{textAlign:"center",color:C.w3,fontSize:12,marginBottom:14}}>— ou —</div>

                {cardError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:10}}>{cardError}</div>}
                <button onClick={cardBusy?undefined:payCardViaPaddle} disabled={cardBusy} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:cardBusy?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:cardBusy?"not-allowed":"pointer"}}>
                  {cardBusy?"⏳ Confirmation en cours...":"Payer "+fmtUSD(total)}
                </button>
                <div style={{color:C.w3,fontSize:12,textAlign:"center",marginTop:12}}>Mobile Money (Orange, MTN), carte bancaire ou PayPal — choisis sur l'écran suivant.</div>
              </>
            )}

            {payStep==="error"&&(
              <div style={{textAlign:"center",padding:"40px 10px"}}>
                <div style={{fontSize:56,marginBottom:16}}>❌</div>
                <div style={{fontWeight:800,fontSize:19,color:C.white,marginBottom:10}}>Paiement échoué</div>
                <div style={{color:"#f87171",fontSize:13,marginBottom:24}}>{payError}</div>
                <button onClick={()=>setPayStep("selectMethod")} style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:"pointer"}}>Réessayer</button>
              </div>
            )}

{payStep==="success"&&(
              <div style={{textAlign:"center",padding:"30px 20px"}}>
                <div style={{fontSize:64,marginBottom:16}}>✅</div>
                <div style={{fontWeight:800,fontSize:22,color:C.white,marginBottom:8}}>Paiement réussi !</div>
                <div style={{color:C.w3,fontSize:14,marginBottom:20}}>Une notification de confirmation t'a été envoyée</div>
                <div style={{background:C.w5,borderRadius:14,padding:18,border:"1px solid "+C.border,textAlign:"left"}}>
                  <div style={{fontWeight:700,fontSize:14,color:C.white,marginBottom:12,textAlign:"center"}}>📋 Récapitulatif du boost</div>
                  {[
                    {lb:"Objectif",val:goal==="profile"?"Visites de profil":goal==="website"?"Visiter votre site":goal==="message"?"Vous envoyer un message":"Mélange d'actions"},
                    {lb:"Audience",val:audience==="auto"?"Audience suggérée":"Audience personnalisée"},
                    {lb:"Durée",val:duration+" jours"},
                    {lb:"Portée estimée",val:fmt(reach)+" - "+fmt(Math.floor(reach*1.85))+" pers."},
                  ].map((r,i)=>(
                    <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:i<3?"1px solid "+C.border:"none"}}>
                      <span style={{color:C.w3,fontSize:13}}>{r.lb}</span>
                      <span style={{color:C.white,fontSize:13,fontWeight:600}}>{r.val}</span>
                    </div>
                  ))}
                  <div style={{display:"flex",justifyContent:"space-between",padding:"10px 0 0",marginTop:6}}>
                    <span style={{color:C.white,fontSize:15,fontWeight:800}}>Montant net débité</span>
                    <span style={{color:C.accent2,fontSize:16,fontWeight:800}}>{fmtUSD(total)}</span>
                  </div>
                </div>
              </div>
            )}

          </div>

          {(payStep==="form")&&(
            <div style={{padding:"14px 16px 32px",borderTop:"1px solid "+C.border}}>
              <button onClick={()=>setPayStep("selectMethod")} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
                🔒 Continuer vers le paiement
              </button>
            </div>
          )}
          {payStep==="success"&&(
            <div style={{padding:"14px 16px 32px",borderTop:"1px solid "+C.border}}>
              <button onClick={()=>{setShowPayment(false);onClose();}} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:"pointer"}}>
                🚀 Retour à Blue Life
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function StatsModal({post,onClose}){
  const [statsData,setStatsData]=useState(null);
  const [loading,setLoading]=useState(true);

  useEffect(()=>{
    async function loadStats(){
      try{
        const d=await db("/post_stats?post_id=eq."+post.id+"&limit=1");
        if(Array.isArray(d)&&d[0]){
          setStatsData(d[0]);
        }else{
          const newStats={post_id:post.id,views:0,likes:post.likes_count||0,comments:0,shares:0,reach:0};
          await db("/post_stats",{method:"POST",body:JSON.stringify(newStats)});
          setStatsData(newStats);
        }
      }catch(e){console.warn("stats:",e);}
      setLoading(false);
    }
    if(post&&post.id)loadStats();
  },[post&&post.id]);

  const s=statsData||{};
  const statIcons={
    views:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>,
    likes:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21s-6.7-4.3-9.3-8.2C1 10 1.6 6.6 4.4 5 6.6 3.8 9.2 4.4 12 7.1 14.8 4.4 17.4 3.8 19.6 5c2.8 1.6 3.4 5 1.7 7.8C18.7 16.7 12 21 12 21z"/></svg>,
    comments:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.5 8.5 0 0 1-11.8 7.8L3 21l1.7-6.2A8.5 8.5 0 1 1 21 11.5z"/></svg>,
    shares:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
    reach:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none"/></svg>,
    impressions:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 17 9 11 13 15 21 6"/><polyline points="14 6 21 6 21 13"/></svg>,
  };
  const stats=[
    {ic:statIcons.views,lb:"Vues",val:s.views||0,color:C.accent2},
    {ic:statIcons.likes,lb:"J'aime",val:s.likes||post.likes_count||0,color:C.red},
    {ic:statIcons.comments,lb:"Commentaires",val:s.comments||0,color:C.green},
    {ic:statIcons.shares,lb:"Partages",val:s.shares||0,color:C.purple},
    {ic:statIcons.reach,lb:"Portée",val:s.reach||0,color:C.orange},
    {ic:statIcons.impressions,lb:"Impressions",val:s.impressions||0,color:"#f59e0b"},
    {ic:<CoinIcon size={18}/>,lb:"Blue Coins reçus",val:post.gifts_received||0,color:"#f0b90b"},
  ];
  return(
    <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.7)",backdropFilter:"blur(4px)"}}/>
      <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:24,border:"1px solid "+C.border,maxHeight:"80vh",overflowY:"auto"}}>
        <div style={{width:40,height:4,background:C.w4,borderRadius:2,margin:"0 auto 16px"}}/>
        <div style={{display:"flex",alignItems:"center",marginBottom:20}}>
          <span style={{fontWeight:800,fontSize:18,color:C.white,flex:1}}>📊 Statistiques</span>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.w3,cursor:"pointer"}}><I.X/></button>
        </div>
        {loading?(
          <div style={{textAlign:"center",padding:30,color:C.w3}}><I.Spin/> Chargement...</div>
        ):(
          <>
            {post.sponsored&&post.sponsor_reach_target&&(()=>{
              const views=s.views||0;
              const targetVal=post.sponsor_reach_target;
              const pct=Math.min(100,Math.round((views/targetVal)*100));
              const reached=views>=targetVal;
              return (
                <div style={{background:reached?C.green+"15":C.accent+"15",borderRadius:14,padding:16,marginBottom:16,border:"1px solid "+(reached?C.green:C.accent2)}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
                    <span style={{fontWeight:700,fontSize:14,color:C.white}}>🎯 Objectif du boost</span>
                    {reached
                      ?<span style={{fontSize:12,fontWeight:800,color:C.green,background:C.green+"22",padding:"4px 10px",borderRadius:20}}>Atteint ✅</span>
                      :<span style={{fontSize:12,fontWeight:700,color:C.accent2}}>{pct}%</span>
                    }
                  </div>
                  <div style={{height:8,background:C.border,borderRadius:4,overflow:"hidden",marginBottom:8}}>
                    <div style={{height:"100%",width:pct+"%",background:reached?C.green:"linear-gradient(90deg,"+C.accent+",#1e4d8c)",borderRadius:4,transition:"width 0.4s"}}/>
                  </div>
                  <div style={{fontSize:12,color:C.w3}}>{fmt(views)} / {fmt(targetVal)} personnes atteintes</div>
                </div>
              );
            })()}

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
              {stats.map((s,i)=>(
                <div key={i} style={{padding:14,borderRadius:14,background:C.w5,border:"1px solid "+C.border,display:"flex",alignItems:"center",gap:12}}>
                  <div style={{width:38,height:38,borderRadius:"50%",background:s.color+"18",color:s.color,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{s.ic}</div>
                  <div>
                    <div style={{fontWeight:800,fontSize:19,color:C.white,lineHeight:1.1}}>{fmt(s.val)}</div>
                    <div style={{fontSize:11,color:C.w3,marginTop:2}}>{s.lb}</div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{background:C.accent+"11",borderRadius:14,padding:14,border:"1px solid "+C.border2}}>
              <div style={{fontSize:12,color:C.w3,lineHeight:1.8}}>
                📅 Données des 30 derniers jours<br/>
                🔄 Mis à jour en temps réel
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function PostCard({post,user,onProfile,posts,postIndex,showToast,onRequireAuth,onOpenVideo,followingUsernames}){
  const t=useTranslation();
  const safeUser=user||{username:"",isGuest:true};
  const [warningDismissed,setWarningDismissed]=useState(false);
  const [liked,setLiked]=useState(()=>hasLikedLocally(post&&post.id,safeUser.username));
  const [imageLoaded,setImageLoaded]=useState(false);
  const [likes,setLikes]=useState(()=>getCachedPostField(post&&post.id,"likes_count",post&&post.likes_count||0));
  const [commentsCount,setCommentsCount]=useState(()=>{
    const fromComments=getLocalComments(post&&post.id).length;
    return fromComments>0?fromComments:getCachedPostField(post&&post.id,"comments_count",post&&post.comments_count||0);
  });
  const [saved,setSaved]=useState(()=>isPostSaved(safeUser.username,post&&post.id));
  const [showComments,setShowComments]=useState(false);
  const [showBoost,setShowBoost]=useState(false);
  const [showStats,setShowStats]=useState(false);
  const [showShare,setShowShare]=useState(false);
  const [showOptions,setShowOptions]=useState(false);
  const [displayCaption,setDisplayCaption]=useState(post&&post.caption);
  const [displayPinned,setDisplayPinned]=useState(post&&post.pinned);
  const [showGift,setShowGift]=useState(false);
  const [giftsReceived,setGiftsReceived]=useState(post&&post.gifts_received||0);
  const [isDeleted,setIsDeleted]=useState(false);
  const [heart,setHeart]=useState(false);
  const likedRef=useRef(hasLikedLocally(post&&post.id,safeUser.username));
  const likesRef=useRef(getCachedPostField(post&&post.id,"likes_count",post&&post.likes_count||0));
  const videoRef=useRef(null);
  const carouselRef=useRef(null);
  const videoTapTimer=useRef(null);
  const [feedMuted,setFeedMuted]=useState(true);
  const replacementAudioRef=useRef(null);
  const [replacementAudioUrl,setReplacementAudioUrl]=useState(null);
  useEffect(()=>{
    if(!post.muted_original||!post.audio_id){setReplacementAudioUrl(null);return;}
    db("/audio_tracks?id=eq."+post.audio_id+"&select=audio_url&limit=1").then(d=>{
      if(Array.isArray(d)&&d[0])setReplacementAudioUrl(d[0].audio_url);
    }).catch(()=>{});
  },[post.audio_id,post.muted_original]);
  const [activeSlide,setActiveSlide]=useState(0);
  // Poll state - post.poll_votes/poll_voters are JSON strings (an array of
  // per-option counts, and a username->option-index map), same pattern as
  // storing carousel image URLs in post.images.
  const [pollVotesState,setPollVotesState]=useState(()=>{
    try{return JSON.parse((post&&post.poll_votes)||"[]");}catch{return [];}
  });
  const [pollVoters,setPollVoters]=useState(()=>{
    try{return JSON.parse((post&&post.poll_voters)||"{}");}catch{return {};}
  });
  let carouselImages=[];
  try{ if(post&&post.images) carouselImages=JSON.parse(post.images)||[]; }catch{ carouselImages=[]; }
  const isCarousel=Array.isArray(carouselImages)&&carouselImages.length>1;
  function handleCarouselScroll(){
    if(!carouselRef.current)return;
    const w=carouselRef.current.clientWidth||1;
    const idx=Math.round(carouselRef.current.scrollLeft/w);
    if(idx!==activeSlide)setActiveSlide(idx);
  }

  useEffect(()=>{
    if(!videoRef.current||post.type!=="video")return;
    const el=videoRef.current;
    const observer=new IntersectionObserver((entries)=>{
      const entry=entries[0];
      if(!entry)return;
      if(entry.isIntersecting&&entry.intersectionRatio>0.6){
        if(post.trim_start)el.currentTime=post.trim_start;
        if(post.muted_original){
          el.muted=true;
          el.play().catch(()=>{});
          if(replacementAudioRef.current){replacementAudioRef.current.currentTime=0;replacementAudioRef.current.play().catch(()=>{});}
        }else{
          el.muted=true;
          const playPromise=el.play();
          if(playPromise&&playPromise.then){
            playPromise.then(()=>{ if(el){el.muted=false;setFeedMuted(false);} }).catch(()=>{});
          }
        }
      }else{
        el.pause();
        if(replacementAudioRef.current)replacementAudioRef.current.pause();
      }
    },{threshold:[0,0.6,1]});
    observer.observe(el);
    return ()=>observer.disconnect();
  },[post&&post.id]);

  useEffect(()=>{
    const el=videoRef.current;
    if(!el||!post.trim_end)return;
    function onTimeUpdate(){
      if(el.currentTime>=post.trim_end)el.currentTime=post.trim_start||0;
    }
    el.addEventListener("timeupdate",onTimeUpdate);
    return()=>el.removeEventListener("timeupdate",onTimeUpdate);
  },[post.trim_start,post.trim_end]);

  function refreshCommentsCount(){
    const c=getLocalComments(post&&post.id).length;
    setCommentsCount(c);
  }

  useEffect(()=>{
    if(!post||!post.id||String(post.id).startsWith("local_"))return;
    fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/rpc/increment_views",{
      method:"POST",
      headers:{
        "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
        "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
        "Content-Type":"application/json"
      },
      body:JSON.stringify({p_post_id:post.id})
    }).catch(()=>{});
  },[post&&post.id]);

  if(!post||!(post.image||post.type==="text"||post.type==="poll")) return null;
  if(isDeleted) return null;
  const isMe=(post.username||'').toLowerCase()===(safeUser.username||'').toLowerCase();
  const [justFollowed,setJustFollowed]=useState(false);
  const isFollowingAuthor=isMe?false:(justFollowed||(followingUsernames||[]).includes(post.username));

  async function followAuthorFromFeed(e){
    e.stopPropagation();
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("follow");return;}
    setJustFollowed(true);
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/Follows",{
        method:"POST",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({follower:safeUser.username,following:post.username})
      });
      const data=await res.json().catch(()=>null);
      if(!res.ok||!Array.isArray(data)||data.length===0){
        if(data&&data.code==="23505"){return;}
        console.error("Follow from feed failed (status "+res.status+"): "+JSON.stringify(data));
        setJustFollowed(false);
        return;
      }
      db("/notifications",{method:"POST",body:JSON.stringify({receiver:post.username,sender:safeUser.username,type:"follow",seen:false})}).catch(()=>{});
    }catch(err){
      console.error("Follow from feed network error: "+err.message);
      setJustFollowed(false);
    }
  }

  async function doLike(){
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("like");return;}
    if(likedRef.current)return;
    likedRef.current=true;
    likesRef.current=likesRef.current+1;
    setLiked(true);setLikes(likesRef.current);setHeart(true);setTimeout(()=>setHeart(false),900);
    persistPostChange(post.id,{likes_count:likesRef.current});
    persistLikedState(post.id,safeUser.username,true);
    if(!post.id||String(post.id).startsWith("local_"))return;
    try{
      const res=await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/Posts?id=eq."+post.id,{
        method:"PATCH",
        headers:{
          "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Content-Type":"application/json",
          "Prefer":"return=minimal"
        },
        body:JSON.stringify({likes_count:likesRef.current})
      });
      if(!res.ok){
        console.warn("like patch failed",res.status);
        showToast&&showToast("⚠️ Like non sauvegardé (code "+res.status+")");
      }
      if(post.username!==safeUser.username){
        db("/notifications",{method:"POST",body:JSON.stringify({receiver:post.username,sender:safeUser.username,type:"like",post_id:post.id,seen:false})}).catch(()=>{});
      }
    }catch(e){console.warn("like err:",e);showToast&&showToast("⚠️ Like non sauvegardé (connexion)");}
  }

  async function toggleLike(){
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("like");return;}
    if(!liked){
      await doLike();
    } else {
      const newLikes=Math.max(0,likes-1);
      likesRef.current=newLikes;likedRef.current=false;
      setLiked(false);setLikes(newLikes);
      persistPostChange(post.id,{likes_count:newLikes});
      persistLikedState(post.id,safeUser.username,false);
      if(!post.id||String(post.id).startsWith("local_"))return;
      try{
        const res=await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/Posts?id=eq."+post.id,{
          method:"PATCH",
          headers:{
            "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
            "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
            "Content-Type":"application/json",
            "Prefer":"return=minimal"
          },
          body:JSON.stringify({likes_count:newLikes})
        });
        if(!res.ok){
          console.warn("unlike patch failed",res.status);
          showToast&&showToast("⚠️ Like non retiré (code "+res.status+")");
        }
      }catch(e){console.warn("unlike err:",e);showToast&&showToast("⚠️ Like non retiré (connexion)");}
    }
  }

  // Vote on a poll option - one vote per person, no changing your mind
  // afterward, matching Facebook's own poll behavior. Votes/voters are
  // stored as JSON on the post row itself rather than a separate table,
  // since this app's scale doesn't need the extra join.
  async function votePoll(optionIndex){
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("like");return;}
    if(pollVoters[safeUser.username]!==undefined)return;
    const newVotes=[...pollVotesState];
    newVotes[optionIndex]=(newVotes[optionIndex]||0)+1;
    const newVoters={...pollVoters,[safeUser.username]:optionIndex};
    setPollVotesState(newVotes);
    setPollVoters(newVoters);
    persistPostChange(post.id,{poll_votes:JSON.stringify(newVotes),poll_voters:JSON.stringify(newVoters)});
    if(!post.id||String(post.id).startsWith("local_"))return;
    try{
      await fetch(SUPABASE_URL+"/rest/v1/Posts?id=eq."+post.id,{
        method:"PATCH",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({poll_votes:JSON.stringify(newVotes),poll_voters:JSON.stringify(newVoters)})
      });
    }catch(e){}
  }

  return(
    <>
      {showComments&&<CommentsPanel post={post} user={safeUser} onClose={()=>{setShowComments(false);refreshCommentsCount();}} showToast={showToast}/>}
      {showBoost&&<BoostModal post={post} user={safeUser} onClose={()=>setShowBoost(false)} showToast={showToast}/>}
      {showStats&&<StatsModal post={post} onClose={()=>setShowStats(false)}/>}
      {showShare&&<ShareSheet
        link={window.location.origin+window.location.pathname+"?post="+post.id}
        shareText={post.caption||"Regarde ce post sur Blue Life !"}
        storyImage={post.image}
        storyCaption={"🔁 Repartagé de @"+post.username}
        repost={{image:post.image,images:post.images||null,caption:post.caption,type:post.type,originalUsername:post.username,originalPostId:post.id}}
        currentUser={safeUser} onClose={()=>setShowShare(false)} showToast={showToast} onRequireAuth={onRequireAuth}
      />}
      {showOptions&&<PostOptionsSheet
        post={{...post,caption:displayCaption,pinned:displayPinned}}
        isOwner={isMe}
        currentUser={safeUser}
        onClose={()=>setShowOptions(false)}
        showToast={showToast}
        onRequireAuth={onRequireAuth}
        onDeleted={()=>setIsDeleted(true)}
        onCaptionUpdated={(c)=>setDisplayCaption(c)}
        onPinToggled={(p)=>setDisplayPinned(p)}
      />}
      {showGift&&<GiftSheet post={{...post,gifts_received:giftsReceived}} user={safeUser} onClose={()=>setShowGift(false)} showToast={showToast} onGiftSent={(newTotal)=>setGiftsReceived(newTotal)} onRequireAuth={onRequireAuth}/>}

      <div style={{marginBottom:18,borderBottom:"1px solid "+C.border,paddingBottom:14}}>

        <div style={{display:"flex",alignItems:"center",padding:"10px 14px",gap:10}}>
          <div onClick={()=>onProfile&&onProfile(post.username,post.avatar,post.page_id)} style={{cursor:"pointer"}}>
            <Avatar src={post.avatar||""} name={post.username} size={32} border={C.border}/>
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div onClick={()=>onProfile&&onProfile(post.username,post.avatar,post.page_id)} style={{display:"flex",alignItems:"center",gap:6,fontWeight:700,fontSize:14,color:C.white,cursor:"pointer",overflow:"hidden"}}>
              <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{post.display_name||post.username}</span>
              {isBadgeActive(post)&&(
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#3897f0" style={{flexShrink:0}}>
                  <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
                  <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
              {displayPinned&&<span title="Épinglé" style={{flexShrink:0,fontSize:12}}>📌</span>}
            </div>
            {post.sponsored&&<div style={{color:C.w3,fontSize:11,marginTop:1}}>Sponsorisée 🌍</div>}
            {post.group_id&&<div style={{color:C.w3,fontSize:11,marginTop:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",display:"flex",alignItems:"center",gap:5}}>
              a publié dans <b style={{color:C.w2}}>{post.group_name||"un groupe"}</b>
              {post.group_poster_role==="owner"&&<span style={{background:C.accent+"22",color:C.accent2,fontSize:9,fontWeight:800,padding:"1px 6px",borderRadius:6,flexShrink:0}}>PROPRIÉTAIRE</span>}
              {post.group_poster_role==="admin"&&<span style={{background:C.accent+"22",color:C.accent2,fontSize:9,fontWeight:800,padding:"1px 6px",borderRadius:6,flexShrink:0}}>ADMIN</span>}
            </div>}
          </div>
          {isMe&&(
            <div style={{display:"flex",gap:6,flexShrink:0}}>
              <button onClick={()=>setShowStats(true)} style={{background:C.w5,border:"1px solid "+C.border,borderRadius:8,padding:"5px 8px",color:C.accent2,cursor:"pointer",fontSize:11,fontWeight:600,display:"flex",alignItems:"center",gap:3}}>
                <I.Bar/> Stats
              </button>
              <button onClick={()=>setShowBoost(true)} style={{background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",border:"none",borderRadius:8,padding:"5px 8px",color:"#fff",cursor:"pointer",fontSize:11,fontWeight:600,display:"flex",alignItems:"center",gap:3}}>
                <I.Rocket/> Booster
              </button>
            </div>
          )}
          {!isMe&&isFollowingAuthor===false&&(
            <button onClick={followAuthorFromFeed} style={{background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",border:"none",borderRadius:8,padding:"5px 10px",color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,flexShrink:0}}>
              Suivre
            </button>
          )}
          <button onClick={()=>setShowOptions(true)} style={{background:"none",border:"none",cursor:"pointer",color:C.w3,padding:"4px 2px",flexShrink:0,display:"flex"}}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="12" cy="19" r="1.8"/></svg>
          </button>
        </div>

        {post.type!=="text"&&post.type!=="poll"&&<CaptionText text={displayCaption} style={{padding:"0 14px 10px",fontSize:14,color:C.w2,lineHeight:1.5}}/>}
        {post.type==="poll"&&<div style={{padding:"0 14px 10px",fontSize:15,color:C.white,fontWeight:700,lineHeight:1.4}}>{displayCaption}</div>}

        <div style={{position:"relative",width:"100%"}} onDoubleClick={()=>{clearTimeout(videoTapTimer.current);post.type!=="poll"&&doLike();}}>
          {post.content_warning&&!warningDismissed&&(
            <div style={{position:"absolute",inset:0,zIndex:5,background:"rgba(10,10,10,0.92)",backdropFilter:"blur(14px)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24,textAlign:"center"}}>
              <div style={{fontSize:32,marginBottom:10}}>⚠️</div>
              <div style={{color:"#fff",fontWeight:700,fontSize:15,marginBottom:6}}>Ce contenu peut être sensible</div>
              <div style={{color:"rgba(255,255,255,0.6)",fontSize:12,marginBottom:18,maxWidth:260}}>{post.content_warning_text||"Ce contenu a été signalé comme pouvant heurter certaines sensibilités."}</div>
              <button onClick={(e)=>{e.stopPropagation();setWarningDismissed(true);}} style={{padding:"10px 20px",borderRadius:10,border:"1px solid rgba(255,255,255,0.3)",background:"rgba(255,255,255,0.1)",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer"}}>Voir quand même</button>
            </div>
          )}
          {isCarousel?(
            <>
              <div ref={carouselRef} onScroll={handleCarouselScroll} style={{display:"flex",overflowX:"auto",scrollSnapType:"x mandatory",width:"100%"}}>
                {carouselImages.map((img,i)=>(
                  <img key={i} src={img} alt="" style={{width:"100%",flexShrink:0,aspectRatio:"4/5",objectFit:"cover",scrollSnapAlign:"start",display:"block"}}/>
                ))}
              </div>
              <div style={{position:"absolute",top:10,right:10,background:"rgba(0,0,0,0.55)",color:"#fff",fontSize:11,fontWeight:700,padding:"3px 9px",borderRadius:10}}>{activeSlide+1}/{carouselImages.length}</div>
              <div style={{position:"absolute",bottom:10,left:0,right:0,display:"flex",justifyContent:"center",gap:5}}>
                {carouselImages.map((_,i)=>(
                  <div key={i} style={{width:6,height:6,borderRadius:"50%",background:i===activeSlide?"#fff":"rgba(255,255,255,0.5)"}}/>
                ))}
              </div>
            </>
          ):post.type==="text"
            ?<div style={{width:"100%",aspectRatio:"4/5",background:post.text_bg||("linear-gradient(135deg,"+C.accent+",#1e4d8c)"),display:"flex",alignItems:"center",justifyContent:"center",padding:28,boxSizing:"border-box"}}>
                <div style={{color:"#fff",fontSize:post.caption&&post.caption.length>120?18:24,fontWeight:700,lineHeight:1.5,textAlign:"center",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:10,WebkitBoxOrient:"vertical"}}>{post.caption}</div>
              </div>
            :post.type==="poll"
            ?(()=>{
                const pollOptions=(()=>{try{return JSON.parse(post.poll_options||"[]");}catch{return [];}})();
                const totalVotes=pollVotesState.reduce((a,b)=>a+b,0);
                const myVote=pollVoters[safeUser.username];
                const hasVoted=myVote!==undefined;
                return (
                  <div style={{width:"100%",padding:"4px 14px 14px",background:C.navy,boxSizing:"border-box"}}>
                    {pollOptions.map((opt,i)=>{
                      const voteCount=pollVotesState[i]||0;
                      const pct=totalVotes>0?Math.round((voteCount/totalVotes)*100):0;
                      const isMyChoice=myVote===i;
                      const optText=typeof opt==="string"?opt:opt.text;
                      const optImage=typeof opt==="string"?null:opt.image;
                      return (
                        <div key={i} onClick={()=>!hasVoted&&votePoll(i)} style={{position:"relative",borderRadius:12,border:"1px solid "+(isMyChoice?C.accent:C.border),overflow:"hidden",marginBottom:10,cursor:hasVoted?"default":"pointer",background:C.w5}}>
                          {hasVoted&&(
                            <div style={{position:"absolute",inset:0,width:pct+"%",background:isMyChoice?C.accent+"33":C.w4,transition:"width 0.4s"}}/>
                          )}
                          <div style={{position:"relative",display:"flex",alignItems:"center",gap:10,padding:"10px 16px"}}>
                            {optImage&&<img src={optImage} alt="" style={{width:40,height:40,borderRadius:8,objectFit:"cover",flexShrink:0}}/>}
                            <span style={{flex:1,color:C.white,fontSize:14,fontWeight:isMyChoice?700:500}}>{isMyChoice?"✓ ":""}{optText}</span>
                            {hasVoted&&<span style={{color:C.w3,fontSize:13,fontWeight:700,flexShrink:0}}>{pct}%</span>}
                          </div>
                        </div>
                      );
                    })}
                    <div style={{color:C.w3,fontSize:12,marginTop:2}}>{fmt(totalVotes)} vote{totalVotes>1?"s":""}</div>
                  </div>
                );
              })()
            :post.type==="video"
            ?<>
                <video ref={videoRef} src={post.image} autoPlay muted={post.muted_original?true:feedMuted} loop playsInline onClick={()=>{
                    clearTimeout(videoTapTimer.current);
                    videoTapTimer.current=setTimeout(()=>{
                      if(videoRef.current)videoRef.current.pause();
                      onOpenVideo&&onOpenVideo([post],0);
                    },280);
                  }} style={{width:"100%",aspectRatio:"4/5",objectFit:"cover",display:"block",background:"#000",cursor:"pointer"}}/>
                {replacementAudioUrl&&<audio ref={replacementAudioRef} src={replacementAudioUrl} loop muted={feedMuted}/>}
                <button onClick={(e)=>{e.stopPropagation();clearTimeout(videoTapTimer.current);setFeedMuted(m=>{const n=!m;if(videoRef.current&&!post.muted_original)videoRef.current.muted=n;return n;});}} style={{position:"absolute",top:10,right:10,background:"rgba(0,0,0,0.5)",border:"none",borderRadius:"50%",width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"#fff"}}>
                  {feedMuted?
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>:
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>
                  }
                </button>
              </>
            :<>
                {!imageLoaded&&<div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",background:C.w5}}>
                  <div style={{width:32,height:32,border:"3px solid "+C.border,borderTopColor:C.accent,borderRadius:"50%",animation:"spin 0.8s linear infinite"}}/>
                </div>}
                <img src={post.image} alt="" onLoad={()=>setImageLoaded(true)} style={{width:"100%",aspectRatio:"4/5",objectFit:"cover",display:"block",opacity:imageLoaded?1:0,transition:"opacity 0.25s"}}/>
              </>
          }
          {heart&&<div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",pointerEvents:"none"}}><div style={{fontSize:90,animation:"heartPop 0.9s ease forwards"}}>❤️</div></div>}
        </div>

        <div style={{padding:"8px 14px 0"}}>
          <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:8}}>
            <div style={{display:"flex",alignItems:"center",gap:6}}>
              <button onClick={toggleLike} style={{background:"none",border:"none",cursor:"pointer",color:liked?C.red:C.white,padding:0,transform:liked?"scale(1.15)":"scale(1)",transition:"transform 0.2s",display:"flex"}}><I.Heart a={liked}/></button>
              {likes>0&&<span style={{fontSize:13,fontWeight:600,color:C.white}}>{fmt(likes)}</span>}
            </div>
            <div style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer"}} onClick={()=>{if(!user||!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("comment");return;}setShowComments(true);}}>
              <span style={{color:C.white,display:"flex"}}><I.Chat/></span>
              {commentsCount>0&&<span style={{fontSize:13,fontWeight:600,color:C.white}}>{commentsCount}</span>}
            </div>
            <button onClick={()=>setShowShare(true)} style={{background:"none",border:"none",cursor:"pointer",color:C.white,padding:0,display:"flex"}}><I.Send/></button>
            {!isCurrentlyBoosted(post)&&(
              <button onClick={()=>setShowGift(true)} style={{background:"none",border:"none",cursor:"pointer",color:C.white,padding:0,display:"flex",alignItems:"center",gap:5}}>
                <span style={{fontSize:18}}>🎁</span>
                {giftsReceived>0&&<span style={{fontSize:13,fontWeight:600,color:"#f0b90b"}}>{fmt(giftsReceived)}</span>}
              </button>
            )}
            {post.views>0&&(
              <div style={{display:"flex",alignItems:"center",gap:5,color:C.w3}}>
                <span style={{fontSize:15}}>👁️</span>
                <span style={{fontSize:13,fontWeight:600}}>{fmt(post.views)}</span>
              </div>
            )}
            <div style={{flex:1}}/>
            <button onClick={()=>{
              if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("login");return;}
              const nowSaved=toggleSavedPost(safeUser.username,post);
              setSaved(nowSaved);
              showToast&&showToast(nowSaved?"🔖 Enregistré":"Retiré des enregistrements");
            }} style={{background:"none",border:"none",cursor:"pointer",color:saved?C.accent2:C.white,padding:0,display:"flex"}}><I.Save a={saved}/></button>
          </div>

          {commentsCount>0?(
            <div onClick={()=>{if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("comment");return;}setShowComments(true);}} style={{fontSize:13,color:C.w3,marginBottom:4,cursor:"pointer"}}>
              {t("seeComments")} {commentsCount} {commentsCount>1?t("comments"):t("comment")}
            </div>
          ):(
            <div onClick={()=>{if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("comment");return;}setShowComments(true);}} style={{fontSize:13,color:C.w3,marginBottom:4,cursor:"pointer"}}>
              Ajouter un commentaire...
            </div>
          )}

          <div style={{fontSize:11,color:C.w3,textTransform:"uppercase"}}>{ago(post.created_at)}</div>
        </div>
      </div>
    </>
  );
}

function SoundPickerSheet({onClose,onPick}){
  const [tracks,setTracks]=useState([]);
  const [search,setSearch]=useState("");
  const [loading,setLoading]=useState(true);

  useEffect(()=>{
    db("/audio_tracks?order=usage_count.desc&limit=100").then(d=>{
      setTracks(Array.isArray(d)?d:[]);
      setLoading(false);
    }).catch(()=>setLoading(false));
  },[]);

  const filtered=tracks.filter(t=>!search||(t.title||"").toLowerCase().includes(search.toLowerCase())||(t.artist||"").toLowerCase().includes(search.toLowerCase()));

  return(
    <div style={{position:"fixed",inset:0,zIndex:960,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)"}}/>
      <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,maxHeight:"75vh",display:"flex",flexDirection:"column",border:"1px solid "+C.border}}>
        <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"10px auto"}}/>
        <div style={{padding:"0 16px 12px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <span style={{fontWeight:700,fontSize:15,color:C.white}}>🎵 Bibliothèque de sons</span>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.w3,cursor:"pointer",fontSize:20}}>✕</button>
        </div>
        <div style={{padding:"0 16px 12px"}}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Rechercher un son..." style={{width:"100%",padding:"10px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:13,outline:"none",boxSizing:"border-box"}}/>
        </div>
        <div style={{overflowY:"auto",padding:"0 16px 20px"}}>
          {loading&&<div style={{textAlign:"center",color:C.w3,padding:20}}>⏳</div>}
          {!loading&&filtered.length===0&&<div style={{textAlign:"center",color:C.w3,padding:20,fontSize:13}}>Aucun son pour le moment — sois le premier à en créer un !</div>}
          {filtered.map(t=>(
            <div key={t.id} onClick={()=>onPick(t)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:"1px solid "+C.border,cursor:"pointer"}}>
              <div style={{width:40,height:40,borderRadius:"50%",background:"linear-gradient(135deg,"+C.accent+","+C.purple+")",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>🎵</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{color:C.white,fontSize:13,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{t.title}</div>
                <div style={{color:C.w3,fontSize:11}}>{t.artist} · {fmt(t.usage_count||0)} vidéo{(t.usage_count||0)>1?"s":""}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function SoundDetailScreen({audioId,audioTitle,onClose,onProfile,onUseSound}){
  const [videos,setVideos]=useState([]);
  const [loading,setLoading]=useState(true);
  const [track,setTrack]=useState(null);
  const sheet=useDragSheet();

  useEffect(()=>{
    (async()=>{
      const rows=await db("/Posts?audio_id=eq."+audioId+"&order=created_at.desc&limit=60").catch(()=>[]);
      setVideos(Array.isArray(rows)?rows:[]);
      const t=await db("/audio_tracks?id=eq."+audioId+"&limit=1").catch(()=>[]);
      if(Array.isArray(t)&&t[0])setTrack(t[0]);
      setLoading(false);
    })();
  },[audioId]);

  return(
    <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",flexDirection:"column",justifyContent:"flex-end",maxWidth:480,margin:"0 auto",pointerEvents:"none"}}>
      {!sheet.expanded&&<div onClick={onClose} style={{flex:1,pointerEvents:"auto"}}/>}
      <div style={{height:sheet.expanded?"100dvh":"66vh",transition:"height 0.25s ease",background:C.navy,borderRadius:sheet.expanded?0:"20px 20px 0 0",overflowY:"auto",fontFamily:"'Segoe UI',system-ui,sans-serif",paddingBottom:80,pointerEvents:"auto",boxShadow:"0 -8px 30px rgba(0,0,0,0.4)"}}>
        <div onClick={()=>sheet.setExpanded(e=>!e)} onTouchStart={sheet.onDragStart} onTouchMove={sheet.onDragMove} onTouchEnd={sheet.onDragEnd} style={{padding:"10px 0 4px",cursor:"pointer"}}>
          <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"0 auto"}}/>
        </div>
        <div style={{display:"flex",alignItems:"center",padding:"12px 16px",borderBottom:"1px solid "+C.border,gap:12}}>
          <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
          <span style={{fontWeight:700,fontSize:16,color:C.white,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>🎵 {track?.title||audioTitle||"Son"}</span>
        </div>
        <div style={{padding:16,textAlign:"center",borderBottom:"1px solid "+C.border}}>
          <div style={{width:52,height:52,borderRadius:"50%",background:"linear-gradient(135deg,"+C.accent+","+C.purple+")",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,margin:"0 auto 8px",animation:"spin2 4s linear infinite"}}>🎵</div>
          <div style={{color:C.white,fontWeight:700,fontSize:14}}>{track?.title||audioTitle}</div>
          {track?.artist&&<div style={{color:C.w3,fontSize:12,marginTop:2}}>{track.artist}</div>}
          <div style={{color:C.w3,fontSize:12,marginTop:4}}>{fmt(track?.usage_count||videos.length)} vidéo{videos.length>1?"s":""}</div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:2,padding:2}}>
          {loading&&<div style={{gridColumn:"1/-1",textAlign:"center",color:C.w3,padding:30}}>⏳</div>}
          {!loading&&videos.length===0&&<div style={{gridColumn:"1/-1",textAlign:"center",color:C.w3,padding:30,fontSize:13}}>Aucune autre vidéo avec ce son pour l'instant</div>}
          {videos.map(v=>(
            <div key={v.id} onClick={()=>onProfile&&onProfile(v.username,v.avatar)} style={{aspectRatio:"9/16",background:"#000",position:"relative",cursor:"pointer",overflow:"hidden"}}>
              <video src={v.image} muted style={{width:"100%",height:"100%",objectFit:"cover"}}/>
              <div style={{position:"absolute",bottom:4,left:6,color:"#fff",fontSize:11,fontWeight:600,textShadow:"0 1px 3px rgba(0,0,0,0.9)"}}>@{v.username}</div>
            </div>
          ))}
        </div>

        <div style={{position:"fixed",bottom:0,left:0,right:0,maxWidth:480,margin:"0 auto",padding:"14px 16px",background:"linear-gradient(0deg,"+C.navy+" 70%,transparent)"}}>
          <button onClick={()=>{
              onUseSound&&onUseSound({id:audioId,title:track?.title||audioTitle,artist:track?.artist||"",usage_count:track?.usage_count||videos.length,audio_url:track?.audio_url||null});
            }} style={{width:"100%",padding:"15px",borderRadius:30,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:15,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,boxShadow:"0 4px 16px rgba(0,0,0,0.4)"}}>
            🎥 Utiliser le son
          </button>
        </div>
      </div>
    </div>
  );
}

function CameraCapture({sound,onClose,onCaptured}){
  const videoRef=useRef(null);
  const soundRef=useRef(null);
  const streamRef=useRef(null);
  const recorderRef=useRef(null);
  const chunksRef=useRef([]);
  const timerRef=useRef(null);
  const [facing,setFacing]=useState("user");
  const [ready,setReady]=useState(false);
  const [recording,setRecording]=useState(false);
  const [seconds,setSeconds]=useState(0);
  const [err,setErr]=useState("");
  const MAX_SECONDS=60;

  async function startCamera(mode){
    try{
      if(streamRef.current)streamRef.current.getTracks().forEach(t=>t.stop());
      const stream=await navigator.mediaDevices.getUserMedia({video:{facingMode:mode},audio:true});
      streamRef.current=stream;
      if(videoRef.current)videoRef.current.srcObject=stream;
      setReady(true);
    }catch(e){
      setErr("Impossible d'accéder à la caméra. Vérifie les autorisations de l'appli.");
    }
  }

  useEffect(()=>{
    startCamera(facing);
    return()=>{
      if(streamRef.current)streamRef.current.getTracks().forEach(t=>t.stop());
      clearInterval(timerRef.current);
    };
  },[facing]);

  function startRecording(){
    if(!streamRef.current)return;
    chunksRef.current=[];
    setSeconds(0);
    try{
      const recorder=new MediaRecorder(streamRef.current,{mimeType:MediaRecorder.isTypeSupported("video/webm;codecs=vp9,opus")?"video/webm;codecs=vp9,opus":"video/webm"});
      recorder.ondataavailable=(e)=>{if(e.data&&e.data.size>0)chunksRef.current.push(e.data);};
      recorder.onstop=()=>{
        const blob=new Blob(chunksRef.current,{type:"video/webm"});
        const file=new File([blob],"capture-"+Date.now()+".webm",{type:"video/webm"});
        onCaptured&&onCaptured(file);
      };
      recorder.start();
      recorderRef.current=recorder;
      setRecording(true);
      if(soundRef.current){soundRef.current.currentTime=0;soundRef.current.play().catch(()=>{});}
      timerRef.current=setInterval(()=>{
        setSeconds(s=>{
          if(s+1>=MAX_SECONDS){stopRecording();return MAX_SECONDS;}
          return s+1;
        });
      },1000);
    }catch(e){
      setErr("Échec du démarrage de l'enregistrement sur cet appareil.");
    }
  }

  function stopRecording(){
    clearInterval(timerRef.current);
    if(recorderRef.current&&recorderRef.current.state!=="inactive")recorderRef.current.stop();
    if(soundRef.current)soundRef.current.pause();
    setRecording(false);
  }

  return(
    <div style={{position:"fixed",inset:0,background:"#000",zIndex:960,maxWidth:480,margin:"0 auto",display:"flex",flexDirection:"column"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 16px",position:"absolute",top:0,left:0,right:0,zIndex:10}}>
        <button onClick={onClose} style={{background:"rgba(0,0,0,0.45)",border:"none",borderRadius:"50%",width:36,height:36,cursor:"pointer",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}><I.X/></button>
        {sound&&<div style={{background:"rgba(0,0,0,0.45)",borderRadius:20,padding:"6px 14px",color:"#fff",fontSize:12,fontWeight:600,display:"flex",alignItems:"center",gap:6}}>🎵 {sound.title}</div>}
        {!recording&&<button onClick={()=>setFacing(f=>f==="user"?"environment":"user")} style={{background:"rgba(0,0,0,0.45)",border:"none",borderRadius:"50%",width:36,height:36,cursor:"pointer",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
        </button>}
      </div>

      <div style={{flex:1,position:"relative",background:"#000"}}>
        <video ref={videoRef} autoPlay muted playsInline style={{width:"100%",height:"100%",objectFit:"cover",transform:facing==="user"?"scaleX(-1)":"none"}}/>
        {sound&&sound.audio_url&&<audio ref={soundRef} src={sound.audio_url}/>}
        {err&&<div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",padding:24,textAlign:"center",color:"#fff",fontSize:14}}>{err}</div>}
        {recording&&(
          <div style={{position:"absolute",top:64,left:0,right:0,display:"flex",justifyContent:"center"}}>
            <div style={{background:"rgba(0,0,0,0.5)",borderRadius:20,padding:"5px 14px",color:"#fff",fontSize:13,fontWeight:700,display:"flex",alignItems:"center",gap:6}}>
              <div style={{width:8,height:8,borderRadius:"50%",background:"#ff3040"}}/>
              {String(Math.floor(seconds/60)).padStart(1,"0")}:{String(seconds%60).padStart(2,"0")}
            </div>
          </div>
        )}
      </div>

      <div style={{padding:"20px 0 40px",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <button onClick={()=>recording?stopRecording():startRecording()} disabled={!ready} style={{width:76,height:76,borderRadius:"50%",border:"5px solid #fff",background:recording?C.red:"transparent",cursor:ready?"pointer":"not-allowed",display:"flex",alignItems:"center",justifyContent:"center"}}>
          {recording&&<div style={{width:26,height:26,borderRadius:6,background:"#fff"}}/>}
        </button>
      </div>
    </div>
  );
}

function NewPost({user,onBack,onDone,showToast,presetSound,postAsPage,initialVideoFile,initialMutedOriginal}){
  const ref=useRef(null);
  const [previews,setPreviews]=useState([]);
  const [caption,setCaption]=useState("");
  const [uploading,setUploading]=useState(false);
  const [prog,setProg]=useState(0);
  const [err,setErr]=useState("");
  const [soundTitle,setSoundTitle]=useState("");
  const [selectedSound,setSelectedSound]=useState(presetSound||null);
  const [showSoundPicker,setShowSoundPicker]=useState(false);
  const [previewMuted,setPreviewMuted]=useState(true);
  const [showTrimEditor,setShowTrimEditor]=useState(false);
  const [trimStart,setTrimStart]=useState(0);
  const [trimEnd,setTrimEnd]=useState(0);
  const [mutedOriginal,setMutedOriginal]=useState(!!initialMutedOriginal);
  const editPreviewRef=useRef(null);

  useEffect(()=>{
    if(!initialVideoFile)return;
    const entry={url:URL.createObjectURL(initialVideoFile),file:initialVideoFile,ftype:"video"};
    setPreviews([entry]);
    getVideoDuration(initialVideoFile).then(d=>{
      setPreviews(cur=>cur.map(p=>p.file===initialVideoFile?{...p,duration:d}:p));
      setTrimEnd(d);
    });
  },[initialVideoFile]);

  function pick(e){
    const files=Array.from(e.target.files||[]);
    if(files.length===0)return;
    setErr("");
    if(files.length===1){
      const f=files[0];
      const isVideo=f.type.startsWith("video");
      const entry={url:URL.createObjectURL(f),file:f,ftype:isVideo?"video":"image"};
      setPreviews(prev=>isVideo?[entry]:[...prev.filter(p=>p.ftype!=="video"),entry].slice(0,10));
      if(isVideo){
        getVideoDuration(f).then(d=>{setPreviews(cur=>cur.map(p=>p.file===f?{...p,duration:d}:p));setTrimEnd(d);});
      }
      return;
    }
    const imageFiles=files.filter(f=>!f.type.startsWith("video"));
    if(imageFiles.length<files.length){
      showToast&&showToast("⚠️ Vidéos ignorées : un carrousel ne contient que des photos");
    }
    const entries=imageFiles.map(f=>({url:URL.createObjectURL(f),file:f,ftype:"image"}));
    setPreviews(prev=>[...prev.filter(p=>p.ftype!=="video"),...entries].slice(0,10));
  }

  function removePreview(idx){
    setPreviews(prev=>prev.filter((_,i)=>i!==idx));
  }

  async function publish(){
    if(isRestricted(user,"restricted_posting","posting_restricted_until")){setErr("Ton compte est temporairement restreint de publication.");return;}
    const _postLoc=await getPostLocation();
    if(previews.length===0){setErr("Choisis au moins une photo ou vidéo");return;}
    const badWords=["nude","naked","sex","porn","xxx","nsfw","18+","adult","explicit","nudité","sexe","porno"];
    const captionLower=(caption||"").toLowerCase();
    if(badWords.some(w=>captionLower.includes(w))){
      setErr("❌ Contenu inapproprié détecté. Blue Life interdit tout contenu adulte ou explicit.");
      return;
    }
    setUploading(true);setProg(5);
    try{
      const isSingleVideo=previews.length===1&&previews[0].ftype==="video";
      let urls=[];
      const type=isSingleVideo?"video":"image";
      if(isSingleVideo){
        const{url}=await upload(previews[0].file);
        urls=[url];
        setProg(80);
      }else{
        let completed=0;
        urls=await Promise.all(previews.map(async(p)=>{
          const{url}=await upload(p.file);
          completed++;
          setProg(10+Math.round((completed/previews.length)*70));
          return url;
        }));
      }
      setProg(90);

      let imageHash=null, isDetectedCopy=false;
      if(!isSingleVideo&&previews[0]&&previews[0].file){
        try{
          const buf=await previews[0].file.arrayBuffer();
          const hashBuf=await crypto.subtle.digest("SHA-256",buf);
          imageHash=Array.from(new Uint8Array(hashBuf)).map(b=>b.toString(16).padStart(2,"0")).join("");
          const existing=await db("/Posts?image_hash=eq."+imageHash+"&username=neq."+encodeURIComponent(user.username)+"&limit=1");
          isDetectedCopy=Array.isArray(existing)&&existing.length>0;
        }catch(e){}
      }

      let audioId=null, audioTitle=null;
      if(isSingleVideo){
        if(selectedSound){
          audioId=selectedSound.id;
          audioTitle=selectedSound.title;
          db("/audio_tracks?id=eq."+selectedSound.id,{method:"PATCH",body:JSON.stringify({usage_count:(selectedSound.usage_count||0)+1})}).catch(()=>{});
        }else{
          try{
            const defaultTitle=soundTitle.trim()||("Son original · "+(user.displayName||user.username));
            const newTrack=await db("/audio_tracks",{method:"POST",body:JSON.stringify({
              title:defaultTitle,artist:"@"+encodeURIComponent(user.username),audio_url:urls[0],added_by:user.username,usage_count:1
            }),headers:{Prefer:"return=representation"}});
            if(Array.isArray(newTrack)&&newTrack[0]){audioId=newTrack[0].id;audioTitle=newTrack[0].title;}
          }catch(e){}
        }
      }

      const postData={
        id:"local_"+Date.now()+"_"+Math.random().toString(36).slice(2,8),
        username:postAsPage?postAsPage.slug:user.username,
        display_name:postAsPage?postAsPage.name:(user.displayName||user.username),
        avatar:postAsPage?(postAsPage.logo||""):(user.avatar||""),
        page_id:postAsPage?postAsPage.id:null,
        image_hash:imageHash,
        is_detected_copy:isDetectedCopy,
        caption:caption||"",
        image:urls[0],
        images:urls.length>1?JSON.stringify(urls):null,
        type,
        duration:type==="video"?Math.round(previews[0].duration||0):null,
        trim_start:isSingleVideo?trimStart:null,
        trim_end:isSingleVideo&&trimEnd>0?trimEnd:null,
        muted_original:isSingleVideo?mutedOriginal:false,
        likes_count:0,
        sponsored:false,
        audio_id:audioId,
        audio_title:audioTitle,
        verified:!!user.verified,
        verified_until:user.verified_until||null,
        created_at:new Date().toISOString()
      };
      const res=await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/Posts",{
        method:"POST",
        headers:{
          "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
          "Content-Type":"application/json",
          "Prefer":"return=representation"
        },
        body:JSON.stringify({...(({id,...rest})=>rest)(postData),..._postLoc})
      });
      setProg(100);
      if(!res.ok){
        const errTxt=await res.text();
        console.error("Post save failed:",res.status,errTxt);
        setErr("⚠️ Échec de l'enregistrement sur Supabase (code "+res.status+"). Rien n'a été sauvegardé. Réponse du serveur : "+errTxt.slice(0,300));
        setUploading(false);setProg(0);
        return;
      }
      const saved=await res.json();
      const finalPost=Array.isArray(saved)&&saved[0]?saved[0]:postData;
      onDone(finalPost);
      db("/Follows?following=eq."+encodeURIComponent(user.username)+"&select=follower").then(followers=>{
        if(Array.isArray(followers)){
          followers.forEach(f=>{
            sendPushNotification({
              type:type==="video"?"reel":"post",
              receiver:f.follower,
              sender:user.username,
              message:caption?caption.slice(0,80):""
            });
          });
        }
      }).catch(()=>{});
      db("/premium_subscriptions?creator=eq."+encodeURIComponent(user.username)+"&select=subscriber").then(subs=>{
        if(Array.isArray(subs)){
          subs.forEach(s=>{
            sendPushNotification({
              type:"premium_new_post",
              receiver:s.subscriber,
              sender:user.username,
              message:"⭐ "+encodeURIComponent(user.username)+" (que tu soutiens) vient de publier !"
            });
          });
        }
      }).catch(()=>{});
    }catch(e){setErr("Erreur upload: "+e.message);}
    setUploading(false);setProg(0);
  }

  const singleVideo=previews.length===1&&previews[0].ftype==="video";

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:500,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12,position:"sticky",top:0,background:C.navy,zIndex:10}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>Nouveau post</span>
        <button onClick={publish} disabled={uploading} style={{background:uploading?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",border:"none",borderRadius:10,padding:"8px 18px",color:"#fff",fontWeight:700,cursor:uploading?"not-allowed":"pointer",fontSize:14}}>
          {uploading?"⏳...":"Publier"}
        </button>
      </div>
      <div style={{padding:20}}>
        {uploading&&<div style={{marginBottom:14}}><div style={{height:4,background:C.w4,borderRadius:4,overflow:"hidden"}}><div style={{height:"100%",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",width:prog+"%",transition:"width 0.3s",borderRadius:4}}/></div><div style={{fontSize:12,color:C.w3,marginTop:6,textAlign:"center"}}>Upload {prog}%</div></div>}

        {previews.length===0?(
          <div onClick={()=>!uploading&&ref.current.click()} style={{width:"100%",aspectRatio:"1/1",borderRadius:20,border:"2px dashed "+C.border,background:C.w5,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:"pointer",marginBottom:14}}>
            <div style={{fontSize:48,marginBottom:10}}>📁</div>
            <div style={{fontWeight:700,fontSize:15,color:C.white}}>Photo(s) ou Vidéo</div>
            <div style={{fontSize:12,color:C.w3,marginTop:4}}>Depuis ta galerie · plusieurs photos possibles</div>
          </div>
        ):singleVideo?(
          <div style={{width:"100%",aspectRatio:"1/1",borderRadius:20,overflow:"hidden",marginBottom:14,position:"relative"}}>
            <video src={previews[0].url} autoPlay muted={previewMuted||mutedOriginal} loop playsInline style={{width:"100%",height:"100%",objectFit:"cover"}}/>
            <button onClick={()=>setPreviewMuted(m=>!m)} style={{position:"absolute",bottom:10,left:10,background:"rgba(0,0,0,0.6)",borderRadius:"50%",width:34,height:34,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:15,border:"none",cursor:"pointer"}}>{(previewMuted||mutedOriginal)?"🔇":"🔊"}</button>
            <div style={{position:"absolute",bottom:10,right:10,display:"flex",gap:6}}>
              {!uploading&&<button onClick={()=>setShowTrimEditor(true)} style={{background:"rgba(0,0,0,0.6)",borderRadius:8,padding:"4px 10px",color:"#fff",fontSize:11,border:"none",cursor:"pointer"}}>✂️ Modifier</button>}
              {!uploading&&<button onClick={()=>ref.current.click()} style={{background:"rgba(0,0,0,0.6)",borderRadius:8,padding:"4px 10px",color:"#fff",fontSize:11,border:"none",cursor:"pointer"}}>Changer ✏️</button>}
            </div>
            {(trimStart>0||trimEnd<(previews[0].duration||0))&&<div style={{position:"absolute",top:10,left:10,background:"rgba(0,0,0,0.6)",borderRadius:8,padding:"3px 8px",color:"#fff",fontSize:10}}>✂️ {Math.round(trimStart)}s–{Math.round(trimEnd)}s{mutedOriginal?" · 🎵":""}</div>}
          </div>
        ):(
          <div style={{marginBottom:14}}>
            <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:4}}>
              {previews.map((p,i)=>(
                <div key={i} style={{position:"relative",flexShrink:0,width:100,height:100,borderRadius:14,overflow:"hidden"}}>
                  <img src={p.url} alt="" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                  {!uploading&&<button onClick={()=>removePreview(i)} style={{position:"absolute",top:4,right:4,width:22,height:22,borderRadius:"50%",background:"rgba(0,0,0,0.6)",color:"#fff",border:"none",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,padding:0}}>✕</button>}
                  {i===0&&<div style={{position:"absolute",bottom:4,left:4,background:C.accent,color:"#fff",fontSize:9,fontWeight:700,padding:"2px 6px",borderRadius:6}}>Couverture</div>}
                </div>
              ))}
              {previews.length<10&&!uploading&&(
                <div onClick={()=>ref.current.click()} style={{flexShrink:0,width:100,height:100,borderRadius:14,border:"2px dashed "+C.border,background:C.w5,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:28,color:C.w3}}>+</div>
              )}
            </div>
            <div style={{fontSize:11,color:C.w3,marginTop:6}}>{previews.length} photo{previews.length>1?"s":""} sélectionnée{previews.length>1?"s":""}</div>
          </div>
        )}
        <input ref={ref} type="file" accept="image/*,video/*" multiple onChange={pick} style={{display:"none"}}/>
        <textarea value={caption} onChange={e=>setCaption(e.target.value)} placeholder="Légende (optionnelle)..." rows={3} style={{width:"100%",padding:"12px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",resize:"none",fontFamily:"inherit",marginBottom:10}}/>

        {previews.length===1&&previews[0].ftype==="video"&&(
          <div style={{background:C.w5,borderRadius:12,border:"1px solid "+C.border,padding:14,marginBottom:10}}>
            <div style={{color:C.w3,fontSize:12,fontWeight:700,marginBottom:10,display:"flex",alignItems:"center",gap:6}}>🎵 Son</div>
            {selectedSound?(
              <div style={{display:"flex",alignItems:"center",gap:10,background:C.navy,borderRadius:10,padding:"10px 12px"}}>
                <div style={{flex:1,color:C.white,fontSize:13,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{selectedSound.title}</div>
                <button onClick={()=>setSelectedSound(null)} style={{background:"none",border:"none",color:C.w3,cursor:"pointer",fontSize:13}}>Changer</button>
              </div>
            ):(
              <>
                <input value={soundTitle} onChange={e=>setSoundTitle(e.target.value)} placeholder="Nommer ce son (optionnel, pour le rendre réutilisable)" style={{width:"100%",padding:"10px 13px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:13,outline:"none",marginBottom:8,boxSizing:"border-box"}}/>
                <button onClick={()=>setShowSoundPicker(true)} style={{width:"100%",padding:"10px",borderRadius:10,border:"1px solid "+C.border,background:"none",color:C.accent2,fontWeight:600,fontSize:13,cursor:"pointer"}}>Choisir un son existant dans la bibliothèque</button>
              </>
            )}
          </div>
        )}

        {err&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13}}>{err}</div>}
      </div>
      {showSoundPicker&&(
        <SoundPickerSheet onClose={()=>setShowSoundPicker(false)} onPick={(track)=>{setSelectedSound(track);setSoundTitle("");setShowSoundPicker(false);}}/>
      )}
      {showTrimEditor&&singleVideo&&(()=>{
        const dur=previews[0].duration||30;
        return (
          <div style={{position:"fixed",inset:0,background:"#000",zIndex:950,display:"flex",flexDirection:"column",maxWidth:480,margin:"0 auto"}}>
            <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid rgba(255,255,255,0.15)"}}>
              <button onClick={()=>setShowTrimEditor(false)} style={{background:"none",border:"none",cursor:"pointer",color:"#fff"}}><I.Back/></button>
              <span style={{fontWeight:700,fontSize:16,color:"#fff",flex:1,textAlign:"center"}}>Modifier</span>
              <button onClick={()=>setShowTrimEditor(false)} style={{background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",border:"none",borderRadius:10,padding:"7px 16px",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer"}}>OK</button>
            </div>
            <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",background:"#000",position:"relative"}}>
              <video ref={editPreviewRef} src={previews[0].url} muted={mutedOriginal} playsInline autoPlay loop style={{maxWidth:"100%",maxHeight:"100%"}}/>
            </div>
            <div style={{padding:"18px 20px 32px",background:"#111"}}>
              <div style={{color:"#fff",fontSize:13,fontWeight:700,marginBottom:8}}>✂️ Découper ({Math.round(trimStart)}s – {Math.round(trimEnd)}s)</div>
              <div style={{color:"rgba(255,255,255,0.5)",fontSize:11,marginBottom:6}}>Début</div>
              <input type="range" min="0" max={dur} step="0.5" value={trimStart} onChange={e=>{
                const v=Math.min(Number(e.target.value),trimEnd-1);
                setTrimStart(Math.max(0,v));
                if(editPreviewRef.current)editPreviewRef.current.currentTime=v;
              }} style={{width:"100%",accentColor:C.accent,marginBottom:12}}/>
              <div style={{color:"rgba(255,255,255,0.5)",fontSize:11,marginBottom:6}}>Fin</div>
              <input type="range" min="0" max={dur} step="0.5" value={trimEnd} onChange={e=>{
                const v=Math.max(Number(e.target.value),trimStart+1);
                setTrimEnd(Math.min(dur,v));
              }} style={{width:"100%",accentColor:C.accent,marginBottom:18}}/>

              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 0",borderTop:"1px solid rgba(255,255,255,0.15)"}}>
                <div>
                  <div style={{color:"#fff",fontSize:13,fontWeight:700}}>🎵 Remplacer le son</div>
                  <div style={{color:"rgba(255,255,255,0.5)",fontSize:11,marginTop:2}}>{mutedOriginal?(selectedSound?selectedSound.title:"Choisis un son ci-dessous"):"Garde le son original de la vidéo"}</div>
                </div>
                <div onClick={()=>setMutedOriginal(m=>!m)} style={{width:46,height:26,borderRadius:13,background:mutedOriginal?C.accent:C.w4,position:"relative",cursor:"pointer",flexShrink:0}}>
                  <div style={{width:20,height:20,borderRadius:"50%",background:"#fff",position:"absolute",top:3,left:mutedOriginal?23:3,transition:"left 0.2s"}}/>
                </div>
              </div>
              {mutedOriginal&&(
                <button onClick={()=>setShowSoundPicker(true)} style={{width:"100%",padding:"11px",borderRadius:10,border:"1px solid rgba(255,255,255,0.2)",background:"transparent",color:C.accent2,fontWeight:600,fontSize:13,cursor:"pointer",marginTop:8}}>
                  {selectedSound?"Changer de son":"Choisir un son"}
                </button>
              )}
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:10,marginTop:14,lineHeight:1.5}}>Le début/fin choisis contrôlent où la lecture démarre et boucle — la vidéo d'origine n'est pas recoupée.</div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

const TEXT_POST_BACKGROUNDS=[
  "linear-gradient(135deg,#2f6fed,#1e4d8c)",
  "linear-gradient(135deg,#f5576c,#f093fb)",
  "linear-gradient(135deg,#43e97b,#38f9d7)",
  "linear-gradient(135deg,#fa709a,#fee140)",
  "linear-gradient(135deg,#30cfd0,#330867)",
  "linear-gradient(135deg,#a18cd1,#fbc2eb)",
  "linear-gradient(135deg,#ff9a56,#ff6a88)",
  "linear-gradient(135deg,#232526,#414345)",
];

function TextPost({user,onBack,onDone,showToast,postAsPage}){
  const [text,setText]=useState("");
  const [bgIndex,setBgIndex]=useState(0);
  const [posting,setPosting]=useState(false);
  const [err,setErr]=useState("");
  const MAX_LEN=500;

  async function publish(){
    if(isRestricted(user,"restricted_posting","posting_restricted_until")){setErr("Ton compte est temporairement restreint de publication.");return;}
    const _postLoc=await getPostLocation();
    if(!text.trim()){setErr("Écris quelque chose avant de publier");return;}
    setPosting(true);setErr("");
    const postData={
      username:postAsPage?postAsPage.slug:user.username,
      display_name:postAsPage?postAsPage.name:(user.displayName||user.username),
      avatar:postAsPage?(postAsPage.logo||""):(user.avatar||""),
      page_id:postAsPage?postAsPage.id:null,
      caption:text.trim(),
      image:null,
      images:null,
      type:"text",
      text_bg:TEXT_POST_BACKGROUNDS[bgIndex],
      duration:null,
      likes_count:0,
      sponsored:false,
      audio_id:null,
      audio_title:null,
      verified:!!user.verified,
      verified_until:user.verified_until||null,
      ..._postLoc,
      created_at:new Date().toISOString()
    };
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/Posts",{
        method:"POST",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify(postData)
      });
      const saved=await res.json().catch(()=>null);
      if(!res.ok||!Array.isArray(saved)||saved.length===0){
        setErr("Échec de la publication. Réessaie.");
        setPosting(false);
        return;
      }
      showToast&&showToast("✅ Publié !");
      onDone&&onDone(saved[0]);
    }catch(e){
      setErr("Erreur réseau. Réessaie.");
      setPosting(false);
    }
  }

  return(
    <div style={{position:"fixed",inset:0,background:TEXT_POST_BACKGROUNDS[bgIndex],zIndex:900,display:"flex",flexDirection:"column",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif",transition:"background 0.2s"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"16px"}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:"#fff"}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:16,color:"#fff"}}>Publier un texte</span>
        <button onClick={posting?undefined:publish} disabled={posting||!text.trim()} style={{background:"none",border:"none",color:(posting||!text.trim())?"rgba(255,255,255,0.5)":"#fff",fontWeight:700,fontSize:15,cursor:(posting||!text.trim())?"not-allowed":"pointer"}}>
          {posting?"...":"Publier"}
        </button>
      </div>
      <div style={{padding:20,flex:1,display:"flex",flexDirection:"column"}}>
        {err&&<div style={{background:"rgba(0,0,0,0.3)",border:"1px solid rgba(255,255,255,0.3)",borderRadius:10,padding:"10px 14px",color:"#fff",fontSize:13,marginBottom:14}}>{err}</div>}
        <textarea
          value={text}
          onChange={e=>setText(e.target.value.slice(0,MAX_LEN))}
          placeholder="Quoi de neuf ?"
          autoFocus
          style={{flex:1,width:"100%",background:"transparent",border:"none",outline:"none",color:"#fff",fontSize:24,fontWeight:700,lineHeight:1.5,resize:"none",fontFamily:"inherit",textAlign:"center"}}
        />
        <div style={{textAlign:"right",color:"rgba(255,255,255,0.7)",fontSize:12,marginBottom:16}}>{text.length}/{MAX_LEN}</div>
        <div style={{display:"flex",gap:10,justifyContent:"center",paddingBottom:10}}>
          {TEXT_POST_BACKGROUNDS.map((bg,i)=>(
            <button key={i} onClick={()=>setBgIndex(i)} style={{width:32,height:32,borderRadius:"50%",background:bg,border:i===bgIndex?"3px solid #fff":"3px solid transparent",cursor:"pointer",padding:0,boxShadow:i===bgIndex?"0 0 0 2px rgba(255,255,255,0.4)":"none"}}/>
          ))}
        </div>
      </div>
    </div>
  );
}

function NewPoll({user,onBack,onDone,showToast,postAsPage}){
  const [question,setQuestion]=useState("");
  const [options,setOptions]=useState([{text:"",image:"",uploading:false},{text:"",image:"",uploading:false}]);
  const [posting,setPosting]=useState(false);
  const [err,setErr]=useState("");
  const fileRefs=useRef([]);

  function updateOptionText(i,val){
    setOptions(prev=>prev.map((o,idx)=>idx===i?{...o,text:val}:o));
  }
  function addOption(){
    setOptions(prev=>[...prev,{text:"",image:"",uploading:false}]);
  }
  function removeOption(i){
    if(options.length>2)setOptions(prev=>prev.filter((_,idx)=>idx!==i));
  }
  async function pickOptionImage(i,file){
    if(!file)return;
    setOptions(prev=>prev.map((o,idx)=>idx===i?{...o,uploading:true}:o));
    try{
      const{url}=await upload(file);
      setOptions(prev=>prev.map((o,idx)=>idx===i?{...o,image:url,uploading:false}:o));
    }catch{
      setOptions(prev=>prev.map((o,idx)=>idx===i?{...o,uploading:false}:o));
      showToast&&showToast("⚠️ Échec de l'upload de l'image");
    }
  }
  function removeOptionImage(i){
    setOptions(prev=>prev.map((o,idx)=>idx===i?{...o,image:""}:o));
  }

  async function publish(){
    if(isRestricted(user,"restricted_posting","posting_restricted_until")){setErr("Ton compte est temporairement restreint de publication.");return;}
    const _postLoc=await getPostLocation();
    const trimmedQuestion=question.trim();
    const cleanOptions=options.map(o=>({text:o.text.trim(),image:o.image||""})).filter(o=>o.text||o.image);
    if(!trimmedQuestion){setErr("Écris une question avant de publier");return;}
    if(cleanOptions.length<2){setErr("Ajoute au moins deux options");return;}
    if(options.some(o=>o.uploading)){setErr("Attends la fin de l'upload des images");return;}
    setPosting(true);setErr("");
    const postData={
      username:postAsPage?postAsPage.slug:user.username,
      display_name:postAsPage?postAsPage.name:(user.displayName||user.username),
      avatar:postAsPage?(postAsPage.logo||""):(user.avatar||""),
      page_id:postAsPage?postAsPage.id:null,
      caption:trimmedQuestion,
      image:null,
      images:null,
      type:"poll",
      poll_options:JSON.stringify(cleanOptions),
      poll_votes:JSON.stringify(cleanOptions.map(()=>0)),
      poll_voters:JSON.stringify({}),
      likes_count:0,
      sponsored:false,
      verified:!!user.verified,
      verified_until:user.verified_until||null,
      ..._postLoc,
      created_at:new Date().toISOString()
    };
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/Posts",{
        method:"POST",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify(postData)
      });
      const saved=await res.json().catch(()=>null);
      if(!res.ok||!Array.isArray(saved)||saved.length===0){
        setErr("Échec de la publication. Réessaie.");
        setPosting(false);
        return;
      }
      showToast&&showToast("✅ Sondage publié !");
      onDone&&onDone(saved[0]);
    }catch(e){
      setErr("Erreur réseau. Réessaie.");
      setPosting(false);
    }
  }

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:900,display:"flex",flexDirection:"column",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"16px",borderBottom:"1px solid "+C.border}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:16,color:C.white}}>Créer un sondage</span>
        <button onClick={posting?undefined:publish} disabled={posting} style={{background:"none",border:"none",color:posting?C.w3:C.accent2,fontWeight:700,fontSize:15,cursor:posting?"not-allowed":"pointer"}}>
          {posting?"...":"Publier"}
        </button>
      </div>
      <div style={{padding:20,flex:1,overflowY:"auto"}}>
        {err&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{err}</div>}
        <textarea
          value={question}
          onChange={e=>setQuestion(e.target.value.slice(0,200))}
          placeholder="Pose ta question..."
          rows={2}
          style={{width:"100%",padding:"14px 16px",borderRadius:14,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:17,fontWeight:700,outline:"none",resize:"none",fontFamily:"inherit",marginBottom:16,boxSizing:"border-box"}}
        />
        {options.map((opt,i)=>(
          <div key={i} style={{border:"1px solid "+C.border,borderRadius:14,padding:12,marginBottom:10}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              {opt.image&&(
                <div style={{position:"relative",width:42,height:42,borderRadius:10,overflow:"hidden",flexShrink:0}}>
                  <img src={opt.image} alt="" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                  <button onClick={()=>removeOptionImage(i)} style={{position:"absolute",top:1,right:1,background:"rgba(0,0,0,0.6)",border:"none",borderRadius:"50%",width:16,height:16,color:"#fff",cursor:"pointer",fontSize:9,display:"flex",alignItems:"center",justifyContent:"center",padding:0}}>✕</button>
                </div>
              )}
              <input
                value={opt.text}
                onChange={e=>updateOptionText(i,e.target.value.slice(0,80))}
                placeholder={"Option "+(i+1)}
                style={{flex:1,minWidth:0,padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",boxSizing:"border-box"}}
              />
              {!opt.image&&(
                <button onClick={()=>fileRefs.current[i]&&fileRefs.current[i].click()} style={{background:C.w5,border:"1px solid "+C.border,borderRadius:10,width:42,height:42,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:17,flexShrink:0}}>
                  {opt.uploading?"⏳":"📷"}
                </button>
              )}
              <input ref={el=>fileRefs.current[i]=el} type="file" accept="image/*" onChange={e=>pickOptionImage(i,e.target.files[0])} style={{display:"none"}}/>
              {options.length>2&&(
                <button onClick={()=>removeOption(i)} style={{background:"none",border:"none",color:C.w3,cursor:"pointer",fontSize:18,padding:4,flexShrink:0}}>✕</button>
              )}
            </div>
          </div>
        ))}
        {(
          <button onClick={addOption} style={{width:"100%",padding:"12px",borderRadius:12,border:"1px dashed "+C.border,background:"transparent",color:C.accent2,fontWeight:700,cursor:"pointer",marginTop:4}}>
            ➕ Ajouter une option
          </button>
        )}
      </div>
    </div>
  );
}

function NewStory({user,onBack,onDone}){
  const ref=useRef(null);
  const [previews,setPreviews]=useState([]);
  const [activeIdx,setActiveIdx]=useState(0);
  const [uploading,setUploading]=useState(false);
  const [prog,setProg]=useState(0);
  const [err,setErr]=useState("");

  function pick(e){
    const files=Array.from(e.target.files||[]);
    if(files.length===0)return;
    setErr("");
    const entries=files.map(f=>({url:URL.createObjectURL(f),file:f,caption:""}));
    const startIdx=previews.length;
    setPreviews(prev=>[...prev,...entries].slice(0,10));
    setActiveIdx(Math.min(startIdx,9));
  }

  function removePreview(idx){
    const updated=previews.filter((_,i)=>i!==idx);
    setPreviews(updated);
    setActiveIdx(i=>Math.max(0,Math.min(i,updated.length-1)));
  }

  function updateActiveCaption(text){
    setPreviews(prev=>prev.map((p,i)=>i===activeIdx?{...p,caption:text}:p));
  }

  async function publish(){
    if(isRestricted(user,"restricted_posting","posting_restricted_until")){setErr("Ton compte est temporairement restreint de publication.");return;}
    const _postLoc=await getPostLocation();
    if(previews.length===0){setErr("Choisis au moins une photo");return;}
    setUploading(true);setProg(5);
    const succeeded=[];
    let failCount=0;
    let lastFailText="";
    try{
      let completed=0;
      const uploaded=await Promise.all(previews.map(async(p)=>{
        const{url}=await upload(p.file);
        completed++;
        setProg(5+Math.round((completed/previews.length)*70));
        return{url,caption:p.caption||""};
      }));
      setProg(80);
      const baseTime=Date.now();
      for(let i=0;i<uploaded.length;i++){
        const story={
          author:user.username,display_name:user.displayName||user.username,avatar:user.avatar||"",
          image:uploaded[i].url,caption:uploaded[i].caption,
          verified:!!user.verified,verified_until:user.verified_until||null,
          expires_at:new Date(baseTime+i+86400000).toISOString(),
          created_at:new Date(baseTime+i).toISOString()
        };
        try{
          const res=await fetch("https://dozesbnushgqabbsjrgv.supabase.co/rest/v1/stories",{
            method:"POST",
            headers:{
              "apikey":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
              "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvemVzYm51c2hncWFiYnNqcmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NjA2NDgsImV4cCI6MjA5NjEzNjY0OH0.oMLosQyEvBT1DB8gvPIvKFs_IxQkJuEkGuzoS8A6-YI",
              "Content-Type":"application/json",
              "Prefer":"return=representation"
            },
            body:JSON.stringify(story)
          });
          if(res.ok){
            const saved=await res.json();
            succeeded.push(Array.isArray(saved)&&saved[0]?saved[0]:story);
          }else{
            failCount++;
            lastFailText=await res.text();
          }
        }catch(e){failCount++;lastFailText=e.message;}
      }
      setProg(100);
    }catch(e){
      setErr("Erreur: "+e.message);
      setUploading(false);setProg(0);
      return;
    }
    if(failCount>0){
      setErr("⚠️ "+failCount+" story"+(failCount>1?"s":"")+" sur "+previews.length+" n'a pas pu être enregistrée (code erreur : "+lastFailText.slice(0,150)+"). "+(succeeded.length>0?succeeded.length+" publiée(s) avec succès.":"Rien n'a été publié."));
      setUploading(false);setProg(0);
      return;
    }
    db("/Follows?following=eq."+encodeURIComponent(user.username)+"&select=follower").then(followers=>{
      if(Array.isArray(followers)){
        followers.forEach(f=>{
          sendPushNotification({
            type:"story",
            receiver:f.follower,
            sender:user.username,
            message:"a ajouté une photo à sa story"
          });
        });
      }
    }).catch(()=>{});
    onDone(succeeded);
    setUploading(false);setProg(0);
  }

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:600,maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif",overflowY:"auto"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>Nouvelle Story</span>
        <button onClick={publish} disabled={uploading||previews.length===0} style={{background:previews.length===0||uploading?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",border:"none",borderRadius:10,padding:"8px 18px",color:"#fff",fontWeight:700,cursor:previews.length===0?"not-allowed":"pointer",fontSize:14}}>
          {uploading?"⏳...":previews.length>1?"Publier ("+previews.length+")":"Publier"}
        </button>
      </div>
      {uploading&&<div style={{padding:"10px 24px 0"}}><div style={{height:4,background:C.w4,borderRadius:4,overflow:"hidden"}}><div style={{height:"100%",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",width:prog+"%",transition:"width 0.3s",borderRadius:4}}/></div></div>}
      <div style={{padding:24,display:"flex",flexDirection:"column",alignItems:"center",gap:12}}>
        <div style={{width:"100%",maxWidth:300,aspectRatio:"9/16",borderRadius:20,overflow:"hidden",border:"2px dashed "+(previews.length?"transparent":C.border),background:previews.length?"transparent":C.w5,position:"relative"}}>
          <div onClick={()=>!uploading&&ref.current.click()} style={{position:"absolute",inset:0,cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            {previews.length>0?<img src={previews[activeIdx].url} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(<><div style={{fontSize:52,marginBottom:10}}>📸</div><div style={{fontWeight:700,fontSize:15,color:C.white}}>Choisir une ou plusieurs photos</div></>)}
          </div>
          {previews.length>0&&!uploading&&<div onClick={()=>ref.current.click()} style={{position:"absolute",top:10,right:10,background:"rgba(0,0,0,0.6)",borderRadius:8,padding:"4px 10px",color:"#fff",fontSize:11,cursor:"pointer"}}>Ajouter ➕</div>}
          {previews.length>1&&<div style={{position:"absolute",top:10,left:10,background:"rgba(0,0,0,0.55)",color:"#fff",fontSize:11,fontWeight:700,padding:"3px 9px",borderRadius:10}}>{activeIdx+1}/{previews.length}</div>}
          {previews.length>0&&(
            <div style={{position:"absolute",left:14,right:14,bottom:18}} onClick={e=>e.stopPropagation()}>
              <textarea
                value={previews[activeIdx].caption}
                onChange={e=>updateActiveCaption(e.target.value)}
                placeholder="Ajouter une légende..."
                rows={2}
                style={{width:"100%",background:"rgba(0,0,0,0.45)",border:"none",borderRadius:12,padding:"10px 12px",color:"#fff",fontSize:15,fontWeight:600,textAlign:"center",outline:"none",resize:"none",fontFamily:"inherit",boxSizing:"border-box"}}
              />
            </div>
          )}
        </div>
        <input ref={ref} type="file" accept="image/*" multiple onChange={pick} style={{display:"none"}}/>

        {previews.length>1&&(
          <div style={{display:"flex",gap:8,overflowX:"auto",width:"100%",paddingBottom:4}}>
            {previews.map((p,i)=>(
              <div key={i} onClick={()=>setActiveIdx(i)} style={{position:"relative",flexShrink:0,width:56,height:56,borderRadius:10,overflow:"hidden",border:"2px solid "+(i===activeIdx?C.accent:"transparent"),cursor:"pointer"}}>
                <img src={p.url} alt="" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                {!uploading&&<button onClick={(e)=>{e.stopPropagation();removePreview(i);}} style={{position:"absolute",top:2,right:2,width:18,height:18,borderRadius:"50%",background:"rgba(0,0,0,0.6)",color:"#fff",border:"none",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,padding:0}}>✕</button>}
              </div>
            ))}
          </div>
        )}

        <div style={{background:C.w5,border:"1px solid "+C.border2,borderRadius:12,padding:12,width:"100%"}}>
          <div style={{fontSize:13,color:C.w3}}>⏰ {previews.length>1?"Chaque photo est visible":"Visible"} pendant <strong style={{color:C.white}}>24 heures</strong> puis disparaît</div>
        </div>
        {err&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,width:"100%"}}>{err}</div>}
      </div>
    </div>
  );
}

function VideoOverlayPlayer({videos,startIdx,onClose,onProfile,showToast,onRequireAuth,user,onOpenSound,followingUsernames}){
  const [current,setCurrent]=useState(startIdx||0);
  const containerRef=useRef(null);

  useEffect(()=>{
    if(containerRef.current)containerRef.current.scrollTop=(startIdx||0)*window.innerHeight;
  },[]);

  function handleScroll(){
    if(!containerRef.current)return;
    const h=window.innerHeight;
    const idx=Math.round(containerRef.current.scrollTop/h);
    if(idx!==current)setCurrent(idx);
  }

  if(!videos||videos.length===0)return null;

  return(
    <div style={{position:"fixed",inset:0,background:"#000",zIndex:1000,maxWidth:480,margin:"0 auto"}}>
      <button onClick={onClose} style={{position:"absolute",top:14,left:16,zIndex:20,background:"none",border:"none",cursor:"pointer",color:"#fff",filter:"drop-shadow(0 1px 3px rgba(0,0,0,0.8))",display:"flex"}}>
        <I.Back/>
      </button>
      <div ref={containerRef} onScroll={handleScroll} style={{height:"100%",overflowY:"scroll",scrollSnapType:"y mandatory"}}>
        {videos.map((p,i)=>(
          <div key={i} style={{height:"100dvh",scrollSnapAlign:"start",flexShrink:0}}>
            <ReelItem p={p} isActive={i===current} onProfile={onProfile} showToast={showToast} user={user} onRequireAuth={onRequireAuth} onOpenSound={onOpenSound} followingUsernames={followingUsernames}/>
          </div>
        ))}
      </div>
    </div>
  );
}

function StoryViewer({allGroups,startGroupIdx,onClose,currentUser,onProfile}){
  const [groupIdx,setGroupIdx]=useState(startGroupIdx||0);
  const [idx,setIdx]=useState(0);
  const [progress,setProgress]=useState(0);
  const [paused,setPaused]=useState(false);
  const [views,setViews]=useState(0);
  const [imgLoaded,setImgLoaded]=useState(false);
  const [replyText,setReplyText]=useState("");
  const [sendingReply,setSendingReply]=useState(false);
  const stories=allGroups[groupIdx]||[];
  const story=stories[idx];
  useEffect(()=>{setImgLoaded(false);},[idx,groupIdx]);

  async function sendReply(){
    if(!replyText.trim()||!currentUser||!currentUser.username)return;
    setSendingReply(true);
    const text="Story: "+replyText.trim();
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/messages",{
        method:"POST",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({sender:currentUser.username,receiver:story.author,text})
      });
      if(res.ok){
        sendPushNotification({type:"message",receiver:story.author,sender:currentUser.username,message:text.slice(0,100)});
        setReplyText("");
      }
    }catch{}
    setSendingReply(false);
  }
  const pausedRef=useRef(false);
  const holdTimerRef=useRef(null);
  const wasHoldRef=useRef(false);
  const safeUser=currentUser||{username:""};
  const isMyStory=!!(safeUser.username&&story&&story.author===safeUser.username);

  useEffect(()=>{pausedRef.current=paused;},[paused]);

  useEffect(()=>{
    if(!story)return;
    setProgress(0);
    const t0=Date.now();
    let accumulatedPause=0;
    let pauseStart=null;
    const timer=setInterval(()=>{
      if(pausedRef.current){
        if(pauseStart===null)pauseStart=Date.now();
        return;
      }
      if(pauseStart!==null){accumulatedPause+=Date.now()-pauseStart;pauseStart=null;}
      const p=((Date.now()-t0-accumulatedPause)/5000)*100;
      if(p>=100){
        if(idx<stories.length-1)setIdx(i=>i+1);
        else if(groupIdx<allGroups.length-1){setGroupIdx(g=>g+1);setIdx(0);}
        else onClose();
        clearInterval(timer);
      }
      else setProgress(p);
    },50);
    return()=>clearInterval(timer);
  },[idx,story]);

  useEffect(()=>{
    if(!story)return;
    if(safeUser.username)markStorySeen(safeUser.username,story.id);
    if(!story.id||String(story.id).startsWith("local_"))return;
    if(isMyStory){
      db("/stories?id=eq."+story.id+"&select=views").then(d=>{
        if(Array.isArray(d)&&d[0])setViews(d[0].views||0);
      }).catch(()=>{});
    }else if(safeUser.username){
      db("/stories?id=eq."+story.id+"&select=views").then(d=>{
        const current=(Array.isArray(d)&&d[0]&&d[0].views)||0;
        db("/stories?id=eq."+story.id,{method:"PATCH",body:JSON.stringify({views:current+1}),headers:{Prefer:"return=minimal"}}).catch(()=>{});
      }).catch(()=>{});
    }
  },[idx,story&&story.id]);

  if(!story)return null;
  function getClientX(e){
    if(e.changedTouches&&e.changedTouches[0])return e.changedTouches[0].clientX;
    if(e.touches&&e.touches[0])return e.touches[0].clientX;
    return e.clientX;
  }
  const tap=(e)=>{
    const x=getClientX(e),w=window.innerWidth;
    if(x<w/2){
      if(idx>0)setIdx(i=>i-1);
      else if(groupIdx>0){const prevLen=allGroups[groupIdx-1].length;setGroupIdx(g=>g-1);setIdx(prevLen-1);}
    }else{
      if(idx<stories.length-1)setIdx(i=>i+1);
      else if(groupIdx<allGroups.length-1){setGroupIdx(g=>g+1);setIdx(0);}
      else onClose();
    }
  };

  const lastTapRef=useRef(0);
  const touchStartXRef=useRef(0);
  function pressStart(e){
    if(e.cancelable)e.preventDefault();
    wasHoldRef.current=false;
    touchStartXRef.current=getClientX(e);
    holdTimerRef.current=setTimeout(()=>{wasHoldRef.current=true;setPaused(true);},250);
  }
  function pressEnd(e){
    if(e.cancelable)e.preventDefault();
    clearTimeout(holdTimerRef.current);
    if(wasHoldRef.current){setPaused(false);wasHoldRef.current=false;return;}
    const now=Date.now();
    if(now-lastTapRef.current<350)return;
    lastTapRef.current=now;
    const deltaX=getClientX(e)-touchStartXRef.current;
    if(Math.abs(deltaX)>70){
      if(deltaX<0&&groupIdx<allGroups.length-1){setGroupIdx(g=>g+1);setIdx(0);}
      else if(deltaX>0&&groupIdx>0){setGroupIdx(g=>g-1);setIdx(0);}
      else if(deltaX<0&&groupIdx===allGroups.length-1)onClose();
      return;
    }
    tap(e);
  }

  return(
    <div style={{position:"fixed",inset:0,background:"#000",zIndex:1000,maxWidth:480,margin:"0 auto",display:"flex",flexDirection:"column"}}>
      <div style={{display:"flex",gap:3,padding:"12px 12px 0",position:"absolute",top:0,left:0,right:0,zIndex:2}}>
        {stories.map((_,i)=>(
          <div key={i} style={{flex:1,height:3,background:"rgba(255,255,255,0.3)",borderRadius:2,overflow:"hidden"}}>
            <div style={{height:"100%",background:"#fff",width:(i<idx?"100%":i===idx?progress+"%":"0%"),transition:"none"}}/>
          </div>
        ))}
      </div>
      <div style={{position:"absolute",top:22,left:0,right:0,zIndex:2,display:"flex",alignItems:"center",padding:"0 16px",gap:10}}>
        <div onClick={(e)=>{e.stopPropagation();onProfile&&onProfile(story.author,story.avatar);}} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",flex:1,minWidth:0}}>
          <Avatar src={story.avatar||""} name={story.author} size={36} border="#fff"/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{color:"#fff",fontWeight:700,fontSize:14,textShadow:"0 1px 3px rgba(0,0,0,0.8)",display:"flex",alignItems:"center",gap:5}}>
              <span>{story.display_name||story.author}</span>
              {isBadgeActive(story)&&(
                <svg width="13" height="13" viewBox="0 0 24 24" fill="#3897f0" style={{flexShrink:0}}>
                  <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
                  <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </div>
          <div style={{color:"rgba(255,255,255,0.7)",fontSize:11,textShadow:"0 1px 3px rgba(0,0,0,0.8)"}}>{ago(story.created_at)}</div>
        </div>
        </div>
        <button onClick={onClose} style={{background:"rgba(0,0,0,0.4)",border:"none",color:"#fff",width:32,height:32,borderRadius:"50%",cursor:"pointer",fontSize:18,display:"flex",alignItems:"center",justifyContent:"center"}}><I.X/></button>
      </div>
      <div
        onTouchStart={pressStart} onTouchEnd={pressEnd}
        onMouseDown={pressStart} onMouseUp={pressEnd}
        style={{flex:1,cursor:"pointer",position:"relative"}}
      >
        {!imgLoaded&&<div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",background:"#000"}}>
          <div style={{width:36,height:36,border:"3px solid rgba(255,255,255,0.3)",borderTopColor:"#fff",borderRadius:"50%",animation:"spin 0.8s linear infinite"}}/>
        </div>}
        <img src={story.image} alt="" onLoad={()=>setImgLoaded(true)} style={{width:"100%",height:"100%",objectFit:"cover",position:"absolute",opacity:imgLoaded?1:0,transition:"opacity 0.2s"}}/>
      </div>
      <div style={{position:"absolute",bottom:0,left:0,right:0,padding:"12px 16px 32px",background:"linear-gradient(transparent,rgba(0,0,0,0.7))"}}>
        {story.caption&&<div style={{color:"#fff",fontSize:15,fontWeight:600,textAlign:"center",marginBottom:14,textShadow:"0 1px 4px rgba(0,0,0,0.8)",lineHeight:1.4}}>{story.caption}</div>}
        {isMyStory?(
          <div style={{display:"flex",alignItems:"center",gap:8,padding:"10px 16px",borderRadius:24,background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.3)",color:"#fff",width:"fit-content"}}>
            <I.Eye on={true}/>
            <span style={{fontSize:14,fontWeight:600}}>{fmt(views)} vue{views>1?"s":""}</span>
          </div>
        ):(
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <input
              value={replyText}
              onChange={e=>setReplyText(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&sendReply()}
              placeholder={"Répondre à "+(story.display_name||story.author)+"..."}
              onFocus={()=>setPaused(true)}
              onBlur={()=>setPaused(false)}
              style={{flex:1,padding:"10px 16px",borderRadius:24,background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.3)",color:"#fff",outline:"none",fontSize:14,boxSizing:"border-box"}}
            />
            {replyText.trim()&&(
              <button onClick={sendReply} disabled={sendingReply} style={{background:"none",border:"none",color:"#3897f0",fontWeight:700,fontSize:14,cursor:sendingReply?"not-allowed":"pointer",flexShrink:0}}>
                {sendingReply?"...":"Envoyer"}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function ProfileScreen({username,avatar,bio,displayName,isMe,currentUser,onBack,onMessage,onSettings,onCertification,onWallet,inTab,onUpdateAvatar,onUpdateProfile,showToast,onOpenVideo}){
  const t=useTranslation();
  const [posts,setPosts]=useState([]);
  const [totalViews,setTotalViews]=useState(0);
  const [modMessages,setModMessages]=useState(null);
  const [appealingId,setAppealingId]=useState(null);
  const [appealText,setAppealText]=useState("");
  const [appealSending,setAppealSending]=useState(false);
  const [appealedIds,setAppealedIds]=useState(()=>{
    try{return new Set(JSON.parse(localStorage.getItem("bl_appealed_ids")||"[]"));}catch{return new Set();}
  });
  const [followers,setFollowers]=useState(0);
  const [profileVerified,setProfileVerified]=useState(false);
  const [isPageProfile,setIsPageProfile]=useState(false);
  const [newCover,setNewCover]=useState("");
  const [newCoverPosition,setNewCoverPosition]=useState(50);
  const [newCoverZoom,setNewCoverZoom]=useState(100);
  const coverEditRef=useRef(null);
  const [profileVerifiedUntil,setProfileVerifiedUntil]=useState(null);
  const [followingCount,setFollowingCount]=useState(0);
  const [isFollowing,setIsFollowing]=useState(false);
  const [showProfileOptions,setShowProfileOptions]=useState(false);
  const [showReportModal,setShowReportModal]=useState(false);
  const [isBlocked,setIsBlocked]=useState(false);
  const [reportSending,setReportSending]=useState(false);

  useEffect(()=>{
    if(isMe||!currentUser||!currentUser.username)return;
    db("/blocks?blocker=eq."+encodeURIComponent(currentUser.username)+"&blocked=eq."+username+"&limit=1").then(d=>{
      setIsBlocked(Array.isArray(d)&&d.length>0);
    }).catch(()=>{});
  },[username,currentUser&&currentUser.username]);

  const [premiumPrice,setPremiumPrice]=useState(0);
  const [activeUserStories,setActiveUserStories]=useState(null);
  const [showFullAvatar,setShowFullAvatar]=useState(false);
  const [newUsernameInput,setNewUsernameInput]=useState(username||"");
  const [changingUsername,setChangingUsername]=useState(false);
  const [usernameChangeError,setUsernameChangeError]=useState("");

  async function submitUsernameChange(){
    const trimmed=newUsernameInput.trim();
    if(!trimmed||!/^[a-zA-Z0-9_.]+$/.test(trimmed)){
      setUsernameChangeError("Lettres, chiffres, _ et . uniquement");
      return;
    }
    if(trimmed===username){
      setUsernameChangeError("C'est déjà ton nom actuel");
      return;
    }
    setChangingUsername(true);setUsernameChangeError("");
    try{
      const res=await fetch(BLUELIFE_BACKEND_URL+"/api/change-username",{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({oldUsername:username,newUsername:trimmed})
      });
      const data=await res.json().catch(()=>({}));
      if(!res.ok&&res.status!==207){
        setUsernameChangeError(data.error||"Échec du changement");
        setChangingUsername(false);
        return;
      }
      showToast&&showToast("✅ @nom changé — reconnecte-toi pour voir partout le changement");
      setShowUsernameChange(false);
    }catch(e){
      setUsernameChangeError("Erreur réseau, réessaie");
    }
    setChangingUsername(false);
  }
  const [storyToView,setStoryToView]=useState(null);
  useEffect(()=>{
    const cutoff=new Date(Date.now()-86400000).toISOString();
    db("/stories?author=eq."+username+"&created_at=gt."+cutoff+"&order=created_at.asc").then(d=>{
      setActiveUserStories(Array.isArray(d)?d:[]);
    }).catch(()=>setActiveUserStories([]));
  },[username]);

  const [showAvatarChoice,setShowAvatarChoice]=useState(false);
  function handleAvatarTap(){
    if(activeUserStories&&activeUserStories.length>0){
      setShowAvatarChoice(true);
    }else{
      setShowFullAvatar(true);
    }
  }
  const [isPremiumSubscriber,setIsPremiumSubscriber]=useState(false);
  const [showPremiumPaymentChoice,setShowPremiumPaymentChoice]=useState(false);
  const [subscribing,setSubscribing]=useState(false);
  useEffect(()=>{
    if(isMe)return;
    db("/profiles?username=eq."+username+"&select=premium_price_xaf&limit=1").then(d=>{
      setPremiumPrice((Array.isArray(d)&&d[0]&&d[0].premium_price_xaf)||0);
    }).catch(()=>{});
    if(currentUser&&currentUser.username){
      db("/premium_subscriptions?subscriber=eq."+encodeURIComponent(currentUser.username)+"&creator=eq."+username+"&limit=1").then(d=>{
        setIsPremiumSubscriber(Array.isArray(d)&&d.length>0);
      }).catch(()=>{});
    }
  },[username,isMe,currentUser&&currentUser.username]);

  async function subscribePremium(){
    if(!currentUser||!currentUser.username){showToast&&showToast("Connecte-toi pour t'abonner");return;}
    setSubscribing(true);
    await payViaCamerPay(
      "premium_subscription",currentUser.username,premiumPrice,null,currentUser.email,{creator:username},
      ()=>{
        setIsPremiumSubscriber(true);
        setSubscribing(false);
        showToast&&showToast("⭐ Abonné(e) premium à @"+username+" !");
      },
      (msg)=>{setSubscribing(false);showToast&&showToast("⚠️ "+msg);}
    );
  }

  async function subscribePremiumViaWallet(){
    if(!currentUser||!currentUser.username){showToast&&showToast("Connecte-toi pour t'abonner");return;}
    setSubscribing(true);
    try{
      await callRpc("subscribe_premium",{p_creator:username,p_target_username:currentUser.username});
      setIsPremiumSubscriber(true);
      showToast&&showToast("⭐ Abonné(e) premium à @"+username+" !");
    }catch(e){
      showToast&&showToast("⚠️ "+(e.message||"Erreur, réessaie"));
    }
    setSubscribing(false);
  }

  async function toggleBlock(){
    setShowProfileOptions(false);
    const wasBlocked=isBlocked;
    setIsBlocked(!wasBlocked);
    try{
      if(wasBlocked){
        const res=await fetch(SUPABASE_URL+"/rest/v1/blocks?blocker=eq."+encodeURIComponent(currentUser.username)+"&blocked=eq."+encodeURIComponent(username),{
          method:"DELETE",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"}
        });
        const data=await res.json().catch(()=>null);
        if(!res.ok||!Array.isArray(data)||data.length===0){setIsBlocked(true);showToast&&showToast("⚠️ Échec");return;}
        showToast&&showToast("Débloqué");
      }else{
        const res=await fetch(SUPABASE_URL+"/rest/v1/blocks",{
          method:"POST",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
          body:JSON.stringify({blocker:currentUser.username,blocked:username})
        });
        const data=await res.json().catch(()=>null);
        if(!res.ok||!Array.isArray(data)||data.length===0){
          if(!(data&&data.code==="23505")){setIsBlocked(false);showToast&&showToast("⚠️ Échec");return;}
        }
        showToast&&showToast("Compte bloqué — tu ne verras plus son contenu");
      }
    }catch(e){
      setIsBlocked(wasBlocked);
      showToast&&showToast("⚠️ Erreur réseau");
    }
  }

  async function submitReport(reason){
    setReportSending(true);
    try{
      await fetch(SUPABASE_URL+"/rest/v1/reports",{
        method:"POST",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({reporter:currentUser.username,reported_username:username,reason})
      });
      showToast&&showToast("Signalement envoyé, merci");
    }catch(e){
      showToast&&showToast("⚠️ Échec de l'envoi");
    }
    setReportSending(false);
    setShowReportModal(false);
  }

  const [editMode,setEditMode]=useState(false);
  const [newBio,setNewBio]=useState(bio||"");
  const [newName,setNewName]=useState(displayName||username||"");
  const [newAge,setNewAge]=useState("");
  const [newNationality,setNewNationality]=useState("");
  const [myAvatar,setMyAvatar]=useState(avatar||"");
  const [saving,setSaving]=useState(false);
  const [selectedPost,setSelectedPost]=useState(null);
  const [selectedIdx,setSelectedIdx]=useState(0);
  const [showDashboard,setShowDashboard]=useState(false);
  const [profileTab,setProfileTab]=useState("all");
  const [showMonetization,setShowMonetization]=useState(false);
  // Real-time location check for monetization eligibility: the self-typed
  // nationality field can't be trusted for this (anyone could pick any
  // country), so the actual "eligible country" criterion is decided from
  // where the phone/network really is right now - IP/network location is
  // the primary signal (always available, hard to fake without a VPN),
  // GPS is an optional confirming signal when the person allows it.
  // Both are compared as ISO country codes, not names, since the
  // geolocation services return English names while the app's own
  // country list is in French.
  const [detectedCountryCode,setDetectedCountryCode]=useState(null);
  const [detectedCountryLoading,setDetectedCountryLoading]=useState(false);
  const [gpsCountryCode,setGpsCountryCode]=useState(null);
  const [eligibleCountryCodes,setEligibleCountryCodes]=useState(null);
  useEffect(()=>{
    if(!showMonetization||eligibleCountryCodes)return;
    db("/eligible_countries?select=country_code").then(d=>{
      setEligibleCountryCodes(Array.isArray(d)&&d.length>0?new Set(d.map(c=>c.country_code)):AFRICAN_COUNTRY_CODES);
    }).catch(()=>setEligibleCountryCodes(AFRICAN_COUNTRY_CODES));
  },[showMonetization]);
  useEffect(()=>{
    if(!showMonetization||detectedCountryCode||detectedCountryLoading)return;
    setDetectedCountryLoading(true);
    fetch("https://ipapi.co/json/").then(r=>r.json()).then(d=>{
      setDetectedCountryCode(d&&d.country_code?d.country_code.toUpperCase():"unknown");
    }).catch(()=>setDetectedCountryCode("unknown")).finally(()=>setDetectedCountryLoading(false));

    if(navigator.geolocation){
      navigator.geolocation.getCurrentPosition((pos)=>{
        fetch("https://nominatim.openstreetmap.org/reverse?format=json&lat="+pos.coords.latitude+"&lon="+pos.coords.longitude+"&zoom=3")
          .then(r=>r.json())
          .then(d=>{if(d&&d.address&&d.address.country_code)setGpsCountryCode(d.address.country_code.toUpperCase());})
          .catch(()=>{});
      },()=>{},{timeout:8000});
    }
  },[showMonetization]);
  const [showShareProfile,setShowShareProfile]=useState(false);
  const fileRef=useRef(null);

  useEffect(()=>{
    if(!username)return;
    async function loadProfilePosts(){
      let localPosts=[];
      try{
        const cached=localStorage.getItem("bl_posts_cache");
        if(cached){
          const parsed=JSON.parse(cached);
          if(Array.isArray(parsed)){
            localPosts=parsed.filter(p=>p.username&&p.username.toLowerCase()===username.toLowerCase());
          }
        }
      }catch{}
      if(localPosts.length>0) setPosts(localPosts);

      try{
        let d=await db("/Posts?username=eq."+encodeURIComponent(username)+"&order=created_at.desc&limit=50&moderation_hidden=eq.false&deleted_by_admin=eq.false");
        if(!Array.isArray(d)||d.length===0){
          const allPosts=await db("/Posts?order=created_at.desc&limit=200&moderation_hidden=eq.false&deleted_by_admin=eq.false");
          if(Array.isArray(allPosts)){
            d=allPosts.filter(p=>p.username&&p.username.toLowerCase()===username.toLowerCase());
          }
        }
        if(Array.isArray(d)){
          const serverIds=new Set(d.map(p=>String(p.id)));
          const localOnly=localPosts.filter(p=>String(p.id).startsWith("local_")&&!serverIds.has(String(p.id)));
          setPosts([...localOnly,...d]);
        }
      }catch(e){console.warn("profile posts:",e);}
    }
    loadProfilePosts();
    db("/Follows?following=eq."+encodeURIComponent(username)).then(d=>setFollowers(Array.isArray(d)?d.length:0)).catch(()=>{});
    db("/Follows?follower=eq."+encodeURIComponent(username)).then(d=>setFollowingCount(Array.isArray(d)?d.length:0)).catch(()=>{});
    if(!isMe&&currentUser&&currentUser.username){
      db("/Follows?follower=eq."+encodeURIComponent(currentUser.username)+"&following=eq."+encodeURIComponent(username)).then(d=>setIsFollowing(Array.isArray(d)&&d.length>0)).catch(()=>{});
    }
    db("/profiles?username=eq."+username+"&limit=1").then(d=>{
      if(Array.isArray(d)&&d[0]){
        if(d[0].bio)setNewBio(d[0].bio);
        if(d[0].avatar)setMyAvatar(d[0].avatar);
        if(d[0].display_name)setNewName(d[0].display_name);
        if(d[0].age)setNewAge(String(d[0].age));
        if(d[0].nationality)setNewNationality(d[0].nationality);
        setProfileVerified(!!d[0].verified);
        setProfileVerifiedUntil(d[0].verified_until||null);
        setIsPageProfile(!!d[0].is_page);
        if(d[0].cover)setNewCover(d[0].cover);
        if(d[0].cover_position!==undefined&&d[0].cover_position!==null)setNewCoverPosition(d[0].cover_position);
        if(d[0].cover_zoom)setNewCoverZoom(d[0].cover_zoom);
      }
    }).catch(()=>{});
  },[username]);

  // Views live in post_stats, not on the post row itself - the dashboard
  // stat needs to sum from there or it always reads as 0.
  useEffect(()=>{
    const realIds=posts.map(p=>p.id).filter(id=>id&&!String(id).startsWith("local_"));
    if(realIds.length===0){setTotalViews(0);return;}
    db("/post_stats?post_id=in.("+realIds.join(",")+")&select=views").then(d=>{
      if(Array.isArray(d))setTotalViews(d.reduce((a,r)=>a+(r.views||0),0));
    }).catch(()=>{});
  },[posts]);

  // Messages from the control tool (account restrictions, content actions)
  // show right here on the person's own profile rather than buried in the
  // general notifications feed, since that's where they're most likely to
  // see and act on something affecting their account.
  useEffect(()=>{
    if(!isMe||!username)return;
    db("/notifications?receiver=eq."+encodeURIComponent(username)+"&type=eq.moderation&order=created_at.desc&limit=20").then(async d=>{
      const rows=Array.isArray(d)?d:[];
      // A thumbnail makes it obvious which post a message is about, rather
      // than the person having to guess from the wording alone.
      const postIds=[...new Set(rows.filter(m=>m.target_type==="post"&&m.target_id).map(m=>m.target_id))];
      let thumbByPost={};
      if(postIds.length>0){
        const posts=await db("/Posts?id=in.("+postIds.join(",")+")&select=id,image,type,caption").catch(()=>[]);
        if(Array.isArray(posts))posts.forEach(p=>{thumbByPost[p.id]=p;});
      }
      setModMessages(rows.map(m=>({...m,thumb:m.target_id?thumbByPost[m.target_id]:null})));
    }).catch(()=>setModMessages([]));
  },[isMe,username]);

  function dismissModMessage(id){
    setModMessages(m=>m.filter(x=>x.id!==id));
    db("/notifications?id=eq."+id,{method:"DELETE",headers:{Prefer:"return=minimal"}}).catch(()=>{});
  }

  async function submitAppeal(m){
    if(!appealText.trim())return;
    setAppealSending(true);
    try{
      await fetch(SUPABASE_URL+"/rest/v1/appeals",{
        method:"POST",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({username:currentUser.username,target_type:m.target_type||"unknown",target_id:m.target_id||null,action_type:m.action_type||null,original_message:m.message,justification:appealText.trim()})
      });
      const next=new Set(appealedIds);next.add(m.id);setAppealedIds(next);
      try{localStorage.setItem("bl_appealed_ids",JSON.stringify([...next]));}catch{}
      setAppealingId(null);setAppealText("");
      showToast&&showToast("✅ Ta contestation a été envoyée");
    }catch{
      showToast&&showToast("⚠️ Échec de l'envoi");
    }
    setAppealSending(false);
  }

  async function toggleFollow(){
    if(currentUser&&currentUser.username===username)return;
    if(isFollowing){
      setFollowers(f=>f-1);setIsFollowing(false);
      try{
        const res=await authedFetch(SUPABASE_URL+"/rest/v1/Follows?follower=eq."+encodeURIComponent(currentUser.username)+"&following=eq."+encodeURIComponent(username),{
          method:"DELETE",headers:{"Content-Type":"application/json",Prefer:"return=representation"}
        });
        const data=await res.json().catch(()=>null);
        if(!res.ok||!Array.isArray(data)||data.length===0){
          console.error("Unfollow failed or matched zero rows (status "+res.status+"): "+JSON.stringify(data));
          showToast&&showToast("🔍 Unfollow échec ("+res.status+"): "+JSON.stringify(data).slice(0,150));
          setFollowers(f=>f+1);setIsFollowing(true);
        }
      }catch(e){
        console.error("Unfollow network error: "+e.message);
        showToast&&showToast("🔍 Erreur réseau: "+e.message);
        setFollowers(f=>f+1);setIsFollowing(true);
      }
    }else{
      setFollowers(f=>f+1);setIsFollowing(true);
      try{
        const res=await authedFetch(SUPABASE_URL+"/rest/v1/Follows",{
          method:"POST",headers:{"Content-Type":"application/json",Prefer:"return=representation"},
          body:JSON.stringify({follower:currentUser.username,following:username})
        });
        const data=await res.json().catch(()=>null);
        if(!res.ok||!Array.isArray(data)||data.length===0){
          if(data&&data.code==="23505"){
            console.error("Follow already existed (23505) - correcting UI to following state, not reverting");
            setFollowers(f=>f-1);
            return;
          }
          console.error("Follow failed (status "+res.status+"): "+JSON.stringify(data));
          showToast&&showToast("🔍 Follow échec ("+res.status+"): "+JSON.stringify(data).slice(0,150));
          setFollowers(f=>f-1);setIsFollowing(false);
          return;
        }
        db("/notifications",{method:"POST",body:JSON.stringify({receiver:username,sender:currentUser.username,type:"follow",seen:false})}).catch(()=>{});
      }catch(e){
        console.error("Follow network error: "+e.message);
        showToast&&showToast("🔍 Erreur réseau: "+e.message);
        setFollowers(f=>f-1);setIsFollowing(false);
      }
    }
  }

  async function saveProfile(){
    setSaving(true);
    let effectiveUsername=currentUser.username;
    const trimmedNewUsername=newUsernameInput.trim();
    if(trimmedNewUsername&&trimmedNewUsername!==username){
      if(!/^[a-zA-Z0-9_.]+$/.test(trimmedNewUsername)){
        showToast&&showToast("⚠️ @nom : lettres, chiffres, _ et . uniquement");
        setSaving(false);
        return;
      }
      try{
        const renameRes=await fetch(BLUELIFE_BACKEND_URL+"/api/change-username",{
          method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({oldUsername:username,newUsername:trimmedNewUsername})
        });
        const renameData=await renameRes.json().catch(()=>({}));
        if(!renameRes.ok&&renameRes.status!==207){
          showToast&&showToast("⚠️ "+(renameData.error||"Échec du changement de @nom"));
          setSaving(false);
          return;
        }
        effectiveUsername=trimmedNewUsername;
      }catch(e){
        showToast&&showToast("⚠️ Erreur réseau pendant le changement de @nom");
        setSaving(false);
        return;
      }
    }
    const res=await fetch(SUPABASE_URL+"/rest/v1/profiles?username=eq."+encodeURIComponent(effectiveUsername),{
      method:"PATCH",
      headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
      body:JSON.stringify({bio:newBio,avatar:myAvatar,display_name:newName,...(newAge?{age:Number(newAge)}:{}),...(newNationality?{nationality:newNationality}:{}),...(isPageProfile?{cover:newCover,cover_position:newCoverPosition,cover_zoom:newCoverZoom}:{})})
    });
    if(!res.ok){
      const bodyText=await res.text().catch(()=>"");
      console.error("Profile save failed (status "+res.status+"): "+bodyText);
      showToast&&showToast("⚠️ Échec de l'enregistrement (code "+res.status+")");
      setSaving(false);
      return;
    }
    if(newName!==displayName||myAvatar!==avatar){
      const propagated={};
      if(newName!==displayName)propagated.display_name=newName;
      if(myAvatar!==avatar)propagated.avatar=myAvatar;
      db("/Posts?username=eq."+encodeURIComponent(effectiveUsername),{method:"PATCH",body:JSON.stringify(propagated)}).catch(()=>{});
      db("/stories?author=eq."+encodeURIComponent(effectiveUsername),{method:"PATCH",body:JSON.stringify(propagated)}).catch(()=>{});
    }
    onUpdateProfile&&onUpdateProfile({bio:newBio,displayName:newName,avatar:myAvatar,...(effectiveUsername!==username?{username:effectiveUsername}:{})});
    setSaving(false);setEditMode(false);
    showToast&&showToast("✅ Profil mis à jour !");
  }

  async function changeAvatar(e){
    const f=e.target.files[0];if(!f)return;
    setSaving(true);
    try{const{url}=await upload(f);setMyAvatar(url);await db("/profiles?username=eq."+encodeURIComponent(currentUser.username),{method:"PATCH",body:JSON.stringify({avatar:url})});onUpdateAvatar&&onUpdateAvatar(url);showToast&&showToast("✅ Photo mise à jour !");}catch{}
    setSaving(false);
  }
  async function changeCover(e){
    const f=e.target.files[0];if(!f)return;
    setSaving(true);
    try{const{url}=await upload(f);setNewCover(url);await db("/profiles?username=eq."+encodeURIComponent(currentUser.username),{method:"PATCH",body:JSON.stringify({cover:url})});showToast&&showToast("✅ Couverture mise à jour !");}catch{}
    setSaving(false);
  }

  const style=inTab?{background:C.navy,fontFamily:"'Segoe UI',system-ui,sans-serif"}:{position:"fixed",inset:0,background:C.navy,zIndex:500,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"};

  return(
    <div style={style}>
      {showShareProfile&&(
        <ShareSheet
          link={window.location.origin+window.location.pathname+"?user="+username}
          shareText={"Découvre mon profil @"+username+" sur Blue Life !"}
          storyImage={myAvatar||avatar}
          storyCaption={"👤 Découvre @"+username+" sur Blue Life"}
          repost={null}
          currentUser={currentUser} onClose={()=>setShowShareProfile(false)} showToast={showToast} onRequireAuth={()=>{}}
        />
      )}
      {showDashboard&&(
        <div style={{position:"fixed",inset:0,background:C.navy,zIndex:700,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
          <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,position:"sticky",top:0,background:C.navy,zIndex:10}}>
            <button onClick={()=>setShowDashboard(false)} style={{background:"none",border:"none",cursor:"pointer",color:C.white,marginRight:12}}><I.Back/></button>
            <span style={{fontWeight:700,fontSize:17,color:C.white}}>📊 Tableau de bord</span>
          </div>
          <div style={{padding:16}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:20}}>
              {[
                {ic:"👥",lb:"Abonnés",val:fmt(followers),color:C.accent2},
                {ic:"👣",lb:"Abonnements",val:fmt(followingCount),color:C.purple},
                {ic:"📸",lb:"Publications",val:posts.length,color:C.green},
                {ic:"❤️",lb:"Total J'aime",val:fmt(posts.reduce((a,p)=>a+(p.likes_count||0),0)),color:C.red},
                {ic:"👁️",lb:"Vues totales",val:fmt(totalViews),color:C.accent2},
                {ic:<CoinIcon size={22}/>,lb:"Blue Coins reçus",val:fmt(posts.reduce((a,p)=>a+(p.gifts_received||0),0)),color:"#f0b90b"},
              ].map((s,i)=>(
                <div key={i} style={{padding:16,borderRadius:14,background:C.w5,border:"1px solid "+C.border,textAlign:"center"}}>
                  <div style={{fontSize:26,marginBottom:6}}>{s.ic}</div>
                  <div style={{fontWeight:800,fontSize:22,color:s.color}}>{s.val}</div>
                  <div style={{fontSize:12,color:C.w3,marginTop:4}}>{s.lb}</div>
                </div>
              ))}
            </div>
            <div onClick={()=>setShowMonetization(true)} style={{background:"linear-gradient(135deg,rgba(245,158,11,0.18),rgba(245,158,11,0.05))",borderRadius:14,padding:14,border:"1px solid rgba(245,158,11,0.3)",cursor:"pointer",marginBottom:20,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div>
                <div style={{fontWeight:700,fontSize:14,color:C.white,marginBottom:2}}>💰 Monétisation</div>
                <div style={{fontSize:12,color:"#f59e0b"}}>↗ Vérifie ton éligibilité</div>
              </div>
              <div style={{fontSize:20}}>💰</div>
            </div>

            <div style={{fontWeight:700,fontSize:15,color:C.white,marginBottom:10}}>📈 Meilleures publications</div>
            {[...posts].sort((a,b)=>(b.likes_count||0)-(a.likes_count||0)).slice(0,5).map((p,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px",background:C.w5,borderRadius:12,marginBottom:8,border:"1px solid "+C.border}}>
                <img src={p.image} alt="" style={{width:48,height:48,borderRadius:8,objectFit:"cover"}}/>
                <div style={{flex:1}}>
                  <div style={{color:C.white,fontSize:13,fontWeight:600,marginBottom:2}}>{p.caption||"Post sans légende"}</div>
                  <div style={{color:C.w3,fontSize:11}}>{ago(p.created_at)}</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{color:C.red,fontWeight:700,fontSize:14}}>❤️ {fmt(p.likes_count||0)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {showMonetization&&(()=>{
        const activeCountryCodes=eligibleCountryCodes||AFRICAN_COUNTRY_CODES;
        const isEligibleCountry = (detectedCountryCode&&activeCountryCodes.has(detectedCountryCode))||(gpsCountryCode&&activeCountryCodes.has(gpsCountryCode));
        const countryStillChecking = detectedCountryLoading&&!detectedCountryCode;
        const hasAge = newAge && Number(newAge)>0;
        const isEligibleAge = hasAge && Number(newAge)>=21;
        const followersCount = followers;
        const followersPct = Math.min(100, Math.round((followersCount/1000)*100));
        const criteria = [
          {
            label: "Réside dans un pays éligible",
            status: countryStillChecking ? "pending" : isEligibleCountry ? "done" : "soon",
            display: countryStillChecking ? "vérification de ta position..." : isEligibleCountry ? "✅ Position vérifiée" : "bientôt disponible dans ta zone",
          },
          {
            label: "Avoir au moins 21 ans",
            status: !hasAge ? "pending" : isEligibleAge ? "done" : "soon",
            display: !hasAge ? "non renseigné" : isEligibleAge ? "✅ Validé" : "pas encore",
          },
          {
            label: "Avoir 1 000 abonnés",
            status: followersCount>=1000 ? "done" : "progress",
            display: fmt(followersCount)+" / 1 000",
            pct: followersPct,
          },
        ];
        return (
          <div style={{position:"fixed",inset:0,background:C.navy,zIndex:750,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
            <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,position:"sticky",top:0,background:C.navy,zIndex:10}}>
              <button onClick={()=>setShowMonetization(false)} style={{background:"none",border:"none",cursor:"pointer",color:C.white,marginRight:12}}><I.Back/></button>
              <span style={{fontWeight:700,fontSize:17,color:C.white}}>💰 Monétisation</span>
            </div>
            <div style={{padding:20}}>
              <div style={{background:"linear-gradient(135deg,rgba(245,158,11,0.15),rgba(245,158,11,0.03))",borderRadius:16,padding:18,border:"1px solid rgba(245,158,11,0.25)",marginBottom:24,textAlign:"center"}}>
                <div style={{fontSize:32,marginBottom:8}}>💰</div>
                <div style={{fontWeight:800,fontSize:18,color:C.white,marginBottom:6}}>Programme de monétisation Blue Life</div>
                <div style={{color:C.w3,fontSize:13,lineHeight:1.6}}>Remplis ces critères pour débloquer la monétisation de ton contenu</div>
              </div>

              {criteria.map((c,i)=>(
                <div key={i} style={{background:C.w5,borderRadius:14,padding:16,marginBottom:12,border:"1px solid "+C.border}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:c.pct!==undefined?10:0}}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <div style={{width:28,height:28,borderRadius:"50%",background:c.status==="done"?C.green+"33":c.status==="pending"?C.w4+"33":"rgba(245,158,11,0.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}>
                        {c.status==="done"?"✅":c.status==="pending"?"⏳":"🔄"}
                      </div>
                      <div style={{color:C.white,fontWeight:600,fontSize:14}}>{c.label}</div>
                    </div>
                    <div style={{color:c.status==="done"?C.green:c.status==="pending"?C.w3:"#f59e0b",fontWeight:700,fontSize:13,whiteSpace:"nowrap",marginLeft:8}}>{c.display}</div>
                  </div>
                  {c.pct!==undefined&&(
                    <div style={{height:6,background:C.border,borderRadius:3,overflow:"hidden",marginTop:8}}>
                      <div style={{height:"100%",width:c.pct+"%",background:"linear-gradient(90deg,"+C.accent+",#1e4d8c)",borderRadius:3,transition:"width 0.3s"}}/>
                    </div>
                  )}
                </div>
              ))}

              <div style={{color:C.w3,fontSize:11,lineHeight:1.6,padding:"0 4px",marginBottom:10}}>📍 Le critère de pays est vérifié en temps réel via la position de ton téléphone et de ton réseau, pas via le pays renseigné sur ton profil.</div>

              <div style={{background:C.w5,borderRadius:12,padding:14,marginTop:10,border:"1px solid "+C.border}}>
                <div style={{fontSize:12,color:C.w3,lineHeight:1.7}}>
                  ℹ️ Ces critères sont mis à jour automatiquement en fonction de ton activité sur Blue Life. La monétisation sera disponible une fois tous les critères validés.
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {selectedPost&&(
        <div style={{position:"fixed",inset:0,background:C.navy,zIndex:600,maxWidth:480,margin:"0 auto",display:"flex",flexDirection:"column",overflowY:"auto"}}>
          <div style={{display:"flex",alignItems:"center",padding:"14px",background:C.navy2,borderBottom:"1px solid "+C.border,position:"sticky",top:0,zIndex:2}}>
            <button onClick={()=>setSelectedPost(null)} style={{background:"none",border:"none",cursor:"pointer",color:C.white,marginRight:10}}><I.Back/></button>
            <span style={{color:C.white,fontWeight:700,fontSize:15}}>{selectedIdx+1}/{posts.length}</span>
          </div>
          <div ref={el=>{
            if(el){
              const target=el.querySelector("#profile-post-"+selectedIdx);
              if(target) target.scrollIntoView({block:"start"});
            }
          }}>
            {posts.map((p,i)=>(
              <div key={i} id={"profile-post-"+i} style={{marginBottom:4}}>
                <PostCard post={p} user={currentUser} onProfile={(u,a)=>{setSelectedPost(null);}} showToast={showToast} onRequireAuth={(r)=>setShowAuthPrompt(r||"login")} onOpenVideo={onOpenVideo}/>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:10,...(!inTab&&{position:"sticky",top:0,background:C.navy,zIndex:10})}}>
        {!inTab&&<button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>}
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1,display:"flex",alignItems:"center",gap:6}}>
          {newName||username}
          {isBadgeActive(currentUser)&&isMe&&(
            <svg width="15" height="15" viewBox="0 0 24 24" fill="#3897f0" style={{flexShrink:0}} title="Compte certifié">
              <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
              <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </span>
        {isMe&&onCertification&&(
          <button onClick={onCertification} style={{background:isBadgeActive(currentUser)?C.accent+"22":C.w5,border:"1px solid "+(isBadgeActive(currentUser)?C.accent:C.border),borderRadius:10,padding:"7px",color:isBadgeActive(currentUser)?C.accent2:"#3897f0",cursor:"pointer",display:"flex",alignItems:"center"}} title="Certification">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/><path d="M9 12l2 2 4-4" stroke={C.navy} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
        )}
        {isMe&&onWallet&&(
          <button onClick={onWallet} style={{background:C.w5,border:"1px solid "+C.border,borderRadius:10,padding:"7px",color:C.accent2,cursor:"pointer",display:"flex",alignItems:"center"}} title="Solde">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 7H5a2 2 0 0 1 0-4h12v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M21 12v5h-3a2.5 2.5 0 0 1 0-5z"/>
            </svg>
          </button>
        )}
        {isMe&&onSettings&&<button onClick={()=>onSettings()} style={{background:C.w5,border:"1px solid "+C.border,borderRadius:10,padding:"7px",color:C.accent2,cursor:"pointer"}}><I.Gear/></button>}
        {!isMe&&currentUser&&currentUser.username&&(
          <button onClick={()=>setShowProfileOptions(true)} style={{background:"none",border:"none",cursor:"pointer",color:C.w3,padding:"4px 2px",display:"flex"}}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="12" cy="19" r="1.8"/></svg>
          </button>
        )}
      </div>

      {isPageProfile&&(
        <div>
          <div onClick={()=>editMode&&coverEditRef.current&&coverEditRef.current.click()} style={{width:"100%",aspectRatio:"16/6",position:"relative",overflow:"hidden",background:newCover?"#000":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",cursor:editMode?"pointer":"default"}}>
            {newCover&&<img src={newCover} alt="" style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center "+newCoverPosition+"%",transform:"scale("+(newCoverZoom/100)+")",transformOrigin:"center "+newCoverPosition+"%",display:"block"}}/>}
            {editMode&&<div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}><div style={{background:"rgba(0,0,0,0.5)",color:"#fff",fontSize:12,padding:"6px 12px",borderRadius:20}}>📷 Changer la couverture</div></div>}
            {editMode&&<input ref={coverEditRef} type="file" accept="image/*" onChange={changeCover} style={{display:"none"}}/>}
          </div>
          {editMode&&newCover&&(
            <div style={{padding:"8px 20px",background:C.w5}}>
              <div style={{color:C.w3,fontSize:11,marginBottom:4}}>🔍 Zoom</div>
              <input type="range" min="100" max="300" value={newCoverZoom} onChange={e=>setNewCoverZoom(Number(e.target.value))} style={{width:"100%",accentColor:C.accent,marginBottom:10}}/>
              <div style={{color:C.w3,fontSize:11,marginBottom:4}}>↕️ Position</div>
              <input type="range" min="0" max="100" value={newCoverPosition} onChange={e=>setNewCoverPosition(Number(e.target.value))} style={{width:"100%",accentColor:C.accent}}/>
            </div>
          )}
        </div>
      )}

      <div style={{padding:20}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,padding:"0 10px"}}>
          
          <div style={{textAlign:"center",flex:1}}>
            <div style={{fontWeight:800,fontSize:22,color:C.white}}>{fmt(followers)}</div>
            <div style={{fontSize:12,color:C.w3,marginTop:2}}>{t("followers")}</div>
          </div>

          <div style={{position:"relative",display:"flex",flexDirection:"column",alignItems:"center"}}>
            <div onClick={handleAvatarTap} style={{cursor:"pointer",borderRadius:"50%",padding:activeUserStories&&activeUserStories.length>0?3:0,background:activeUserStories&&activeUserStories.length>0?"linear-gradient(135deg,#f5576c,#f093fb,#fee140)":"transparent"}}>
              {myAvatar
                ?<img src={myAvatar} alt="" style={{width:96,height:96,borderRadius:"50%",objectFit:"cover",border:"3px solid "+C.accent,display:"block"}}/>
                :<div style={{width:96,height:96,borderRadius:"50%",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",border:"3px solid "+C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:38,color:"#fff",fontWeight:800}}>{initials(newName||username)}</div>
              }
            </div>
            {isMe&&editMode&&(
              <button onClick={()=>fileRef.current.click()} style={{position:"absolute",bottom:0,right:0,width:28,height:28,borderRadius:"50%",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",border:"2px solid "+C.navy,color:"#fff",cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center"}}>📷</button>
            )}
            {saving&&<div style={{position:"absolute",inset:0,borderRadius:"50%",background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center"}}><I.Spin/></div>}
            <input ref={fileRef} type="file" accept="image/*" onChange={changeAvatar} style={{display:"none"}}/>
          </div>

          <div style={{textAlign:"center",flex:1}}>
            <div style={{fontWeight:800,fontSize:22,color:C.white}}>{fmt(followingCount)}</div>
            <div style={{fontSize:12,color:C.w3,marginTop:2}}>{t("following")}</div>
          </div>
        </div>

        <div style={{marginBottom:14}}>
          {editMode?(
            <input value={newName} onChange={e=>setNewName(e.target.value)} placeholder="Nom complet" style={{width:"100%",padding:"10px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,fontWeight:700,outline:"none",marginBottom:8,boxSizing:"border-box"}}/>
          ):(
            <div style={{fontWeight:700,color:C.white,fontSize:16,marginBottom:2,display:"flex",alignItems:"center",gap:6}}>
              {newName||username}
              {isBadgeActive({verified:profileVerified,verified_until:profileVerifiedUntil})&&(
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#3897f0" style={{flexShrink:0}} title="Compte certifié">
                  <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
                  <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </div>
          )}
          {editMode?(
            !isPageProfile&&<input value={newUsernameInput} onChange={e=>setNewUsernameInput(e.target.value.replace(/[^a-zA-Z0-9_.]/g,""))} placeholder="nom.utilisateur" style={{width:"100%",padding:"8px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.accent2,fontSize:13,outline:"none",marginBottom:6,boxSizing:"border-box"}}/>
          ):(
            !isPageProfile&&<div style={{fontSize:12,color:C.w3,marginBottom:6}}>@{username}</div>
          )}
          {editMode?<textarea value={newBio} onChange={e=>setNewBio(e.target.value)} rows={2} placeholder="Ta bio..." style={{width:"100%",padding:"10px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",resize:"none",fontFamily:"inherit"}}/>:<div style={{fontSize:14,color:C.w3}}>{newBio||"✨ Nouveau sur Blue Life"}</div>}
          {editMode&&(
            <div style={{display:"flex",gap:8,marginTop:8}}>
              <input value={newAge} onChange={e=>setNewAge(e.target.value.replace(/[^0-9]/g,"").slice(0,3))} placeholder="Âge" inputMode="numeric" style={{width:80,padding:"10px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",boxSizing:"border-box"}}/>
              <select value={newNationality} onChange={e=>setNewNationality(e.target.value)} style={{flex:1,padding:"10px 10px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:newNationality?C.white:C.w3,fontSize:13,outline:"none"}}>
                <option value="">Nationalité</option>
                {WORLD_COUNTRIES.map((c,i)=><option key={i} value={c}>{c}</option>)}
              </select>
            </div>
          )}
        </div>

        {editMode&&<button onClick={saveProfile} disabled={saving} style={{width:"100%",padding:"10px",borderRadius:12,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:"pointer",marginBottom:12,fontSize:14}}>{saving?"Sauvegarde...":"✅ Sauvegarder les modifications"}</button>}
        {editMode&&onSettings&&(
          <>
            <button onClick={()=>onSettings("premium")} style={{width:"100%",padding:"10px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:600,cursor:"pointer",marginBottom:12,fontSize:14}}>⭐ Abonnements premium</button>
          </>
        )}

        {isMe&&!editMode&&(
          <div style={{marginBottom:16}}>
            <div style={{display:"flex",gap:8,marginBottom:10}}>
              {!(currentUser&&currentUser.isPage&&currentUser.pagePermission==="limited")&&<button onClick={()=>setEditMode(true)} style={{flex:1,padding:"10px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:700,cursor:"pointer",fontSize:14}}>{t("editProfile")}</button>}
              <button onClick={()=>setShowShareProfile(true)} style={{flex:1,padding:"10px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:700,cursor:"pointer",fontSize:14}}>Partager</button>
            </div>
            <div onClick={()=>setShowDashboard(true)} style={{background:"linear-gradient(135deg,rgba(37,99,235,0.15),rgba(37,99,235,0.05))",borderRadius:14,padding:14,border:"1px solid "+C.border2,cursor:"pointer",marginBottom:8}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <div style={{fontWeight:700,fontSize:14,color:C.white,marginBottom:2}}>{t("dashboard")}</div>
                  <div style={{fontSize:12,color:C.accent2}}>↗ Voir les statistiques du profil</div>
                </div>
                <div style={{fontSize:20}}>📊</div>
              </div>
            </div>
          </div>
        )}

        {isMe&&modMessages&&modMessages.length>0&&(
          <div style={{marginBottom:16}}>
            <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:8,letterSpacing:0.3}}>Messages de l'équipe Blue Life</div>
            {modMessages.map((m,i)=>(
              <div key={i} style={{padding:12,borderRadius:12,marginBottom:8,background:"rgba(245,158,11,0.1)",border:"1px solid rgba(245,158,11,0.3)"}}>
                <div style={{display:"flex",gap:10}}>
                  {m.thumb&&m.thumb.image&&m.thumb.type!=="text"&&(
                    <img src={m.thumb.image} alt="" style={{width:44,height:44,borderRadius:8,objectFit:"cover",flexShrink:0}}/>
                  )}
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{color:C.white,fontSize:13,lineHeight:1.5}}>{m.message}</div>
                    <div style={{color:C.w3,fontSize:11,marginTop:4}}>{ago(m.created_at)}</div>
                  </div>
                  <div onClick={()=>dismissModMessage(m.id)} style={{color:C.w3,fontSize:16,cursor:"pointer",padding:4,flexShrink:0}}>✕</div>
                </div>
                {appealedIds.has(m.id)?(
                  <div style={{color:"#3ddc97",fontSize:12,fontWeight:600,marginTop:8}}>✓ Contestation envoyée, en attente de réponse</div>
                ):appealingId===m.id?(
                  <div style={{marginTop:10}}>
                    <textarea value={appealText} onChange={e=>setAppealText(e.target.value)} rows={3} placeholder="Explique pourquoi tu penses que cette décision devrait être annulée..." style={{width:"100%",padding:"10px 12px",borderRadius:8,border:"1px solid rgba(245,158,11,0.3)",background:"rgba(0,0,0,0.2)",color:C.white,fontSize:13,outline:"none",resize:"none",fontFamily:"inherit",boxSizing:"border-box",marginBottom:8}}/>
                    <div style={{display:"flex",gap:8}}>
                      <button onClick={()=>{setAppealingId(null);setAppealText("");}} style={{flex:1,padding:"8px",borderRadius:8,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontSize:12,fontWeight:700,cursor:"pointer"}}>Annuler</button>
                      <button onClick={()=>submitAppeal(m)} disabled={appealSending||!appealText.trim()} style={{flex:2,padding:"8px",borderRadius:8,border:"none",background:C.accent,color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer"}}>{appealSending?"...":"Envoyer la contestation"}</button>
                    </div>
                  </div>
                ):(
                  <div onClick={()=>setAppealingId(m.id)} style={{color:C.accent,fontSize:12,fontWeight:700,marginTop:8,cursor:"pointer"}}>Contester cette décision</div>
                )}
              </div>
            ))}
          </div>
        )}

        {!isMe&&(
          <div style={{display:"flex",gap:8,marginBottom:16}}>
            <button onClick={toggleFollow} style={{flex:1,padding:"10px",borderRadius:12,border:isFollowing?"1px solid "+C.border:"none",background:isFollowing?"transparent":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:isFollowing?C.white:"#fff",fontWeight:700,cursor:"pointer",fontSize:14}}>
              {isFollowing?"Abonné(e)":"➕ S'abonner"}
            </button>
            <button onClick={()=>onMessage&&onMessage({username,avatar:myAvatar,displayName:newName})} style={{flex:1,padding:"10px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:700,cursor:"pointer",fontSize:14}}>💬 Message</button>
          </div>
        )}
        {!isMe&&premiumPrice>0&&!isPremiumSubscriber&&(
          <button onClick={subscribing?undefined:()=>setShowPremiumPaymentChoice(true)} disabled={subscribing} style={{width:"100%",padding:"11px",borderRadius:12,border:"none",background:subscribing?"rgba(10,10,10,0.15)":"linear-gradient(135deg,#f5a623,#e08e0b)",color:"#fff",fontWeight:700,fontSize:14,cursor:subscribing?"not-allowed":"pointer",marginBottom:16,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
            {subscribing?"...":"⭐ Abonnement premium — "+fmtUSD(premiumPrice)}
          </button>
        )}
        {showPremiumPaymentChoice&&(
          <div onClick={()=>!subscribing&&setShowPremiumPaymentChoice(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:1000,display:"flex",alignItems:"flex-end"}}>
            <div onClick={e=>e.stopPropagation()} style={{background:C.navy2,borderRadius:"20px 20px 0 0",padding:"20px 16px 32px",width:"100%",border:"1px solid "+C.border,borderBottom:"none"}}>
              <div style={{color:C.white,fontWeight:700,fontSize:15,marginBottom:14,textAlign:"center"}}>Payer avec quoi ?</div>
              <button onClick={()=>{setShowPremiumPaymentChoice(false);subscribePremiumViaWallet();}} disabled={subscribing} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,fontSize:15,cursor:"pointer",marginBottom:10}}>
                👛 Solde du portefeuille
              </button>
              <button onClick={()=>{setShowPremiumPaymentChoice(false);subscribePremium();}} disabled={subscribing} style={{width:"100%",padding:"16px",borderRadius:14,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:700,fontSize:15,cursor:"pointer",marginBottom:10}}>
                💳 Mobile Money, carte ou PayPal
              </button>
              <button onClick={()=>setShowPremiumPaymentChoice(false)} style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Annuler</button>
            </div>
          </div>
        )}
        {!isMe&&isPremiumSubscriber&&(
          <div style={{width:"100%",padding:"11px",borderRadius:12,border:"1px solid #f5a623",background:"rgba(245,166,35,0.12)",color:"#f5a623",fontWeight:700,fontSize:14,textAlign:"center",marginBottom:16}}>
            ⭐ Tu es abonné(e) premium
          </div>
        )}
      </div>

      <div style={{display:"flex",borderTop:"1px solid "+C.border,borderBottom:"1px solid "+C.border}}>
        {[
          {key:"all",icon:(
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="3" y="3" width="6" height="6" rx="1"/><rect x="9.5" y="3" width="6" height="6" rx="1"/><rect x="16" y="3" width="5" height="6" rx="1"/><rect x="3" y="9.5" width="6" height="6" rx="1"/><rect x="9.5" y="9.5" width="6" height="6" rx="1"/><rect x="16" y="9.5" width="5" height="6" rx="1"/><rect x="3" y="16" width="6" height="5" rx="1"/><rect x="9.5" y="16" width="6" height="5" rx="1"/><rect x="16" y="16" width="5" height="5" rx="1"/></svg>
          )},
          {key:"videos",icon:(
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="12" cy="12" r="9.5"/><polygon points="10,8.5 16,12 10,15.5" fill="currentColor" stroke="none"/></svg>
          )},
          {key:"reposts",icon:(
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
          )},
          ...(isMe?[{key:"saved",icon:(
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1z"/></svg>
          )}]:[]),
        ].map(tabInfo=>(
          <button key={tabInfo.key} onClick={()=>setProfileTab(tabInfo.key)} style={{flex:1,padding:"11px 0",background:"none",border:"none",borderBottom:profileTab===tabInfo.key?"2px solid "+C.white:"2px solid transparent",color:profileTab===tabInfo.key?C.white:C.w3,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>
            {tabInfo.icon}
          </button>
        ))}
      </div>

      {(()=>{
        const tabbedPosts=profileTab==="videos"?posts.filter(p=>p.type==="video")
          :profileTab==="reposts"?posts.filter(p=>p.caption&&p.caption.startsWith("🔁 via @"))
          :profileTab==="saved"?getSavedPosts(currentUser&&currentUser.username)
          :[...posts].sort((a,b)=>(b.pinned?1:0)-(a.pinned?1:0));
        const emptyMsg=profileTab==="videos"?t("noVideoYet")
          :profileTab==="reposts"?"Aucune republication"
          :profileTab==="saved"?t("noSaved")
          :t("noPostYet");
        return tabbedPosts.length===0?<div style={{textAlign:"center",padding:40,color:C.w3}}>{emptyMsg}</div>:(
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:2}}>
            {tabbedPosts.map((p,i)=>(
              <div key={i} onClick={()=>{
                if(p.type==="video"&&onOpenVideo){
                  const vids=tabbedPosts.filter(x=>x.type==="video");
                  onOpenVideo(vids,vids.indexOf(p));
                  return;
                }
                setSelectedPost(p);setSelectedIdx(tabbedPosts.indexOf(p));
              }} style={{aspectRatio:"1/1",overflow:"hidden",cursor:"pointer",position:"relative",background:"#000"}}>
                {p.type==="text"
                  ?<div style={{width:"100%",height:"100%",background:p.text_bg||("linear-gradient(135deg,"+C.accent+",#1e4d8c)"),display:"flex",alignItems:"center",justifyContent:"center",padding:8,boxSizing:"border-box"}}>
                      <div style={{color:"#fff",fontSize:11,fontWeight:700,lineHeight:1.3,textAlign:"center",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:5,WebkitBoxOrient:"vertical"}}>{p.caption}</div>
                    </div>
                  :p.type==="poll"
                  ?<div style={{width:"100%",height:"100%",background:"linear-gradient(135deg,#2f6fed,#1e4d8c)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:8,boxSizing:"border-box"}}>
                      <div style={{fontSize:20,marginBottom:4}}>📊</div>
                      <div style={{color:"#fff",fontSize:10,fontWeight:700,lineHeight:1.3,textAlign:"center",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:3,WebkitBoxOrient:"vertical"}}>{p.caption}</div>
                    </div>
                  :p.type==="video"
                  ?<img src={cloudinaryVideoThumbnail(p.image)} alt="" style={{width:"100%",height:"100%",objectFit:"cover",display:"block",background:"#000"}}/>
                  :<GridThumbnail src={p.image}/>
                }
                {p.type==="video"&&<div style={{position:"absolute",top:4,right:4,background:"rgba(0,0,0,0.5)",borderRadius:"50%",width:20,height:20,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:"white"}}>▶</div>}
                {p.pinned&&<div style={{position:"absolute",top:4,left:4,fontSize:12,textShadow:"0 1px 3px rgba(0,0,0,0.8)"}}>📌</div>}
                {p.is_detected_copy&&isMe&&(
                  <div style={{position:"absolute",bottom:4,left:4,right:4,background:"rgba(0,0,0,0.7)",borderRadius:4,padding:"2px 5px"}}>
                    <span style={{color:"#ff4444",fontSize:9,fontWeight:800}}>copié/collé</span>
                  </div>
                )}
                <div style={{position:"absolute",inset:0,background:"rgba(0,0,0,0)",transition:"background 0.2s",display:"flex",alignItems:"center",justifyContent:"center",gap:12}}>
                  <div style={{color:C.white,fontSize:11,fontWeight:700,display:"flex",alignItems:"center",gap:3}}>
                    <span>❤️</span><span>{p.likes_count||0}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        );
      })()}

      {showProfileOptions&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:900,display:"flex",alignItems:"flex-end"}} onClick={()=>setShowProfileOptions(false)}>
          <div onClick={e=>e.stopPropagation()} style={{background:C.navy2,borderRadius:"20px 20px 0 0",padding:20,width:"100%",border:"1px solid "+C.border}}>
            <button onClick={()=>{setShowProfileOptions(false);setShowReportModal(true);}} style={{width:"100%",padding:"14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:"#f87171",fontWeight:600,textAlign:"left",marginBottom:10,cursor:"pointer"}}>🚩 Signaler @{username}</button>
            <button onClick={toggleBlock} style={{width:"100%",padding:"14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:"#f87171",fontWeight:600,textAlign:"left",marginBottom:10,cursor:"pointer"}}>{isBlocked?"✅ Débloquer @"+username:"🚫 Bloquer @"+username}</button>
            <button onClick={()=>setShowProfileOptions(false)} style={{width:"100%",padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Annuler</button>
          </div>
        </div>
      )}

      {showReportModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:900,display:"flex",alignItems:"center",justifyContent:"center",padding:24}} onClick={()=>setShowReportModal(false)}>
          <div onClick={e=>e.stopPropagation()} style={{background:C.navy2,borderRadius:20,padding:24,width:"100%",maxWidth:360,border:"1px solid "+C.border}}>
            <div style={{color:C.white,fontWeight:800,fontSize:17,marginBottom:16}}>Pourquoi signales-tu @{username} ?</div>
            {["Spam","Contenu inapproprié","Harcèlement ou intimidation","Faux compte / usurpation","Autre"].map(reason=>(
              <button key={reason} disabled={reportSending} onClick={()=>submitReport(reason)} style={{width:"100%",padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:600,textAlign:"left",marginBottom:10,cursor:reportSending?"not-allowed":"pointer"}}>{reason}</button>
            ))}
            <button onClick={()=>setShowReportModal(false)} style={{width:"100%",padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Annuler</button>
          </div>
        </div>
      )}

      {showAvatarChoice&&(
        <div onClick={()=>setShowAvatarChoice(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:1000,display:"flex",alignItems:"flex-end"}}>
          <div onClick={e=>e.stopPropagation()} style={{background:C.navy2,borderRadius:"20px 20px 0 0",padding:"20px 16px 32px",width:"100%",border:"1px solid "+C.border,borderBottom:"none"}}>
            <button onClick={()=>{setShowAvatarChoice(false);setStoryToView(activeUserStories);}} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:"linear-gradient(135deg,#f5576c,#f093fb)",color:"#fff",fontWeight:700,fontSize:15,cursor:"pointer",marginBottom:10}}>
              📖 Voir la story
            </button>
            <button onClick={()=>{setShowAvatarChoice(false);setShowFullAvatar(true);}} style={{width:"100%",padding:"16px",borderRadius:14,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:700,fontSize:15,cursor:"pointer",marginBottom:10}}>
              🖼️ Voir la photo de profil
            </button>
            <button onClick={()=>setShowAvatarChoice(false)} style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {storyToView&&<StoryViewer allGroups={[storyToView]} startGroupIdx={0} onClose={()=>setStoryToView(null)} currentUser={currentUser}/>}

      {showFullAvatar&&myAvatar&&(
        <div onClick={()=>setShowFullAvatar(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.92)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
          <img src={myAvatar} alt="" style={{width:"100%",maxWidth:400,aspectRatio:"1/1",borderRadius:"50%",objectFit:"cover"}}/>
        </div>
      )}

    </div>
  );
}

function CertificationFlow({user,onClose,onCertified,showToast,pageContext}){
  const active=isBadgeActive(pageContext||user);
  const targetName=pageContext?pageContext.name:("@"+user.username);
  const [page,setPage]=useState(active?"already":"intro");
  const [paying,setPaying]=useState(false);
  const [payError,setPayError]=useState("");
  const [pendingRef,setPendingRef]=useState("");
  const [notchpayRef,setNotchpayRef]=useState("");
  const [payStep,setPayStep]=useState("form");
  const [momoChannel,setMomoChannel]=useState("cm.mtn");
  const [momoPhone,setMomoPhone]=useState("");
  const [charging,setCharging]=useState(false);
  const [cmSelected,setCmSelected]=useState(false);

  const CERT_PLANS=[
    {id:"1m",label:"1 mois",price:4500,sub:null,months:1},
    {id:"6m",label:"6 mois",price:22500,sub:fmtUSD(3750)+" / mois",months:6},
    {id:"12m",label:"12 mois",price:45000,sub:fmtUSD(3750)+" / mois",months:12},
  ];
  const [certPlanId,setCertPlanId]=useState("1m");
  const selectedPlan=CERT_PLANS.find(pl=>pl.id===certPlanId)||CERT_PLANS[0];
  const CERT_PRICE=selectedPlan.price;

  async function processCertPayment(){
    setPaying(true);setPayError("");setPayStep("processing");
    const ref="cert_"+encodeURIComponent(user.username)+"_"+Date.now();
    try{
      const res=await fetch(BLUELIFE_BACKEND_URL+"/api/pay-initiate",{
        method:"POST",cache:"no-store",
        headers:{
          "Content-Type":"application/json","Accept":"application/json"
        },
        body:JSON.stringify({
          amount:CERT_PRICE,currency:"XAF",
          email:user.email||user.username+"@bluelife.app",
          description:"Certification Blue Life ("+selectedPlan.label+") - @"+user.username
        })
      });
      let data={};
      try{const t=await res.text();data=t?JSON.parse(t):{};}catch{
        setPayStep("error");
        setPayError("Le serveur de paiement n'a pas répondu correctement. Réessaie.");
        setPaying(false);return;
      }
      if(!res.ok||!data.transaction||!data.transaction.reference){
        console.error("Notchpay raw response (status "+res.status+"): "+JSON.stringify(data));
        const reason=data?.message||data?.error||"Impossible d'initialiser le paiement";
        setPayStep("error");
        setPayError(reason+" (code "+res.status+")");
        setPaying(false);return;
      }
      setPendingRef(ref);
      setNotchpayRef(data.transaction.reference);
      setPayStep("selectMethod");
      setPaying(false);
    }catch(e){
      setPayStep("error");
      const isNetwork=e.message&&e.message.toLowerCase().includes("fetch");
      setPayError(isNetwork?"Connexion au serveur de paiement impossible. Réessaie.":("Erreur: "+e.message));
      setPaying(false);
    }
  }

  async function finalizeCertification(ref){
    const until=addMonths(new Date(),selectedPlan.months).toISOString();
    if(pageContext){
      await db("/pages?id=eq."+pageContext.id,{method:"PATCH",body:JSON.stringify({verified:true,verified_until:until}),headers:{Prefer:"return=minimal"}}).catch(()=>{});
      await db("/Posts?page_id=eq."+pageContext.id,{method:"PATCH",body:JSON.stringify({verified:true,verified_until:until}),headers:{Prefer:"return=minimal"}}).catch(()=>{});
      await db("/notifications",{method:"POST",body:JSON.stringify({
        receiver:user.username,sender:"Blue Life",type:"certification_confirmed",seen:false,
        message:"Félicitations ! "+pageContext.name+" est maintenant certifié(e) avec le badge bleu. Formule: "+selectedPlan.label+". Valide jusqu'au "+new Date(until).toLocaleDateString("fr-FR")+". Montant débité: "+fmtUSD(CERT_PRICE)+". Référence: "+ref
      })}).catch(()=>{});
      onCertified&&onCertified(until);
      setPage("success");
      return;
    }
    await db("/profiles?username=eq."+encodeURIComponent(user.username),{method:"PATCH",body:JSON.stringify({verified:true,verified_until:until,verified_notified:false}),headers:{Prefer:"return=minimal"}}).catch(()=>{});
    try{
      const postsRes=await fetch(SUPABASE_URL+"/rest/v1/Posts?username=eq."+encodeURIComponent(user.username),{
        method:"PATCH",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({verified:true,verified_until:until})
      });
      if(!postsRes.ok){
        const bodyText=await postsRes.text().catch(()=>"");
        console.error("Badge propagation to Posts failed (status "+postsRes.status+"): "+bodyText);
      }
    }catch(e){
      console.error("Badge propagation to Posts network error: "+e.message);
    }
    try{
      const storiesRes=await fetch(SUPABASE_URL+"/rest/v1/stories?author=eq."+encodeURIComponent(user.username),{
        method:"PATCH",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({verified:true,verified_until:until})
      });
      if(!storiesRes.ok){
        const bodyText=await storiesRes.text().catch(()=>"");
        console.error("Badge propagation to stories failed (status "+storiesRes.status+"): "+bodyText);
      }
    }catch(e){
      console.error("Badge propagation to stories network error: "+e.message);
    }
    await db("/notifications",{method:"POST",body:JSON.stringify({
      receiver:user.username,sender:"Blue Life",type:"certification_confirmed",seen:false,
      message:"Felicitations ! Ton compte @"+encodeURIComponent(user.username)+" est maintenant certifie avec le badge bleu. Formule: "+selectedPlan.label+". Valide jusqu'au "+new Date(until).toLocaleDateString("fr-FR")+". Montant debite: "+fmtUSD(CERT_PRICE)+". Reference: "+ref
    })}).catch(()=>{});
    onCertified&&onCertified(until);
    setPage("success");
  }

  const [cardBusy,setCardBusy]=useState(false);
  const [cardError,setCardError]=useState("");
  async function payCardViaPaddle(){
    setCardError("");
    setCardBusy(true);
    await payViaCamerPay(
      "certification",(user.username||"").trim(),CERT_PRICE,null,user.email,{months:String(selectedPlan.months)},
      async ()=>{
        showToast&&showToast("⏳ Confirmation du paiement...");
        for(let i=0;i<15;i++){
          await new Promise(r=>setTimeout(r,2000));
          const res=await db("/profiles?username=eq."+encodeURIComponent(user.username)+"&select=verified,verified_until").catch(()=>null);
          if(res&&res[0]&&res[0].verified){
            onCertified&&onCertified(res[0].verified_until);
            setPage("success");
            setCardBusy(false);
            return;
          }
        }
        setCardError("Paiement confirmé mais pas encore synchronisé côté Blue Life. Réessaie de vérifier dans un instant.");
        setCardBusy(false);
      },
      (msg)=>{setCardError(msg);setCardBusy(false);}
    );
  }

  const [walletBalance,setWalletBalance]=useState(null);

  useEffect(()=>{
    if(payStep!=="selectMethod"||!user||!user.username)return;
    db("/profiles?username=eq."+encodeURIComponent(user.username)+"&select=wallet_balance&limit=1").then(d=>{
      if(Array.isArray(d)&&d[0])setWalletBalance(d[0].wallet_balance||0);
    }).catch(()=>{});
  },[payStep]);

  async function payCertWithWallet(){
    setCharging(true);setPayError("");
    try{
      await callRpc("spend_wallet",{p_amount_xaf:CERT_PRICE,p_description:"Certification "+selectedPlan.label,p_target_username:user.username});
      await finalizeCertification(pendingRef);
      showToast&&showToast("✅ Certification activée avec ton solde !");
    }catch(e){
      setPayError(e.message||"Échec du paiement par solde. Réessaie.");
    }
    setCharging(false);
  }

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:850,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12,position:"sticky",top:0,background:C.navy,zIndex:10}}>
        <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1,display:"flex",alignItems:"center",gap:8}}>
          <svg width="19" height="19" viewBox="0 0 24 24" fill="#3897f0" style={{flexShrink:0}}>
            <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
            <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Certification Blue
        </span>
      </div>

      {page==="already"&&(
        <div style={{textAlign:"center",padding:"60px 24px"}}>
          <div style={{fontSize:64,marginBottom:16}}>✅</div>
          <div style={{fontWeight:800,fontSize:20,color:C.white,marginBottom:10}}>Compte déjà certifié</div>
          <div style={{color:C.w3,fontSize:14,marginBottom:24}}>
            Ton compte {targetName} possède déjà le badge bleu vérifié.
            {user.verified_until&&<><br/><br/>Valide jusqu'au <b style={{color:C.white}}>{new Date(user.verified_until).toLocaleDateString("fr-FR")}</b>. Tu recevras une notification 5 jours avant l'expiration pour renouveler.</>}
          </div>
          <button onClick={()=>setPage("intro")} style={{width:"100%",padding:"14px",borderRadius:14,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:700,fontSize:14,cursor:"pointer"}}>
            🔄 Renouveler / changer de formule
          </button>
        </div>
      )}

      {page==="intro"&&(
        <div style={{padding:20}}>
          <div style={{textAlign:"center",marginBottom:24}}>
            <div style={{width:72,height:72,margin:"0 auto 14px",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <svg width="72" height="72" viewBox="0 0 24 24" fill={C.accent}>
                <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
                <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div style={{fontWeight:800,fontSize:20,color:C.white,marginBottom:6}}>Avantages de la certification</div>
            <div style={{color:C.w3,fontSize:14}}>Le badge bleu vérifié pour {targetName}</div>
          </div>

          {[
            {ic:"🛡️",title:"Protection contre les faux comptes",desc:"Ton identité devient vérifiée et fiable, plus difficile à usurper"},
            {ic:"🚫",title:"Anti-usurpation",desc:"Plus personne ne peut créer un compte avec ton nom une fois certifié"},
            {ic:"🚀",title:"Mise en avant prioritaire",desc:"Ton contenu est mis en avant dans le feed de tous les utilisateurs"},
          ].map((b,i)=>(
            <div key={i} style={{display:"flex",gap:14,padding:16,background:C.w5,borderRadius:14,marginBottom:10,border:"1px solid "+C.border}}>
              <div style={{fontSize:26}}>{b.ic}</div>
              <div>
                <div style={{fontWeight:700,fontSize:14,color:C.white,marginBottom:3}}>{b.title}</div>
                <div style={{fontSize:12,color:C.w3,lineHeight:1.5}}>{b.desc}</div>
              </div>
            </div>
          ))}

          <div style={{marginTop:20,marginBottom:20}}>
            <div style={{color:C.w3,fontSize:12,fontWeight:700,letterSpacing:0.5,marginBottom:10,textTransform:"uppercase"}}>Choisir une formule</div>
            {CERT_PLANS.map(p=>(
              <div key={p.id} onClick={()=>setCertPlanId(p.id)} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 16px",borderRadius:14,marginBottom:10,cursor:"pointer",background:certPlanId===p.id?C.accent+"15":C.w5,border:"2px solid "+(certPlanId===p.id?C.accent:C.border)}}>
                <div>
                  <div style={{fontWeight:700,fontSize:15,color:C.white}}>{p.label}</div>
                  {p.sub&&<div style={{fontSize:12,color:C.w3,marginTop:2}}>{p.sub}</div>}
                </div>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{fontWeight:800,fontSize:16,color:C.white}}>{fmtUSD(p.price)}</div>
                  <div style={{width:20,height:20,borderRadius:"50%",border:"2px solid "+(certPlanId===p.id?C.accent:C.w3),background:certPlanId===p.id?C.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    {certPlanId===p.id&&<div style={{width:8,height:8,borderRadius:"50%",background:"#fff"}}/>}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button onClick={()=>setPage("payment")} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:"pointer"}}>
            Continuer vers le paiement
          </button>
        </div>
      )}

      {page==="payment"&&payStep==="form"&&(
        <div style={{padding:20}}>
          <div style={{background:C.accent+"22",borderRadius:16,padding:16,marginBottom:20,border:"1px solid "+C.border2,textAlign:"center"}}>
            <div style={{fontSize:28,fontWeight:800,color:C.white}}>{fmtUSD(CERT_PRICE)}</div>
            <div style={{color:C.w3,fontSize:13}}>Certification du compte @{user.username} · {selectedPlan.label}</div>
          </div>

          <div style={{textAlign:"center",padding:"20px 10px"}}>
            <div style={{fontSize:44,marginBottom:14}}>🔒</div>
            <div style={{fontWeight:700,fontSize:16,color:C.white,marginBottom:8}}>Paiement sécurisé via CamerPay</div>
            <div style={{color:C.w3,fontSize:13,lineHeight:1.6}}>
              Choisis Mobile Money, carte bancaire ou PayPal sur l'écran suivant.
            </div>
          </div>

          {payError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{payError}</div>}

          <button onClick={()=>setPayStep("selectMethod")} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
            🔒 Continuer vers le paiement
          </button>
        </div>
      )}

      {page==="payment"&&payStep==="processing"&&(
        <div style={{padding:20,textAlign:"center",paddingTop:60}}>
          <div style={{fontSize:48,marginBottom:16,animation:"spin 1s linear infinite",display:"inline-block"}}>⏳</div>
          <div style={{fontWeight:700,fontSize:18,color:C.white,marginBottom:8}}>Initialisation du paiement...</div>
        </div>
      )}

      {page==="payment"&&payStep==="selectMethod"&&(
        <div style={{padding:20}}>
          <div style={{background:C.accent+"22",borderRadius:16,padding:16,marginBottom:20,border:"1px solid "+C.border2,textAlign:"center"}}>
            <div style={{fontSize:28,fontWeight:800,color:C.white}}>{fmtUSD(CERT_PRICE)}</div>
            <div style={{color:C.w3,fontSize:13}}>Certification du compte @{user.username} · {selectedPlan.label}</div>
          </div>

          {walletBalance!==null&&(
            <button onClick={payCertWithWallet} disabled={charging||walletBalance<CERT_PRICE} style={{width:"100%",padding:"14px",borderRadius:14,border:"1px solid "+(walletBalance>=CERT_PRICE?C.accent:C.border),background:walletBalance>=CERT_PRICE?C.accent+"22":C.w5,color:walletBalance>=CERT_PRICE?C.white:C.w3,fontWeight:700,fontSize:14,cursor:(charging||walletBalance<CERT_PRICE)?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:14}}>
              💼 Payer avec mon solde ({fmtUSD(walletBalance)})
            </button>
          )}
          <div style={{textAlign:"center",color:C.w3,fontSize:12,marginBottom:14}}>— ou —</div>

          {cardError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:10}}>{cardError}</div>}
          <button onClick={cardBusy?undefined:payCardViaPaddle} disabled={cardBusy} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:cardBusy?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:cardBusy?"not-allowed":"pointer"}}>
            {cardBusy?"⏳ Confirmation en cours...":"Payer "+fmtUSD(CERT_PRICE)}
          </button>
          <div style={{color:C.w3,fontSize:12,textAlign:"center",marginTop:12}}>Mobile Money (Orange, MTN), carte bancaire ou PayPal — choisis sur l'écran suivant.</div>
        </div>
      )}

      {page==="payment"&&payStep==="error"&&(
        <div style={{padding:20,textAlign:"center",paddingTop:40}}>
          <div style={{fontSize:56,marginBottom:16}}>❌</div>
          <div style={{fontWeight:800,fontSize:19,color:C.white,marginBottom:10}}>Paiement échoué</div>
          <div style={{color:"#f87171",fontSize:13,marginBottom:24}}>{payError}</div>
          <button onClick={()=>setPayStep("selectMethod")} style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:"pointer"}}>Réessayer</button>
        </div>
      )}

      {page==="success"&&(
        <div style={{textAlign:"center",padding:"50px 24px"}}>
          <div style={{fontSize:64,marginBottom:16}}>🎉</div>
          <div style={{fontWeight:800,fontSize:22,color:C.white,marginBottom:10}}>Compte certifié !</div>
          <div style={{color:C.w3,fontSize:14,marginBottom:24,lineHeight:1.6}}>
            Ton compte @{user.username} possède maintenant le badge bleu vérifié <svg width="16" height="16" viewBox="0 0 24 24" fill="#3897f0" style={{display:"inline-block",verticalAlign:"middle"}}>
              <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
              <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
            </svg><br/>
            Ton nom d'utilisateur est désormais protégé contre toute usurpation.
            {user.verified_until&&<><br/><br/>Valide jusqu'au <b style={{color:C.white}}>{new Date(user.verified_until).toLocaleDateString("fr-FR")}</b>.</>}
          </div>
          <button onClick={onClose} style={{width:"100%",padding:"15px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:15,cursor:"pointer"}}>
            🚀 Retour à Blue Life
          </button>
        </div>
      )}
    </div>
  );
}

const APP_LANGUAGES = ["Français","English","Español","Deutsch","Lingala","العربية"];

const TRANSLATIONS = {
  Français: {
    home:"Accueil", explore:"Explorer", reels:"Reels", video:"Vidéo", notifications:"Notifications", profile:"Profil",
    settings:"Paramètres", logout:"Se déconnecter", editProfile:"Modifier le profil", share:"Partager",
    dashboard:"Tableau de bord professionnel", viewStats:"Voir les statistiques du profil",
    saved:"Enregistrés", noSaved:"Rien d'enregistré", savedHint:"Les posts que tu enregistres apparaîtront ici",
    followers:"Abonnés", following:"Abonnements", posts:"Publications", totalLikes:"Total J'aime", totalViews:"Vues totales",
    likeAction:"J'aime", comments:"commentaires", comment:"commentaire", seeComments:"Voir les",
    newPost:"Nouvelle publication", newStory:"Nouvelle story", boost:"Booster", certification:"Certification Blue",
    payments:"Paiements", privacy:"Confidentialité", security:"Sécurité", language:"Langue", help:"Aide", terms:"Conditions",
    login:"Se connecter", register:"Créer mon compte", noAccount:"Continuer sans compte",
    needAccount:"Rejoins Blue Life", needAccountDesc:"Connecte-toi pour continuer",
    monetization:"Monétisation", payNow:"Continuer vers le paiement", paymentSuccess:"Paiement réussi !",
    backToApp:"Retour à Blue Life", noPostYet:"Aucun post", noReelYet:"Aucun Reel encore", noVideoYet:"Aucune vidéo encore",
    search:"Rechercher", users:"Utilisateurs", noResults:"Aucun résultat pour", loading:"Chargement...",
  },
  English: {
    home:"Home", explore:"Explore", reels:"Reels", video:"Video", notifications:"Notifications", profile:"Profile",
    settings:"Settings", logout:"Log out", editProfile:"Edit profile", share:"Share",
    dashboard:"Professional dashboard", viewStats:"View profile statistics",
    saved:"Saved", noSaved:"Nothing saved", savedHint:"Posts you save will appear here",
    followers:"Followers", following:"Following", posts:"Posts", totalLikes:"Total likes", totalViews:"Total views",
    likeAction:"Likes", comments:"comments", comment:"comment", seeComments:"View",
    newPost:"New post", newStory:"New story", boost:"Boost", certification:"Blue Certification",
    payments:"Payments", privacy:"Privacy", security:"Security", language:"Language", help:"Help", terms:"Terms",
    login:"Log in", register:"Create my account", noAccount:"Continue without an account",
    needAccount:"Join Blue Life", needAccountDesc:"Log in to continue",
    monetization:"Monetization", payNow:"Continue to payment", paymentSuccess:"Payment successful!",
    backToApp:"Back to Blue Life", noPostYet:"No posts", noReelYet:"No Reels yet", noVideoYet:"No videos yet",
    search:"Search", users:"Users", noResults:"No results for", loading:"Loading...",
  },
  Español: {
    home:"Inicio", explore:"Explorar", reels:"Reels", video:"Video", notifications:"Notificaciones", profile:"Perfil",
    settings:"Configuración", logout:"Cerrar sesión", editProfile:"Editar perfil", share:"Compartir",
    dashboard:"Panel profesional", viewStats:"Ver estadísticas del perfil",
    saved:"Guardados", noSaved:"Nada guardado", savedHint:"Las publicaciones que guardes aparecerán aquí",
    followers:"Seguidores", following:"Siguiendo", posts:"Publicaciones", totalLikes:"Total de me gusta", totalViews:"Vistas totales",
    likeAction:"Me gusta", comments:"comentarios", comment:"comentario", seeComments:"Ver",
    newPost:"Nueva publicación", newStory:"Nueva historia", boost:"Impulsar", certification:"Certificación Blue",
    payments:"Pagos", privacy:"Privacidad", security:"Seguridad", language:"Idioma", help:"Ayuda", terms:"Términos",
    login:"Iniciar sesión", register:"Crear mi cuenta", noAccount:"Continuar sin cuenta",
    needAccount:"Únete a Blue Life", needAccountDesc:"Inicia sesión para continuar",
    monetization:"Monetización", payNow:"Continuar al pago", paymentSuccess:"¡Pago exitoso!",
    backToApp:"Volver a Blue Life", noPostYet:"Sin publicaciones", noReelYet:"Aún no hay Reels", noVideoYet:"Aún no hay videos",
    search:"Buscar", users:"Usuarios", noResults:"Sin resultados para", loading:"Cargando...",
  },
  Deutsch: {
    home:"Start", explore:"Entdecken", reels:"Reels", video:"Video", notifications:"Benachrichtigungen", profile:"Profil",
    settings:"Einstellungen", logout:"Abmelden", editProfile:"Profil bearbeiten", share:"Teilen",
    dashboard:"Profi-Dashboard", viewStats:"Profilstatistiken ansehen",
    saved:"Gespeichert", noSaved:"Nichts gespeichert", savedHint:"Gespeicherte Beiträge erscheinen hier",
    followers:"Follower", following:"Folge ich", posts:"Beiträge", totalLikes:"Likes insgesamt", totalViews:"Aufrufe insgesamt",
    likeAction:"Gefällt mir", comments:"Kommentare", comment:"Kommentar", seeComments:"Ansehen",
    newPost:"Neuer Beitrag", newStory:"Neue Story", boost:"Bewerben", certification:"Blue-Zertifizierung",
    payments:"Zahlungen", privacy:"Privatsphäre", security:"Sicherheit", language:"Sprache", help:"Hilfe", terms:"Bedingungen",
    login:"Anmelden", register:"Konto erstellen", noAccount:"Ohne Konto fortfahren",
    needAccount:"Tritt Blue Life bei", needAccountDesc:"Melde dich an, um fortzufahren",
    monetization:"Monetarisierung", payNow:"Weiter zur Zahlung", paymentSuccess:"Zahlung erfolgreich!",
    backToApp:"Zurück zu Blue Life", noPostYet:"Keine Beiträge", noReelYet:"Noch keine Reels", noVideoYet:"Noch keine Videos",
    search:"Suchen", users:"Nutzer", noResults:"Keine Ergebnisse für", loading:"Lädt...",
  },
  Lingala: {
    home:"Ndako", explore:"Luka", reels:"Reels", video:"Vidéo", notifications:"Basango", profile:"Profil",
    settings:"Paramètres", logout:"Kobima", editProfile:"Kobongisa profil", share:"Kokabola",
    dashboard:"Tableau ya travail", viewStats:"Kotala statistiques ya profil",
    saved:"Ebombami", noSaved:"Eloko moko te ebombami", savedHint:"Ba publication oyo okobomba ekomonana awa",
    followers:"Balandi", following:"Nazali kolanda", posts:"Ba publication", totalLikes:"Motango ya J'aime", totalViews:"Motango ya batali",
    likeAction:"Nalingi", comments:"ba commentaire", comment:"commentaire", seeComments:"Talá",
    newPost:"Publication ya sika", newStory:"Story ya sika", boost:"Kotombola", certification:"Certification Blue",
    payments:"Ba paiement", privacy:"Vie privée", security:"Sécurité", language:"Monoko", help:"Lisalisi", terms:"Ba conditions",
    login:"Kokota", register:"Kosala compte na ngai", noAccount:"Kokoba kozanga compte",
    needAccount:"Kokota na Blue Life", needAccountDesc:"Kota mpo na kokoba",
    monetization:"Kozwa mbongo", payNow:"Kokoba na paiement", paymentSuccess:"Paiement esali malamu !",
    backToApp:"Zonga na Blue Life", noPostYet:"Publication ezali te", noReelYet:"Reel ezali te", noVideoYet:"Vidéo ezali te",
    search:"Luka", users:"Ba utilisateur", noResults:"Eloko te mpo na", loading:"Ezali kotambola...",
  },
  "العربية": {
    home:"الرئيسية", explore:"استكشاف", reels:"ريلز", video:"فيديو", notifications:"الإشعارات", profile:"الملف الشخصي",
    settings:"الإعدادات", logout:"تسجيل الخروج", editProfile:"تعديل الملف الشخصي", share:"مشاركة",
    dashboard:"لوحة التحكم الاحترافية", viewStats:"عرض إحصائيات الملف الشخصي",
    saved:"المحفوظات", noSaved:"لا يوجد محفوظات", savedHint:"ستظهر هنا المنشورات التي تحفظها",
    followers:"المتابعون", following:"يتابع", posts:"المنشورات", totalLikes:"مجموع الإعجابات", totalViews:"مجموع المشاهدات",
    likeAction:"إعجاب", comments:"تعليقات", comment:"تعليق", seeComments:"عرض",
    newPost:"منشور جديد", newStory:"قصة جديدة", boost:"ترويج", certification:"توثيق Blue",
    payments:"المدفوعات", privacy:"الخصوصية", security:"الأمان", language:"اللغة", help:"المساعدة", terms:"الشروط",
    login:"تسجيل الدخول", register:"إنشاء حسابي", noAccount:"المتابعة بدون حساب",
    needAccount:"انضم إلى Blue Life", needAccountDesc:"سجّل الدخول للمتابعة",
    monetization:"تحقيق الدخل", payNow:"متابعة الدفع", paymentSuccess:"تم الدفع بنجاح!",
    backToApp:"العودة إلى Blue Life", noPostYet:"لا توجد منشورات", noReelYet:"لا توجد ريلز بعد", noVideoYet:"لا توجد فيديوهات بعد",
    search:"بحث", users:"المستخدمون", noResults:"لا نتائج لـ", loading:"جارٍ التحميل...",
  },
};

let _currentLang = (()=>{ try{ return localStorage.getItem("bl_language")||"Français"; }catch{ return "Français"; } })();
const _langListeners = new Set();
function setAppLanguage(lang){
  _currentLang = lang;
  try{ localStorage.setItem("bl_language", lang); }catch{}
  _langListeners.forEach(fn=>fn());
}
function useTranslation(){
  const [, forceUpdate] = useState(0);
  useEffect(()=>{
    const listener = () => forceUpdate(n=>n+1);
    _langListeners.add(listener);
    return () => _langListeners.delete(listener);
  },[]);
  return (key) => (TRANSLATIONS[_currentLang] && TRANSLATIONS[_currentLang][key]) || TRANSLATIONS.Français[key] || key;
}

function PremiumSettingsPanel({user,showToast,pageContext}){
  const [currentPriceXaf,setCurrentPriceXaf]=useState(null);
  const [priceInput,setPriceInput]=useState("");
  const [saving,setSaving]=useState(false);
  const targetTable=pageContext?"pages":"profiles";
  const targetFilter=pageContext?("id=eq."+pageContext.id):("username=eq."+encodeURIComponent(user.username));

  useEffect(()=>{
    db("/"+targetTable+"?"+targetFilter+"&select=premium_price_xaf&limit=1").then(d=>{
      const p=(Array.isArray(d)&&d[0]&&d[0].premium_price_xaf)||0;
      setCurrentPriceXaf(p);
      if(p>0)setPriceInput(String(Math.round(p/_xafPerUsd)));
    }).catch(()=>setCurrentPriceXaf(0));
  },[user.username,pageContext&&pageContext.id]);

  async function save(newXafOrNull){
    setSaving(true);
    const res=await fetch(SUPABASE_URL+"/rest/v1/"+targetTable+"?"+targetFilter,{
      method:"PATCH",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
      body:JSON.stringify({premium_price_xaf:newXafOrNull})
    });
    const rawText=await res.text();
    const data=(()=>{try{return JSON.parse(rawText);}catch{return null;}})();
    setSaving(false);
    if(!res.ok||!Array.isArray(data)||data.length===0){
      showToast&&showToast("⚠️ Échec de l'enregistrement");
      return;
    }
    setCurrentPriceXaf(newXafOrNull||0);
    showToast&&showToast(newXafOrNull?"✅ Abonnement premium activé":"Abonnement premium désactivé");
  }

  if(currentPriceXaf===null){
    return <div style={{color:C.w3,fontSize:13,textAlign:"center",padding:20}}>Chargement...</div>;
  }

  return (
    <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:16}}>
      <div style={{color:C.w3,fontSize:13,lineHeight:1.6,marginBottom:16}}>
        Laisse tes abonnés te soutenir avec un paiement unique. En échange, ils reçoivent un badge spécial, et tes prochaines publications leur sont mises en avant en priorité dans leur fil, avec une notification dès que tu postes.
      </div>
      {currentPriceXaf>0&&(
        <div style={{background:C.accent+"22",borderRadius:12,padding:14,marginBottom:16,textAlign:"center"}}>
          <div style={{color:C.w3,fontSize:12}}>Prix actuel de ton abonnement</div>
          <div style={{color:C.white,fontWeight:800,fontSize:22}}>{fmtUSD(currentPriceXaf)}</div>
        </div>
      )}
      <div style={{color:C.w3,fontSize:13,marginBottom:8,fontWeight:600}}>{currentPriceXaf>0?"Modifier le prix":"Fixe ton prix"}</div>
      <input value={priceInput} onChange={e=>setPriceInput(e.target.value.replace(/[^0-9]/g,""))} placeholder="Montant en $" inputMode="numeric" style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:15,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>
      <button disabled={saving||!priceInput||Number(priceInput)<=0} onClick={()=>save(Math.round(Number(priceInput)*_xafPerUsd))} style={{width:"100%",padding:"14px",borderRadius:12,border:"none",background:(saving||!priceInput||Number(priceInput)<=0)?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:(saving||!priceInput||Number(priceInput)<=0)?"not-allowed":"pointer",marginBottom:currentPriceXaf>0?10:0}}>
        {saving?"...":currentPriceXaf>0?"Mettre à jour le prix":"Activer les abonnements premium"}
      </button>
      {currentPriceXaf>0&&(
        <button disabled={saving} onClick={()=>save(null)} style={{width:"100%",padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:"#f87171",fontWeight:600,cursor:saving?"not-allowed":"pointer"}}>
          Désactiver les abonnements premium
        </button>
      )}
    </div>
  );
}

function SwitchAccountPanel({currentUsername,onSwitchAccount,onAddAccount,showToast}){
  const [accounts,setAccounts]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("bl_multi_accounts")||"[]");}catch{return [];}
  });

  function removeAccount(e,username){
    e.stopPropagation();
    if(username===currentUsername){
      showToast&&showToast("Impossible de retirer le compte actif");
      return;
    }
    const updated=accounts.filter(a=>a.username!==username);
    setAccounts(updated);
    try{localStorage.setItem("bl_multi_accounts",JSON.stringify(updated));}catch{}
  }

  return (
    <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:16}}>
      <div style={{color:C.w3,fontSize:13,lineHeight:1.6,marginBottom:16}}>
        Garde plusieurs comptes connectés en même temps, et bascule de l'un à l'autre instantanément, sans jamais te déconnecter.
      </div>
      {accounts.map((acc,i)=>{
        const isCurrent=acc.username===currentUsername;
        return (
          <div key={i} onClick={()=>!isCurrent&&onSwitchAccount&&onSwitchAccount(acc)} style={{display:"flex",alignItems:"center",gap:12,padding:"12px",borderRadius:14,marginBottom:10,cursor:isCurrent?"default":"pointer",background:isCurrent?C.accent+"18":C.navy,border:"1px solid "+(isCurrent?C.accent:C.border)}}>
            <Avatar src={acc.avatar||""} name={acc.username} size={44}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{color:C.white,fontWeight:700,fontSize:14,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{acc.displayName||acc.username}</div>
              <div style={{color:isCurrent?C.accent2:C.w3,fontSize:12}}>{isCurrent?"Compte actif":"@"+acc.username}</div>
            </div>
            {!isCurrent&&(
              <button onClick={e=>removeAccount(e,acc.username)} style={{background:"none",border:"none",color:C.w3,fontSize:18,cursor:"pointer",padding:4}}>✕</button>
            )}
          </div>
        );
      })}
      <button onClick={onAddAccount} style={{width:"100%",padding:"14px",borderRadius:12,border:"1px dashed "+C.border,background:"transparent",color:C.accent2,fontWeight:700,cursor:"pointer",marginTop:6}}>
        ➕ Ajouter un compte
      </button>
    </div>
  );
}

function MyPagesPanel({user,onCreatePage,onOpenPage,onSwitchToPage,showToast}){
  const [pages,setPages]=useState(null);
  const [pendingInvites,setPendingInvites]=useState(null);
  const [responding,setResponding]=useState({});
  const [debugErr,setDebugErr]=useState("");

  function load(){
    (async()=>{
      setDebugErr("");
      const owned=await db("/profiles?managed_by=eq."+encodeURIComponent(user.username)+"&order=username.asc");
      if(owned&&!Array.isArray(owned)){
        console.error("MyPagesPanel: owned pages fetch returned an error object: "+JSON.stringify(owned));
        setDebugErr("Erreur (pages possédées): "+JSON.stringify(owned).slice(0,150));
      }
      const adminRows=await db("/page_admins?admin_username=eq."+encodeURIComponent(user.username)+"&status=eq.accepted");
      if(adminRows&&!Array.isArray(adminRows)){
        console.error("MyPagesPanel: page_admins fetch returned an error object: "+JSON.stringify(adminRows));
        setDebugErr(d=>d||"Erreur (page_admins): "+JSON.stringify(adminRows).slice(0,150));
      }
      let administered=[];
      if(Array.isArray(adminRows)&&adminRows.length>0){
        const usernames=adminRows.map(r=>r.page_username);
        const profs=await db("/profiles?username=in.("+usernames.join(",")+")");
        if(profs&&!Array.isArray(profs)){
          console.error("MyPagesPanel: profiles-by-username fetch returned an error object: "+JSON.stringify(profs));
          setDebugErr(d=>d||"Erreur (profils des pages): "+JSON.stringify(profs).slice(0,150));
        }
        if(Array.isArray(profs)){
          administered=profs.map(p=>({...p,_permission:(adminRows.find(r=>r.page_username===p.username)||{}).permission_level||"limited"}));
        }
      }
      const ownedTagged=(Array.isArray(owned)?owned:[]).map(p=>({...p,_role:"owner"}));
      const adminTagged=administered.map(p=>({...p,_role:"admin"}));
      setPages([...ownedTagged,...adminTagged]);

      const pendingRows=await db("/page_admins?admin_username=eq."+encodeURIComponent(user.username)+"&status=eq.pending").catch(()=>[]);
      if(Array.isArray(pendingRows)&&pendingRows.length>0){
        const usernames=pendingRows.map(r=>r.page_username);
        const profs=await db("/profiles?username=in.("+usernames.join(",")+")").catch(()=>[]);
        setPendingInvites(pendingRows.map(r=>({...r,profile:Array.isArray(profs)?profs.find(p=>p.username===r.page_username):null})));
      }else{
        setPendingInvites([]);
      }
    })();
  }
  useEffect(()=>{load();},[user.username]);

  async function respond(pageUsername,accept){
    setResponding(r=>({...r,[pageUsername]:true}));
    try{
      await callRpc(accept?"accept_page_admin":"decline_page_admin",{p_page_username:pageUsername});
      setPendingInvites(inv=>inv.filter(x=>x.page_username!==pageUsername));
      if(accept){showToast&&showToast("✅ Tu es maintenant administrateur");load();}
    }catch(e){
      showToast&&showToast("⚠️ "+(e.message||"Échec, réessaie"));
    }
    setResponding(r=>({...r,[pageUsername]:false}));
  }

  return (
    <div>
      {debugErr&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:12,marginBottom:14}}>{debugErr}</div>}
      {!user.isPage&&(
        <button onClick={onCreatePage} style={{width:"100%",padding:"14px",borderRadius:12,border:"1px dashed "+C.border,background:"transparent",color:C.accent2,fontWeight:700,cursor:"pointer",marginBottom:16}}>
          ➕ Créer une Page ou un Groupe
        </button>
      )}
      {pendingInvites&&pendingInvites.length>0&&(
        <>
          <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:8}}>Invitations reçues</div>
          {pendingInvites.map((inv,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"12px",borderRadius:14,marginBottom:10,background:C.accent+"0e",border:"1px solid "+C.accent}}>
              <div style={{width:44,height:44,borderRadius:"50%",backgroundImage:(inv.profile&&inv.profile.avatar)?"url("+inv.profile.avatar+")":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",backgroundSize:"cover",backgroundPosition:"center",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,flexShrink:0}}>
                {!(inv.profile&&inv.profile.avatar)&&initials(inv.page_username)}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{color:C.white,fontWeight:700,fontSize:14,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{(inv.profile&&inv.profile.display_name)||inv.page_username}</div>
                <div style={{color:C.w3,fontSize:12}}>Admin {inv.permission_level==="full"?"(accès complet)":"(limité)"}</div>
              </div>
              <button onClick={()=>respond(inv.page_username,true)} disabled={responding[inv.page_username]} style={{padding:"7px 12px",borderRadius:8,border:"none",background:C.accent,color:"#fff",fontWeight:700,fontSize:12,cursor:"pointer",flexShrink:0}}>Accepter</button>
              <button onClick={()=>respond(inv.page_username,false)} disabled={responding[inv.page_username]} style={{padding:"7px 10px",borderRadius:8,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:700,fontSize:12,cursor:"pointer",flexShrink:0}}>✕</button>
            </div>
          ))}
        </>
      )}
      {pages===null?(
        <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
      ):pages.length===0?(
        <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:20,textAlign:"center",marginBottom:16}}>
          <div style={{fontSize:32,marginBottom:10}}>📄</div>
          <div style={{color:C.w3,fontSize:13,lineHeight:1.6}}>Tu ne gères encore aucune Page ni Groupe.</div>
        </div>
      ):(
        pages.map((p,i)=>(
          <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"12px",borderRadius:14,marginBottom:10,background:C.w5,border:"1px solid "+C.border}}>
            <div onClick={()=>onOpenPage&&onOpenPage(p.username)} style={{display:"flex",alignItems:"center",gap:12,flex:1,minWidth:0,cursor:"pointer"}}>
              <div style={{width:44,height:44,borderRadius:"50%",backgroundImage:p.avatar?"url("+p.avatar+")":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",backgroundSize:"cover",backgroundPosition:"center",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,flexShrink:0}}>
                {!p.avatar&&initials(p.display_name)}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{color:C.white,fontWeight:700,fontSize:14,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.display_name}</div>
                <div style={{color:C.w3,fontSize:12}}>{p.entity_type==="group"?"Groupe":"Page"} · {p._role==="owner"?"Propriétaire":p._permission==="full"?"Admin (accès complet)":"Admin (limité)"}</div>
              </div>
            </div>
            <button onClick={()=>onSwitchToPage&&onSwitchToPage(p)} style={{background:C.accent+"18",border:"1px solid "+C.accent,borderRadius:10,padding:"7px 12px",color:C.accent2,fontWeight:700,fontSize:12,cursor:"pointer",flexShrink:0}}>Basculer</button>
          </div>
        ))
      )}
    </div>
  );
}

function MyGroupsPanel({user,onCreateGroup,onOpenGroup,showToast}){
  const [groups,setGroups]=useState(null);
  const [invites,setInvites]=useState(null);
  const [responding,setResponding]=useState({});

  function load(){
    (async()=>{
      const owned=await db("/groups?owner_username=eq."+encodeURIComponent(user.username)+"&order=created_at.desc").catch(()=>[]);
      const memberRows=await db("/group_members?username=eq."+encodeURIComponent(user.username)+"&status=eq.member").catch(()=>[]);
      let joined=[];
      if(Array.isArray(memberRows)&&memberRows.length>0){
        const ownedIds=(Array.isArray(owned)?owned:[]).map(g=>g.id);
        const ids=memberRows.map(r=>r.group_id).filter(id=>!ownedIds.includes(id));
        if(ids.length>0){
          const rows=await db("/groups?id=in.("+ids.join(",")+")").catch(()=>[]);
          joined=Array.isArray(rows)?rows:[];
        }
      }
      const ownedTagged=(Array.isArray(owned)?owned:[]).map(g=>({...g,_role:"owner"}));
      const joinedTagged=joined.map(g=>({...g,_role:"member"}));
      setGroups([...ownedTagged,...joinedTagged]);

      const inviteRows=await db("/group_members?username=eq."+encodeURIComponent(user.username)+"&status=eq.invited").catch(()=>[]);
      if(Array.isArray(inviteRows)&&inviteRows.length>0){
        const ids=inviteRows.map(r=>r.group_id);
        const rows=await db("/groups?id=in.("+ids.join(",")+")").catch(()=>[]);
        setInvites(Array.isArray(rows)?rows:[]);
      }else{
        setInvites([]);
      }
    })();
  }
  useEffect(()=>{load();},[user.username]);

  async function respond(groupId,accept){
    setResponding(r=>({...r,[groupId]:true}));
    try{
      if(accept){
        await callRpc("join_group",{p_group_id:groupId,p_status:"member"});
        showToast&&showToast("✅ Tu as rejoint le groupe");
        // Move it straight into "groups" locally instead of only relying on
        // the follow-up reload - that reload was arriving late enough that
        // the invite card could reappear as if nothing happened.
        setInvites(inv=>{
          const joined=inv.find(g=>g.id===groupId);
          if(joined)setGroups(gs=>[...gs,{...joined,_role:"member"}]);
          return inv.filter(g=>g.id!==groupId);
        });
      }else{
        await authedFetch(SUPABASE_URL+"/rest/v1/group_members?group_id=eq."+groupId+"&username=eq."+encodeURIComponent(user.username),{method:"DELETE"}).catch(()=>{});
        setInvites(inv=>inv.filter(g=>g.id!==groupId));
      }
      await load();
    }catch(e){
      console.error("Group invite response failed: "+e.message);
      showToast&&showToast("⚠️ "+(e.message||"Échec, réessaie"));
    }
    setResponding(r=>({...r,[groupId]:false}));
  }

  return (
    <div>
      {!user.isPage&&(
        <button onClick={onCreateGroup} style={{width:"100%",padding:"14px",borderRadius:12,border:"1px dashed "+C.border,background:"transparent",color:C.accent2,fontWeight:700,cursor:"pointer",marginBottom:16}}>
          ➕ Créer un groupe
        </button>
      )}
      {invites&&invites.length>0&&(
        <>
          <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:8}}>Invitations reçues</div>
          {invites.map((g,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"12px",borderRadius:14,marginBottom:10,background:C.accent+"0e",border:"1px solid "+C.accent}}>
              <div style={{width:44,height:44,borderRadius:"50%",backgroundImage:g.avatar?"url("+g.avatar+")":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",backgroundSize:"cover",backgroundPosition:"center",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,flexShrink:0}}>
                {!g.avatar&&initials(g.name)}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{color:C.white,fontWeight:700,fontSize:14,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{g.name}</div>
                <div style={{color:C.w3,fontSize:12}}>{g.privacy==="private"?"Privé":"Public"} · {fmt(g.members_count)} membre{g.members_count>1?"s":""}</div>
              </div>
              <button onClick={()=>respond(g.id,true)} disabled={responding[g.id]} style={{padding:"7px 12px",borderRadius:8,border:"none",background:C.accent,color:"#fff",fontWeight:700,fontSize:12,cursor:"pointer",flexShrink:0}}>Accepter</button>
              <button onClick={()=>respond(g.id,false)} disabled={responding[g.id]} style={{padding:"7px 10px",borderRadius:8,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:700,fontSize:12,cursor:"pointer",flexShrink:0}}>✕</button>
            </div>
          ))}
        </>
      )}
      {groups===null?(
        <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
      ):groups.length===0?(
        <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:20,textAlign:"center"}}>
          <div style={{fontSize:32,marginBottom:10}}>👥</div>
          <div style={{color:C.w3,fontSize:13,lineHeight:1.6}}>Tu ne gères ni ne rejoins encore aucun groupe.</div>
        </div>
      ):(
        groups.map((g,i)=>(
          <div key={i} onClick={()=>onOpenGroup&&onOpenGroup(g.id)} style={{display:"flex",alignItems:"center",gap:12,padding:"12px",borderRadius:14,marginBottom:10,cursor:"pointer",background:C.w5,border:"1px solid "+C.border}}>
            <div style={{width:44,height:44,borderRadius:"50%",backgroundImage:g.avatar?"url("+g.avatar+")":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",backgroundSize:"cover",backgroundPosition:"center",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,flexShrink:0}}>
              {!g.avatar&&initials(g.name)}
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{color:C.white,fontWeight:700,fontSize:14,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{g.name}</div>
              <div style={{color:C.w3,fontSize:12}}>{g._role==="owner"?"Propriétaire":"Membre"} · {g.privacy==="private"?"Privé":"Public"} · {fmt(g.members_count)} membre{g.members_count>1?"s":""}</div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

function AdminManagementPanel({pageUsername,pageDisplayName,showToast}){
  const [admins,setAdmins]=useState(null);
  const [searchUsername,setSearchUsername]=useState("");
  const [selectedUser,setSelectedUser]=useState(null);
  const [matches,setMatches]=useState([]);
  const [searchLevel,setSearchLevel]=useState("limited");
  const [adding,setAdding]=useState(false);
  const [err,setErr]=useState("");

  function loadAdmins(){
    db("/page_admins?page_username=eq."+encodeURIComponent(pageUsername)).then(async rows=>{
      if(!Array.isArray(rows)){setAdmins([]);return;}
      if(rows.length===0){setAdmins([]);return;}
      const usernames=rows.map(r=>r.admin_username);
      const profs=await db("/profiles?username=in.("+usernames.join(",")+")&select=username,avatar,display_name").catch(()=>[]);
      setAdmins(rows.map(r=>({...r,profile:Array.isArray(profs)?profs.find(p=>p.username===r.admin_username):null})));
    }).catch(()=>setAdmins([]));
  }
  useEffect(()=>{loadAdmins();},[pageUsername]);

  useEffect(()=>{
    setSelectedUser(null);
    const q=searchUsername.trim().replace(/^@/,"");
    if(q.length<2){setMatches([]);return;}
    const handle=setTimeout(()=>{
      db("/profiles?is_page=eq.false&or=(username.ilike.*"+encodeURIComponent(q)+"*,display_name.ilike.*"+encodeURIComponent(q)+"*)&select=username,avatar,display_name&limit=6").then(d=>{
        setMatches(Array.isArray(d)?d:[]);
      }).catch(()=>setMatches([]));
    },300);
    return()=>clearTimeout(handle);
  },[searchUsername]);

  async function addAdmin(){
    if(!selectedUser){setErr("Choisis un compte dans la liste");return;}
    setAdding(true);setErr("");
    try{
      let alreadyExisted=false;
      const res=await authedFetch(SUPABASE_URL+"/rest/v1/page_admins",{
        method:"POST",
        headers:{"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({page_username:pageUsername,admin_username:selectedUser.username,permission_level:searchLevel,status:"pending"})
      });
      const saved=await res.json().catch(()=>null);
      if(!res.ok||!Array.isArray(saved)||saved.length===0){
        if(saved&&saved.code==="23505"){
          alreadyExisted=true;
        }else{
          setErr("Échec de l'ajout ("+res.status+")");
          setAdding(false);
          return;
        }
      }
      db("/notifications",{method:"POST",body:JSON.stringify({
        receiver:selectedUser.username,sender:pageDisplayName||pageUsername,type:"page_admin_invite",seen:false,ref_id:pageUsername,
        message:(pageDisplayName||pageUsername)+" t'invite à devenir administrateur "+(searchLevel==="full"?"(accès complet)":"(limité)")
      })}).then(result=>{
        if(result&&!Array.isArray(result)&&result.code){
          console.error("Admin-invite notification insert failed: "+JSON.stringify(result));
        }
      }).catch(e=>console.error("Admin-invite notification network error: "+e.message));
      showToast&&showToast(alreadyExisted?"✅ Invitation renvoyée":"✅ Invitation envoyée");
      setSearchUsername("");setSelectedUser(null);setMatches([]);
      loadAdmins();
    }catch{
      setErr("Erreur réseau");
    }
    setAdding(false);
  }

  async function removeAdmin(uname){
    await fetch(SUPABASE_URL+"/rest/v1/page_admins?page_username=eq."+encodeURIComponent(pageUsername)+"&admin_username=eq."+encodeURIComponent(uname),{
      method:"DELETE",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),Prefer:"return=minimal"}
    }).catch(()=>{});
    showToast&&showToast("Administrateur retiré");
    loadAdmins();
  }

  async function changeLevel(uname,level){
    await fetch(SUPABASE_URL+"/rest/v1/page_admins?page_username=eq."+encodeURIComponent(pageUsername)+"&admin_username=eq."+encodeURIComponent(uname),{
      method:"PATCH",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
      body:JSON.stringify({permission_level:level})
    }).catch(()=>{});
    loadAdmins();
  }

  return (
    <div>
      <div style={{color:C.w3,fontSize:12,lineHeight:1.6,marginBottom:16}}>
        <b style={{color:C.white}}>Accès complet</b> : tout comme toi (modifier la Page, gérer les admins, supprimer).<br/>
        <b style={{color:C.white}}>Limité</b> : publier, aimer en tant que la Page, répondre aux messages, gérer dépôts/retraits — sans modifier ni supprimer la Page ni gérer les admins.
      </div>

      <div style={{background:C.w5,borderRadius:14,border:"1px solid "+C.border,padding:14,marginBottom:20}}>
        <div style={{color:C.w3,fontSize:12,fontWeight:700,marginBottom:8}}>Ajouter un administrateur</div>
        {selectedUser?(
          <div style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",borderRadius:10,background:C.navy,border:"1px solid "+C.accent,marginBottom:10}}>
            <Avatar src={selectedUser.avatar||""} name={selectedUser.username} size={30}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{color:C.white,fontWeight:700,fontSize:13}}>{selectedUser.display_name||selectedUser.username}</div>
              <div style={{color:C.w3,fontSize:11}}>@{selectedUser.username}</div>
            </div>
            <button onClick={()=>{setSelectedUser(null);setSearchUsername("");}} style={{background:"none",border:"none",color:C.w3,cursor:"pointer",fontSize:16}}>✕</button>
          </div>
        ):(
          <div style={{position:"relative",marginBottom:10}}>
            <input value={searchUsername} onChange={e=>setSearchUsername(e.target.value)} placeholder="Nom ou identifiant..." style={{width:"100%",padding:"11px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:14,outline:"none",boxSizing:"border-box"}}/>
            {matches.length>0&&(
              <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,background:C.navy2,border:"1px solid "+C.border,borderRadius:10,overflow:"hidden",zIndex:5,boxShadow:"0 4px 16px rgba(0,0,0,0.25)"}}>
                {matches.map((m,i)=>(
                  <div key={i} onClick={()=>{setSelectedUser(m);setMatches([]);}} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",cursor:"pointer",borderBottom:i<matches.length-1?"1px solid "+C.border:"none"}}>
                    <Avatar src={m.avatar||""} name={m.username} size={30}/>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{color:C.white,fontWeight:700,fontSize:13}}>{m.display_name||m.username}</div>
                      <div style={{color:C.w3,fontSize:11}}>@{m.username}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        <div style={{display:"flex",gap:8,marginBottom:10}}>
          {[{k:"limited",l:"Limité"},{k:"full",l:"Accès complet"}].map(o=>(
            <button key={o.k} onClick={()=>setSearchLevel(o.k)} style={{flex:1,padding:"9px",borderRadius:10,border:"1px solid "+(searchLevel===o.k?C.accent:C.border),background:searchLevel===o.k?C.accent+"22":"transparent",color:searchLevel===o.k?C.accent2:C.w3,fontWeight:700,fontSize:12,cursor:"pointer"}}>{o.l}</button>
          ))}
        </div>
        {err&&<div style={{color:"#f87171",fontSize:12,marginBottom:10}}>{err}</div>}
        <button onClick={addAdmin} disabled={adding||!selectedUser} style={{width:"100%",padding:"11px",borderRadius:10,border:"none",background:selectedUser?"linear-gradient(135deg,"+C.accent+",#1e4d8c)":C.w4,color:"#fff",fontWeight:700,fontSize:13,cursor:selectedUser?"pointer":"not-allowed"}}>{adding?"...":"Ajouter"}</button>
      </div>

      <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:8}}>Administrateurs actuels</div>
      {admins===null?(
        <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
      ):admins.length===0?(
        <div style={{color:C.w3,fontSize:13,textAlign:"center",padding:16}}>Aucun administrateur pour l'instant</div>
      ):(
        admins.map((a,i)=>(
          <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"10px",borderRadius:12,marginBottom:8,background:C.w5,border:"1px solid "+C.border}}>
            <Avatar src={(a.profile&&a.profile.avatar)||""} name={a.admin_username} size={36}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{color:C.white,fontWeight:700,fontSize:13}}>{(a.profile&&a.profile.display_name)||a.admin_username}</div>
              <div style={{color:C.w3,fontSize:11}}>@{a.admin_username}{a.status==="pending"&&<span style={{color:"#f59e0b"}}> · invitation en attente</span>}</div>
            </div>
            <select value={a.permission_level} onChange={e=>changeLevel(a.admin_username,e.target.value)} style={{padding:"6px 8px",borderRadius:8,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:11,outline:"none"}}>
              <option value="limited">Limité</option>
              <option value="full">Accès complet</option>
            </select>
            <button onClick={()=>removeAdmin(a.admin_username)} style={{background:"none",border:"none",color:C.red,cursor:"pointer",fontSize:16,padding:4}}>✕</button>
          </div>
        ))
      )}
    </div>
  );
}

const PAGE_CATEGORIES=["Entreprise locale","Marque","Communauté","Média/Actualités","Artiste","Association","Autre"];

function CreatePageScreen({user,onBack,onCreated,showToast}){
  const [name,setName]=useState("");
  const [category,setCategory]=useState(PAGE_CATEGORIES[0]);
  const [bio,setBio]=useState("");
  const [logo,setLogo]=useState("");
  const [cover,setCover]=useState("");
  const [coverPosition,setCoverPosition]=useState(50);
  const [coverZoom,setCoverZoom]=useState(100);
  const [uploadingLogo,setUploadingLogo]=useState(false);
  const [uploadingCover,setUploadingCover]=useState(false);
  const [creating,setCreating]=useState(false);
  const [err,setErr]=useState("");
  const logoRef=useRef(null);
  const coverRef=useRef(null);

  function slugify(str){
    return str.trim().toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g,"")
      .replace(/[^a-z0-9]+/g,"-").replace(/(^-|-$)/g,"")
      .slice(0,50);
  }

  async function pickLogo(file){
    if(!file)return;
    setUploadingLogo(true);
    try{const{url}=await upload(file);setLogo(url);}
    catch{showToast&&showToast("⚠️ Échec de l'upload du logo");}
    setUploadingLogo(false);
  }
  async function pickCover(file){
    if(!file)return;
    setUploadingCover(true);
    try{const{url}=await upload(file);setCover(url);}
    catch{showToast&&showToast("⚠️ Échec de l'upload de la couverture");}
    setUploadingCover(false);
  }

  async function create(){
    if(user.isPage){setErr("Une Page ne peut pas créer une autre Page ou Groupe");return;}
    const trimmedName=name.trim();
    if(!trimmedName){setErr("Donne un nom à ta Page");return;}
    if(uploadingLogo||uploadingCover){setErr("Attends la fin de l'upload");return;}
    setCreating(true);setErr("");
    const baseSlug=slugify(trimmedName)||"page";
    const pageUsername=baseSlug+"-"+Math.random().toString(36).slice(2,7);
    const syntheticEmail="page-"+pageUsername+"@internal.bluelife.app";
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/profiles",{
        method:"POST",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({
          username:pageUsername,display_name:trimmedName,bio,avatar:logo,cover,cover_position:coverPosition,cover_zoom:coverZoom,
          email:syntheticEmail,auth_email:syntheticEmail,
          is_page:true,managed_by:user.username,entity_type:"page",category,
          followers_count:0,following_count:0,posts_count:0,
          verified:false,wallet_balance:0,coins_balance:0,gift_coins_balance:0,earnings_balance:0
        })
      });
      const saved=await res.json().catch(()=>null);
      if(!res.ok||!Array.isArray(saved)||saved.length===0){
        setErr("Échec de la création. Réessaie.");
        setCreating(false);
        return;
      }
      showToast&&showToast("✅ Page créée !");
      onCreated&&onCreated(saved[0]);
    }catch(e){
      setErr("Erreur réseau. Réessaie.");
    }
    setCreating(false);
  }

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:850,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12,position:"sticky",top:0,background:C.navy,zIndex:10}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>Créer une Page</span>
      </div>

      <div style={{padding:20}}>
        <div style={{color:C.w3,fontSize:12,marginBottom:20,lineHeight:1.5}}>
          Pour une entreprise, une marque ou une figure publique. Les gens s'abonnent pour suivre tes publications.
        </div>

        <div onClick={()=>coverRef.current&&coverRef.current.click()} style={{width:"100%",aspectRatio:"16/6",borderRadius:14,position:"relative",overflow:"hidden",background:cover?"#000":C.w5,border:"2px dashed "+C.border,cursor:"pointer"}}>
          {cover&&<img src={cover} alt="" style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center "+coverPosition+"%",transform:"scale("+(coverZoom/100)+")",transformOrigin:"center "+coverPosition+"%",display:"block"}}/>}
          {!cover&&<span style={{color:C.w3,fontSize:13,position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>{uploadingCover?"⏳ Upload...":"🖼️ Photo de couverture"}</span>}
          <input ref={coverRef} type="file" accept="image/*" onChange={e=>pickCover(e.target.files[0])} style={{display:"none"}}/>
        </div>
        {cover&&(
          <div style={{marginBottom:16}}>
            <div style={{color:C.w3,fontSize:11,margin:"6px 0 4px"}}>🔍 Zoom</div>
            <input type="range" min="100" max="300" value={coverZoom} onChange={e=>setCoverZoom(Number(e.target.value))} style={{width:"100%",accentColor:C.accent,marginBottom:8}}/>
            <div style={{color:C.w3,fontSize:11,margin:"6px 0 4px"}}>↕️ Position</div>
            <input type="range" min="0" max="100" value={coverPosition} onChange={e=>setCoverPosition(Number(e.target.value))} style={{width:"100%",accentColor:C.accent}}/>
          </div>
        )}

        <div onClick={()=>logoRef.current&&logoRef.current.click()} style={{width:84,height:84,borderRadius:"50%",backgroundColor:logo?"transparent":C.w5,border:"2px dashed "+C.border,backgroundImage:logo?"url("+logo+")":"none",backgroundSize:"cover",backgroundPosition:"center",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",margin:"0 auto 20px"}}>
          {!logo&&<span style={{fontSize:11,color:C.w3,textAlign:"center"}}>{uploadingLogo?"⏳":"📷 Logo"}</span>}
          <input ref={logoRef} type="file" accept="image/*" onChange={e=>pickLogo(e.target.files[0])} style={{display:"none"}}/>
        </div>

        <div style={{color:C.w3,fontSize:12,marginBottom:6,fontWeight:600}}>Nom de la Page</div>
        <input value={name} onChange={e=>setName(e.target.value.slice(0,80))} placeholder="Ex: Africa Tech" style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>

        <div style={{color:C.w3,fontSize:12,marginBottom:6,fontWeight:600}}>Catégorie</div>
        <select value={category} onChange={e=>setCategory(e.target.value)} style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",marginBottom:14,boxSizing:"border-box"}}>
          {PAGE_CATEGORIES.map(c=><option key={c} value={c}>{c}</option>)}
        </select>

        <div style={{color:C.w3,fontSize:12,marginBottom:6,fontWeight:600}}>Bio</div>
        <textarea value={bio} onChange={e=>setBio(e.target.value.slice(0,300))} rows={3} placeholder="Décris ta Page..." style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",resize:"none",fontFamily:"inherit",marginBottom:18,boxSizing:"border-box"}}/>

        {err&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{err}</div>}

        <button onClick={create} disabled={creating} style={{width:"100%",padding:"15px",borderRadius:14,border:"none",background:creating?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:15,cursor:creating?"not-allowed":"pointer"}}>
          {creating?"...":"Créer la Page"}
        </button>
      </div>
    </div>
  );
}

function CreateGroupScreen({user,onBack,onCreated,showToast}){
  const [step,setStep]=useState("name");
  const [name,setName]=useState("");
  const [privacy,setPrivacy]=useState("public");
  const [cover,setCover]=useState("");
  const [coverPosition,setCoverPosition]=useState(50);
  const [coverZoom,setCoverZoom]=useState(100);
  const [uploadingCover,setUploadingCover]=useState(false);
  const [creating,setCreating]=useState(false);
  const [err,setErr]=useState("");
  const [createdGroup,setCreatedGroup]=useState(null);
  const [suggested,setSuggested]=useState(null);
  const [invited,setInvited]=useState([]);
  const coverRef=useRef(null);

  async function pickCover(file){
    if(!file)return;
    setUploadingCover(true);
    try{const{url}=await upload(file);setCover(url);}
    catch{showToast&&showToast("⚠️ Échec de l'upload");}
    setUploadingCover(false);
  }

  async function create(){
    if(user.isPage){setErr("Une Page ne peut pas créer un Groupe — reviens sur ton compte normal d'abord");return;}
    const trimmedName=name.trim();
    if(!trimmedName){setErr("Nomme ton groupe");return;}
    if(uploadingCover){setErr("Attends la fin de l'upload");return;}
    setCreating(true);setErr("");
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/groups",{
        method:"POST",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({owner_username:user.username,name:trimmedName,privacy,cover:cover||null,cover_position:coverPosition,cover_zoom:coverZoom})
      });
      const saved=await res.json().catch(()=>null);
      if(!res.ok||!Array.isArray(saved)||saved.length===0){
        console.error("Group creation failed (status "+res.status+"): "+JSON.stringify(saved));
        setErr("Échec ("+res.status+"): "+(saved&&saved.message?saved.message:JSON.stringify(saved)).slice(0,200));
        setCreating(false);
        return;
      }
      await fetch(SUPABASE_URL+"/rest/v1/group_members",{
        method:"POST",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json"},
        body:JSON.stringify({group_id:saved[0].id,username:user.username,status:"member"})
      }).catch(()=>{});
      setCreatedGroup(saved[0]);
      setStep("invite");
      db("/Follows?follower=eq."+encodeURIComponent(user.username)+"&select=following&limit=30").then(async d=>{
        if(!Array.isArray(d)||d.length===0){setSuggested([]);return;}
        const profs=await db("/profiles?username=in.("+d.map(f=>f.following).join(",")+")&select=username,avatar,display_name&limit=30").catch(()=>[]);
        setSuggested(Array.isArray(profs)?profs:[]);
      }).catch(()=>setSuggested([]));
    }catch(e){
      setErr("Erreur réseau. Réessaie.");
    }
    setCreating(false);
  }

  function toggleInvite(username){
    setInvited(inv=>inv.includes(username)?inv.filter(u=>u!==username):[...inv,username]);
  }

  async function sendInvites(){
    if(createdGroup&&invited.length>0){
      await Promise.all(invited.map(u=>
        db("/notifications",{method:"POST",body:JSON.stringify({
          receiver:u,sender:user.username,type:"group_invite",seen:false,
          message:user.displayName||user.username+" t'invite à rejoindre le groupe "+createdGroup.name
        })}).catch(()=>{})
      ));
    }
    onCreated&&onCreated(createdGroup);
  }

  if(step==="invite"&&createdGroup){
    return(
      <div style={{position:"fixed",inset:0,background:C.navy,zIndex:850,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif",display:"flex",flexDirection:"column"}}>
        <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12}}>
          <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>Inviter les utilisateur(ice)s suggéré(e)s</span>
        </div>
        <div style={{padding:20,flex:1}}>
          <div style={{color:C.w3,fontSize:13,lineHeight:1.6,marginBottom:20}}>Envoie des invitations à rejoindre ton groupe aux personnes qui pourraient être intéressées.</div>
          {suggested===null?(
            <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
          ):suggested.length===0?(
            <div style={{color:C.w3,fontSize:13,textAlign:"center",padding:20}}>Aucune suggestion pour l'instant.</div>
          ):(
            suggested.map((s,i)=>(
              <div key={i} onClick={()=>toggleInvite(s.username)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 4px",cursor:"pointer"}}>
                <Avatar src={s.avatar||""} name={s.username} size={42}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{color:C.white,fontWeight:600,fontSize:14}}>{s.display_name||s.username}</div>
                  <div style={{color:C.w3,fontSize:12}}>@{s.username}</div>
                </div>
                <div style={{width:22,height:22,borderRadius:"50%",border:"2px solid "+(invited.includes(s.username)?C.accent:C.border),background:invited.includes(s.username)?C.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:12,flexShrink:0}}>{invited.includes(s.username)?"✓":""}</div>
              </div>
            ))
          )}
        </div>
        <div style={{padding:16,borderTop:"1px solid "+C.border}}>
          <button onClick={sendInvites} style={{width:"100%",padding:"15px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:15,cursor:"pointer"}}>
            {invited.length>0?"Inviter et continuer ("+invited.length+")":"Passer"}
          </button>
        </div>
      </div>
    );
  }

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:850,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12,position:"sticky",top:0,background:C.navy,zIndex:10}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>Créer un groupe</span>
      </div>

      <div style={{padding:20}}>
        <div onClick={()=>coverRef.current&&coverRef.current.click()} style={{width:"100%",aspectRatio:"16/7",borderRadius:14,position:"relative",overflow:"hidden",background:cover?"#000":C.w5,border:"2px dashed "+C.border,cursor:"pointer",marginBottom:8}}>
          {cover&&<img src={cover} alt="" style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center "+coverPosition+"%",transform:"scale("+(coverZoom/100)+")",transformOrigin:"center "+coverPosition+"%",display:"block"}}/>}
          {!cover&&<span style={{color:C.w3,fontSize:13,position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>{uploadingCover?"⏳ Upload...":"🖼️ Photo de couverture du groupe"}</span>}
          <input ref={coverRef} type="file" accept="image/*" onChange={e=>pickCover(e.target.files[0])} style={{display:"none"}}/>
        </div>
        {cover&&(
          <div style={{marginBottom:20}}>
            <div style={{color:C.w3,fontSize:11,margin:"6px 0 4px"}}>🔍 Zoom</div>
            <input type="range" min="100" max="300" value={coverZoom} onChange={e=>setCoverZoom(Number(e.target.value))} style={{width:"100%",accentColor:C.accent,marginBottom:8}}/>
            <div style={{color:C.w3,fontSize:11,margin:"6px 0 4px"}}>↕️ Position</div>
            <input type="range" min="0" max="100" value={coverPosition} onChange={e=>setCoverPosition(Number(e.target.value))} style={{width:"100%",accentColor:C.accent}}/>
          </div>
        )}

        <div style={{color:C.w3,fontSize:12,marginBottom:6,fontWeight:600}}>Nom</div>
        <div style={{color:C.w4,fontSize:11,marginBottom:8}}>Nommez votre groupe</div>
        <input value={name} onChange={e=>setName(e.target.value.slice(0,80))} placeholder="Mondial groupe" style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",marginBottom:24,boxSizing:"border-box"}}/>

        <div style={{color:C.w3,fontSize:12,marginBottom:10,fontWeight:600,textTransform:"uppercase"}}>Confidentialité</div>
        {[
          {k:"public",l:"🌍 Public",d:"Tout le monde peut voir qui est dans le groupe et ce qui est publié. En fonction de la taille et de l'ancienneté de votre groupe, vous pourrez peut-être le transformer en groupe privé plus tard."},
          {k:"private",l:"🔒 Privé",d:"Seuls les membres peuvent voir qui est dans le groupe et ce qui est publié. Rejoindre le groupe nécessite l'approbation d'un membre."},
        ].map(o=>(
          <div key={o.k} onClick={()=>setPrivacy(o.k)} style={{display:"flex",gap:12,padding:14,borderRadius:14,border:"1px solid "+(privacy===o.k?C.accent:C.border),background:privacy===o.k?C.accent+"10":C.w5,marginBottom:10,cursor:"pointer"}}>
            <div style={{width:20,height:20,borderRadius:"50%",border:"2px solid "+(privacy===o.k?C.accent:C.border),background:privacy===o.k?C.accent:"transparent",flexShrink:0,marginTop:2,display:"flex",alignItems:"center",justifyContent:"center"}}>
              {privacy===o.k&&<div style={{width:8,height:8,borderRadius:"50%",background:"#fff"}}/>}
            </div>
            <div>
              <div style={{color:C.white,fontWeight:700,fontSize:14,marginBottom:3}}>{o.l}</div>
              <div style={{color:C.w3,fontSize:12,lineHeight:1.5}}>{o.d}</div>
            </div>
          </div>
        ))}

        {err&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginTop:10,marginBottom:14}}>{err}</div>}

        <button onClick={create} disabled={creating} style={{width:"100%",padding:"15px",borderRadius:14,border:"none",background:creating?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:15,cursor:creating?"not-allowed":"pointer",marginTop:10}}>
          {creating?"...":"Créer"}
        </button>
      </div>
    </div>
  );
}

function GroupScreen({groupId,currentUser,onBack,onProfile,showToast,onOpenVideo}){
  const [group,setGroup]=useState(null);
  const [myStatus,setMyStatus]=useState(null);
  const [myPermission,setMyPermission]=useState(null);
  const [members,setMembers]=useState(null);
  const [posts,setPosts]=useState([]);
  const [loading,setLoading]=useState(true);
  const [busy,setBusy]=useState(false);
  const [groupTab,setGroupTab]=useState("discussion");
  const [showRequests,setShowRequests]=useState(false);
  const [pendingRequests,setPendingRequests]=useState(null);
  const [composerText,setComposerText]=useState("");
  const [composerImage,setComposerImage]=useState("");
  const [uploadingComposer,setUploadingComposer]=useState(false);
  const [expandComposer,setExpandComposer]=useState(false);
  const [posting,setPosting]=useState(false);
  const [editMode,setEditMode]=useState(false);
  const [editName,setEditName]=useState("");
  const [editDescription,setEditDescription]=useState("");
  const [editPrivacy,setEditPrivacy]=useState("public");
  const [editCover,setEditCover]=useState("");
  const [editCoverPosition,setEditCoverPosition]=useState(50);
  const [editCoverZoom,setEditCoverZoom]=useState(100);
  const [uploadingEditCover,setUploadingEditCover]=useState(false);
  const [saving,setSaving]=useState(false);
  const [showAdminManage,setShowAdminManage]=useState(false);
  const [showInvite,setShowInvite]=useState(false);
  const [inviteCandidates,setInviteCandidates]=useState(null);
  const [selectedInvites,setSelectedInvites]=useState([]);
  const [inviteAsAdminLevel,setInviteAsAdminLevel]=useState(null);
  const [sendingInvites,setSendingInvites]=useState(false);
  const fileRef=useRef(null);
  const editCoverRef=useRef(null);
  const safeUser=currentUser||{username:"",isGuest:true};

  function loadGroup(){
    db("/groups?id=eq."+groupId+"&limit=1").then(rows=>{
      if(Array.isArray(rows)&&rows[0]){
        setGroup(rows[0]);
        setEditName(rows[0].name);setEditDescription(rows[0].description||"");setEditPrivacy(rows[0].privacy);
        setEditCover(rows[0].cover||"");setEditCoverPosition(rows[0].cover_position||50);setEditCoverZoom(rows[0].cover_zoom||100);
      }
    });
    if(safeUser.username&&!safeUser.isGuest){
      db("/group_members?group_id=eq."+groupId+"&username=eq."+encodeURIComponent(safeUser.username)+"&limit=1").then(rows=>{
        setMyStatus(Array.isArray(rows)&&rows[0]?rows[0].status:null);
        setMyPermission(Array.isArray(rows)&&rows[0]?rows[0].permission_level:null);
      });
    }
    setLoading(false);
  }
  useEffect(()=>{loadGroup();},[groupId]);

  const isOwner=group&&safeUser.username===group.owner_username;
  const isMember=myStatus==="member"||isOwner;
  const isFullAdmin=isOwner||myPermission==="full";
  const isAnyAdmin=isOwner||myPermission==="full"||myPermission==="limited";

  useEffect(()=>{
    if(!isMember)return;
    db("/Posts?group_id=eq."+groupId+"&order=created_at.desc&limit=60").then(d=>{
      setPosts(Array.isArray(d)?d:[]);
    }).catch(()=>{});
  },[groupId,isMember]);

  function loadPendingRequests(){
    db("/group_members?group_id=eq."+groupId+"&status=eq.pending").then(async rows=>{
      if(!Array.isArray(rows)||rows.length===0){setPendingRequests([]);return;}
      const usernames=rows.map(r=>r.username);
      const profs=await db("/profiles?username=in.("+usernames.join(",")+")&select=username,avatar,display_name").catch(()=>[]);
      setPendingRequests(rows.map(r=>({...r,profile:Array.isArray(profs)?profs.find(p=>p.username===r.username):null})));
    }).catch(()=>setPendingRequests([]));
  }

  async function respondToRequest(uname,approve){
    if(approve){
      await authedFetch(SUPABASE_URL+"/rest/v1/group_members?group_id=eq."+groupId+"&username=eq."+encodeURIComponent(uname),{
        method:"PATCH",headers:{"Content-Type":"application/json",Prefer:"return=minimal"},body:JSON.stringify({status:"member"})
      }).catch(()=>{});
      setGroup(g=>g?{...g,members_count:g.members_count+1}:g);
      db("/notifications",{method:"POST",body:JSON.stringify({receiver:uname,sender:safeUser.username,type:"group_approved",seen:false,ref_id:groupId,message:"Ta demande pour rejoindre "+group.name+" a été acceptée"})}).catch(()=>{});
    }else{
      await authedFetch(SUPABASE_URL+"/rest/v1/group_members?group_id=eq."+groupId+"&username=eq."+encodeURIComponent(uname),{method:"DELETE"}).catch(()=>{});
    }
    setPendingRequests(r=>r.filter(x=>x.username!==uname));
  }

  function loadMembers(){
    db("/group_members?group_id=eq."+groupId+"&status=eq.member&order=joined_at.desc&limit=100").then(async rows=>{
      if(!Array.isArray(rows)){setMembers([]);return;}
      const usernames=rows.map(r=>r.username);
      const profs=usernames.length>0?await db("/profiles?username=in.("+usernames.join(",")+")&select=username,avatar,display_name").catch(()=>[]):[];
      setMembers(Array.isArray(profs)?profs.map(p=>({...p,permission_level:(rows.find(r=>r.username===p.username)||{}).permission_level||null})):[]);
    }).catch(()=>setMembers([]));
  }

  async function pickEditCover(file){
    if(!file)return;
    setUploadingEditCover(true);
    try{const{url}=await upload(file);setEditCover(url);}
    catch{showToast&&showToast("⚠️ Échec de l'upload");}
    setUploadingEditCover(false);
  }

  async function saveGroupSettings(){
    const trimmedName=editName.trim();
    if(!trimmedName){showToast&&showToast("⚠️ Le nom ne peut pas être vide");return;}
    setSaving(true);
    try{
      const res=await authedFetch(SUPABASE_URL+"/rest/v1/groups?id=eq."+groupId,{
        method:"PATCH",headers:{"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({name:trimmedName,description:editDescription.trim(),privacy:editPrivacy,cover:editCover||null,cover_position:editCoverPosition,cover_zoom:editCoverZoom})
      });
      const saved=await res.json().catch(()=>null);
      if(res.ok&&Array.isArray(saved)&&saved[0]){
        setGroup(saved[0]);
        setEditMode(false);
        showToast&&showToast("✅ Groupe mis à jour");
      }else{
        console.error("Group settings save failed (status "+res.status+"): "+JSON.stringify(saved));
        showToast&&showToast("⚠️ Échec ("+res.status+"): "+(saved&&saved.message?saved.message:JSON.stringify(saved)).slice(0,150));
      }
    }catch{showToast&&showToast("⚠️ Erreur réseau");}
    setSaving(false);
  }

  async function setMemberPermission(uname,level){
    await authedFetch(SUPABASE_URL+"/rest/v1/group_members?group_id=eq."+groupId+"&username=eq."+encodeURIComponent(uname),{
      method:"PATCH",headers:{"Content-Type":"application/json",Prefer:"return=minimal"},
      body:JSON.stringify({permission_level:level})
    }).catch(()=>{});
    setMembers(m=>m.map(x=>x.username===uname?{...x,permission_level:level}:x));
    if(level){
      db("/notifications",{method:"POST",body:JSON.stringify({receiver:uname,sender:safeUser.username,type:"group_admin_added",seen:false,message:"Tu es maintenant administrateur ("+(level==="full"?"accès complet":"limité")+") du groupe "+group.name})}).catch(()=>{});
    }
  }

  function loadInviteCandidates(){
    setInviteCandidates(null);
    Promise.all([
      db("/Follows?follower=eq."+encodeURIComponent(safeUser.username)+"&select=following").catch(()=>[]),
      db("/Follows?following=eq."+encodeURIComponent(safeUser.username)+"&select=follower").catch(()=>[]),
    ]).then(async([followingRows,followerRows])=>{
      const usernames=[...new Set([
        ...(Array.isArray(followingRows)?followingRows.map(r=>r.following):[]),
        ...(Array.isArray(followerRows)?followerRows.map(r=>r.follower):[]),
      ])];
      if(usernames.length===0){setInviteCandidates([]);return;}
      const profs=await db("/profiles?username=in.("+usernames.join(",")+")&select=username,avatar,display_name,is_page").catch(()=>[]);
      setInviteCandidates(Array.isArray(profs)?profs:[]);
    }).catch(()=>setInviteCandidates([]));
  }

  function toggleInviteSelect(uname){
    setSelectedInvites(sel=>sel.includes(uname)?sel.filter(u=>u!==uname):[...sel,uname]);
  }

  async function sendGroupInvites(){
    if(selectedInvites.length===0)return;
    setSendingInvites(true);
    await Promise.all(selectedInvites.map(async uname=>{
      await authedFetch(SUPABASE_URL+"/rest/v1/group_members",{
        method:"POST",headers:{"Content-Type":"application/json",Prefer:"resolution=ignore-duplicates"},
        body:JSON.stringify({group_id:groupId,username:uname,status:"invited",invited_by:safeUser.username,...(inviteAsAdminLevel?{permission_level:inviteAsAdminLevel}:{})})
      }).catch(()=>{});
      await db("/notifications",{method:"POST",body:JSON.stringify({
        receiver:uname,sender:safeUser.username,type:"group_invite",seen:false,ref_id:groupId,
        message:(safeUser.displayName||safeUser.username)+" t'invite à rejoindre le groupe "+group.name+(inviteAsAdminLevel?" en tant qu'administrateur":"")
      })}).catch(()=>{});
    }));
    setSelectedInvites([]);
    setSendingInvites(false);
    setInviteAsAdminLevel(null);
    showToast&&showToast("✅ Invitations envoyées");
  }

  async function joinOrRequest(){
    if(!safeUser.username||safeUser.isGuest)return;
    setBusy(true);
    const status=group.privacy==="private"?"pending":"member";
    try{
      await callRpc("join_group",{p_group_id:groupId,p_status:status});
      setMyStatus(status);
      if(status==="member")setGroup(g=>g?{...g,members_count:g.members_count+1}:g);
      showToast&&showToast(status==="pending"?"Demande envoyée":"✅ Tu as rejoint le groupe");
    }catch(e){
      console.error("Join group failed: "+e.message);
      showToast&&showToast("⚠️ "+(e.message||"Échec, réessaie"));
    }
    setBusy(false);
  }

  async function leaveGroup(){
    setBusy(true);
    try{
      await callRpc("leave_group",{p_group_id:groupId});
      setGroup(g=>g?{...g,members_count:Math.max(0,g.members_count-1)}:g);
      setMyStatus(null);
      showToast&&showToast("Tu as quitté le groupe");
    }catch{
      showToast&&showToast("⚠️ Échec, réessaie");
    }
    setBusy(false);
  }

  async function pickComposerImage(file){
    if(!file)return;
    setUploadingComposer(true);
    try{const{url}=await upload(file);setComposerImage(url);}
    catch{showToast&&showToast("⚠️ Échec de l'upload");}
    setUploadingComposer(false);
  }

  async function publishToGroup(){
    if(!composerText.trim()&&!composerImage)return;
    setPosting(true);
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/Posts",{
        method:"POST",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({
          username:safeUser.username,display_name:safeUser.displayName||safeUser.username,avatar:safeUser.avatar||"",
          group_id:groupId,group_name:group.name,group_poster_role:isOwner?"owner":(myPermission?"admin":null),caption:composerText.trim(),image:composerImage||null,
          type:composerImage?"image":"text",text_bg:composerImage?null:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",
          likes_count:0,sponsored:false,verified:!!safeUser.verified
        })
      });
      const saved=await res.json().catch(()=>null);
      if(res.ok&&Array.isArray(saved)&&saved[0]){
        if(!saved[0].group_id){
          console.error("Post created but group_id did not persist - saved row: "+JSON.stringify(saved[0]));
          showToast&&showToast("⚠️ Publié, mais pas lié au groupe (voir la console)");
        }else{
          showToast&&showToast("✅ Publié dans le groupe");
        }
        setPosts(p=>[saved[0],...p]);
        setComposerText("");setComposerImage("");
      }else{
        console.error("Group post failed (status "+res.status+"): "+JSON.stringify(saved));
        showToast&&showToast("⚠️ Échec ("+res.status+")");
      }
    }catch{
      showToast&&showToast("⚠️ Erreur réseau");
    }
    setPosting(false);
  }

  if(loading||!group)return <div style={{position:"fixed",inset:0,display:"flex",alignItems:"center",justifyContent:"center",background:C.navy,zIndex:500}}><I.Spin/></div>;

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:500,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{width:"100%",aspectRatio:"16/9",position:"relative",background:group.cover?"#000":"linear-gradient(135deg,"+C.accent+",#1e4d8c)"}}>
        {group.cover&&<img src={group.cover} alt="" style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center "+(group.cover_position||50)+"%",transform:"scale("+((group.cover_zoom||100)/100)+")",transformOrigin:"center "+(group.cover_position||50)+"%",display:"block"}}/>}
        <div style={{position:"absolute",inset:0,background:"linear-gradient(180deg,rgba(0,0,0,0.35) 0%,transparent 30%,transparent 60%,rgba(0,0,0,0.55) 100%)"}}/>
        <button onClick={onBack} style={{position:"absolute",top:14,left:14,background:"rgba(0,0,0,0.45)",border:"none",borderRadius:"50%",width:36,height:36,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"#fff"}}><I.Back/></button>
        <div style={{position:"absolute",bottom:12,left:16,right:16}}>
          <div style={{color:"#fff",fontWeight:800,fontSize:20,textShadow:"0 1px 4px rgba(0,0,0,0.6)"}}>{group.name}</div>
          <div style={{color:"rgba(255,255,255,0.85)",fontSize:12,textShadow:"0 1px 3px rgba(0,0,0,0.6)"}}>{group.privacy==="private"?"🔒 Groupe privé":"🌍 Groupe public"} · {fmt(group.members_count)} membre{group.members_count>1?"s":""}</div>
        </div>
      </div>

      <div style={{padding:"12px 16px"}}>
        {!isOwner&&myStatus!=="member"&&(
          <button onClick={joinOrRequest} disabled={busy||myStatus==="pending"} style={{width:"100%",padding:"12px",borderRadius:12,border:"none",background:myStatus==="pending"?C.w4:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:myStatus==="pending"?"default":"pointer",fontSize:14,marginBottom:4}}>
            {myStatus==="pending"?"Demande envoyée":group.privacy==="private"?"Demander à rejoindre":"➕ Rejoindre le groupe"}
          </button>
        )}
        {!isOwner&&myStatus==="member"&&(
          <button onClick={leaveGroup} disabled={busy} style={{width:"100%",padding:"12px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:700,cursor:"pointer",fontSize:14,marginBottom:4}}>
            Quitter le groupe
          </button>
        )}
      </div>

      <div style={{display:"flex",borderBottom:"1px solid "+C.border,position:"sticky",top:0,background:C.navy,zIndex:10}}>
        {[{k:"discussion",l:"Discussion"},{k:"about",l:"À propos"},{k:"members",l:"Membres"}].map(t=>(
          <div key={t.k} onClick={()=>{setGroupTab(t.k);if(t.k==="members"&&members===null)loadMembers();}} style={{flex:1,textAlign:"center",padding:"12px 0",cursor:"pointer",color:groupTab===t.k?C.accent2:C.w3,fontWeight:700,fontSize:13,borderBottom:"2px solid "+(groupTab===t.k?C.accent:"transparent")}}>
            {t.l}
          </div>
        ))}
      </div>

      {groupTab==="discussion"&&(
        <div style={{padding:16}}>
          {!isMember?(
            <div style={{textAlign:"center",padding:40,color:C.w3,fontSize:13}}>
              {group.privacy==="private"?"🔒 Groupe privé — rejoins-le pour voir les publications.":"Rejoins le groupe pour voir et publier du contenu."}
            </div>
          ):(
            <>
              {!expandComposer?(
                <div onClick={()=>setExpandComposer(true)} style={{display:"flex",alignItems:"center",gap:10,background:C.w5,borderRadius:24,border:"1px solid "+C.border,padding:"10px 16px",marginBottom:16,cursor:"pointer"}}>
                  <Avatar src={safeUser.avatar||""} name={safeUser.username} size={30}/>
                  <span style={{color:C.w3,fontSize:14}}>Écris quelque chose...</span>
                </div>
              ):(
                <div style={{background:C.w5,borderRadius:14,border:"1px solid "+C.border,padding:12,marginBottom:16}}>
                  <textarea autoFocus value={composerText} onChange={e=>setComposerText(e.target.value.slice(0,500))} placeholder={"Écris quelque chose dans "+group.name+"..."} rows={3} style={{width:"100%",background:"none",border:"none",outline:"none",color:C.white,fontSize:14,resize:"none",fontFamily:"inherit",marginBottom:8}}/>
                  {composerImage&&<img src={composerImage} alt="" style={{width:"100%",borderRadius:10,marginBottom:8,maxHeight:200,objectFit:"cover"}}/>}
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <button onClick={()=>fileRef.current&&fileRef.current.click()} style={{background:"none",border:"none",fontSize:18,cursor:"pointer"}}>{uploadingComposer?"⏳":"📷"}</button>
                    <input ref={fileRef} type="file" accept="image/*" onChange={e=>pickComposerImage(e.target.files[0])} style={{display:"none"}}/>
                    <div style={{display:"flex",gap:8}}>
                      <button onClick={()=>{setExpandComposer(false);setComposerText("");setComposerImage("");}} style={{padding:"8px 14px",borderRadius:20,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:700,fontSize:13,cursor:"pointer"}}>Annuler</button>
                      <button onClick={()=>{publishToGroup();setExpandComposer(false);}} disabled={posting||(!composerText.trim()&&!composerImage)} style={{padding:"8px 18px",borderRadius:20,border:"none",background:(composerText.trim()||composerImage)?"linear-gradient(135deg,"+C.accent+",#1e4d8c)":C.w4,color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer"}}>{posting?"...":"Publier"}</button>
                    </div>
                  </div>
                </div>
              )}

              {posts.length===0?(
                <div style={{textAlign:"center",padding:30,color:C.w3,fontSize:13}}>Aucune publication pour l'instant. Sois le premier !</div>
              ):(
                posts.map((p,i)=>(
                  <div key={p.id||i} style={{marginBottom:16}}>
                    <PostCard post={p} user={currentUser} onProfile={onProfile} showToast={showToast} onRequireAuth={()=>{}} onOpenVideo={onOpenVideo}/>
                  </div>
                ))
              )}
            </>
          )}
        </div>
      )}

      {groupTab==="about"&&!editMode&&(
        <div style={{padding:16}}>
          {isFullAdmin&&(
            <button onClick={()=>setEditMode(true)} style={{width:"100%",padding:"11px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:700,fontSize:13,cursor:"pointer",marginBottom:16}}>✏️ Modifier le groupe</button>
          )}
          {group.description&&<div style={{color:C.w2,fontSize:14,lineHeight:1.5,marginBottom:16}}>{group.description}</div>}
          <div style={{background:C.w5,borderRadius:14,border:"1px solid "+C.border,padding:14,marginBottom:12}}>
            <div style={{color:C.white,fontWeight:700,fontSize:13,marginBottom:4}}>{group.privacy==="private"?"🔒 Groupe privé":"🌍 Groupe public"}</div>
            <div style={{color:C.w3,fontSize:12,lineHeight:1.5}}>
              {group.privacy==="private"
                ?"Seuls les membres peuvent voir qui est dans le groupe et ce qui est publié."
                :"Tout le monde peut voir qui est dans le groupe et ce qui est publié."}
            </div>
          </div>
          <div style={{color:C.w3,fontSize:12,marginBottom:12}}>Créé le {new Date(group.created_at).toLocaleDateString("fr-FR")}</div>
          {isAnyAdmin&&group.privacy==="private"&&(
            <div onClick={()=>{setShowRequests(true);loadPendingRequests();}} style={{color:C.accent2,fontSize:13,fontWeight:600,marginBottom:10,cursor:"pointer"}}>📨 Demandes en attente</div>
          )}
          {isOwner&&(
            <div onClick={()=>{setShowAdminManage(true);loadMembers();}} style={{color:C.accent2,fontSize:13,fontWeight:600,cursor:"pointer"}}>🛡️ Gérer les administrateurs</div>
          )}
        </div>
      )}

      {groupTab==="about"&&editMode&&(
        <div style={{padding:16}}>
          <div onClick={()=>editCoverRef.current&&editCoverRef.current.click()} style={{width:"100%",aspectRatio:"16/7",borderRadius:14,position:"relative",overflow:"hidden",background:editCover?"#000":C.w5,border:"2px dashed "+C.border,cursor:"pointer",marginBottom:8}}>
            {editCover&&<img src={editCover} alt="" style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center "+editCoverPosition+"%",transform:"scale("+(editCoverZoom/100)+")",transformOrigin:"center "+editCoverPosition+"%",display:"block"}}/>}
            {!editCover&&<span style={{color:C.w3,fontSize:13,position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>{uploadingEditCover?"⏳ Upload...":"🖼️ Photo de couverture"}</span>}
            <input ref={editCoverRef} type="file" accept="image/*" onChange={e=>pickEditCover(e.target.files[0])} style={{display:"none"}}/>
          </div>
          {editCover&&(
            <div style={{marginBottom:18}}>
              <div style={{color:C.w3,fontSize:11,margin:"6px 0 4px"}}>🔍 Zoom</div>
              <input type="range" min="100" max="300" value={editCoverZoom} onChange={e=>setEditCoverZoom(Number(e.target.value))} style={{width:"100%",accentColor:C.accent,marginBottom:8}}/>
              <div style={{color:C.w3,fontSize:11,margin:"6px 0 4px"}}>↕️ Position</div>
              <input type="range" min="0" max="100" value={editCoverPosition} onChange={e=>setEditCoverPosition(Number(e.target.value))} style={{width:"100%",accentColor:C.accent}}/>
            </div>
          )}

          <div style={{color:C.w3,fontSize:12,marginBottom:6,fontWeight:600}}>Nom</div>
          <input value={editName} onChange={e=>setEditName(e.target.value.slice(0,80))} style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",marginBottom:16,boxSizing:"border-box"}}/>

          <div style={{color:C.w3,fontSize:12,marginBottom:6,fontWeight:600}}>Description</div>
          <textarea value={editDescription} onChange={e=>setEditDescription(e.target.value.slice(0,300))} rows={3} style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",resize:"none",fontFamily:"inherit",marginBottom:20,boxSizing:"border-box"}}/>

          <div style={{color:C.w3,fontSize:12,marginBottom:10,fontWeight:600,textTransform:"uppercase"}}>Confidentialité</div>
          {[
            {k:"public",l:"🌍 Public",d:"Tout le monde peut voir qui est dans le groupe et ce qui est publié."},
            {k:"private",l:"🔒 Privé",d:"Seuls les membres peuvent voir qui est dans le groupe et ce qui est publié. Rejoindre nécessite une approbation."},
          ].map(o=>(
            <div key={o.k} onClick={()=>setEditPrivacy(o.k)} style={{display:"flex",gap:12,padding:14,borderRadius:14,border:"1px solid "+(editPrivacy===o.k?C.accent:C.border),background:editPrivacy===o.k?C.accent+"10":C.w5,marginBottom:10,cursor:"pointer"}}>
              <div style={{width:20,height:20,borderRadius:"50%",border:"2px solid "+(editPrivacy===o.k?C.accent:C.border),background:editPrivacy===o.k?C.accent:"transparent",flexShrink:0,marginTop:2,display:"flex",alignItems:"center",justifyContent:"center"}}>
                {editPrivacy===o.k&&<div style={{width:8,height:8,borderRadius:"50%",background:"#fff"}}/>}
              </div>
              <div>
                <div style={{color:C.white,fontWeight:700,fontSize:14,marginBottom:3}}>{o.l}</div>
                <div style={{color:C.w3,fontSize:12,lineHeight:1.5}}>{o.d}</div>
              </div>
            </div>
          ))}

          <div style={{display:"flex",gap:8,marginTop:16}}>
            <button onClick={()=>{setEditMode(false);setEditName(group.name);setEditDescription(group.description||"");setEditPrivacy(group.privacy);setEditCover(group.cover||"");}} style={{flex:1,padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:700,cursor:"pointer"}}>Annuler</button>
            <button onClick={saveGroupSettings} disabled={saving} style={{flex:2,padding:"13px",borderRadius:12,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:"pointer"}}>{saving?"...":"Enregistrer"}</button>
          </div>
        </div>
      )}

      {groupTab==="members"&&(
        <div style={{padding:16}}>
          {isMember&&(
            <button onClick={()=>{setShowInvite(true);loadInviteCandidates();}} style={{width:"100%",padding:"11px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:700,fontSize:13,cursor:"pointer",marginBottom:16}}>➕ Inviter des personnes</button>
          )}
          {members===null?(
            <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
          ):members.length===0?(
            <div style={{textAlign:"center",padding:16,color:C.w3,fontSize:13}}>Aucun membre pour l'instant</div>
          ):(
            members.map((m,i)=>(
              <div key={i} onClick={()=>onProfile&&onProfile(m.username,m.avatar)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 4px",cursor:"pointer"}}>
                <Avatar src={m.avatar||""} name={m.username} size={40}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{color:C.white,fontWeight:600,fontSize:14}}>{m.display_name||m.username}</div>
                  {m.username===group.owner_username?(
                    <div style={{color:C.accent2,fontSize:11,fontWeight:700}}>Propriétaire</div>
                  ):m.permission_level&&(
                    <div style={{color:C.accent2,fontSize:11,fontWeight:700}}>Admin ({m.permission_level==="full"?"accès complet":"limité"})</div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {showInvite&&(
        <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div onClick={()=>{setShowInvite(false);setSelectedInvites([]);setInviteAsAdminLevel(null);}} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
          <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"20px 16px 32px",border:"1px solid "+C.border,maxHeight:"70vh",overflowY:"auto"}}>
            <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"0 auto 16px"}}/>
            <div style={{color:C.white,fontWeight:700,fontSize:15,marginBottom:6,textAlign:"center"}}>{inviteAsAdminLevel?"Inviter comme administrateur":"Inviter des personnes"}</div>
            {inviteAsAdminLevel&&<div style={{textAlign:"center",marginBottom:10}}><span style={{background:C.accent+"22",color:C.accent2,fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:10}}>{inviteAsAdminLevel==="full"?"Accès complet":"Limité"}</span></div>}
            <div style={{color:C.w3,fontSize:11,textAlign:"center",marginBottom:14}}>Comptes et Pages que tu suis ou qui te suivent</div>
            {inviteCandidates===null?(
              <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
            ):inviteCandidates.length===0?(
              <div style={{textAlign:"center",padding:16,color:C.w3,fontSize:13}}>Aucun abonné ni abonnement pour l'instant</div>
            ):(
              inviteCandidates.map((m,i)=>{
                const selected=selectedInvites.includes(m.username);
                return (
                  <div key={i} onClick={()=>toggleInviteSelect(m.username)} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 4px",cursor:"pointer"}}>
                    <Avatar src={m.avatar||""} name={m.username} size={36}/>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{color:C.white,fontWeight:600,fontSize:13}}>{m.display_name||m.username}{m.is_page&&<span style={{color:C.w3,fontWeight:400}}> · Page</span>}</div>
                      <div style={{color:C.w3,fontSize:11}}>@{m.username}</div>
                    </div>
                    <div style={{width:22,height:22,borderRadius:"50%",border:"2px solid "+(selected?C.accent:C.border),background:selected?C.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:12,flexShrink:0}}>{selected?"✓":""}</div>
                  </div>
                );
              })
            )}
            {selectedInvites.length>0&&(
              <button onClick={sendGroupInvites} disabled={sendingInvites} style={{width:"100%",padding:"12px",borderRadius:12,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,fontSize:14,cursor:"pointer",marginTop:14}}>
                {sendingInvites?"...":"Inviter ("+selectedInvites.length+")"}
              </button>
            )}
          </div>
        </div>
      )}

      {showAdminManage&&(
        <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div onClick={()=>setShowAdminManage(false)} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
          <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"20px 16px 32px",border:"1px solid "+C.border,maxHeight:"70vh",overflowY:"auto"}}>
            <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"0 auto 16px"}}/>
            <div style={{color:C.white,fontWeight:700,fontSize:15,marginBottom:6,textAlign:"center"}}>Administrateurs</div>
            <div style={{color:C.w3,fontSize:11,lineHeight:1.6,marginBottom:14,textAlign:"center"}}>Limité : approuve les demandes, modère les publications. Accès complet : ça, plus modifier le groupe.</div>

            <div style={{display:"flex",gap:8,marginBottom:16}}>
              <button onClick={()=>{setShowAdminManage(false);setInviteAsAdminLevel("limited");setShowInvite(true);loadInviteCandidates();}} style={{flex:1,padding:"9px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:700,fontSize:12,cursor:"pointer"}}>➕ Inviter (limité)</button>
              <button onClick={()=>{setShowAdminManage(false);setInviteAsAdminLevel("full");setShowInvite(true);loadInviteCandidates();}} style={{flex:1,padding:"9px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:700,fontSize:12,cursor:"pointer"}}>➕ Inviter (complet)</button>
            </div>

            {members===null?(
              <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
            ):members.filter(m=>m.username!==group.owner_username).length===0?(
              <div style={{textAlign:"center",padding:16,color:C.w3,fontSize:13}}>Pas encore d'autre membre — invite quelqu'un ci-dessus, ou attends que des gens rejoignent le groupe pour les promouvoir ici.</div>
            ):(
              members.filter(m=>m.username!==group.owner_username).map((m,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 4px"}}>
                  <Avatar src={m.avatar||""} name={m.username} size={36}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{color:C.white,fontWeight:600,fontSize:13}}>{m.display_name||m.username}</div>
                  </div>
                  <select value={m.permission_level||""} onChange={e=>setMemberPermission(m.username,e.target.value||null)} style={{padding:"6px 8px",borderRadius:8,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:11,outline:"none"}}>
                    <option value="">Membre</option>
                    <option value="limited">Limité</option>
                    <option value="full">Accès complet</option>
                  </select>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {showRequests&&(
        <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div onClick={()=>setShowRequests(false)} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
          <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"20px 16px 32px",border:"1px solid "+C.border,maxHeight:"70vh",overflowY:"auto"}}>
            <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"0 auto 16px"}}/>
            <div style={{color:C.white,fontWeight:700,fontSize:15,marginBottom:14,textAlign:"center"}}>Demandes en attente</div>
            {pendingRequests===null?(
              <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
            ):pendingRequests.length===0?(
              <div style={{textAlign:"center",padding:16,color:C.w3,fontSize:13}}>Aucune demande en attente</div>
            ):(
              pendingRequests.map((r,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 4px"}}>
                  <Avatar src={(r.profile&&r.profile.avatar)||""} name={r.username} size={40}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{color:C.white,fontWeight:600,fontSize:14}}>{(r.profile&&r.profile.display_name)||r.username}</div>
                    <div style={{color:C.w3,fontSize:11}}>@{r.username}</div>
                  </div>
                  <button onClick={()=>respondToRequest(r.username,true)} style={{background:C.accent,border:"none",borderRadius:8,padding:"7px 12px",color:"#fff",fontWeight:700,fontSize:12,cursor:"pointer"}}>Accepter</button>
                  <button onClick={()=>respondToRequest(r.username,false)} style={{background:"none",border:"1px solid "+C.border,borderRadius:8,padding:"7px 12px",color:C.w3,fontWeight:700,fontSize:12,cursor:"pointer"}}>Refuser</button>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function PageProfileScreen({pageId,currentUser,onBack,onMessage,showToast,onOpenVideo,onPublishAs,onSwitchPage,onSwitchToPage}){
  const [page,setPage]=useState(null);
  const [posts,setPosts]=useState([]);
  const [isFollowing,setIsFollowing]=useState(false);
  const [loading,setLoading]=useState(true);
  const [busy,setBusy]=useState(false);
  const [editMode,setEditMode]=useState(false);
  const [editName,setEditName]=useState("");
  const [editCategory,setEditCategory]=useState("");
  const [editBio,setEditBio]=useState("");
  const [editLogo,setEditLogo]=useState("");
  const [editCover,setEditCover]=useState("");
  const [editWebsite,setEditWebsite]=useState("");
  const [editContactEmail,setEditContactEmail]=useState("");
  const [editContactPhone,setEditContactPhone]=useState("");
  const [saving,setSaving]=useState(false);
  const [showSwitcher,setShowSwitcher]=useState(false);
  const [myOtherPages,setMyOtherPages]=useState(null);
  const [activeTab,setActiveTab]=useState("posts");
  const [showOptions,setShowOptions]=useState(false);
  const [showDeleteConfirm,setShowDeleteConfirm]=useState(false);
  const [deleting,setDeleting]=useState(false);
  const [showFollowers,setShowFollowers]=useState(false);
  const [followersList,setFollowersList]=useState(null);
  const [selectedPost,setSelectedPost]=useState(null);
  const logoRef=useRef(null);
  const coverRef=useRef(null);
  const safeUser=currentUser||{username:"",isGuest:true};

  useEffect(()=>{
    setLoading(true);
    setEditMode(false);
    setActiveTab("posts");
    (async()=>{
      const rows=await db("/pages?id=eq."+pageId+"&limit=1");
      if(Array.isArray(rows)&&rows[0]){
        setPage(rows[0]);
        setEditName(rows[0].name);setEditCategory(rows[0].category||"");setEditBio(rows[0].bio||"");setEditLogo(rows[0].logo||"");setEditCover(rows[0].cover||"");
        setEditWebsite(rows[0].website||"");setEditContactEmail(rows[0].contact_email||"");setEditContactPhone(rows[0].contact_phone||"");
      }
      const postRows=await db("/Posts?page_id=eq."+pageId+"&order=created_at.desc&limit=60");
      setPosts(Array.isArray(postRows)?postRows:[]);
      if(safeUser.username&&!safeUser.isGuest){
        const f=await db("/page_follows?follower=eq."+encodeURIComponent(safeUser.username)+"&page_id=eq."+pageId+"&limit=1");
        setIsFollowing(Array.isArray(f)&&f.length>0);
      }
      setLoading(false);
    })();
  },[pageId]);

  const isOwner=page&&safeUser.username===page.owner_username;

  async function toggleFollow(){
    if(!safeUser.username||safeUser.isGuest)return;
    setBusy(true);
    const wasFollowing=isFollowing;
    setIsFollowing(!wasFollowing);
    setPage(p=>p?{...p,followers_count:p.followers_count+(wasFollowing?-1:1)}:p);
    try{
      await callRpc(wasFollowing?"unfollow_page":"follow_page",{p_page_id:pageId});
    }catch{
      setIsFollowing(wasFollowing);
      setPage(p=>p?{...p,followers_count:p.followers_count+(wasFollowing?1:-1)}:p);
      showToast&&showToast("⚠️ Échec, réessaie");
    }
    setBusy(false);
  }

  async function openSwitcher(){
    setShowSwitcher(true);
    if(myOtherPages===null){
      const rows=await db("/pages?owner_username=eq."+encodeURIComponent(safeUser.username)+"&order=created_at.desc");
      setMyOtherPages(Array.isArray(rows)?rows.filter(p=>p.id!==pageId):[]);
    }
  }

  async function openFollowers(){
    setShowFollowers(true);
    if(followersList===null){
      const rows=await db("/page_follows?page_id=eq."+pageId+"&select=follower&order=created_at.desc&limit=200");
      if(!Array.isArray(rows)){setFollowersList([]);return;}
      const usernames=rows.map(r=>r.follower);
      if(usernames.length===0){setFollowersList([]);return;}
      const profs=await db("/profiles?username=in.("+usernames.join(",")+")&select=username,avatar,display_name").catch(()=>[]);
      setFollowersList(Array.isArray(profs)?profs:[]);
    }
  }

  async function pickEditLogo(file){
    if(!file)return;
    try{const{url}=await upload(file);setEditLogo(url);}
    catch{showToast&&showToast("⚠️ Échec de l'upload");}
  }
  async function pickEditCover(file){
    if(!file)return;
    try{const{url}=await upload(file);setEditCover(url);}
    catch{showToast&&showToast("⚠️ Échec de l'upload");}
  }

  async function saveEdits(){
    if(!editName.trim()){showToast&&showToast("Le nom ne peut pas être vide");return;}
    setSaving(true);
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/pages?id=eq."+pageId,{
        method:"PATCH",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({name:editName.trim(),category:editCategory,bio:editBio,logo:editLogo,cover:editCover,website:editWebsite,contact_email:editContactEmail,contact_phone:editContactPhone})
      });
      const saved=await res.json().catch(()=>null);
      if(!res.ok||!Array.isArray(saved)||saved.length===0){
        showToast&&showToast("⚠️ Échec de l'enregistrement");
        setSaving(false);
        return;
      }
      setPage(saved[0]);
      setEditMode(false);
      showToast&&showToast("✅ Mis à jour !");
    }catch{
      showToast&&showToast("⚠️ Échec de l'enregistrement");
    }
    setSaving(false);
  }

  async function deletePage(){
    setDeleting(true);
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/pages?id=eq."+pageId,{
        method:"DELETE",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),Prefer:"return=representation"}
      });
      const data=await res.json().catch(()=>null);
      if(!res.ok||!Array.isArray(data)||data.length===0){
        showToast&&showToast("⚠️ Échec de la suppression");
        setDeleting(false);
        return;
      }
      showToast&&showToast("Page supprimée");
      onBack&&onBack();
    }catch{
      showToast&&showToast("⚠️ Échec de la suppression");
      setDeleting(false);
    }
  }

  if(loading)return <div style={{position:"fixed",inset:0,display:"flex",alignItems:"center",justifyContent:"center",background:C.navy,zIndex:500}}><I.Spin/></div>;
  if(!page)return <div style={{position:"fixed",inset:0,display:"flex",alignItems:"center",justifyContent:"center",background:C.navy,color:C.w3,zIndex:500}}>Introuvable</div>;

  const videoPosts=posts.filter(p=>p.type==="video");
  const tabPosts=activeTab==="videos"?videoPosts:posts;

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:500,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 16px",position:"absolute",top:0,left:0,right:0,zIndex:10}}>
        <button onClick={onBack} style={{background:"rgba(0,0,0,0.45)",border:"none",borderRadius:"50%",width:36,height:36,cursor:"pointer",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}><I.Back/></button>
        {isOwner&&!editMode&&(
          <div style={{display:"flex",gap:8}}>
            <button onClick={openSwitcher} title="Changer de Page" style={{background:"rgba(0,0,0,0.45)",border:"none",borderRadius:"50%",width:36,height:36,cursor:"pointer",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
            </button>
            <button onClick={()=>setEditMode(true)} title="Modifier" style={{background:"rgba(0,0,0,0.45)",border:"none",borderRadius:"50%",width:36,height:36,cursor:"pointer",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <I.Edit/>
            </button>
            <button onClick={()=>onPublishAs&&onPublishAs(page)} title="Publier" style={{background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",border:"none",borderRadius:"50%",width:36,height:36,cursor:"pointer",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <I.Plus/>
            </button>
          </div>
        )}
        {!isOwner&&(
          <button onClick={()=>setShowOptions(true)} style={{background:"rgba(0,0,0,0.45)",border:"none",borderRadius:"50%",width:36,height:36,cursor:"pointer",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="12" cy="19" r="1.8"/></svg>
          </button>
        )}
      </div>

      <div onClick={()=>editMode&&coverRef.current&&coverRef.current.click()} style={{width:"100%",aspectRatio:"16/7",backgroundImage:(editMode?editCover:page.cover)?"url("+(editMode?editCover:page.cover)+")":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",backgroundSize:"cover",backgroundPosition:"center",cursor:editMode?"pointer":"default",display:"flex",alignItems:"center",justifyContent:"center"}}>
        {editMode&&<div style={{background:"rgba(0,0,0,0.5)",color:"#fff",fontSize:12,padding:"6px 12px",borderRadius:20}}>📷 Changer la couverture</div>}
        {editMode&&<input ref={coverRef} type="file" accept="image/*" onChange={e=>pickEditCover(e.target.files[0])} style={{display:"none"}}/>}
      </div>

      <div style={{padding:"0 20px 20px",marginTop:-40}}>
        <div onClick={()=>editMode&&logoRef.current&&logoRef.current.click()} style={{width:84,height:84,borderRadius:"50%",border:"4px solid "+C.navy,backgroundImage:(editMode?editLogo:page.logo)?"url("+(editMode?editLogo:page.logo)+")":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",backgroundSize:"cover",backgroundPosition:"center",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,fontSize:30,marginBottom:10,cursor:editMode?"pointer":"default"}}>
          {!(editMode?editLogo:page.logo)&&initials(editMode?editName:page.name)}
          {editMode&&<input ref={logoRef} type="file" accept="image/*" onChange={e=>pickEditLogo(e.target.files[0])} style={{display:"none"}}/>}
        </div>

        {!editMode?(
          <>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
              <span style={{fontWeight:800,fontSize:20,color:C.white}}>{page.name}</span>
              <span style={{fontSize:11,fontWeight:700,color:C.accent2,background:C.accent+"18",padding:"2px 8px",borderRadius:10}}>{page.entity_type==="group"?"GROUPE":"PAGE"}</span>
            </div>
            <div onClick={openFollowers} style={{color:C.accent2,fontSize:13,marginBottom:8,cursor:"pointer",width:"fit-content"}}>{page.category} · {fmt(page.followers_count)} abonné{page.followers_count>1?"s":""}</div>
            {page.bio&&<div style={{color:C.w2,fontSize:14,lineHeight:1.5,marginBottom:16}}>{page.bio}</div>}

            {!isOwner&&(
              <div style={{display:"flex",gap:8}}>
                <button onClick={toggleFollow} disabled={busy} style={{flex:2,padding:"12px",borderRadius:12,border:isFollowing?"1px solid "+C.border:"none",background:isFollowing?"transparent":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:isFollowing?C.white:"#fff",fontWeight:700,cursor:"pointer",fontSize:14}}>
                  {isFollowing?"Abonné(e)":"➕ S'abonner"}
                </button>
                <button onClick={()=>onMessage&&onMessage({username:page.slug,displayName:page.name,avatar:page.logo||""})} style={{flex:1,padding:"12px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:700,cursor:"pointer",fontSize:14}}>
                  💬
                </button>
              </div>
            )}
            {isOwner&&onSwitchToPage&&(
              <button onClick={()=>onSwitchToPage(page)} style={{width:"100%",padding:"13px",borderRadius:12,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
                Passer en Mode Page
              </button>
            )}
          </>
        ):(
          <>
            <input value={editName} onChange={e=>setEditName(e.target.value.slice(0,80))} placeholder="Nom" style={{width:"100%",padding:"12px 14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:16,fontWeight:700,outline:"none",marginBottom:10,boxSizing:"border-box"}}/>
            <select value={editCategory} onChange={e=>setEditCategory(e.target.value)} style={{width:"100%",padding:"12px 14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",marginBottom:10,boxSizing:"border-box"}}>
              {PAGE_CATEGORIES.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
            <textarea value={editBio} onChange={e=>setEditBio(e.target.value.slice(0,300))} rows={3} placeholder="Bio" style={{width:"100%",padding:"12px 14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",resize:"none",fontFamily:"inherit",marginBottom:10,boxSizing:"border-box"}}/>
            <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:8}}>Coordonnées (optionnel)</div>
            <input value={editWebsite} onChange={e=>setEditWebsite(e.target.value)} placeholder="Site web" style={{width:"100%",padding:"12px 14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",marginBottom:10,boxSizing:"border-box"}}/>
            <input value={editContactEmail} onChange={e=>setEditContactEmail(e.target.value)} placeholder="Email de contact" style={{width:"100%",padding:"12px 14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",marginBottom:10,boxSizing:"border-box"}}/>
            <input value={editContactPhone} onChange={e=>setEditContactPhone(e.target.value)} placeholder="Téléphone" style={{width:"100%",padding:"12px 14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",marginBottom:16,boxSizing:"border-box"}}/>
            <div style={{display:"flex",gap:8,marginBottom:16}}>
              <button onClick={()=>{setEditMode(false);setEditName(page.name);setEditCategory(page.category||"");setEditBio(page.bio||"");setEditLogo(page.logo||"");setEditCover(page.cover||"");setEditWebsite(page.website||"");setEditContactEmail(page.contact_email||"");setEditContactPhone(page.contact_phone||"");}} style={{flex:1,padding:"12px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:700,cursor:"pointer"}}>Annuler</button>
              <button onClick={saveEdits} disabled={saving} style={{flex:1,padding:"12px",borderRadius:12,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:"pointer"}}>{saving?"...":"Enregistrer"}</button>
            </div>
            <button onClick={()=>setShowDeleteConfirm(true)} style={{width:"100%",padding:"12px",borderRadius:12,border:"1px solid "+C.red,background:"transparent",color:C.red,fontWeight:700,cursor:"pointer",fontSize:13}}>
              🗑️ Supprimer cette {page.entity_type==="group"?"Groupe":"Page"}
            </button>
          </>
        )}
      </div>

      {!editMode&&(
        <div style={{display:"flex",borderTop:"1px solid "+C.border,borderBottom:"1px solid "+C.border}}>
          {[{k:"posts",l:"Publications"},{k:"videos",l:"Vidéos"},{k:"about",l:"À propos"}].map(tabInfo=>(
            <button key={tabInfo.k} onClick={()=>setActiveTab(tabInfo.k)} style={{flex:1,padding:"11px 0",background:"none",border:"none",borderBottom:activeTab===tabInfo.k?"2px solid "+C.accent:"2px solid transparent",color:activeTab===tabInfo.k?C.accent:C.w3,cursor:"pointer",fontSize:13,fontWeight:700}}>
              {tabInfo.l}
            </button>
          ))}
        </div>
      )}

      {!editMode&&activeTab==="about"?(
        <div style={{padding:20}}>
          {page.bio&&(
            <div style={{marginBottom:18}}>
              <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:6}}>Bio</div>
              <div style={{color:C.white,fontSize:14,lineHeight:1.5}}>{page.bio}</div>
            </div>
          )}
          <div style={{marginBottom:18}}>
            <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:6}}>Catégorie</div>
            <div style={{color:C.white,fontSize:14}}>{page.category||"—"}</div>
          </div>
          {page.website&&(
            <div style={{marginBottom:18}}>
              <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:6}}>Site web</div>
              <div style={{color:C.accent2,fontSize:14}}>{page.website}</div>
            </div>
          )}
          {page.contact_email&&(
            <div style={{marginBottom:18}}>
              <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:6}}>Email</div>
              <div style={{color:C.white,fontSize:14}}>{page.contact_email}</div>
            </div>
          )}
          {page.contact_phone&&(
            <div style={{marginBottom:18}}>
              <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:6}}>Téléphone</div>
              <div style={{color:C.white,fontSize:14}}>{page.contact_phone}</div>
            </div>
          )}
          <div>
            <div style={{color:C.w3,fontSize:11,fontWeight:700,textTransform:"uppercase",marginBottom:6}}>Créée</div>
            <div style={{color:C.white,fontSize:14}}>{ago(page.created_at)}</div>
          </div>
        </div>
      ):!editMode&&(
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:2}}>
          {tabPosts.length===0
            ?<div style={{gridColumn:"1/-1",textAlign:"center",padding:40,color:C.w3}}>Aucune publication pour l'instant</div>
            :tabPosts.map((p,i)=>(
              <div key={i} onClick={()=>{
                if(p.type==="video"&&onOpenVideo){onOpenVideo(videoPosts,videoPosts.indexOf(p));return;}
                setSelectedPost(p);
              }} style={{aspectRatio:"1/1",overflow:"hidden",position:"relative",background:"#000",cursor:"pointer"}}>
                {p.type==="text"
                  ?<div style={{width:"100%",height:"100%",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",display:"flex",alignItems:"center",justifyContent:"center",padding:8}}><div style={{color:"#fff",fontSize:10,fontWeight:700,textAlign:"center"}}>{p.caption}</div></div>
                  :p.type==="poll"
                  ?<div style={{width:"100%",height:"100%",background:"linear-gradient(135deg,#2f6fed,#1e4d8c)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:8}}><div style={{fontSize:20,marginBottom:4}}>📊</div><div style={{color:"#fff",fontSize:10,fontWeight:700,textAlign:"center"}}>{p.caption}</div></div>
                  :p.type==="video"
                  ?<img src={cloudinaryVideoThumbnail(p.image)} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                  :<GridThumbnail src={p.image}/>
                }
              </div>
            ))
          }
        </div>
      )}

      {selectedPost&&(
        <div style={{position:"fixed",inset:0,background:C.navy,zIndex:600,maxWidth:480,margin:"0 auto",display:"flex",flexDirection:"column",overflowY:"auto"}}>
          <div style={{display:"flex",alignItems:"center",padding:"14px",background:C.navy2,borderBottom:"1px solid "+C.border,position:"sticky",top:0,zIndex:2}}>
            <button onClick={()=>setSelectedPost(null)} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
          </div>
          <PostCard post={selectedPost} user={currentUser} onProfile={()=>{}} showToast={showToast} onRequireAuth={()=>{}} onOpenVideo={onOpenVideo}/>
        </div>
      )}

      {showFollowers&&(
        <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div onClick={()=>setShowFollowers(false)} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
          <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"20px 16px 32px",border:"1px solid "+C.border,maxHeight:"70vh",overflowY:"auto"}}>
            <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"0 auto 16px"}}/>
            <div style={{color:C.white,fontWeight:700,fontSize:15,marginBottom:14,textAlign:"center"}}>Abonnés</div>
            {followersList===null?(
              <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
            ):followersList.length===0?(
              <div style={{textAlign:"center",padding:16,color:C.w3,fontSize:13}}>Aucun abonné pour l'instant</div>
            ):(
              followersList.map((f,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 4px"}}>
                  <Avatar src={f.avatar||""} name={f.username} size={40}/>
                  <div style={{color:C.white,fontWeight:600,fontSize:14}}>{f.display_name||f.username}</div>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {showOptions&&(
        <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div onClick={()=>setShowOptions(false)} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
          <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"10px 16px 32px",border:"1px solid "+C.border}}>
            <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"6px auto 16px"}}/>
            <button onClick={()=>{copyText(window.location.origin+window.location.pathname+"?page="+pageId,showToast);setShowOptions(false);}} style={{width:"100%",display:"flex",alignItems:"center",gap:14,padding:"13px 8px",background:"none",border:"none",borderBottom:"1px solid "+C.border,cursor:"pointer",textAlign:"left"}}>
              <span style={{fontSize:20,width:26,textAlign:"center"}}>🔗</span>
              <span style={{fontSize:15,color:C.white,fontWeight:600}}>Copier le lien</span>
            </button>
            <button onClick={()=>{setShowOptions(false);showToast&&showToast("Signalement envoyé, merci");}} style={{width:"100%",display:"flex",alignItems:"center",gap:14,padding:"13px 8px",background:"none",border:"none",cursor:"pointer",textAlign:"left"}}>
              <span style={{fontSize:20,width:26,textAlign:"center"}}>🚩</span>
              <span style={{fontSize:15,color:C.red,fontWeight:600}}>Signaler {page.entity_type==="group"?"ce Groupe":"cette Page"}</span>
            </button>
          </div>
        </div>
      )}

      {showDeleteConfirm&&(
        <div style={{position:"fixed",inset:0,zIndex:970,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
          <div onClick={()=>!deleting&&setShowDeleteConfirm(false)} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.7)"}}/>
          <div style={{position:"relative",background:C.navy2,borderRadius:20,padding:24,width:"100%",maxWidth:360,border:"1px solid "+C.border}}>
            <div style={{fontSize:40,textAlign:"center",marginBottom:10}}>⚠️</div>
            <div style={{color:C.white,fontWeight:800,fontSize:16,marginBottom:10,textAlign:"center"}}>Supprimer définitivement ?</div>
            <div style={{color:C.w3,fontSize:13,lineHeight:1.6,marginBottom:20,textAlign:"center"}}>Cette {page.entity_type==="group"?"Groupe":"Page"} et toutes ses publications seront supprimées. Action irréversible.</div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setShowDeleteConfirm(false)} disabled={deleting} style={{flex:1,padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:700,cursor:"pointer"}}>Annuler</button>
              <button onClick={deletePage} disabled={deleting} style={{flex:1,padding:"13px",borderRadius:12,border:"none",background:C.red,color:"#fff",fontWeight:700,cursor:"pointer"}}>{deleting?"...":"Supprimer"}</button>
            </div>
          </div>
        </div>
      )}

      {showSwitcher&&(
        <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div onClick={()=>setShowSwitcher(false)} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
          <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"20px 16px 32px",border:"1px solid "+C.border,maxHeight:"70vh",overflowY:"auto"}}>
            <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"0 auto 16px"}}/>
            <div style={{color:C.white,fontWeight:700,fontSize:15,marginBottom:14,textAlign:"center"}}>Changer de Page</div>
            <div onClick={()=>{setShowSwitcher(false);}} style={{display:"flex",alignItems:"center",gap:12,padding:"12px",borderRadius:14,marginBottom:8,background:C.accent+"15",border:"1px solid "+C.accent}}>
              <div style={{width:40,height:40,borderRadius:"50%",backgroundImage:page.logo?"url("+page.logo+")":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",backgroundSize:"cover",backgroundPosition:"center",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,flexShrink:0}}>{!page.logo&&initials(page.name)}</div>
              <div style={{flex:1,color:C.white,fontWeight:700,fontSize:14}}>{page.name}</div>
              <span style={{color:C.accent2,fontSize:12,fontWeight:700}}>Actuelle</span>
            </div>
            {myOtherPages===null?(
              <div style={{textAlign:"center",padding:20,color:C.w3}}><I.Spin/></div>
            ):myOtherPages.length===0?(
              <div style={{textAlign:"center",padding:16,color:C.w3,fontSize:13}}>Tu ne gères pas d'autre Page ou Groupe</div>
            ):(
              myOtherPages.map((p,i)=>(
                <div key={i} onClick={()=>{setShowSwitcher(false);onSwitchPage&&onSwitchPage(p.id);}} style={{display:"flex",alignItems:"center",gap:12,padding:"12px",borderRadius:14,marginBottom:8,cursor:"pointer",background:C.w5,border:"1px solid "+C.border}}>
                  <div style={{width:40,height:40,borderRadius:"50%",backgroundImage:p.logo?"url("+p.logo+")":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",backgroundSize:"cover",backgroundPosition:"center",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,flexShrink:0}}>{!p.logo&&initials(p.name)}</div>
                  <div style={{flex:1,color:C.white,fontWeight:700,fontSize:14}}>{p.name}</div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function Settings({user,onBack,onLogout,onCertification,onWallet,onAdminFinance,showToast,initialPanel,onSwitchAccount,onAddAccount,onCreatePage,onOpenPage,onSwitchToPage,onExitPageMode,onCreateGroup,onOpenGroup}){
  const t=useTranslation();
  const [activePanel,setActivePanel]=useState(initialPanel||null);
  const [blockedList,setBlockedList]=useState(null);
  useEffect(()=>{
    if(activePanel!=="blockedAccounts")return;
    db("/blocks?blocker=eq."+encodeURIComponent(user.username)+"&select=blocked").then(async d=>{
      if(!Array.isArray(d)){setBlockedList([]);return;}
      if(d.length===0){setBlockedList([]);return;}
      const usernames=d.map(b=>b.blocked);
      const profiles=await db("/profiles?username=in.("+usernames.join(",")+")&select=username,avatar").catch(()=>[]);
      const avatarByUsername={};
      if(Array.isArray(profiles))profiles.forEach(p=>{avatarByUsername[p.username]=p.avatar;});
      setBlockedList(d.map(b=>({blocked:b.blocked,avatar:avatarByUsername[b.blocked]||""})));
    }).catch(()=>setBlockedList([]));
  },[activePanel]);
  const [language,setLanguage]=useState(()=>_currentLang);
  const [isPrivate,setIsPrivate]=useState(()=>localStorage.getItem("bl_private_account")==="true");
  const [notifSettings,setNotifSettings]=useState(()=>{
    try{const c=localStorage.getItem("bl_notif_settings");return c?JSON.parse(c):{likes:true,comments:true,follows:true,messages:true};}
    catch{return{likes:true,comments:true,follows:true,messages:true};}
  });
  const [sponsorHistory,setSponsorHistory]=useState([]);
  const [loadingHistory,setLoadingHistory]=useState(false);
  const [pwOld,setPwOld]=useState(""); const [pwNew,setPwNew]=useState("");
  const [pwChanging,setPwChanging]=useState(false);
  const [pwError,setPwError]=useState("");
  const [pwSuccess,setPwSuccess]=useState(false);
  const [pwOtpStep,setPwOtpStep]=useState("idle");
  const [pwOtpCode,setPwOtpCode]=useState("");
  const [pwOtpBusy,setPwOtpBusy]=useState(false);
  const [pwOtpError,setPwOtpError]=useState("");

  const [newEmail,setNewEmail]=useState("");
  const [emailChanging,setEmailChanging]=useState(false);
  const [emailError,setEmailError]=useState("");
  const [emailSuccess,setEmailSuccess]=useState(false);
  const [emailOtpStep,setEmailOtpStep]=useState("idle");
  const [emailOtpCode,setEmailOtpCode]=useState("");
  const [emailOtpBusy,setEmailOtpBusy]=useState(false);
  const [emailOtpError,setEmailOtpError]=useState("");

  const [newPhone,setNewPhone]=useState("");
  const [phoneChanging,setPhoneChanging]=useState(false);
  const [phoneError,setPhoneError]=useState("");
  const [phoneSuccess,setPhoneSuccess]=useState(false);
  const [phoneOtpStep,setPhoneOtpStep]=useState("idle");
  const [phoneOtpCode,setPhoneOtpCode]=useState("");
  const [phoneOtpBusy,setPhoneOtpBusy]=useState(false);
  const [phoneOtpError,setPhoneOtpError]=useState("");

  async function sendOtpFor(setStep,setBusy,setErr){
    setErr("");setBusy(true);
    try{
      await sendVerificationCode(user.email);
      setStep("sent");
    }catch(e){
      setErr(e.message||"Échec de l'envoi du code");
    }
    setBusy(false);
  }
  async function verifyOtpFor(code,setStep,setBusy,setErr){
    if(!code.trim()){setErr("Entre le code reçu par email");return;}
    setErr("");setBusy(true);
    try{
      await verifyCode(user.email,code.trim());
      setStep("verified");
    }catch(e){
      setErr(e.message||"Code invalide ou expiré");
    }
    setBusy(false);
  }


  async function changeEmail(){
    setEmailError("");setEmailSuccess(false);
    if(emailOtpStep!=="verified"){setEmailError("Vérifie d'abord ton identité avec le code reçu par email");return;}
    if(!newEmail.trim()||!newEmail.includes("@")){setEmailError("Entre une adresse email valide");return;}
    setEmailChanging(true);
    try{
      const res=await fetch(SUPABASE_URL+"/auth/v1/user",{
        method:"PUT",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+user.token,"Content-Type":"application/json"},
        body:JSON.stringify({email:newEmail.trim()})
      });
      if(!res.ok){
        const bodyText=await res.text().catch(()=>"");
        console.error("Email change failed (status "+res.status+"): "+bodyText);
        setEmailError("Échec de la mise à jour (code "+res.status+")");
        setEmailChanging(false);
        return;
      }
      const profRes=await fetch(SUPABASE_URL+"/rest/v1/profiles?username=eq."+encodeURIComponent(user.username),{
        method:"PATCH",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({email:newEmail.trim()})
      });
      const profData=await profRes.json().catch(()=>null);
      if(!profRes.ok||!Array.isArray(profData)||profData.length===0){
        console.error("Settings email change: profiles sync failed or matched nothing (status "+profRes.status+"): "+safeStringify(profData));
        setEmailError("L'email de connexion est changé, mais la synchronisation du profil a échoué. Contacte le support.");
        setEmailChanging(false);
        return;
      }
      setEmailSuccess(true);
      setNewEmail("");
      showToast&&showToast("📩 Vérifie ta nouvelle adresse pour confirmer");
    }catch(e){
      setEmailError("Erreur de connexion, réessaie");
    }
    setEmailChanging(false);
  }

  async function changePhone(){
    setPhoneError("");setPhoneSuccess(false);
    if(phoneOtpStep!=="verified"){setPhoneError("Vérifie d'abord ton identité avec le code reçu par email");return;}
    if(!newPhone.trim()){setPhoneError("Entre un numéro de téléphone");return;}
    setPhoneChanging(true);
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/profiles?username=eq."+encodeURIComponent(user.username),{
        method:"PATCH",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({phone_number:newPhone.trim()})
      });
      if(!res.ok){
        const bodyText=await res.text().catch(()=>"");
        console.error("Phone change failed (status "+res.status+"): "+bodyText);
        setPhoneError("Échec de la mise à jour (code "+res.status+")");
        setPhoneChanging(false);
        return;
      }
      setPhoneSuccess(true);
      showToast&&showToast("✅ Numéro mis à jour !");
    }catch(e){
      setPhoneError("Erreur de connexion, réessaie");
    }
    setPhoneChanging(false);
  }

  async function changePassword(){
    setPwError("");setPwSuccess(false);
    if(pwOtpStep!=="verified"){setPwError("Vérifie d'abord ton identité avec le code reçu par email");return;}
    if(!pwOld.trim()||!pwNew.trim()){setPwError("Remplis les deux champs");return;}
    if(pwNew.length<6){setPwError("Le nouveau mot de passe doit faire au moins 6 caractères");return;}
    setPwChanging(true);
    try{
      const verifyRes=await fetch(SUPABASE_URL+"/auth/v1/token?grant_type=password",{
        method:"POST",
        headers:{apikey:SUPABASE_ANON_KEY,"Content-Type":"application/json"},
        body:JSON.stringify({email:user.email,password:pwOld})
      });
      if(!verifyRes.ok){
        setPwError("Mot de passe actuel incorrect");
        setPwChanging(false);
        return;
      }
      const verifyData=await verifyRes.json();

      const updateRes=await fetch(SUPABASE_URL+"/auth/v1/user",{
        method:"PUT",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(verifyData.access_token||user.token),"Content-Type":"application/json"},
        body:JSON.stringify({password:pwNew})
      });
      if(!updateRes.ok){
        const bodyText=await updateRes.text().catch(()=>"");
        console.error("Password update failed (status "+updateRes.status+"): "+bodyText);
        setPwError("Échec de la mise à jour (code "+updateRes.status+")");
        setPwChanging(false);
        return;
      }
      setPwSuccess(true);
      setPwOld("");setPwNew("");
      showToast&&showToast("✅ Mot de passe mis à jour !");
    }catch(e){
      setPwError("Erreur de connexion, réessaie");
    }
    setPwChanging(false);
  }

  const [settingsSearch,setSettingsSearch]=useState("");
  const [showDeleteAccount,setShowDeleteAccount]=useState(false);
  const [deleting,setDeleting]=useState(false);
  const [deletePassword,setDeletePassword]=useState("");
  const [deleteError,setDeleteError]=useState("");

  async function requestAccountDeletion(){
    if(!deletePassword){setDeleteError("Entre ton mot de passe pour confirmer");return;}
    setDeleteError("");
    setDeleting(true);
    try{
      await authCall("/token?grant_type=password",{email:user.email,password:deletePassword});
    }catch{
      setDeleteError("Mot de passe incorrect");
      setDeleting(false);
      return;
    }
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/profiles?username=eq."+encodeURIComponent(user.username),{
        method:"PATCH",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({deletion_requested_at:new Date().toISOString()})
      });
      if(res.ok){
        showToast&&showToast("Compte programmé pour suppression dans 30 jours");
        onLogout();
      }else{
        setDeleteError("⚠️ Échec de la demande (code "+res.status+")");
        setDeleting(false);
      }
    }catch{
      setDeleteError("⚠️ Échec de la demande de suppression");
      setDeleting(false);
    }
  }

  function selectLanguage(l){
    setLanguage(l);
    setAppLanguage(l);
  }
  function togglePrivate(){
    const v=!isPrivate;setIsPrivate(v);
    try{localStorage.setItem("bl_private_account",String(v));}catch{}
  }
  function toggleNotif(key){
    const updated={...notifSettings,[key]:!notifSettings[key]};
    setNotifSettings(updated);
    try{localStorage.setItem("bl_notif_settings",JSON.stringify(updated));}catch{}
  }

  useEffect(()=>{
    if(activePanel==="payments"&&user&&user.username){
      setLoadingHistory(true);
      db("/sponsored_posts?username=eq."+encodeURIComponent(user.username)+"&order=created_at.desc&limit=50")
        .then(d=>setSponsorHistory(Array.isArray(d)?d:[]))
        .catch(()=>setSponsorHistory([]))
        .finally(()=>setLoadingHistory(false));
    }
  },[activePanel,user&&user.username]);

  const items=[
    {key:"notifications",icon:"🔔",label:t("notifications"),desc:language==="English"?"Manage alerts":"Gérer les alertes"},
    {key:"privacy",icon:"🔒",label:t("privacy"),desc:isPrivate?(language==="English"?"Private account":"Compte privé"):(language==="English"?"Public account":"Compte public")},
    {key:"certification",icon:(
      <svg width="22" height="22" viewBox="0 0 24 24" fill="#3897f0" style={{flexShrink:0}}>
        <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
        <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),label:t("certification"),desc:isBadgeActive(user)?(language==="English"?"Verified account":"Compte certifié"):(language==="English"?"Get the verified blue badge":"Obtenir le badge bleu vérifié")},
    {key:"wallet",icon:"💼",label:"Solde",desc:language==="English"?"Wallet, Blue Coins and earnings":"Portefeuille, Blue Coins et gains"},
    {key:"adminFinance",icon:"🏦",label:"Finances (admin)",desc:"Vue d'ensemble pour le propriétaire"},
    {key:"payments",icon:"💳",label:t("payments"),desc:language==="English"?"Sponsoring history":"Historique de sponsoring"},
    {key:"security",icon:"🛡️",label:t("security"),desc:language==="English"?"Password and access":"Mot de passe et accès"},
    {key:"blockedAccounts",icon:"🚫",label:"Comptes bloqués",desc:language==="English"?"Manage blocked accounts":"Gérer les comptes bloqués"},
    {key:"switchAccount",icon:"🔄",label:"Changer de compte",desc:language==="English"?"Switch between accounts":"Basculer entre tes comptes"},
    {key:"premium",icon:"⭐",label:"Abonnements premium",desc:language==="English"?"Let fans support you":"Laisse tes fans te soutenir"},
    {key:"myPages",icon:(
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke={C.accent2} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="14" rx="2"/><path d="M3 9h18"/><circle cx="7" cy="6.5" r="0.6" fill={C.accent2} stroke="none"/><path d="M7 13h4"/><path d="M7 15.5h7"/></svg>
    ),label:"Mes Pages",desc:language==="English"?"Pages you manage":"Pages que tu gères"},
    {key:"myGroups",icon:(
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke={C.accent2} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
    ),label:"Mes Groupes",desc:"Groupes que tu gères ou rejoins"},
    {key:"admins",icon:"🛡️",label:"Administrateurs",desc:"Qui peut gérer cette Page"},
    {key:"language",icon:"🌍",label:t("language"),desc:language},
    {key:"help",icon:"❓",label:t("help"),desc:language==="English"?"Blue Life Help Center":"Centre d'aide Blue Life"},
    {key:"terms",icon:"📋",label:t("terms"),desc:language==="English"?"Terms & privacy":"CGU et confidentialité"},
    {key:"monetization",icon:"💰",label:"Monétisation",desc:language==="English"?"How earning works":"Comment fonctionnent les gains"},
    {key:"download",icon:"📥",label:"Télécharger l'appli",desc:language==="English"?"Share with friends":"Partager avec des amis"},
  ];
  const byKey=k=>items.find(it=>it.key===k);
  const groups=[
    {title:"",items:[byKey("switchAccount")]},
    {title:language==="English"?"How you use Blue Life":"Comment vous utilisez Blue Life",items:[byKey("notifications"),byKey("privacy")]},
    {title:language==="English"?"Account":"Compte",items:[byKey("myPages"),byKey("myGroups"),...(user.isPage&&user.pageRole==="owner"?[byKey("admins")]:[]),byKey("certification"),byKey("wallet"),...(user.username===ADMIN_USERNAME?[byKey("adminFinance")]:[]),byKey("payments"),...(user.isPage?[]:[byKey("security")]),byKey("blockedAccounts"),byKey("premium")]},
    {title:language==="English"?"General":"Général",items:[byKey("language")]},
    {title:language==="English"?"Support":"Assistance",items:[byKey("help"),byKey("terms"),byKey("monetization"),byKey("download")]},
  ];

  function handleItemClick(key){
    if(key==="certification"){onCertification&&onCertification();return;}
    if(key==="wallet"){onWallet&&onWallet();return;}
    if(key==="adminFinance"){onAdminFinance&&onAdminFinance();return;}
    if(key==="download"){window.open("https://bluelifes.com/download.html","_blank");return;}
    setActivePanel(key);
  }

  if(activePanel){
    const titles={notifications:"🔔 Notifications",privacy:"🔒 Confidentialité",payments:"💳 Paiements",security:"🛡️ Sécurité",blockedAccounts:"🚫 Comptes bloqués",premium:"⭐ Abonnements premium",myPages:"📄 Mes Pages",myGroups:"👥 Mes Groupes",admins:"🛡️ Administrateurs",language:"🌍 Langue",help:"❓ Aide",terms:"📋 Conditions",monetization:"💰 Monétisation"};
    return(
      <div style={{position:"fixed",inset:0,background:C.navy,zIndex:520,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
        <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12,position:"sticky",top:0,background:C.navy,zIndex:10}}>
          <button onClick={()=>setActivePanel(null)} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
          <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>{titles[activePanel]}</span>
        </div>
        <div style={{padding:16}}>

          {activePanel==="notifications"&&(
            <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,overflow:"hidden"}}>
              {[{k:"likes",l:"J'aime"},{k:"comments",l:"Commentaires"},{k:"follows",l:"Nouveaux abonnés"},{k:"messages",l:"Messages"}].map((n,i)=>(
                <div key={n.k} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"16px",borderBottom:i<3?"1px solid "+C.border:"none"}}>
                  <span style={{color:C.white,fontSize:14}}>{n.l}</span>
                  <div onClick={()=>toggleNotif(n.k)} style={{width:46,height:26,borderRadius:13,background:notifSettings[n.k]?C.accent:C.w4,position:"relative",cursor:"pointer",transition:"background 0.2s"}}>
                    <div style={{width:20,height:20,borderRadius:"50%",background:"#fff",position:"absolute",top:3,left:notifSettings[n.k]?23:3,transition:"left 0.2s"}}/>
                  </div>
                </div>
              ))}
            </div>
          )}

          {activePanel==="privacy"&&(
            <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:"16px"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <div style={{color:C.white,fontWeight:600,fontSize:14,marginBottom:4}}>Compte privé</div>
                  <div style={{color:C.w3,fontSize:12}}>Seuls tes abonnés approuvés voient tes publications</div>
                </div>
                <div onClick={togglePrivate} style={{width:46,height:26,borderRadius:13,background:isPrivate?C.accent:C.w4,position:"relative",cursor:"pointer",flexShrink:0,marginLeft:12}}>
                  <div style={{width:20,height:20,borderRadius:"50%",background:"#fff",position:"absolute",top:3,left:isPrivate?23:3,transition:"left 0.2s"}}/>
                </div>
              </div>
            </div>
          )}

          {activePanel==="payments"&&(
            loadingHistory?(
              <div style={{textAlign:"center",padding:30,color:C.w3}}><I.Spin/> Chargement...</div>
            ):sponsorHistory.length===0?(
              <div style={{textAlign:"center",padding:30,color:C.w3}}>Aucun sponsoring effectué pour le moment</div>
            ):(
              sponsorHistory.map((s,i)=>(
                <div key={i} style={{background:C.w5,borderRadius:14,padding:14,marginBottom:10,border:"1px solid "+C.border}}>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                    <span style={{color:C.white,fontWeight:700,fontSize:14}}>{fmtUSD(Number(s.amount))}</span>
                    <span style={{color:s.status==="active"?C.green:C.w3,fontSize:12,fontWeight:600}}>{s.status==="active"?"✅ Actif":s.status}</span>
                  </div>
                  <div style={{color:C.w3,fontSize:12}}>{s.duration_days} jours · {ago(s.created_at)}</div>
                </div>
              ))
            )
          )}

          {activePanel==="security"&&(
            <>
            <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:"16px",marginBottom:14}}>
              <div style={{color:C.w3,fontSize:12,marginBottom:8}}>Email actuel</div>
              <div style={{color:C.white,fontSize:14,marginBottom:14,padding:"12px 14px",background:C.navy,borderRadius:10}}>{user.email||"—"}</div>
              {emailOtpStep!=="verified"&&(
                <div style={{background:"rgba(56,132,255,0.08)",border:"1px solid "+C.border2,borderRadius:12,padding:14,marginBottom:14}}>
                  <div style={{color:C.w3,fontSize:12,marginBottom:10,display:"flex",alignItems:"center",gap:6}}>🔒 Vérification requise avant de changer l'email</div>
                  {emailOtpStep==="idle"&&(
                    <button onClick={()=>sendOtpFor(setEmailOtpStep,setEmailOtpBusy,setEmailOtpError)} disabled={emailOtpBusy} style={{width:"100%",padding:"12px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontWeight:600,fontSize:13,cursor:emailOtpBusy?"not-allowed":"pointer"}}>
                      {emailOtpBusy?"Envoi...":"Envoyer un code de vérification"}
                    </button>
                  )}
                  {emailOtpStep==="sent"&&(
                    <>
                      <div style={{color:C.w3,fontSize:12,marginBottom:8}}>Code reçu par email à {user.email}</div>
                      <input value={emailOtpCode} onChange={e=>setEmailOtpCode(e.target.value)} placeholder="123456" inputMode="numeric" style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:16,outline:"none",marginBottom:10,boxSizing:"border-box",textAlign:"center",letterSpacing:4}}/>
                      <button onClick={()=>verifyOtpFor(emailOtpCode,setEmailOtpStep,setEmailOtpBusy,setEmailOtpError)} disabled={emailOtpBusy} style={{width:"100%",padding:"12px",borderRadius:10,border:"none",background:emailOtpBusy?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,fontSize:13,cursor:emailOtpBusy?"not-allowed":"pointer"}}>
                        {emailOtpBusy?"Vérification...":"Vérifier le code"}
                      </button>
                    </>
                  )}
                  {emailOtpError&&<div style={{color:"#f87171",fontSize:12,marginTop:10}}>{emailOtpError}</div>}
                </div>
              )}
              {emailOtpStep==="verified"&&(
                <>
                  <div style={{color:C.w3,fontSize:12,marginBottom:8}}>Nouvel email</div>
                  <input type="email" value={newEmail} onChange={e=>setNewEmail(e.target.value)} placeholder="nouveau@email.com" style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:14,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>
                  {emailError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{emailError}</div>}
                  {emailSuccess&&<div style={{background:"rgba(46,204,113,0.1)",border:"1px solid rgba(46,204,113,0.3)",borderRadius:10,padding:"10px 14px",color:"#4ade80",fontSize:13,marginBottom:14}}>📩 Vérifie ta nouvelle adresse pour confirmer le changement.</div>}
                  <button onClick={changeEmail} disabled={emailChanging} style={{width:"100%",padding:"13px",borderRadius:12,border:"none",background:emailChanging?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:emailChanging?"not-allowed":"pointer"}}>
                    {emailChanging?"Mise à jour...":"Changer l'email"}
                  </button>
                </>
              )}
            </div>

            <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:"16px",marginBottom:14}}>
              <div style={{color:C.w3,fontSize:12,marginBottom:8}}>Numéro de téléphone</div>
              {phoneOtpStep!=="verified"&&(
                <div style={{background:"rgba(56,132,255,0.08)",border:"1px solid "+C.border2,borderRadius:12,padding:14}}>
                  <div style={{color:C.w3,fontSize:12,marginBottom:10,display:"flex",alignItems:"center",gap:6}}>🔒 Vérification requise avant de changer le numéro</div>
                  {phoneOtpStep==="idle"&&(
                    <button onClick={()=>sendOtpFor(setPhoneOtpStep,setPhoneOtpBusy,setPhoneOtpError)} disabled={phoneOtpBusy} style={{width:"100%",padding:"12px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontWeight:600,fontSize:13,cursor:phoneOtpBusy?"not-allowed":"pointer"}}>
                      {phoneOtpBusy?"Envoi...":"Envoyer un code de vérification"}
                    </button>
                  )}
                  {phoneOtpStep==="sent"&&(
                    <>
                      <div style={{color:C.w3,fontSize:12,marginBottom:8}}>Code reçu par email à {user.email}</div>
                      <input value={phoneOtpCode} onChange={e=>setPhoneOtpCode(e.target.value)} placeholder="123456" inputMode="numeric" style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:16,outline:"none",marginBottom:10,boxSizing:"border-box",textAlign:"center",letterSpacing:4}}/>
                      <button onClick={()=>verifyOtpFor(phoneOtpCode,setPhoneOtpStep,setPhoneOtpBusy,setPhoneOtpError)} disabled={phoneOtpBusy} style={{width:"100%",padding:"12px",borderRadius:10,border:"none",background:phoneOtpBusy?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,fontSize:13,cursor:phoneOtpBusy?"not-allowed":"pointer"}}>
                        {phoneOtpBusy?"Vérification...":"Vérifier le code"}
                      </button>
                    </>
                  )}
                  {phoneOtpError&&<div style={{color:"#f87171",fontSize:12,marginTop:10}}>{phoneOtpError}</div>}
                </div>
              )}
              {phoneOtpStep==="verified"&&(
                <>
                  <input type="tel" value={newPhone} onChange={e=>setNewPhone(e.target.value)} placeholder="+237 6xx xx xx xx" style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:14,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>
                  {phoneError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{phoneError}</div>}
                  <button onClick={changePhone} disabled={phoneChanging} style={{width:"100%",padding:"13px",borderRadius:12,border:"none",background:phoneChanging?"rgba(10,10,10,0.15)":(phoneSuccess?"rgba(46,204,113,0.3)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)"),color:"#fff",fontWeight:700,cursor:phoneChanging?"not-allowed":"pointer"}}>
                    {phoneChanging?"Mise à jour...":phoneSuccess?"✓ Mis à jour !":"Changer le numéro"}
                  </button>
                </>
              )}
            </div>

            <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:"16px"}}>
              <div style={{color:C.w3,fontSize:12,marginBottom:8}}>Mot de passe</div>
              {pwOtpStep!=="verified"&&(
                <div style={{background:"rgba(56,132,255,0.08)",border:"1px solid "+C.border2,borderRadius:12,padding:14}}>
                  <div style={{color:C.w3,fontSize:12,marginBottom:10,display:"flex",alignItems:"center",gap:6}}>🔒 Vérification requise avant de changer le mot de passe</div>
                  {pwOtpStep==="idle"&&(
                    <button onClick={()=>sendOtpFor(setPwOtpStep,setPwOtpBusy,setPwOtpError)} disabled={pwOtpBusy} style={{width:"100%",padding:"12px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontWeight:600,fontSize:13,cursor:pwOtpBusy?"not-allowed":"pointer"}}>
                      {pwOtpBusy?"Envoi...":"Envoyer un code de vérification"}
                    </button>
                  )}
                  {pwOtpStep==="sent"&&(
                    <>
                      <div style={{color:C.w3,fontSize:12,marginBottom:8}}>Code reçu par email à {user.email}</div>
                      <input value={pwOtpCode} onChange={e=>setPwOtpCode(e.target.value)} placeholder="123456" inputMode="numeric" style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:16,outline:"none",marginBottom:10,boxSizing:"border-box",textAlign:"center",letterSpacing:4}}/>
                      <button onClick={()=>verifyOtpFor(pwOtpCode,setPwOtpStep,setPwOtpBusy,setPwOtpError)} disabled={pwOtpBusy} style={{width:"100%",padding:"12px",borderRadius:10,border:"none",background:pwOtpBusy?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,fontSize:13,cursor:pwOtpBusy?"not-allowed":"pointer"}}>
                        {pwOtpBusy?"Vérification...":"Vérifier le code"}
                      </button>
                    </>
                  )}
                  {pwOtpError&&<div style={{color:"#f87171",fontSize:12,marginTop:10}}>{pwOtpError}</div>}
                </div>
              )}
              {pwOtpStep==="verified"&&(
                <>
                  <div style={{color:C.w3,fontSize:12,marginBottom:8,marginTop:14}}>Mot de passe actuel</div>
                  <input type="password" value={pwOld} onChange={e=>setPwOld(e.target.value)} style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:14,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>
                  <div style={{color:C.w3,fontSize:12,marginBottom:8}}>Nouveau mot de passe</div>
                  <input type="password" value={pwNew} onChange={e=>setPwNew(e.target.value)} style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:14,outline:"none",marginBottom:16,boxSizing:"border-box"}}/>
                  {pwError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{pwError}</div>}
                  <button onClick={changePassword} disabled={pwChanging} style={{width:"100%",padding:"13px",borderRadius:12,border:"none",background:pwChanging?"rgba(10,10,10,0.15)":(pwSuccess?"rgba(46,204,113,0.3)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)"),color:"#fff",fontWeight:700,cursor:pwChanging?"not-allowed":"pointer"}}>
                    {pwChanging?"Mise à jour...":pwSuccess?"✓ Mis à jour !":"Mettre à jour"}
                  </button>
                </>
              )}
            </div>
            </>
          )}

          {activePanel==="blockedAccounts"&&(
            <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:"16px"}}>
              {blockedList===null&&<div style={{color:C.w3,fontSize:13,textAlign:"center",padding:20}}>Chargement...</div>}
              {Array.isArray(blockedList)&&blockedList.length===0&&(
                <div style={{color:C.w3,fontSize:13,textAlign:"center",padding:20}}>Tu n'as bloqué personne pour l'instant.</div>
              )}
              {Array.isArray(blockedList)&&blockedList.map((b,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:i<blockedList.length-1?"1px solid "+C.border:"none"}}>
                  <Avatar src={b.avatar||""} name={b.blocked} size={40}/>
                  <div style={{flex:1,color:C.white,fontWeight:600,fontSize:14}}>@{b.blocked}</div>
                  <button onClick={async()=>{
                    const res=await fetch(SUPABASE_URL+"/rest/v1/blocks?blocker=eq."+encodeURIComponent(user.username)+"&blocked=eq."+b.blocked,{
                      method:"DELETE",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"}
                    });
                    const data=await res.json().catch(()=>null);
                    if(res.ok&&Array.isArray(data)&&data.length>0){
                      setBlockedList(prev=>prev.filter(x=>x.blocked!==b.blocked));
                      showToast&&showToast("Débloqué");
                    }else{
                      showToast&&showToast("⚠️ Échec");
                    }
                  }} style={{padding:"7px 14px",borderRadius:20,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:600,fontSize:12,cursor:"pointer"}}>Débloquer</button>
                </div>
              ))}
            </div>
          )}

          {activePanel==="premium"&&(
            <PremiumSettingsPanel user={user} showToast={showToast}/>
          )}

          {activePanel==="myPages"&&(
            <MyPagesPanel user={user} onCreatePage={onCreatePage} onOpenPage={onOpenPage} onSwitchToPage={onSwitchToPage} showToast={showToast}/>
          )}

          {activePanel==="myGroups"&&(
            <MyGroupsPanel user={user} onCreateGroup={onCreateGroup} onOpenGroup={onOpenGroup} showToast={showToast}/>
          )}

          {activePanel==="admins"&&(
            <AdminManagementPanel pageUsername={user.username} pageDisplayName={user.displayName} showToast={showToast}/>
          )}

          {activePanel==="switchAccount"&&(
            <SwitchAccountPanel currentUsername={user.username} onSwitchAccount={onSwitchAccount} onAddAccount={onAddAccount} showToast={showToast}/>
          )}

          {activePanel==="language"&&(
            <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,overflow:"hidden"}}>
              {APP_LANGUAGES.map((l,i)=>(
                <div key={l} onClick={()=>selectLanguage(l)} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 16px",borderBottom:i<APP_LANGUAGES.length-1?"1px solid "+C.border:"none",cursor:"pointer",background:language===l?C.accent+"15":"transparent"}}>
                  <span style={{color:C.white,fontSize:14}}>{l}</span>
                  {language===l&&<span style={{color:C.accent2,fontWeight:800}}>✓</span>}
                </div>
              ))}
            </div>
          )}

          {activePanel==="help"&&(
            <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:"18px"}}>
              <div style={{color:C.white,fontWeight:700,marginBottom:10}}>Centre d'aide Blue Life</div>
              <div style={{color:C.w3,fontSize:13,lineHeight:1.7}}>
                Pour toute question, contacte-nous :<br/>
                📧 support@bluelife.app<br/><br/>
                Made by Africa-Tech 🌍
              </div>
            </div>
          )}

          {activePanel==="terms"&&(
            <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:"18px"}}>
              <div style={{color:C.white,fontWeight:700,marginBottom:14,fontSize:16}}>Politique d'utilisation</div>
              <div style={{color:C.w3,fontSize:13,lineHeight:1.7}}>

                <b style={{color:C.white}}>1. Acceptation</b><br/>
                En créant un compte sur Blue Life, tu acceptes cette politique d'utilisation dans son intégralité. Si tu n'es pas d'accord, merci de ne pas utiliser l'application.<br/><br/>

                <b style={{color:C.white}}>2. Ton compte</b><br/>
                Tu dois avoir au moins 18 ans pour créer un compte. Les informations fournies à l'inscription doivent être exactes. Tu es responsable de la confidentialité de ton mot de passe et de toute activité sur ton compte.<br/><br/>

                <b style={{color:C.white}}>3. Contenu autorisé</b><br/>
                Sont strictement interdits : le contenu à caractère sexuel impliquant des mineurs, le harcèlement, les menaces, l'incitation à la violence, la haine envers un groupe ou une personne, le contenu illégal, et l'usurpation d'identité. Blue Life se réserve le droit de supprimer tout contenu enfreignant ces règles et de suspendre ou supprimer le compte concerné, avec ou sans préavis. Chaque utilisateur peut bloquer un autre compte ou signaler un contenu directement depuis l'application.<br/><br/>

                <b style={{color:C.white}}>4. Portefeuille et paiements</b><br/>
                Blue Life propose des fonctionnalités payantes (Boost, Certification, Blue Coins) via des prestataires de paiement tiers (Mobile Money, carte bancaire). Les montants payés pour des services numériques déjà fournis (Boost activé, Certification accordée, Coins crédités) ne sont pas remboursables, sauf erreur technique avérée de notre part. Les fonds disponibles pour retrait peuvent être retirés selon les modalités indiquées dans l'application.<br/><br/>

                <b style={{color:C.white}}>5. Certification (badge bleu)</b><br/>
                La certification est un service payant qui ne garantit ni visibilité accrue ni authenticité du contenu publié par le compte certifié — elle atteste uniquement du paiement effectué. Elle peut être retirée en cas de non-respect de cette politique.<br/><br/>

                <b style={{color:C.white}}>6. Ton contenu</b><br/>
                Tu conserves tous les droits sur les photos, vidéos et textes que tu publies. En les publiant sur Blue Life, tu nous autorises à les héberger et les afficher dans l'application, dans le seul but de faire fonctionner le service.<br/><br/>

                <b style={{color:C.white}}>7. Suspension et suppression</b><br/>
                Blue Life peut suspendre ou supprimer un compte en cas de non-respect de cette politique. Un compte peut aussi être supprimé à la demande de son propriétaire, avec un délai de grâce de 30 jours avant suppression définitive des données.<br/><br/>

                <b style={{color:C.white}}>8. Modifications</b><br/>
                Cette politique peut être mise à jour. Les changements importants seront communiqués dans l'application.<br/><br/>

                <b style={{color:C.white}}>9. Contact</b><br/>
                Pour toute question : africatechdevelopment@gmail.com<br/><br/>

                Made by Africa Tech 🌍
              </div>
            </div>
          )}

          {activePanel==="monetization"&&(
            <div style={{background:C.w5,borderRadius:16,border:"1px solid "+C.border,padding:"18px"}}>
              <div style={{color:C.white,fontWeight:700,marginBottom:14,fontSize:16}}>Politique de monétisation</div>
              <div style={{color:C.w3,fontSize:13,lineHeight:1.7}}>

                <b style={{color:C.white}}>1. Notre principe de base</b><br/>
                Blue Life récompense la vraie création de contenu. Chaque fonctionnalité de monétisation — cadeaux virtuels, abonnements premium, badge de certification — existe pour soutenir des créateurs qui partagent leur propre travail.<br/><br/>
                <span style={{color:C.accent2,fontWeight:600}}>Nous n'encourageons pas les comptes qui copient ou republient les publications d'autres personnes en se les appropriant. Nous encourageons les vrais créateurs.</span><br/><br/>

                <b style={{color:C.white}}>2. Comment fonctionne la monétisation</b><br/>
                <u>Cadeaux virtuels :</u> envoyés directement aux publications, créditant le créateur.<br/>
                <u>Abonnements premium :</u> prix libre fixé par chaque créateur, en échange d'un badge de soutien et d'une mise en avant de son contenu.<br/>
                <u>Certification (badge bleu) :</u> confirme l'authenticité d'un compte, distinct de la monétisation du contenu.<br/>
                <u>Retraits :</u> vers Mobile Money, dès 120$ de solde, frais de service de 5% toujours indiqués avant chaque retrait.<br/><br/>

                <b style={{color:C.white}}>3. Détection des contenus copiés</b><br/>
                Un système technique identifie les images publiées qui sont des copies exactes d'un contenu déjà présent sur la plateforme sous un autre compte. En cas de copie détectée : les cadeaux envoyés vers cette publication ne créditent jamais son auteur, et une note discrète l'informe, visible uniquement par lui-même. Republier correctement via la fonction de republication intégrée reste toujours autorisé et encouragé.<br/><br/>

                <b style={{color:C.white}}>4. Transparence</b><br/>
                Toutes nos commissions sont annoncées clairement avant chaque transaction, sans frais cachés. Nous nous réservons le droit de suspendre l'accès à la monétisation pour tout compte utilisant des méthodes frauduleuses.<br/><br/>

                Made by Africa Tech 🌍
              </div>
            </div>
          )}

        </div>
      </div>
    );
  }

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:500,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12,position:"sticky",top:0,background:C.navy,zIndex:10}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>⚙️ {t("settings")}</span>
      </div>
      <div style={{padding:16}}>
        {user.isPage&&(
          <div style={{display:"flex",alignItems:"center",gap:10,background:C.accent+"18",border:"1px solid "+C.accent,borderRadius:14,padding:12,marginBottom:18}}>
            <div style={{width:36,height:36,borderRadius:"50%",backgroundImage:user.avatar?"url("+user.avatar+")":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",backgroundSize:"cover",backgroundPosition:"center",flexShrink:0}}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{color:C.white,fontWeight:700,fontSize:13}}>Mode Page actif</div>
              <div style={{color:C.w3,fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>Tu gères les paramètres de {user.displayName}</div>
            </div>
            <button onClick={onExitPageMode} style={{background:"transparent",border:"1px solid "+C.accent,borderRadius:10,padding:"6px 10px",color:C.accent2,fontWeight:700,fontSize:12,cursor:"pointer",flexShrink:0}}>Quitter</button>
          </div>
        )}
        <div style={{background:C.w5,borderRadius:12,padding:"10px 14px",display:"flex",alignItems:"center",gap:8,marginBottom:22,border:"1px solid "+C.border}}>
          <I.Search a={false}/>
          <input value={settingsSearch} onChange={e=>setSettingsSearch(e.target.value)} placeholder={language==="English"?"Search":"Rechercher"} style={{background:"none",border:"none",outline:"none",flex:1,fontSize:15,color:C.white}}/>
        </div>

        {(()=>{
          const term=settingsSearch.trim().toLowerCase();
          const visibleGroups=groups.map(g=>({...g,items:g.items.filter(it=>it&&(!term||it.label.toLowerCase().includes(term)))})).filter(g=>g.items.length>0);
          if(term&&visibleGroups.length===0){
            return <div style={{textAlign:"center",padding:30,color:C.w3,fontSize:14}}>{language==="English"?"No results":"Aucun résultat"}</div>;
          }
          return visibleGroups.map((g,gi)=>(
            <div key={gi} style={{marginBottom:22}}>
              {g.title&&<div style={{color:C.w3,fontSize:12,fontWeight:700,letterSpacing:0.4,marginBottom:8,paddingLeft:4,textTransform:"uppercase"}}>{g.title}</div>}
              <div style={{background:C.w5,borderRadius:16,overflow:"hidden",border:"1px solid "+C.border}}>
                {g.items.map((s,i)=>(
                  <div key={i} onClick={()=>handleItemClick(s.key)} style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",borderBottom:i<g.items.length-1?"1px solid "+C.border:"none",cursor:"pointer"}}>
                    <div style={{fontSize:20,width:30,textAlign:"center"}}>{s.icon}</div>
                    <div style={{flex:1}}><div style={{fontWeight:600,fontSize:14,color:C.white}}>{s.label}</div><div style={{fontSize:12,color:C.w3}}>{s.desc}</div></div>
                    <div style={{color:C.w3,fontSize:18}}>›</div>
                  </div>
                ))}
              </div>
            </div>
          ));
        })()}

        <button onClick={onLogout} style={{width:"100%",padding:"14px",borderRadius:14,border:"1px solid rgba(239,68,68,0.3)",background:"rgba(239,68,68,0.1)",color:C.red,fontWeight:700,cursor:"pointer",fontSize:15,display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginBottom:10}}>
          <I.Out/> {t("logout")}
        </button>
        <div style={{color:C.w3,fontSize:11,fontWeight:700,letterSpacing:0.4,margin:"18px 0 8px 4px",textTransform:"uppercase"}}>Zone de danger</div>
        <button onClick={()=>setShowDeleteAccount(true)} style={{width:"100%",padding:"14px",borderRadius:14,border:"1px solid "+C.red,background:"transparent",color:C.red,fontWeight:700,cursor:"pointer",fontSize:15}}>
          Supprimer mon compte
        </button>
        <div style={{textAlign:"center",marginTop:16,color:C.w3,fontSize:12}}>Blue Life v1.0.0 🌊</div>
      </div>

      {showDeleteAccount&&(
        <div style={{position:"fixed",inset:0,zIndex:970,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div onClick={()=>{if(deleting)return;setShowDeleteAccount(false);setDeletePassword("");setDeleteError("");}} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.65)",backdropFilter:"blur(3px)"}}/>
          <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"24px 20px 36px",border:"1px solid "+C.border}}>
            <div style={{fontSize:44,textAlign:"center",marginBottom:10}}>⚠️</div>
            <div style={{fontWeight:800,fontSize:18,color:C.white,marginBottom:12,textAlign:"center"}}>Supprimer ton compte ?</div>
            <div style={{color:C.w3,fontSize:14,lineHeight:1.6,marginBottom:18}}>
              Ton compte sera désactivé <b style={{color:C.white}}>immédiatement</b> (tu seras déconnecté). Il sera ensuite <b style={{color:C.white}}>définitivement supprimé dans 30 jours</b> — posts, commentaires, messages, stories, tout disparaîtra.
              <br/><br/>
              Tu peux annuler à tout moment pendant ces 30 jours en te reconnectant simplement avec ton email et ton mot de passe.
            </div>
            <div style={{fontSize:13,fontWeight:700,color:C.white,marginBottom:6}}>Confirme avec ton mot de passe</div>
            <input
              type="password"
              value={deletePassword}
              onChange={e=>{setDeletePassword(e.target.value);setDeleteError("");}}
              placeholder="Mot de passe"
              style={{width:"100%",padding:"12px 14px",borderRadius:12,border:"1px solid "+(deleteError?C.red:C.border),background:C.w5,color:C.white,fontSize:14,outline:"none",marginBottom:8,boxSizing:"border-box"}}
            />
            {deleteError&&<div style={{color:C.red,fontSize:12,marginBottom:10}}>{deleteError}</div>}
            <div style={{display:"flex",gap:8,marginTop:deleteError?0:8}}>
              <button onClick={()=>{setShowDeleteAccount(false);setDeletePassword("");setDeleteError("");}} disabled={deleting} style={{flex:1,padding:"14px",borderRadius:14,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:700,cursor:"pointer"}}>Annuler</button>
              <button onClick={requestAccountDeletion} disabled={deleting||!deletePassword} style={{flex:1,padding:"14px",borderRadius:14,border:"none",background:deletePassword?C.red:C.w4,color:"#fff",fontWeight:700,cursor:deleting||!deletePassword?"not-allowed":"pointer"}}>{deleting?"...":"Supprimer"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ChatScreen({currentUser,receiver,onBack,showToast}){
  const [msgs,setMsgs]=useState([]);
  const [text,setText]=useState("");
  const [optionsFor,setOptionsFor]=useState(null);
  const [receiverLastSeen,setReceiverLastSeen]=useState(null);
  const bottom=useRef(null);

  async function load(){const d=await db("/messages?or=(and(sender.eq."+encodeURIComponent(currentUser.username)+",receiver.eq."+encodeURIComponent(receiver.username)+"),and(sender.eq."+encodeURIComponent(receiver.username)+",receiver.eq."+encodeURIComponent(currentUser.username)+"))&order=created_at.asc");setMsgs(Array.isArray(d)?d:[]);}
  useEffect(()=>{load();return()=>{};},[receiver.username]);
  useEffect(()=>{
    function fetchPresence(){
      db("/profiles?username=eq."+encodeURIComponent(receiver.username)+"&select=last_seen&limit=1").then(d=>{
        if(Array.isArray(d)&&d[0])setReceiverLastSeen(d[0].last_seen||null);
      }).catch(()=>{});
    }
    fetchPresence();
    const interval=setInterval(fetchPresence,20000);
    return ()=>clearInterval(interval);
  },[receiver.username]);
  useEffect(()=>{bottom.current&&bottom.current.scrollIntoView({behavior:"smooth"});},[msgs]);

  async function sendMessageObject(localMsg){
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/messages",{
        method:"POST",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({sender:localMsg.sender,receiver:localMsg.receiver,text:localMsg.text})
      });
      if(res.ok){
        const saved=await res.json();
        if(Array.isArray(saved)&&saved[0]){
          setMsgs(m=>m.map(x=>x.id===localMsg.id?saved[0]:x));
        }
        sendPushNotification({type:"message",receiver:localMsg.receiver,sender:localMsg.sender,message:localMsg.text.slice(0,100)});
        return true;
      }
      const bodyText=await res.text().catch(()=>"");
      console.error("Message send failed (status "+res.status+"): "+bodyText);
      showToast&&showToast("⚠️ Message non envoyé (code "+res.status+")");
      return false;
    }catch(e){
      console.error("Message send failed (network): "+e.message);
      showToast&&showToast("⚠️ Message non envoyé (connexion)");
      return false;
    }
  }

  async function send(){
    if(!text.trim())return;
    if(isRestricted(currentUser,"restricted_messaging","messaging_restricted_until")){showToast&&showToast("⚠️ Ton compte est temporairement restreint d'envoyer des messages.");return;}
    const t=text;setText("");
    const localMsg={id:"local_"+Date.now(),sender:currentUser.username,receiver:receiver.username,text:t,created_at:new Date().toISOString()};
    setMsgs(m=>[...m,localMsg]);
    await sendMessageObject(localMsg);
  }

  async function resendMessage(m){
    showToast&&showToast("Renvoi en cours...");
    const ok=await sendMessageObject(m);
    if(ok)showToast&&showToast("✅ Message envoyé");
  }

  function deleteMessage(m){
    setMsgs(list=>list.filter(x=>x.id!==m.id));
    if(!String(m.id).startsWith("local_")){
      fetch(SUPABASE_URL+"/rest/v1/messages?id=eq."+m.id,{
        method:"DELETE",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),Prefer:"return=minimal"}
      }).catch(()=>{});
    }
    showToast&&showToast("Message supprimé");
  }

  const sheet=useDragSheet();

  return(
    <div style={{position:"fixed",inset:0,zIndex:500,display:"flex",flexDirection:"column",justifyContent:"flex-end",maxWidth:480,margin:"0 auto",pointerEvents:"none"}}>
      {!sheet.expanded&&<div onClick={onBack} style={{flex:1,pointerEvents:"auto"}}/>}
      <div style={{height:sheet.expanded?"100dvh":"70vh",transition:"height 0.25s ease",background:C.navy,borderRadius:sheet.expanded?0:"20px 20px 0 0",display:"flex",flexDirection:"column",fontFamily:"'Segoe UI',system-ui,sans-serif",pointerEvents:"auto",boxShadow:"0 -8px 30px rgba(0,0,0,0.4)",overflow:"hidden"}}>
        <div onClick={()=>sheet.setExpanded(e=>!e)} onTouchStart={sheet.onDragStart} onTouchMove={sheet.onDragMove} onTouchEnd={sheet.onDragEnd} style={{padding:"8px 0 2px",cursor:"pointer",flexShrink:0,background:C.navy2}}>
          <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"0 auto"}}/>
        </div>
      <div style={{display:"flex",alignItems:"center",padding:"12px 16px",borderBottom:"1px solid "+C.border,gap:12,background:C.navy2,flexShrink:0}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <Avatar src={receiver.avatar||""} name={receiver.username} size={38}/>
        <div style={{flex:1}}>
          <div style={{fontWeight:700,fontSize:15,color:C.white}}>{receiver.displayName||receiver.username}</div>
          <div style={{fontSize:11,color:receiverLastSeen&&(Date.now()-new Date(receiverLastSeen).getTime())<120000?C.green:C.w3}}>
            {receiverLastSeen
              ?((Date.now()-new Date(receiverLastSeen).getTime())<120000?"● En ligne":"Vu il y a "+ago(receiverLastSeen))
              :"Hors ligne"}
          </div>
        </div>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"14px",display:"flex",flexDirection:"column",gap:8}}>
        {msgs.length===0&&<div style={{textAlign:"center",padding:40,color:C.w3}}>Commencez à discuter !</div>}
        {msgs.map((m,i)=>{const me=m.sender===currentUser.username;return(
          <div key={i} onClick={()=>setOptionsFor(m)} style={{display:"flex",justifyContent:me?"flex-end":"flex-start",cursor:"pointer"}}>
            <div style={{maxWidth:"75%",padding:"9px 13px",borderRadius:me?"16px 16px 4px 16px":"16px 16px 16px 4px",background:me?"linear-gradient(135deg,"+C.accent+",#1e4d8c)":C.w5,color:me?"#fff":C.white,fontSize:14,border:me?"none":"1px solid "+C.border}}>
              {m.text}<div style={{fontSize:10,color:"rgba(255,255,255,0.5)",marginTop:3,textAlign:"right"}}>{String(m.id).startsWith("local_")?"en attente":ago(m.created_at)}</div>
            </div>
          </div>
        );})}
        <div ref={bottom}/>
      </div>
      <div style={{padding:"10px 14px 24px",borderTop:"1px solid "+C.border,display:"flex",gap:8,background:C.navy2}}>
        <div style={{flex:1,display:"flex",alignItems:"center",background:C.w5,borderRadius:24,padding:"8px 14px",border:"1px solid "+C.border}}>
          <input value={text} onChange={e=>setText(e.target.value)} onKeyDown={e=>e.key==="Enter"&&send()} placeholder="Message..." style={{flex:1,background:"none",border:"none",outline:"none",fontSize:14,color:C.white}}/>
        </div>
        <button onClick={send} disabled={!text.trim()} style={{width:40,height:40,borderRadius:"50%",border:"none",background:text?"linear-gradient(135deg,"+C.accent+",#1e4d8c)":"transparent",color:"#fff",cursor:text?"pointer":"default",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <I.Send/>
        </button>
      </div>
      </div>

      {optionsFor&&(()=>{
        const isOwner=optionsFor.sender===currentUser.username;
        const isFailed=String(optionsFor.id).startsWith("local_");
        const opts=isOwner?[
          {ic:"📋",label:"Copier",action:()=>copyText(optionsFor.text,showToast)},
          ...(isFailed?[{ic:"🔁",label:"Renvoyer",action:()=>resendMessage(optionsFor)}]:[]),
          {ic:"🗑️",label:"Supprimer",action:()=>deleteMessage(optionsFor),danger:true},
        ]:[
          {ic:"📋",label:"Copier",action:()=>copyText(optionsFor.text,showToast)},
        ];
        return(
          <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
            <div onClick={()=>setOptionsFor(null)} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
            <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"10px 16px 32px",border:"1px solid "+C.border}}>
              <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"6px auto 16px"}}/>
              {opts.map((o,i)=>(
                <button key={i} onClick={()=>{o.action();setOptionsFor(null);}} style={{width:"100%",display:"flex",alignItems:"center",gap:14,padding:"13px 8px",background:"none",border:"none",borderBottom:i<opts.length-1?"1px solid "+C.border:"none",cursor:"pointer",textAlign:"left"}}>
                  <span style={{fontSize:20,width:26,textAlign:"center"}}>{o.ic}</span>
                  <span style={{fontSize:15,color:o.danger?C.red:C.white,fontWeight:600}}>{o.label}</span>
                </button>
              ))}
            </div>
          </div>
        );
      })()}
    </div>
  );
}


function GuestPrompt({onClose,onAuth}){
  const t=useTranslation();
  return(
    <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.7)",backdropFilter:"blur(4px)"}}/>
      <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:28,border:"1px solid "+C.border,animation:"slideUp 0.3s ease"}}>
        <div style={{textAlign:"center",marginBottom:24}}>
          <div style={{fontSize:48,marginBottom:12}}>🌊</div>
          <div style={{fontWeight:800,fontSize:22,color:C.white,marginBottom:8}}>Rejoins Blue Life</div>
          <div style={{color:C.w3,fontSize:14}}>Crée un compte pour liker, commenter et publier</div>
        </div>
        <button onClick={()=>onAuth("register")} style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:"pointer",marginBottom:10}}>
          Créer un compte
        </button>
        <button onClick={()=>onAuth("login")} style={{width:"100%",padding:"14px",borderRadius:14,border:"1px solid "+C.border,background:"transparent",color:C.white,fontWeight:700,fontSize:16,cursor:"pointer",marginBottom:10}}>
          {t("login")}
        </button>
        <button onClick={onClose} style={{width:"100%",padding:"10px",borderRadius:14,border:"none",background:"transparent",color:C.w3,fontWeight:600,fontSize:14,cursor:"pointer"}}>
          {t("noAccount")}
        </button>
      </div>
    </div>
  );
}

function AuthScreen({onAuth,onGuest=null}){
  const t=useTranslation();
  const [mode,setMode]=useState("login");
  const [method,setMethod]=useState("email");
  const [username,setUsername]=useState("");
  const [displayName,setDisplayName]=useState("");
  const [bio,setBio]=useState("");
  const [age,setAge]=useState("");
  const [nationality,setNationality]=useState("");
  const [email,setEmail]=useState("");
  const [phone,setPhone]=useState("");
  const [phoneCode,setPhoneCode]=useState("+237");
  const [password,setPassword]=useState("");
  const [showPass,setShowPass]=useState(false);
  const [rememberedAccounts,setRememberedAccounts]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("bl_remembered_accounts")||"[]");}catch{return [];}
  });
  const [selectedAccount,setSelectedAccount]=useState(null);

  function selectRememberedAccount(acc){
    setSelectedAccount(acc);
    setMethod("email");
    setEmail(acc.loginEmail);
    setMode("login");
    setPassword("");
  }

  function forgetRememberedAccount(e,uname){
    e.stopPropagation();
    const updated=rememberedAccounts.filter(a=>a.username!==uname);
    setRememberedAccounts(updated);
    try{localStorage.setItem("bl_remembered_accounts",JSON.stringify(updated));}catch{}
  }
  const [showForgotPassword,setShowForgotPassword]=useState(false);
  const [forgotStep,setForgotStep]=useState("choose");
  const [forgotWhat,setForgotWhat]=useState("");
  const [forgotEmail,setForgotEmail]=useState("");
  const [forgotCode,setForgotCode]=useState("");
  const [forgotSending,setForgotSending]=useState(false);
  const [forgotError,setForgotError]=useState("");
  const [forgotToken,setForgotToken]=useState("");
  const [forgotUsername,setForgotUsername]=useState("");
  const [forgotAccounts,setForgotAccounts]=useState([]);
  const [forgotNewPassword,setForgotNewPassword]=useState("");
  const [forgotNewEmail,setForgotNewEmail]=useState("");
  const [forgotNewPhone,setForgotNewPhone]=useState("");

  function resetForgotFlow(){
    setForgotStep("choose");setForgotWhat("");setForgotEmail("");setForgotCode("");setForgotError("");setForgotToken("");setForgotUsername("");setForgotAccounts([]);setForgotNewPassword("");setForgotNewEmail("");setForgotNewPhone("");
  }

  async function forgotSendCode(){
    setForgotError("");
    if(!forgotEmail.trim()||!forgotEmail.includes("@")){setForgotError("Entre une adresse email valide");return;}
    setForgotSending(true);
    try{
      await sendVerificationCode(forgotEmail.trim());
      setForgotStep("code");
    }catch(e){
      setForgotError(e.message||"Échec de l'envoi du code");
    }
    setForgotSending(false);
  }

  async function forgotVerifyCode(){
    if(!forgotCode.trim()){setForgotError("Entre le code reçu par email");return;}
    setForgotError("");setForgotSending(true);
    try{
      const d=await verifyCode(forgotEmail.trim(),forgotCode.trim());
      setForgotToken(d.access_token||"");
      try{
        const rows=await db("/profiles?email=ilike."+encodeURIComponent(forgotEmail.trim())+"&select=username,display_name,avatar");
        if(Array.isArray(rows)&&rows.length>1){
          setForgotAccounts(rows);
          setForgotStep("pickAccount");
        }else{
          if(Array.isArray(rows)&&rows[0])setForgotUsername(rows[0].username||"");
          setForgotStep(forgotWhat==="password"?"password":forgotWhat==="email"?"email_new":"phone_new");
        }
      }catch{
        setForgotStep(forgotWhat==="password"?"password":forgotWhat==="email"?"email_new":"phone_new");
      }
    }catch(e){
      setForgotError(e.message||"Code invalide ou expiré");
    }
    setForgotSending(false);
  }

  async function forgotApplyPassword(){
    setForgotError("");
    if(forgotNewPassword.length<6){setForgotError("Le mot de passe doit faire au moins 6 caractères");return;}
    setForgotSending(true);
    try{
      const res=await fetch(SUPABASE_URL+"/auth/v1/user",{
        method:"PUT",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+forgotToken,"Content-Type":"application/json"},
        body:JSON.stringify({password:forgotNewPassword})
      });
      if(!res.ok){const t=await res.text().catch(()=>"");console.error("Forgot-flow password update failed: "+t);setForgotError("Échec de la mise à jour");setForgotSending(false);return;}
      setForgotStep("done");
    }catch(e){
      setForgotError("Erreur de connexion, réessaie");
    }
    setForgotSending(false);
  }

  async function forgotApplyEmail(){
    setForgotError("");
    if(!forgotNewEmail.trim()||!forgotNewEmail.includes("@")){setForgotError("Entre une adresse email valide");return;}
    setForgotSending(true);
    try{
      const res=await fetch(SUPABASE_URL+"/auth/v1/user",{
        method:"PUT",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+forgotToken,"Content-Type":"application/json"},
        body:JSON.stringify({email:forgotNewEmail.trim()})
      });
      if(!res.ok){const t=await res.text().catch(()=>"");console.error("Forgot-flow email update failed: "+t);setForgotError("Échec de la mise à jour");setForgotSending(false);return;}
      const patchFilter=forgotUsername?"username=eq."+forgotUsername:"email=ilike."+encodeURIComponent(forgotEmail.trim());
      const profRes=await fetch(SUPABASE_URL+"/rest/v1/profiles?"+patchFilter,{
        method:"PATCH",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({email:forgotNewEmail.trim()})
      });
      const profData=await profRes.json().catch(()=>null);
      if(!profRes.ok||!Array.isArray(profData)||profData.length===0){
        console.error("Forgot-flow profiles email sync failed or matched nothing (status "+profRes.status+"): "+safeStringify(profData));
        setForgotError("L'email de connexion est changé, mais la synchronisation du profil a échoué. Contacte le support pour finir la mise à jour.");
        setForgotSending(false);
        return;
      }
      setForgotStep("done");
    }catch(e){
      setForgotError("Erreur de connexion, réessaie");
    }
    setForgotSending(false);
  }

  async function forgotApplyPhone(){
    setForgotError("");
    if(!forgotNewPhone.trim()){setForgotError("Entre un numéro de téléphone");return;}
    if(!forgotUsername){setForgotError("Compte introuvable");return;}
    setForgotSending(true);
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/profiles?username=eq."+forgotUsername,{
        method:"PATCH",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({phone_number:forgotNewPhone.trim()})
      });
      if(!res.ok){const t=await res.text().catch(()=>"");console.error("Forgot-flow phone update failed: "+t);setForgotError("Échec de la mise à jour");setForgotSending(false);return;}
      setForgotStep("done");
    }catch(e){
      setForgotError("Erreur de connexion, réessaie");
    }
    setForgotSending(false);
  }

  const [loading,setLoading]=useState(false);
  const [debugInfo,setDebugInfo]=useState("");
  const [emailLoginAccounts,setEmailLoginAccounts]=useState([]);
  const [error,setError]=useState("");
  const [success,setSuccess]=useState("");
  const [pendingDeletion,setPendingDeletion]=useState(null);
  const [cancelling,setCancelling]=useState(false);

  async function completeLoginWithAuthResponse(d,loginEmail){
    _currentUserToken=d.access_token||null;
    _currentRefreshToken=d.refresh_token||null;
    let uname=loginEmail.split("@")[0],uavatar="",ubio="",udname=uname,uphoneCode="",uverified=false,uverifiedUntil=null,uDeletionAt=null,uWallet=0,uEarnings=0,uCoins=0,uGiftCoins=0,uRestrictedPosting=false,uPostingUntil=null,uRestrictedMessaging=false,uMessagingUntil=null;
    try{
      const byEmail=await db("/profiles?or=(auth_email.eq."+encodeURIComponent(loginEmail)+",email.ilike."+encodeURIComponent(loginEmail)+")&limit=1");
      const found=Array.isArray(byEmail)?byEmail[0]:null;
      setDebugInfo("Recherche par email=["+loginEmail+"] -> "+(Array.isArray(byEmail)?byEmail.length+" résultat(s)":"réponse non-tableau: "+safeStringify(byEmail))+(found?(" | trouvé: username="+encodeURIComponent(found.username)+" display_name="+found.display_name+" avatar="+(found.avatar?"present":"VIDE")):" | AUCUN PROFIL TROUVÉ"));
      if(found){
        uname=found.username||uname;uavatar=found.avatar||"";ubio=found.bio||"";udname=found.display_name||uname;uphoneCode=found.phone_code||"";uverified=!!found.verified;uverifiedUntil=found.verified_until||null;uDeletionAt=found.deletion_requested_at||null;uWallet=found.wallet_balance||0;uEarnings=found.earnings_balance||0;uCoins=found.coins_balance||0;uGiftCoins=found.gift_coins_balance||0;uRestrictedPosting=!!found.restricted_posting;uPostingUntil=found.posting_restricted_until||null;uRestrictedMessaging=!!found.restricted_messaging;uMessagingUntil=found.messaging_restricted_until||null;
        if(!found.auth_email){
          db("/profiles?username=eq."+encodeURIComponent(uname),{method:"PATCH",body:JSON.stringify({auth_email:loginEmail})}).catch(()=>{});
        }
      }else{
        const all=await db("/profiles?limit=200");
        setDebugInfo(dbg=>dbg+" | scan de secours: "+(Array.isArray(all)?all.length+" profils":"échec")+" cherché username=["+uname+"]");
        if(Array.isArray(all)){
          const guess=all.find(p=>p.username&&p.username.toLowerCase()===uname.toLowerCase());
          if(guess){uname=guess.username||uname;uavatar=guess.avatar||"";ubio=guess.bio||"";udname=guess.display_name||uname;uphoneCode=guess.phone_code||"";uverified=!!guess.verified;uverifiedUntil=guess.verified_until||null;uDeletionAt=guess.deletion_requested_at||null;uWallet=guess.wallet_balance||0;uEarnings=guess.earnings_balance||0;uCoins=guess.coins_balance||0;uGiftCoins=guess.gift_coins_balance||0;uRestrictedPosting=!!guess.restricted_posting;uPostingUntil=guess.posting_restricted_until||null;uRestrictedMessaging=!!guess.restricted_messaging;uMessagingUntil=guess.messaging_restricted_until||null;}
          else setDebugInfo(dbg=>dbg+" | AUCUNE CORRESPONDANCE dans le scan non plus");
        }
      }
    }catch(lookupErr){
      setDebugInfo("ERREUR pendant la recherche du profil: "+lookupErr.message);
    }

    if(uDeletionAt){
      const daysPassed=(Date.now()-new Date(uDeletionAt).getTime())/86400000;
      if(daysPassed>=30){
        await finalizeAccountDeletion(uname);
        setError("Ce compte a été définitivement supprimé (délai de 30 jours écoulé).");
        setLoading(false);
        return;
      }
      setPendingDeletion({
        username:uname,
        daysLeft:Math.max(1,Math.ceil(30-daysPassed)),
        authData:{token:d.access_token,username:uname,displayName:udname,avatar:uavatar,bio:ubio,email:loginEmail,phoneCode:uphoneCode,verified:uverified,verified_until:uverifiedUntil}
      });
      setLoading(false);
      return;
    }

    console.error("LOGIN: about to call onAuth, username="+uname);
    const fullAuthObj={token:d.access_token,refreshToken:d.refresh_token,username:uname,displayName:udname,avatar:uavatar,bio:ubio,email:loginEmail,phoneCode:uphoneCode,verified:uverified,verified_until:uverifiedUntil,wallet_balance:uWallet,earnings_balance:uEarnings,coins_balance:uCoins,gift_coins_balance:uGiftCoins,restricted_posting:uRestrictedPosting,posting_restricted_until:uPostingUntil,restricted_messaging:uRestrictedMessaging,messaging_restricted_until:uMessagingUntil};
    try{
      const existing=JSON.parse(localStorage.getItem("bl_remembered_accounts")||"[]");
      const withoutThis=existing.filter(a=>a.username!==uname);
      const updated=[{username:uname,displayName:udname,avatar:uavatar,loginEmail,refreshToken:d.refresh_token},...withoutThis];
      localStorage.setItem("bl_remembered_accounts",JSON.stringify(updated));

      const multiExisting=JSON.parse(localStorage.getItem("bl_multi_accounts")||"[]");
      const multiWithoutThis=multiExisting.filter(a=>a.username!==uname);
      const multiUpdated=[fullAuthObj,...multiWithoutThis];
      localStorage.setItem("bl_multi_accounts",JSON.stringify(multiUpdated));
    }catch{}
    onAuth(fullAuthObj);
    console.error("LOGIN: onAuth call completed");
    if(window.Capacitor&&window.Capacitor.Plugins&&window.Capacitor.Plugins.PushNotifications){
      window.Capacitor.Plugins.PushNotifications.requestPermissions().then(result=>{
        if(result.receive==="granted"){
          window.Capacitor.Plugins.PushNotifications.register();
          window.Capacitor.Plugins.PushNotifications.addListener("registration",token=>{
            saveFcmToken(uname,token.value);
          });
        }
      }).catch(()=>{});
    }
  }

  async function reconnectWithToken(acc){
    setError("");setSuccess("");
    if(!acc.refreshToken){
      setError("Reconnexion rapide indisponible pour ce compte, entre ton mot de passe.");
      selectRememberedAccount(acc);
      return;
    }
    setLoading(true);
    try{
      const d=await authCall("/token?grant_type=refresh_token",{refresh_token:acc.refreshToken});
      await completeLoginWithAuthResponse(d,acc.loginEmail);
    }catch(e){
      setError("Ta session a expiré, entre ton mot de passe pour te reconnecter.");
      selectRememberedAccount(acc);
    }
    setLoading(false);
  }

  async function submit(overrideAuthEmail){
    setError("");setSuccess("");
    let loginEmail=email;
    let profileEmail=email;
    if(method==="phone"){
      if(!phone||!password){setError("Numéro de téléphone et mot de passe requis");return;}
      if(mode==="register"){
        if(!username){setError("Nom d'utilisateur requis");return;}
        loginEmail=phone.trim()+"@phone.bluelife.app";
        profileEmail=loginEmail;
      }else{
        setLoading(true);
        const rows=await db("/profiles?phone_number=eq."+encodeURIComponent(phone.trim())+"&select=email&limit=1");
        if(!Array.isArray(rows)||!rows[0]||!rows[0].email){
          setError("Aucun compte trouvé avec ce numéro de téléphone.");
          setLoading(false);
          return;
        }
        loginEmail=rows[0].email;
        profileEmail=loginEmail;
        setLoading(false);
      }
    }else if(method==="email"&&mode==="register"&&email.includes("@")){
      const [localPart,domain]=email.split("@");
      loginEmail=localPart+"+"+username.trim().toLowerCase().replace(/[^a-z0-9]/g,"")+"@"+domain;
      profileEmail=email;
    }else if(method==="email"&&mode==="login"&&email.includes("@")&&overrideAuthEmail){
      loginEmail=overrideAuthEmail;
    }else if(method==="email"&&mode==="login"&&email.includes("@")){
      setLoading(true);
      const rows=await db("/profiles?email=ilike."+encodeURIComponent(email.trim())+"&select=username,display_name,avatar,auth_email");
      setLoading(false);
      if(Array.isArray(rows)&&rows.length>1){
        setEmailLoginAccounts(rows);
        return;
      }
      if(Array.isArray(rows)&&rows[0]){
        loginEmail=rows[0].auth_email||email;
      }
    }
    if(!loginEmail||!password){setError("Email et mot de passe requis");return;}
    if(mode==="register"&&!username){setError("Nom d'utilisateur requis");return;}
    if(mode==="register"&&(!age||Number(age)<13||Number(age)>120)){setError("Indique un âge valide");return;}
    if(mode==="register"&&!nationality){setError("Sélectionne ta nationalité");return;}
    setLoading(true);
    console.error("LOGIN: starting, mode="+mode);
    try{
      if(mode==="login"){
        console.error("LOGIN: about to call authCall token endpoint");
        const d=await authCall("/token?grant_type=password",{email:loginEmail,password});
        await completeLoginWithAuthResponse(d,loginEmail);
      }else{
        try{
          const existing=await db("/profiles?username=eq."+encodeURIComponent(username)+"&limit=1");
          if(Array.isArray(existing)&&existing[0]&&existing[0].verified){
            setError("❌ Ce nom d'utilisateur appartient à un compte certifié et ne peut pas être réutilisé. Choisis un autre nom.");
            setLoading(false);
            return;
          }
        }catch{}

        const signupData = await authCall("/signup",{email:loginEmail,password,data:{username}});
        const profCreateRes=await fetch(SUPABASE_URL+"/rest/v1/profiles",{
          method:"POST",
          headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
          body:JSON.stringify({username,display_name:displayName||username,bio:bio||"",avatar:"",age:Number(age),nationality,followers_count:0,following_count:0,posts_count:0,email:profileEmail,auth_email:loginEmail,phone_code:phoneCode,phone_number:phone||"",verified:false,wallet_balance:0,coins_balance:0,gift_coins_balance:0,earnings_balance:0})
        });
        const profCreateData=await profCreateRes.json().catch(()=>null);
        if(!profCreateRes.ok||!Array.isArray(profCreateData)||profCreateData.length===0){
          console.error("Signup profile creation failed (status "+profCreateRes.status+"): "+safeStringify(profCreateData));
          setError("Ton compte de connexion a été créé, mais la création de ton profil a échoué. Contacte le support avant de continuer, ou réessaie avec un autre nom d'utilisateur.");
          setLoading(false);
          return;
        }
        if(signupData && signupData.access_token){
          onAuth({token:signupData.access_token,username,displayName:displayName||username,avatar:"",bio:bio||"",email:profileEmail,phoneCode,verified:false});
        } else {
          try{
            const loginData = await authCall("/token?grant_type=password",{email:loginEmail,password});
            onAuth({token:loginData.access_token,username,displayName:displayName||username,avatar:"",bio:bio||"",email:profileEmail,phoneCode,verified:false});
          }catch{
            setSuccess("✅ Compte créé ! Connecte-toi.");
            setMode("login");
          }
        }
      }
    }catch(e){setError(e.message);setDebugInfo("STACK: "+(e.stack||"non disponible").slice(0,400));}
    setLoading(false);
  }

  async function cancelDeletion(){
    setCancelling(true);
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/profiles?username=eq."+encodeURIComponent(pendingDeletion.username),{
        method:"PATCH",
        headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({deletion_requested_at:null})
      });
      if(res.ok){
        onAuth(pendingDeletion.authData);
      }else{
        setError("⚠️ Échec de l'annulation (code "+res.status+")");
        setPendingDeletion(null);
      }
    }catch{
      setError("⚠️ Échec de l'annulation");
      setPendingDeletion(null);
    }
    setCancelling(false);
  }

  if(pendingDeletion){
    return(
      <div style={{minHeight:"100dvh",background:"linear-gradient(160deg,"+C.navy+" 0%,"+C.navy2+" 50%,#1a3a6b 100%)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24,fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
        <div style={{background:C.w5,backdropFilter:"blur(20px)",borderRadius:24,padding:28,width:"100%",maxWidth:380,border:"1px solid "+C.border,textAlign:"center"}}>
          <div style={{fontSize:44,marginBottom:14}}>⏳</div>
          <div style={{fontWeight:800,fontSize:19,color:C.white,marginBottom:10}}>Compte programmé pour suppression</div>
          <div style={{color:C.w3,fontSize:14,lineHeight:1.6,marginBottom:22}}>
            Le compte @{pendingDeletion.username} sera définitivement supprimé dans <b style={{color:C.white}}>{pendingDeletion.daysLeft} jour{pendingDeletion.daysLeft>1?"s":""}</b>. Tu peux annuler maintenant pour tout récupérer.
          </div>
          <button onClick={cancelDeletion} disabled={cancelling} style={{width:"100%",padding:"14px",borderRadius:14,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:15,cursor:cancelling?"not-allowed":"pointer",marginBottom:10}}>
            {cancelling?"...":"Annuler la suppression"}
          </button>
          <button onClick={()=>setPendingDeletion(null)} disabled={cancelling} style={{width:"100%",padding:"12px",borderRadius:14,border:"none",background:"transparent",color:C.w3,fontWeight:600,fontSize:14,cursor:"pointer"}}>
            Retour
          </button>
        </div>
      </div>
    );
  }

  return(
    <div style={{minHeight:"100dvh",background:"linear-gradient(160deg,"+C.navy+" 0%,"+C.navy2+" 50%,#1a3a6b 100%)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24,fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{marginBottom:32,textAlign:"center"}}>
        <div style={{width:72,height:72,borderRadius:20,background:"linear-gradient(135deg,"+C.accent+","+C.light+")",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px",fontSize:32,boxShadow:"0 0 40px "+C.accent+"44"}}>🌊</div>
        <div style={{fontFamily:"'Segoe UI',system-ui,sans-serif",fontSize:42,fontWeight:900,color:C.white,letterSpacing:-1}}>Blue Life</div>
        <div style={{color:C.w3,fontSize:13,marginTop:6,letterSpacing:2,textTransform:"uppercase"}}>Social Network</div>
      </div>
      <div style={{background:C.w5,backdropFilter:"blur(20px)",borderRadius:24,padding:28,width:"100%",maxWidth:380,border:"1px solid "+C.border}}>
        <div style={{display:"flex",gap:4,marginBottom:20,background:"rgba(0,0,0,0.2)",borderRadius:14,padding:4}}>
          {["login","register"].map(m=>(
            <button key={m} onClick={()=>{setMode(m);setError("");setSuccess("");}} style={{flex:1,padding:"10px 0",borderRadius:10,border:"none",background:mode===m?"linear-gradient(135deg,"+C.accent+",#1e4d8c)":"transparent",color:mode===m?C.white:C.w3,fontWeight:700,cursor:"pointer",fontSize:14,transition:"all 0.2s"}}>
              {m==="login"?"Connexion":"Inscription"}
            </button>
          ))}
        </div>
        {mode==="login"&&!selectedAccount&&rememberedAccounts.length>0&&(
          <div style={{marginBottom:18}}>
            <div style={{color:C.w3,fontSize:12,marginBottom:10}}>Comptes récents</div>
            <div style={{display:"flex",gap:10,overflowX:"auto"}}>
              {rememberedAccounts.map((acc,i)=>(
                <div key={i} onClick={()=>reconnectWithToken(acc)} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:6,cursor:"pointer",minWidth:64,position:"relative"}}>
                  <button onClick={e=>forgetRememberedAccount(e,acc.username)} style={{position:"absolute",top:-4,right:2,background:"rgba(0,0,0,0.6)",border:"none",borderRadius:"50%",width:18,height:18,color:"#fff",fontSize:11,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1}}>✕</button>
                  <Avatar src={acc.avatar||""} name={acc.username} size={56}/>
                  <span style={{fontSize:11,color:C.w3,maxWidth:64,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>@{acc.username}</span>
                </div>
              ))}
            </div>
          </div>
        )}
        {mode==="register"&&(
          <>
            <input value={username} onChange={e=>setUsername(e.target.value.replace(/[^a-zA-Z0-9_.]/g,""))} placeholder="Nom d'utilisateur (@jean_doe)" style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",boxSizing:"border-box",marginBottom:10}}/>
            <input value={bio} onChange={e=>setBio(e.target.value)} placeholder="Bio (optionnel)" style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",boxSizing:"border-box",marginBottom:10}}/>
            <div style={{display:"flex",gap:8,marginBottom:10}}>
              <input value={age} onChange={e=>setAge(e.target.value.replace(/[^0-9]/g,"").slice(0,3))} placeholder="Âge" inputMode="numeric" style={{width:90,padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",boxSizing:"border-box"}}/>
              <select value={nationality} onChange={e=>setNationality(e.target.value)} style={{flex:1,padding:"13px 10px",borderRadius:12,border:"1px solid "+C.border,background:C.navy,color:nationality?C.white:C.w3,fontSize:14,outline:"none"}}>
                <option value="">Nationalité</option>
                {WORLD_COUNTRIES.map((c,i)=><option key={i} value={c}>{c}</option>)}
              </select>
            </div>
          </>
        )}
        {selectedAccount?(
          <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16,padding:"10px 12px",background:C.w5,borderRadius:12,border:"1px solid "+C.border}}>
            <Avatar src={selectedAccount.avatar||""} name={selectedAccount.username} size={40}/>
            <div style={{flex:1}}>
              <div style={{color:C.white,fontWeight:700,fontSize:14}}>@{selectedAccount.username}</div>
              <span onClick={()=>{setSelectedAccount(null);setEmail("");}} style={{color:C.accent2,fontSize:12,cursor:"pointer"}}>Ce n'est pas toi ?</span>
            </div>
          </div>
        ):(
          <>
            <div style={{display:"flex",gap:8,marginBottom:10}}>
              {["email","phone"].map(m=>(
                <button key={m} onClick={()=>setMethod(m)} style={{flex:1,padding:"9px",borderRadius:10,border:"1px solid "+(method===m?C.accent:C.border),background:method===m?C.accent+"22":"transparent",color:method===m?C.accent2:C.w3,fontSize:13,fontWeight:600,cursor:"pointer"}}>
                  {m==="email"?"📧 Email":"📱 Téléphone"}
                </button>
              ))}
            </div>
            {method==="email"?(
              <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email" type="email" onKeyDown={e=>e.key==="Enter"&&submit()} style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",boxSizing:"border-box",marginBottom:10}}/>
            ):(
              <div style={{marginBottom:10}}>
                <div style={{display:"flex",gap:8}}>
                  <select value={phoneCode} onChange={e=>setPhoneCode(e.target.value)} style={{width:100,padding:"13px 8px",borderRadius:12,border:"1px solid "+C.border,background:C.navy,color:C.white,fontSize:13,outline:"none"}}>
                    {COUNTRY_CODES.map((c,i)=><option key={i} value={c.c}>{c.f} {c.c}</option>)}
                  </select>
                  <input value={phone} onChange={e=>setPhone(e.target.value)} placeholder="Numéro" type="tel" style={{flex:1,padding:"13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none"}}/>
                </div>
              </div>
            )}
          </>
        )}
        <div style={{position:"relative",marginBottom:16}}>
          <input value={password} onChange={e=>setPassword(e.target.value)} placeholder="Mot de passe" type={showPass?"text":"password"} onKeyDown={e=>e.key==="Enter"&&submit()} style={{width:"100%",padding:"13px 48px 13px 16px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:15,outline:"none",boxSizing:"border-box"}}/>
          <button onClick={()=>setShowPass(!showPass)} style={{position:"absolute",right:14,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:C.w3,cursor:"pointer"}}><I.Eye on={showPass}/></button>
        </div>
        {mode==="login"&&(
          <div style={{textAlign:"right",marginBottom:16,marginTop:-8}}>
            <span onClick={()=>{resetForgotFlow();setForgotEmail(email);setShowForgotPassword(true);}} style={{color:C.accent2,fontSize:13,cursor:"pointer"}}>Mot de passe oublié ?</span>
          </div>
        )}
        {error&&<div style={{background:"rgba(239,68,68,0.15)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:12}}>{error}</div>}
        {debugInfo&&<div style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:10,padding:"10px 14px",color:C.w3,fontSize:11,marginBottom:12,wordBreak:"break-word",fontFamily:"monospace"}}>{debugInfo}</div>}
        {success&&<div style={{background:"rgba(34,197,94,0.15)",border:"1px solid rgba(34,197,94,0.3)",borderRadius:10,padding:"10px 14px",color:"#4ade80",fontSize:13,marginBottom:12}}>{success}</div>}
        {emailLoginAccounts.length>0?(
          <>
            <div style={{color:C.w3,fontSize:13,marginBottom:10}}>Plusieurs comptes utilisent cet email. Choisis le tien :</div>
            {emailLoginAccounts.map((acc,i)=>(
              <button key={i} onClick={()=>{setEmailLoginAccounts([]);submit(acc.auth_email||email);}} style={{width:"100%",display:"flex",alignItems:"center",gap:12,padding:"12px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,marginBottom:10,cursor:"pointer",textAlign:"left"}}>
                <Avatar src={acc.avatar||""} name={acc.username} size={40}/>
                <div>
                  <div style={{color:C.white,fontWeight:700,fontSize:14}}>{acc.display_name||acc.username}</div>
                  <div style={{color:C.w3,fontSize:12}}>@{acc.username}</div>
                </div>
              </button>
            ))}
            <button onClick={()=>setEmailLoginAccounts([])} style={{width:"100%",padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Annuler</button>
          </>
        ):(
        <button onClick={()=>submit(selectedAccount?selectedAccount.loginEmail:undefined)} disabled={loading} style={{width:"100%",padding:"14px 0",borderRadius:12,border:"none",background:loading?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:800,fontSize:16,cursor:loading?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
          {loading?<><I.Spin/> {t("loading")}</>:mode==="login"?t("login"):t("register")}
        </button>
        )}
        {onGuest&&(
          <button onClick={onGuest} style={{width:"100%",padding:"12px 0",borderRadius:12,border:"none",background:"transparent",color:C.w3,fontWeight:600,fontSize:14,cursor:"pointer",marginTop:8}}>
            {t("noAccount")} →
          </button>
        )}
      </div>

      {showForgotPassword&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:800,display:"flex",alignItems:"center",justifyContent:"center",padding:24}} onClick={()=>{setShowForgotPassword(false);resetForgotFlow();}}>
          <div onClick={e=>e.stopPropagation()} style={{background:C.navy2,borderRadius:20,padding:26,width:"100%",maxWidth:360,border:"1px solid "+C.border}}>

            {forgotStep==="choose"&&(
              <>
                <div style={{color:C.white,fontWeight:800,fontSize:17,marginBottom:6}}>Mot de passe oublié ?</div>
                <div style={{color:C.w3,fontSize:13,marginBottom:16}}>Que veux-tu changer ?</div>
                <button onClick={()=>{setForgotWhat("password");setForgotStep("identify");}} style={{width:"100%",padding:"14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:600,textAlign:"left",marginBottom:10,cursor:"pointer"}}>🔑 Mot de passe</button>
                <button onClick={()=>{setForgotWhat("email");setForgotStep("identify");}} style={{width:"100%",padding:"14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:600,textAlign:"left",marginBottom:10,cursor:"pointer"}}>📧 Adresse email</button>
                <button onClick={()=>{setForgotWhat("phone");setForgotStep("identify");}} style={{width:"100%",padding:"14px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:600,textAlign:"left",marginBottom:14,cursor:"pointer"}}>📱 Numéro de téléphone</button>
                <button onClick={()=>{setShowForgotPassword(false);resetForgotFlow();}} style={{width:"100%",padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Fermer</button>
              </>
            )}

            {forgotStep==="identify"&&(
              <>
                <div style={{color:C.white,fontWeight:800,fontSize:17,marginBottom:6}}>Vérifions que c'est bien toi</div>
                <div style={{color:C.w3,fontSize:13,marginBottom:8}}>Entre ton email actuel, on t'envoie un code de vérification.</div>
                <div style={{color:C.w3,fontSize:12,marginBottom:16,fontStyle:"italic"}}>Cette fonctionnalité prend en charge uniquement les comptes créés par email pour le moment — pas encore les comptes créés par numéro de téléphone.</div>
                <input value={forgotEmail} onChange={e=>setForgotEmail(e.target.value)} placeholder="Email" type="email" onKeyDown={e=>e.key==="Enter"&&forgotSendCode()} style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>
                {forgotError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{forgotError}</div>}
                <div style={{display:"flex",gap:10}}>
                  <button onClick={()=>setForgotStep("choose")} style={{flex:1,padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Retour</button>
                  <button onClick={forgotSendCode} disabled={forgotSending} style={{flex:2,padding:"13px",borderRadius:12,border:"none",background:forgotSending?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:forgotSending?"not-allowed":"pointer"}}>{forgotSending?"Envoi...":"Envoyer le code"}</button>
                </div>
              </>
            )}

            {forgotStep==="code"&&(
              <>
                <div style={{color:C.white,fontWeight:800,fontSize:17,marginBottom:6}}>Vérification</div>
                <div style={{color:C.w3,fontSize:13,marginBottom:16}}>Code envoyé à {forgotEmail}</div>
                <input value={forgotCode} onChange={e=>setForgotCode(e.target.value)} placeholder="123456" inputMode="numeric" onKeyDown={e=>e.key==="Enter"&&forgotVerifyCode()} style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:16,outline:"none",marginBottom:14,boxSizing:"border-box",textAlign:"center",letterSpacing:4}}/>
                {forgotError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{forgotError}</div>}
                <div style={{display:"flex",gap:10}}>
                  <button onClick={()=>setForgotStep("identify")} style={{flex:1,padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Retour</button>
                  <button onClick={forgotVerifyCode} disabled={forgotSending} style={{flex:2,padding:"13px",borderRadius:12,border:"none",background:forgotSending?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:forgotSending?"not-allowed":"pointer"}}>{forgotSending?"Vérification...":"Vérifier"}</button>
                </div>
              </>
            )}

            {forgotStep==="pickAccount"&&(
              <>
                <div style={{color:C.white,fontWeight:800,fontSize:17,marginBottom:6}}>Plusieurs comptes trouvés</div>
                <div style={{color:C.w3,fontSize:13,marginBottom:16}}>Cet email est utilisé par {forgotAccounts.length} comptes. Choisis celui à modifier.</div>
                {forgotAccounts.map((acc,i)=>(
                  <button key={i} onClick={()=>{setForgotUsername(acc.username);setForgotStep(forgotWhat==="password"?"password":forgotWhat==="email"?"email_new":"phone_new");}} style={{width:"100%",display:"flex",alignItems:"center",gap:12,padding:"12px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,marginBottom:10,cursor:"pointer",textAlign:"left"}}>
                    <Avatar src={acc.avatar||""} name={acc.username} size={40}/>
                    <div>
                      <div style={{color:C.white,fontWeight:700,fontSize:14}}>{acc.display_name||acc.username}</div>
                      <div style={{color:C.w3,fontSize:12}}>@{acc.username}</div>
                    </div>
                  </button>
                ))}
                <button onClick={()=>{setShowForgotPassword(false);resetForgotFlow();}} style={{width:"100%",padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Annuler</button>
              </>
            )}

            {forgotStep==="password"&&(
              <>
                <div style={{color:C.white,fontWeight:800,fontSize:17,marginBottom:16}}>Nouveau mot de passe</div>
                <input value={forgotNewPassword} onChange={e=>setForgotNewPassword(e.target.value)} placeholder="Au moins 6 caractères" type="password" onKeyDown={e=>e.key==="Enter"&&forgotApplyPassword()} style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>
                {forgotError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{forgotError}</div>}
                <div style={{display:"flex",gap:10}}>
                  <button onClick={()=>setForgotStep("choose")} style={{flex:1,padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Retour</button>
                  <button onClick={forgotApplyPassword} disabled={forgotSending} style={{flex:2,padding:"13px",borderRadius:12,border:"none",background:forgotSending?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:forgotSending?"not-allowed":"pointer"}}>{forgotSending?"...":"Confirmer"}</button>
                </div>
              </>
            )}

            {forgotStep==="email_new"&&(
              <>
                <div style={{color:C.white,fontWeight:800,fontSize:17,marginBottom:16}}>Nouvelle adresse email</div>
                <input value={forgotNewEmail} onChange={e=>setForgotNewEmail(e.target.value)} placeholder="nouveau@email.com" type="email" onKeyDown={e=>e.key==="Enter"&&forgotApplyEmail()} style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>
                {forgotError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{forgotError}</div>}
                <div style={{display:"flex",gap:10}}>
                  <button onClick={()=>setForgotStep("choose")} style={{flex:1,padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Retour</button>
                  <button onClick={forgotApplyEmail} disabled={forgotSending} style={{flex:2,padding:"13px",borderRadius:12,border:"none",background:forgotSending?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:forgotSending?"not-allowed":"pointer"}}>{forgotSending?"...":"Confirmer"}</button>
                </div>
              </>
            )}

            {forgotStep==="phone_new"&&(
              <>
                <div style={{color:C.white,fontWeight:800,fontSize:17,marginBottom:16}}>Nouveau numéro de téléphone</div>
                <input value={forgotNewPhone} onChange={e=>setForgotNewPhone(e.target.value)} placeholder="+237 6xx xx xx xx" type="tel" onKeyDown={e=>e.key==="Enter"&&forgotApplyPhone()} style={{width:"100%",padding:"12px 14px",borderRadius:10,border:"1px solid "+C.border,background:C.w5,color:C.white,fontSize:14,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>
                {forgotError&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:10,padding:"10px 14px",color:"#f87171",fontSize:13,marginBottom:14}}>{forgotError}</div>}
                <div style={{display:"flex",gap:10}}>
                  <button onClick={()=>setForgotStep("choose")} style={{flex:1,padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:600,cursor:"pointer"}}>Retour</button>
                  <button onClick={forgotApplyPhone} disabled={forgotSending} style={{flex:2,padding:"13px",borderRadius:12,border:"none",background:forgotSending?"rgba(10,10,10,0.15)":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:forgotSending?"not-allowed":"pointer"}}>{forgotSending?"...":"Confirmer"}</button>
                </div>
              </>
            )}

            {forgotStep==="done"&&(
              <>
                <div style={{textAlign:"center",marginBottom:16}}>
                  <div style={{fontSize:36,marginBottom:10}}>✅</div>
                  <div style={{color:C.white,fontWeight:800,fontSize:17}}>C'est fait !</div>
                  <div style={{color:C.w3,fontSize:13,marginTop:8,lineHeight:1.5}}>Tu peux maintenant te connecter avec tes nouvelles informations.</div>
                </div>
                <button onClick={()=>{setShowForgotPassword(false);resetForgotFlow();}} style={{width:"100%",padding:"13px",borderRadius:12,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:"pointer"}}>Fermer</button>
              </>
            )}

          </div>
        </div>
      )}
    </div>
  );
}

function ReelItem({p,isActive,onProfile,showToast,user,onRequireAuth,onOpenSound,followingUsernames}){
  const vidRef=useRef(null);
  const safeUser=user||{username:"",isGuest:true};
  const [liked,setLiked]=useState(()=>hasLikedLocally(p&&p.id,safeUser.username));
  const [likes,setLikes]=useState(()=>getCachedPostField(p&&p.id,"likes_count",p&&p.likes_count||0));
  const likedRef=useRef(hasLikedLocally(p&&p.id,safeUser.username));
  const likesRef=useRef(getCachedPostField(p&&p.id,"likes_count",p&&p.likes_count||0));
  const [commentsCount,setCommentsCount]=useState(()=>{
    const fromComments=getLocalComments(p&&p.id).length;
    return fromComments>0?fromComments:getCachedPostField(p&&p.id,"comments_count",p&&p.comments_count||0);
  });
  const [showComments,setShowComments]=useState(false);
  const [showShare,setShowShare]=useState(false);
  const [showGift,setShowGift]=useState(false);
  const [giftsReceived,setGiftsReceived]=useState(p&&p.gifts_received||0);
  const [saved,setSaved]=useState(()=>isPostSaved(safeUser.username,p&&p.id));
  const [paused,setPaused]=useState(false);
  const [heart,setHeart]=useState(false);
  const [muted,setMuted]=useState(false);
  const [showOptions,setShowOptions]=useState(false);
  const [isDeleted,setIsDeleted]=useState(false);
  const [displayCaption,setDisplayCaption]=useState(p&&p.caption);
  const isMe=(p.username||"").toLowerCase()===(safeUser.username||"").toLowerCase();
  const [pipActive,setPipActive]=useState(false);
  const pipSupported=typeof document!=="undefined"&&document.pictureInPictureEnabled;

  const [justFollowed,setJustFollowed]=useState(false);
  const isFollowingAuthor=isMe?false:(justFollowed||(followingUsernames||[]).includes(p.username));

  useEffect(()=>{
    if(!p||!p.id||String(p.id).startsWith("local_"))return;
    fetch(SUPABASE_URL+"/rest/v1/rpc/increment_views",{
      method:"POST",
      headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json"},
      body:JSON.stringify({p_post_id:p.id})
    }).catch(()=>{});
  },[p&&p.id]);

  async function followAuthor(e){
    e.stopPropagation();
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("follow");return;}
    setJustFollowed(true);
    try{
      const res=await fetch(SUPABASE_URL+"/rest/v1/Follows",{
        method:"POST",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({follower:safeUser.username,following:p.username})
      });
      const data=await res.json().catch(()=>null);
      if(!res.ok||!Array.isArray(data)||data.length===0){
        if(data&&data.code==="23505")return;
        setJustFollowed(false);
        return;
      }
      db("/notifications",{method:"POST",body:JSON.stringify({receiver:p.username,sender:safeUser.username,type:"follow",seen:false})}).catch(()=>{});
    }catch{setJustFollowed(false);}
  }

  const replacementAudioRef=useRef(null);
  const [replacementAudioUrl,setReplacementAudioUrl]=useState(null);
  useEffect(()=>{
    if(!p.muted_original||!p.audio_id){setReplacementAudioUrl(null);return;}
    db("/audio_tracks?id=eq."+p.audio_id+"&select=audio_url&limit=1").then(d=>{
      if(Array.isArray(d)&&d[0])setReplacementAudioUrl(d[0].audio_url);
    }).catch(()=>{});
  },[p.audio_id,p.muted_original]);

  useEffect(()=>{
    if(!vidRef.current)return;
    const el=vidRef.current;
    if(isActive&&!paused){
      if(p.trim_start)el.currentTime=p.trim_start;
      if(p.muted_original){
        el.muted=true;
        el.play().catch(()=>{});
        if(replacementAudioRef.current){replacementAudioRef.current.currentTime=0;replacementAudioRef.current.play().catch(()=>{});}
      }else{
        el.muted=true;
        const playPromise=el.play();
        if(playPromise&&playPromise.then){
          playPromise.then(()=>{ if(el){el.muted=false;setMuted(false);} }).catch(()=>{});
        }
      }
    }else{
      el.pause();
      if(replacementAudioRef.current)replacementAudioRef.current.pause();
    }
  },[isActive,paused]);

  useEffect(()=>{
    const el=vidRef.current;
    if(!el||!p.trim_end)return;
    function onTimeUpdate(){
      if(el.currentTime>=p.trim_end){
        el.currentTime=p.trim_start||0;
        if(replacementAudioRef.current){replacementAudioRef.current.currentTime=0;}
      }
    }
    el.addEventListener("timeupdate",onTimeUpdate);
    return()=>el.removeEventListener("timeupdate",onTimeUpdate);
  },[p.trim_start,p.trim_end]);

  function refreshCommentsCount(){
    setCommentsCount(getLocalComments(p&&p.id).length);
  }

  async function doLike(){
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("like");return;}
    if(likedRef.current)return;
    likedRef.current=true;likesRef.current=likesRef.current+1;
    setLiked(true);setLikes(likesRef.current);setHeart(true);setTimeout(()=>setHeart(false),900);
    persistPostChange(p.id,{likes_count:likesRef.current});
    persistLikedState(p.id,safeUser.username,true);
    if(!p.id||String(p.id).startsWith("local_"))return;
    try{
      await fetch(SUPABASE_URL+"/rest/v1/Posts?id=eq."+p.id,{
        method:"PATCH",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({likes_count:likesRef.current})
      });
      if(p.username!==safeUser.username){
        db("/notifications",{method:"POST",body:JSON.stringify({receiver:p.username,sender:safeUser.username,type:"like",post_id:p.id,seen:false})}).catch(()=>{});
      }
    }catch{}
  }
  async function toggleLike(e){
    e&&e.stopPropagation();
    if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("like");return;}
    if(!liked){await doLike();}
    else{
      const newLikes=Math.max(0,likes-1);
      likesRef.current=newLikes;likedRef.current=false;
      setLiked(false);setLikes(newLikes);
      persistPostChange(p.id,{likes_count:newLikes});
      persistLikedState(p.id,safeUser.username,false);
      if(!p.id||String(p.id).startsWith("local_"))return;
      fetch(SUPABASE_URL+"/rest/v1/Posts?id=eq."+p.id,{
        method:"PATCH",headers:{apikey:SUPABASE_ANON_KEY,Authorization:"Bearer "+(_currentUserToken||SUPABASE_ANON_KEY),"Content-Type":"application/json",Prefer:"return=minimal"},
        body:JSON.stringify({likes_count:newLikes})
      }).catch(()=>{});
    }
  }

  function togglePip(e){
    e&&e.stopPropagation();
    if(!vidRef.current||!pipSupported)return;
    if(document.pictureInPictureElement){
      document.exitPictureInPicture().catch(()=>{});
    }else{
      vidRef.current.requestPictureInPicture().then(()=>setPipActive(true)).catch(()=>{
        showToast&&showToast("⚠️ Picture-in-Picture non disponible");
      });
    }
  }
  useEffect(()=>{
    const vid=vidRef.current;
    if(!vid)return;
    const onEnterPip=()=>setPipActive(true);
    const onLeavePip=()=>setPipActive(false);
    vid.addEventListener("enterpictureinpicture",onEnterPip);
    vid.addEventListener("leavepictureinpicture",onLeavePip);
    return()=>{
      vid.removeEventListener("enterpictureinpicture",onEnterPip);
      vid.removeEventListener("leavepictureinpicture",onLeavePip);
    };
  },[]);

  if(isDeleted)return null;

  return(
    <div style={{position:"relative",width:"100%",height:"100%",background:"#000",overflow:"hidden"}} onClick={()=>setPaused(p=>!p)}>
      {showComments&&<CommentsPanel post={p} user={safeUser} onClose={()=>{setShowComments(false);refreshCommentsCount();}} showToast={showToast}/>}
      {showShare&&<ShareSheet
        link={window.location.origin+window.location.pathname+"?post="+p.id}
        shareText={p.caption||"Regarde cette vidéo sur Blue Life !"}
        storyImage={cloudinaryVideoThumbnail(p.image)}
        storyCaption={"🔁 Repartagé de @"+p.username}
        repost={{image:p.image,caption:p.caption,type:"video",originalUsername:p.username,originalPostId:p.id}}
        currentUser={safeUser} onClose={()=>setShowShare(false)} showToast={showToast} onRequireAuth={onRequireAuth}
      />}
      {showGift&&<GiftSheet post={{...p,gifts_received:giftsReceived}} user={safeUser} onClose={()=>setShowGift(false)} showToast={showToast} onGiftSent={(newTotal)=>setGiftsReceived(newTotal)} onRequireAuth={onRequireAuth}/>}
      {showOptions&&<PostOptionsSheet
        post={{...p,caption:displayCaption}}
        isOwner={isMe}
        currentUser={safeUser}
        onClose={()=>setShowOptions(false)}
        showToast={showToast}
        onRequireAuth={onRequireAuth}
        onDeleted={()=>setIsDeleted(true)}
        onCaptionUpdated={(c)=>setDisplayCaption(c)}
        onPinToggled={()=>{}}
      />}

      <video ref={vidRef} src={p.image} loop muted={p.muted_original?true:muted} playsInline style={{width:"100%",height:"100%",objectFit:"cover"}}/>
      {replacementAudioUrl&&<audio ref={replacementAudioRef} src={replacementAudioUrl} loop muted={muted}/>}

      <button onClick={(e)=>{e.stopPropagation();setMuted(m=>!m);}} style={{position:"absolute",top:14,right:56,zIndex:20,background:"rgba(0,0,0,0.35)",border:"none",borderRadius:8,width:34,height:34,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
        {muted?
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>:
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>
        }
      </button>

      {pipSupported&&(
        <button onClick={togglePip} style={{position:"absolute",top:14,right:14,zIndex:20,background:"rgba(0,0,0,0.35)",border:"none",borderRadius:8,width:34,height:34,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" style={{filter:"drop-shadow(0 1px 3px rgba(0,0,0,0.5))"}}><rect x="2" y="4" width="20" height="16" rx="2"/><rect x="12" y="12" width="8" height="6" rx="1" fill={pipActive?C.accent2:"#fff"} stroke="none"/></svg>
        </button>
      )}

      {paused&&<div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",pointerEvents:"none"}}><div style={{width:70,height:70,borderRadius:"50%",background:"rgba(0,0,0,0.4)",display:"flex",alignItems:"center",justifyContent:"center"}}><I.Play a={true}/></div></div>}
      {heart&&<div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",pointerEvents:"none"}}><div style={{fontSize:100,animation:"heartPop 0.9s ease forwards"}}>❤️</div></div>}

      <div style={{position:"absolute",bottom:0,left:0,right:80,padding:"0 14px 20px",color:"#fff"}}>
        <div onClick={(e)=>{e.stopPropagation();onProfile&&onProfile(p.username,p.avatar,p.page_id);}} style={{display:"flex",alignItems:"center",gap:8,marginBottom:10,cursor:"pointer"}}>
          <Avatar src={p.avatar||""} name={p.username} size={34} border="#fff"/>
          <span style={{fontWeight:700,fontSize:14,textShadow:"0 1px 3px rgba(0,0,0,0.5)",display:"flex",alignItems:"center",gap:5}}>
            @{p.username}
            {isBadgeActive(p)&&(
              <svg width="13" height="13" viewBox="0 0 24 24" fill="#3897f0" style={{flexShrink:0}}>
                <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
                <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </span>
          {!isMe&&isFollowingAuthor===false&&(
            <button onClick={followAuthor} style={{background:"rgba(255,255,255,0.2)",border:"1px solid rgba(255,255,255,0.5)",borderRadius:8,padding:"3px 10px",color:"#fff",cursor:"pointer",fontSize:11,fontWeight:700,marginLeft:4}}>Suivre</button>
          )}
        </div>
        {displayCaption&&<CaptionText text={displayCaption} maxChars={90} maxLines={2} style={{fontSize:13,textShadow:"0 1px 3px rgba(0,0,0,0.5)"}}/>}
      </div>

      <div style={{position:"absolute",right:10,bottom:20,display:"flex",flexDirection:"column",alignItems:"center",gap:20}}>
        <div onClick={toggleLike} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer"}}>
          <div style={{color:liked?"#ff3040":"#fff",transform:liked?"scale(1.15)":"scale(1)",transition:"transform 0.2s",filter:"drop-shadow(0 1px 3px rgba(0,0,0,0.5))"}}><I.Heart a={liked}/></div>
          <span style={{color:"#fff",fontSize:11,fontWeight:700,textShadow:"0 1px 3px rgba(0,0,0,0.5)"}}>{fmt(likes)}</span>
        </div>
        <div onClick={(e)=>{e.stopPropagation();if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("comment");return;}setShowComments(true);}} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer"}}>
          <div style={{color:"#fff",filter:"drop-shadow(0 1px 3px rgba(0,0,0,0.5))"}}><I.Chat/></div>
          <span style={{color:"#fff",fontSize:11,fontWeight:700,textShadow:"0 1px 3px rgba(0,0,0,0.5)"}}>{commentsCount}</span>
        </div>
        <div onClick={(e)=>{e.stopPropagation();if(!safeUser.username||safeUser.isGuest){onRequireAuth&&onRequireAuth("login");return;}const nowSaved=toggleSavedPost(safeUser.username,p);setSaved(nowSaved);showToast&&showToast(nowSaved?"🔖 Enregistré":"Retiré des enregistrements");}} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer"}}>
          <div style={{color:saved?C.accent2:"#fff",filter:"drop-shadow(0 1px 3px rgba(0,0,0,0.5))"}}><I.Save a={saved}/></div>
        </div>
        {!isCurrentlyBoosted(p)&&(
          <div onClick={(e)=>{e.stopPropagation();setShowGift(true);}} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer"}}>
            <div style={{fontSize:24,filter:"drop-shadow(0 1px 3px rgba(0,0,0,0.5))"}}>🎁</div>
            {giftsReceived>0&&<span style={{color:"#f0b90b",fontSize:11,fontWeight:700,textShadow:"0 1px 3px rgba(0,0,0,0.5)"}}>{fmt(giftsReceived)}</span>}
          </div>
        )}
        <div onClick={(e)=>{e.stopPropagation();setShowShare(true);}} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer"}}>
          <div style={{color:"#fff",filter:"drop-shadow(0 1px 3px rgba(0,0,0,0.5))"}}><I.Share/></div>
        </div>
        <div onClick={(e)=>{e.stopPropagation();setShowOptions(true);}} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer"}}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff" style={{filter:"drop-shadow(0 1px 3px rgba(0,0,0,0.5))"}}><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg>
        </div>
        {p.audio_id&&(
          <div onClick={(e)=>{e.stopPropagation();onOpenSound&&onOpenSound({id:p.audio_id,title:p.audio_title});}} style={{width:34,height:34,borderRadius:"50%",overflow:"hidden",cursor:"pointer",border:"2px solid rgba(255,255,255,0.7)",animation:"spin2 4s linear infinite",filter:"drop-shadow(0 1px 3px rgba(0,0,0,0.5))"}}>
            {p.avatar
              ?<img src={p.avatar} alt="" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
              :<div style={{width:"100%",height:"100%",background:"linear-gradient(135deg,"+C.accent+","+C.purple+")",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}>🎵</div>
            }
          </div>
        )}
      </div>
    </div>
  );
}

function ReelsScreen({posts,currentUser,onProfile,showToast,onRequireAuth,tabMode,onOpenSound,followingUsernames}){
  const t=useTranslation();
  const [active,setActive]=useState(0);
  const containerRef=useRef(null);
  const safeUser=currentUser||{username:"",isGuest:true};
  const [followedUsernames,setFollowedUsernames]=useState(null);
  const isSuivis=tabMode==="suivis";

  useEffect(()=>{
    setActive(0);
    if(containerRef.current)containerRef.current.scrollTop=0;
  },[tabMode]);

  useEffect(()=>{
    if(!isSuivis)return;
    if(!safeUser.username||safeUser.isGuest){setFollowedUsernames([]);return;}
    db("/Follows?follower=eq."+encodeURIComponent(safeUser.username)+"&select=following").then(d=>{
      setFollowedUsernames(Array.isArray(d)?d.map(f=>f.following):[]);
    }).catch(()=>setFollowedUsernames([]));
  },[safeUser.username,isSuivis]);

  const videos=!isSuivis
    ? posts.filter(p=>p.type==="video")
    : (followedUsernames||[]).length===0?[]:posts.filter(p=>p.type==="video"&&followedUsernames.includes(p.username));

  function handleScroll(){
    if(!containerRef.current)return;
    const h=containerRef.current.clientHeight;
    const idx=Math.round(containerRef.current.scrollTop/h);
    if(idx!==active)setActive(idx);
  }

  if(isSuivis&&(!safeUser.username||safeUser.isGuest)){
    return <div style={{height:"100%",display:"flex",alignItems:"center",justifyContent:"center",color:C.w3,background:"#000",textAlign:"center",padding:24}}>Connecte-toi pour voir les vidéos des comptes que tu suis</div>;
  }
  if(isSuivis&&followedUsernames===null){
    return <div style={{height:"100%",display:"flex",alignItems:"center",justifyContent:"center",color:C.w3,background:"#000"}}><I.Spin/></div>;
  }
  if(videos.length===0){
    return <div style={{height:"100%",display:"flex",alignItems:"center",justifyContent:"center",color:C.w3,background:"#000",textAlign:"center",padding:24}}>{isSuivis?(followedUsernames.length===0?"Suis des comptes pour voir leurs vidéos ici":t("noVideoYet")):t("noReelYet")}</div>;
  }

  return(
    <div ref={containerRef} onScroll={handleScroll} style={{height:"100%",overflowY:"scroll",scrollSnapType:"y mandatory",background:"#000"}}>
      {videos.map((p,i)=>(
        <div key={i} style={{height:"100%",scrollSnapAlign:"start"}}>
          <ReelItem p={p} isActive={i===active} onProfile={onProfile} showToast={showToast} user={currentUser} onRequireAuth={onRequireAuth} onOpenSound={onOpenSound} followingUsernames={followingUsernames}/>
        </div>
      ))}
    </div>
  );
}

function SuspendedScreen({suspension}){
  return(
    <div style={{position:"fixed",inset:0,background:C.navy,display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:28}}>
      <div style={{textAlign:"center",maxWidth:340}}>
        <div style={{width:72,height:72,borderRadius:20,background:"rgba(240,101,74,0.12)",border:"1px solid rgba(240,101,74,0.3)",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 20px",fontSize:32}}>🚫</div>
        <div style={{fontFamily:"'Segoe UI',system-ui,sans-serif",fontSize:22,fontWeight:900,color:C.white,letterSpacing:-0.5,marginBottom:10}}>Blue Life n'est pas disponible</div>
        <div style={{color:C.w3,fontSize:14,lineHeight:1.6,marginBottom:14}}>
          L'application n'est actuellement pas accessible dans ton pays{suspension.reason?" : "+suspension.reason:"."}
        </div>
        <div style={{color:C.w3,fontSize:12,fontWeight:600}}>
          {suspension.suspended_until
            ?"Accès prévu à nouveau le "+new Date(suspension.suspended_until).toLocaleDateString("fr-FR",{day:"numeric",month:"long",year:"numeric"})
            :"Suspension pour une durée indéterminée"}
        </div>
      </div>
    </div>
  );
}

function SplashScreen(){
  const img=typeof splashImg!=="undefined"?splashImg:null;
  return(
    <div style={{position:"fixed",inset:0,background:C.navy,display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999}}>
      {img
        ?<img src={img} alt="" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
        :<div style={{textAlign:"center"}}>
            <div style={{width:88,height:88,borderRadius:24,background:"linear-gradient(135deg,"+C.accent+","+C.light+")",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 18px",fontSize:40,boxShadow:"0 0 50px "+C.accent+"55",animation:"pulse 1.6s ease-in-out infinite"}}>🌊</div>
            <div style={{fontFamily:"'Segoe UI',system-ui,sans-serif",fontSize:36,fontWeight:900,color:C.white,letterSpacing:-1}}>Blue Life</div>
          </div>
      }
    </div>
  );
}

export default function App(){
  const t=useTranslation();
  const [, forceLangUpdate]=useState(0);
  useEffect(()=>{
    const listener=()=>forceLangUpdate(n=>n+1);
    _langListeners.add(listener);
    return ()=>_langListeners.delete(listener);
  },[]);

  // Country-level suspension check, applies to everyone (even guests) and
  // runs before anything else loads, same detection method already used
  // for monetization eligibility - IP-based, no permission prompt.
  const [suspensionCheck,setSuspensionCheck]=useState({checked:false,suspended:null});
  useEffect(()=>{
    fetch("https://ipapi.co/json/").then(r=>r.json()).then(async d=>{
      const code=d&&d.country_code?d.country_code.toUpperCase():null;
      if(!code){setSuspensionCheck({checked:true,suspended:null});return;}
      const rows=await db("/country_suspensions?country_code=eq."+code).catch(()=>null);
      const row=Array.isArray(rows)&&rows[0]?rows[0]:null;
      const active=row&&(!row.suspended_until||new Date(row.suspended_until).getTime()>Date.now());
      setSuspensionCheck({checked:true,suspended:active?row:null});
    }).catch(()=>setSuspensionCheck({checked:true,suspended:null}));
  },[]);

  const [auth,setAuth]=useState(()=>{
    try{
      const saved=localStorage.getItem("bl_auth_v3");
      return saved?JSON.parse(saved):null;
    }catch{return null;}
  });
  // Default to guest browsing (TikTok-style: feed/explore/reels visible to
  // everyone) - only gated behind AuthScreen once someone actively chooses
  // to log in, via GuestPrompt's "onAuth" path below.
  const [guestMode,setGuestMode]=useState(true);
  const [showSplash,setShowSplash]=useState(true);
  const [tab,setTab]=useState("home");
  const [posts,setPosts]=useState([]);
  const [loadingPosts,setLoadingPosts]=useState(true);
  const [stories,setStories]=useState([]);
  const [showAddMenu,setShowAddMenu]=useState(false);
  const [showNewPost,setShowNewPost]=useState(false);
  const [showNewStory,setShowNewStory]=useState(false);
  const [showNewTextPost,setShowNewTextPost]=useState(false);
  const [showNewPoll,setShowNewPoll]=useState(false);
  const [postAsPage,setPostAsPage]=useState(null);
  const [showCreatePage,setShowCreatePage]=useState(false);
  const [showCreateGroup,setShowCreateGroup]=useState(false);
  const [viewingGroupId,setViewingGroupId]=useState(null);
  const [viewingPageId,setViewingPageId]=useState(null);
  const [presetSound,setPresetSound]=useState(null);
  const [showCamera,setShowCamera]=useState(false);
  const [capturedVideoFile,setCapturedVideoFile]=useState(null);
  const [viewProfile,setViewProfile]=useState(null);
  const [showSettings,setShowSettings]=useState(false);
  const [settingsInitialPanel,setSettingsInitialPanel]=useState(null);
  const [showCertification,setShowCertification]=useState(false);
  const [showWallet,setShowWallet]=useState(false);
  const [showAdminFinance,setShowAdminFinance]=useState(false);
  const [showAuthPrompt,setShowAuthPrompt]=useState(null);
  const [activeChat,setActiveChat]=useState(null);
  const [toast,setToast]=useState("");
  const [storyGroupToView,setStoryGroupToView]=useState(null);
  const [searchQuery,setSearchQuery]=useState("");
  const [searchResults,setSearchResults]=useState([]);
  const [videoOverlay,setVideoOverlay]=useState(null);
  const [selectedExplorePost,setSelectedExplorePost]=useState(null);
  const [soundDetail,setSoundDetail]=useState(null);
  const [liveSession,setLiveSession]=useState(null);
  const [showLivePicker,setShowLivePicker]=useState(false);

  function showToast(msg){
    setToast(msg);
    setTimeout(()=>setToast(""),2500);
  }

  useEffect(()=>{
    const timer=setTimeout(()=>setShowSplash(false),1800);
    return()=>clearTimeout(timer);
  },[]);

  // If the refresh token itself has expired (or is missing), db()/authedFetch
  // can't silently recover - every screen would otherwise sit there showing
  // "JWT expired" forever. Sign out cleanly instead so the person gets a
  // normal login screen rather than a wall of stuck error messages.
  useEffect(()=>{
    _onSessionExpired=()=>{
      setAuth(null);
      setRealAccount(null);
      _currentUserToken=null;_currentRefreshToken=null;
      try{localStorage.removeItem("bl_auth_v3");}catch{}
      showToast("Session expirée, reconnecte-toi");
    };
    return()=>{_onSessionExpired=null;};
  },[]);

  // Captures where the person is connecting from once per login, for the
  // control tool's account-location view - IP-based only (no GPS prompt),
  // same lightweight service already used for monetization eligibility.
  // Also logs the login itself (day/hour) for the traffic dashboard.
  const locationCapturedFor=useRef(null);
  useEffect(()=>{
    if(!auth||!auth.username||auth.isGuest||auth.isPage)return;
    if(locationCapturedFor.current===auth.username)return;
    locationCapturedFor.current=auth.username;
    db("/login_events",{method:"POST",headers:{Prefer:"return=minimal"},body:JSON.stringify({username:auth.username})}).catch(()=>{});
    fetch("https://ipapi.co/json/").then(r=>r.json()).then(d=>{
      if(!d||!d.country_name)return;
      db("/profiles?username=eq."+encodeURIComponent(auth.username),{method:"PATCH",headers:{Prefer:"return=minimal"},body:JSON.stringify({last_country:d.country_name,last_city:d.city||null,last_location_at:new Date().toISOString()})}).catch(()=>{});
    }).catch(()=>{});
  },[auth&&auth.username]);

  useEffect(()=>{
    if(auth&&auth.token){
      _currentUserToken=auth.token;
      _currentRefreshToken=auth.refreshToken||null;
      try{localStorage.setItem("bl_auth_v3",JSON.stringify(auth));}catch{}
    }
  },[auth]);

  useEffect(()=>{
    if(!auth||!auth.refreshToken)return;
    const interval=setInterval(()=>{
      refreshAccessToken().then(ok=>{
        if(ok){
          setAuth(prev=>prev?{...prev,token:_currentUserToken,refreshToken:_currentRefreshToken}:prev);
        }
      });
    },50*60*1000);
    return()=>clearInterval(interval);
  },[auth&&auth.refreshToken]);

  useEffect(()=>{
    if(!auth||!auth.username)return;
    function heartbeat(){
      db("/profiles?username=eq."+encodeURIComponent(auth.username),{method:"PATCH",body:JSON.stringify({last_seen:new Date().toISOString()})}).catch(()=>{});
    }
    heartbeat();
    const interval=setInterval(heartbeat,45000);
    return()=>clearInterval(interval);
  },[auth&&auth.username]);

  useEffect(()=>{
    loadDisplayRate();
  },[]);

  const currentUser=auth?{...auth,isGuest:false}:(guestMode?{username:"",isGuest:true}:null);

  // A Page/Groupe is just a profiles row with no login of its own, managed
  // by a real account. "Switching to" one works exactly like switching
  // accounts: auth itself becomes the Page's identity (name/avatar/bio/
  // wallet/verified all read from ITS OWN profile row), while the real
  // JWT token is kept so writes still pass RLS. realAccount remembers who
  // to switch back to.
  const [realAccount,setRealAccount]=useState(null);
  function switchToPage(pageProfile){
    setRealAccount(auth);
    setAuth({
      token:auth.token,refreshToken:auth.refreshToken,
      username:pageProfile.username,displayName:pageProfile.display_name,avatar:pageProfile.avatar||"",
      bio:pageProfile.bio||"",email:pageProfile.email,phoneCode:"",
      verified:!!pageProfile.verified,verified_until:pageProfile.verified_until||null,
      wallet_balance:pageProfile.wallet_balance||0,earnings_balance:pageProfile.earnings_balance||0,
      coins_balance:pageProfile.coins_balance||0,gift_coins_balance:pageProfile.gift_coins_balance||0,
      isPage:true,managedBy:realAccount?realAccount.username:auth.username,
      pageRole:pageProfile._role||"owner",pagePermission:pageProfile._role==="owner"?"full":(pageProfile._permission||"limited"),
    });
    setTab("home");
    showToast("Tu navigues maintenant en tant que "+pageProfile.display_name);
  }
  function exitPageMode(){
    if(realAccount){setAuth(realAccount);setRealAccount(null);}
    setTab("home");
  }

  const [blockedUsers,setBlockedUsers]=useState([]);
  useEffect(()=>{
    if(!auth||!auth.username){setBlockedUsers([]);return;}
    db("/blocks?blocker=eq."+encodeURIComponent(auth.username)+"&select=blocked").then(d=>{
      setBlockedUsers(Array.isArray(d)?d.map(b=>b.blocked):[]);
    }).catch(()=>{});
  },[auth&&auth.username]);

  // Fetched once instead of one /Follows request per post rendered - this
  // is what was causing the flood of "DB request timed out" console spam
  // on the feed.
  const [followingUsernames,setFollowingUsernames]=useState([]);
  useEffect(()=>{
    if(!auth||!auth.username){setFollowingUsernames([]);return;}
    db("/Follows?follower=eq."+encodeURIComponent(auth.username)+"&select=following").then(d=>{
      setFollowingUsernames(Array.isArray(d)?d.map(f=>f.following):[]);
    }).catch(()=>{});
  },[auth&&auth.username]);

  // Groups the person is a member of - a group post only ever surfaces in
  // the home feed for members, public or private, so this never leaks a
  // private group's content to non-members browsing Home.
  const [myGroupIds,setMyGroupIds]=useState([]);
  useEffect(()=>{
    if(!auth||!auth.username){setMyGroupIds([]);return;}
    db("/group_members?username=eq."+encodeURIComponent(auth.username)+"&status=eq.member&select=group_id").then(d=>{
      setMyGroupIds(Array.isArray(d)?d.map(r=>r.group_id):[]);
    }).catch(()=>{});
  },[auth&&auth.username]);

  // Auto Picture-in-Picture: if a video is mid-playback and the person
  // switches away from the tab/app without pausing it first, keep it
  // playing in a floating window instead of just silently stopping -
  // matches how YouTube behaves.
  useEffect(()=>{
    if(typeof document==="undefined"||!document.pictureInPictureEnabled)return;
    function onVisibilityChange(){
      if(document.visibilityState!=="hidden")return;
      if(document.pictureInPictureElement)return;
      const playing=Array.from(document.querySelectorAll("video")).find(v=>!v.paused&&!v.ended&&v.readyState>2);
      if(playing&&playing.requestPictureInPicture){
        playing.requestPictureInPicture().catch(()=>{});
      }
    }
    document.addEventListener("visibilitychange",onVisibilityChange);
    return()=>document.removeEventListener("visibilitychange",onVisibilityChange);
  },[]);

  const [refreshing,setRefreshing]=useState(false);
  async function handleManualRefresh(){
    if(refreshing)return;
    setRefreshing(true);
    window.scrollTo({top:0,behavior:"smooth"});
    savedScrollY.current=0;
    await Promise.all([loadPosts(),loadStories()]);
    setRefreshing(false);
  }

  async function loadPosts(){
    setLoadingPosts(true);
    let localPosts=[];
    try{
      const cached=localStorage.getItem("bl_posts_cache");
      if(cached){
        const parsed=JSON.parse(cached);
        if(Array.isArray(parsed))localPosts=parsed;
      }
    }catch{}
    if(localPosts.length>0){
      setPosts(localPosts);
      setLoadingPosts(false);
    }
    try{
      const d=await db("/Posts?order=created_at.desc&limit=200&moderation_hidden=eq.false&deleted_by_admin=eq.false");
      if(Array.isArray(d)){
        // Views live in post_stats, a separate table - one batched fetch
        // for the whole feed here, merged onto each post, rather than a
        // request per post which would flood the connection.
        const realIds=d.map(p=>p.id).filter(id=>id&&!String(id).startsWith("local_"));
        let viewsByPost={};
        if(realIds.length>0){
          const stats=await db("/post_stats?post_id=in.("+realIds.join(",")+")&select=post_id,views").catch(()=>[]);
          if(Array.isArray(stats))stats.forEach(s=>{viewsByPost[s.post_id]=s.views||0;});
        }
        const dWithViews=d.map(p=>({...p,views:viewsByPost[p.id]||0}));
        const serverIds=new Set(dWithViews.map(p=>String(p.id)));
        const localOnly=localPosts.filter(p=>String(p.id).startsWith("local_")&&!serverIds.has(String(p.id)));
        const merged=[...localOnly,...dWithViews];
        setPosts(merged);
        try{localStorage.setItem("bl_posts_cache",JSON.stringify(merged));}catch{}
      }
    }catch(e){console.warn("loadPosts:",e);}
    setLoadingPosts(false);
  }

  async function loadStories(){
    try{
      const cutoff=new Date(Date.now()-86400000).toISOString();
      const d=await db("/stories?created_at=gt."+cutoff+"&order=created_at.desc");
      setStories(Array.isArray(d)?d:[]);
    }catch(e){console.warn("loadStories:",e);}
  }

  useEffect(()=>{
    loadPosts();
    loadStories();
    const interval=setInterval(()=>{loadPosts();loadStories();},60000);
    return()=>clearInterval(interval);
  },[]);

  function postDone(newPost){
    setPosts(p=>[newPost,...p]);
    setShowNewPost(false);setShowNewTextPost(false);setShowNewPoll(false);
    setPresetSound(null);setPostAsPage(null);setCapturedVideoFile(null);
    showToast("✅ Publié !");
    try{
      const cached=localStorage.getItem("bl_posts_cache");
      const parsed=cached?JSON.parse(cached):[];
      localStorage.setItem("bl_posts_cache",JSON.stringify([newPost,...(Array.isArray(parsed)?parsed:[])]));
    }catch{}
  }

  function storyDone(newStories){
    const arr=Array.isArray(newStories)?newStories:[newStories];
    setStories(s=>[...arr,...s]);
    setShowNewStory(false);
    showToast(arr.length>1?"✅ "+arr.length+" stories publiées !":"✅ Story publiée !");
  }

  function requireAuth(reason){
    setShowAuthPrompt(reason||"login");
  }

  function handleLogout(){
    setAuth(null);
    try{localStorage.removeItem("bl_auth_v3");}catch{}
    _currentUserToken=null;_currentRefreshToken=null;
    setShowSettings(false);
    setTab("home");
  }

  function handleSwitchAccount(acc){
    setAuth(acc);
    _currentUserToken=acc.token;_currentRefreshToken=acc.refreshToken||null;
    setShowSettings(false);
    setTab("home");
    showToast("Basculé vers @"+acc.username);
  }

  const [searchGroupResults,setSearchGroupResults]=useState([]);
  useEffect(()=>{
    if(!searchQuery.trim()){setSearchResults([]);setSearchGroupResults([]);return;}
    const timer=setTimeout(async()=>{
      try{
        const d=await db("/profiles?username=ilike.*"+encodeURIComponent(searchQuery.trim())+"*&limit=20");
        setSearchResults(Array.isArray(d)?d:[]);
      }catch{setSearchResults([]);}
      try{
        const g=await db("/groups?name=ilike.*"+encodeURIComponent(searchQuery.trim())+"*&limit=10");
        setSearchGroupResults(Array.isArray(g)?g:[]);
      }catch{setSearchGroupResults([]);}
    },300);
    return()=>clearTimeout(timer);
  },[searchQuery]);

  const visiblePosts=posts.filter(p=>p&&(p.image||p.type==="text"||p.type==="poll")&&!blockedUsers.includes(p.username)&&(!p.group_id||myGroupIds.includes(p.group_id)));

  const scoredPosts=(()=>{
    const now=Date.now();
    return visiblePosts.map(p=>{
      let score=0;
      const ageHours=(now-new Date(p.created_at).getTime())/3600000;
      score+=Math.max(0,72-ageHours);
      score+=(p.likes_count||0)*0.5;
      if(isCurrentlyBoosted(p))score+=Math.random()*120;
      return{...p,_score:score};
    }).sort((a,b)=>b._score-a._score);
  })();

  const storyGroups=(()=>{
    const byAuthor={};
    stories.forEach(s=>{
      if(blockedUsers.includes(s.author))return;
      if(!byAuthor[s.author])byAuthor[s.author]=[];
      byAuthor[s.author].push(s);
    });
    const seenSet=auth&&auth.username?getSeenStories(auth.username):new Set();
    const groups=Object.keys(byAuthor).map(author=>{
      const authorStories=byAuthor[author].sort((a,b)=>new Date(a.created_at)-new Date(b.created_at));
      const allSeen=authorStories.every(s=>seenSet.has(String(s.id)));
      return{author,stories:authorStories,allSeen,isMe:auth&&author===auth.username};
    });
    groups.sort((a,b)=>{
      if(a.isMe&&!b.isMe)return -1;
      if(b.isMe&&!a.isMe)return 1;
      if(a.allSeen!==b.allSeen)return a.allSeen?1:-1;
      return new Date(b.stories[b.stories.length-1].created_at)-new Date(a.stories[a.stories.length-1].created_at);
    });
    return groups;
  })();

  function openStoryGroup(authorIdx){
    const allGroups=storyGroups.map(g=>g.stories);
    setStoryGroupToView({allGroups,startGroupIdx:authorIdx});
  }

  const savedScrollY=useRef(0);
  function changeTab(newTab){
    if(tab==="home")savedScrollY.current=window.scrollY;
    setTab(newTab);
  }
  function openProfile(username,avatar,pageId){
    if(tab==="home")savedScrollY.current=window.scrollY;
    if(pageId){setViewingPageId(pageId);return;}
    setViewProfile({username,avatar});
    setTab("profile_other");
  }

  useEffect(()=>{
    if(tab==="home")window.scrollTo(0,savedScrollY.current);
  },[tab]);

  const addMenuButtons=(postAsPage?[
    {bg:"linear-gradient(135deg,#2f6fed,#1e4d8c)",icon:"🖼️",label:"Photo ou vidéo",action:()=>{setShowAddMenu(false);setShowNewPost(true);}},
    {bg:"linear-gradient(135deg,#64748b,#475569)",icon:"📝",label:"Publier un texte",action:()=>{setShowAddMenu(false);setShowNewTextPost(true);}},
    {bg:"linear-gradient(135deg,#f5a623,#e08e0b)",icon:"📊",label:"Créer un sondage",action:()=>{setShowAddMenu(false);setShowNewPoll(true);}},
  ]:[
    {bg:"linear-gradient(135deg,#2f6fed,#1e4d8c)",icon:"🖼️",label:"Photo ou vidéo",action:()=>{setShowAddMenu(false);auth?setShowNewPost(true):setShowAuthPrompt("post");}},
    {bg:"linear-gradient(135deg,#f5576c,#f093fb)",icon:"📖",label:"Story",action:()=>{setShowAddMenu(false);auth?setShowNewStory(true):setShowAuthPrompt("post");}},
    {bg:"linear-gradient(135deg,#64748b,#475569)",icon:"📝",label:"Publier un texte",action:()=>{setShowAddMenu(false);auth?setShowNewTextPost(true):setShowAuthPrompt("post");}},
    {bg:"linear-gradient(135deg,#f5a623,#e08e0b)",icon:"📊",label:"Créer un sondage",action:()=>{setShowAddMenu(false);auth?setShowNewPoll(true):setShowAuthPrompt("post");}},
  ]);

  if(showSplash)return <SplashScreen/>;

  if(suspensionCheck.checked&&suspensionCheck.suspended){
    return <SuspendedScreen suspension={suspensionCheck.suspended}/>;
  }

  if(!auth&&!guestMode){
    return <AuthScreen onAuth={(a)=>{setAuth(a);setGuestMode(false);}} onGuest={()=>{setGuestMode(true);try{localStorage.setItem("bl_guest_mode","true");}catch{}}}/>;
  }

  return(
    <div style={{minHeight:"100dvh",background:C.navy,maxWidth:480,margin:"0 auto",position:"relative",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <style>{`
        @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
        @keyframes spin2{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
        @keyframes pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.08)}}
        @keyframes fadeIn{from{opacity:0;transform:translate(-50%,-10px)}to{opacity:1;transform:translate(-50%,0)}}
        @keyframes slideUp{from{transform:translateY(30px);opacity:0}to{transform:translateY(0);opacity:1}}
        @keyframes heartPop{0%{transform:scale(0);opacity:0}15%{transform:scale(1.3);opacity:1}30%{transform:scale(1)}100%{transform:scale(1);opacity:0}}
        @keyframes avatarPulse{0%,100%{opacity:0.5}50%{opacity:0.8}}
        * { box-sizing: border-box; }
        html, body, #root { display:block !important; place-items:normal !important; min-height:auto !important; max-width:none !important; width:auto !important; padding:0 !important; margin:0 !important; text-align:left !important; }
        body { background:${C.navy}; }
        input, textarea, select { font-family: inherit; }
        ::-webkit-scrollbar{width:0;height:0;background:transparent;}
      `}</style>

      <Toast msg={toast}/>

      {tab==="home"&&(
        <>
          <div style={{position:"sticky",top:0,zIndex:50,background:C.navy,borderBottom:"1px solid "+C.border,padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <span style={{fontFamily:"'Segoe UI',system-ui,sans-serif",fontSize:24,fontWeight:900,color:C.accent,letterSpacing:-0.5}}>Blue Life</span>
            <div style={{display:"flex",gap:16,alignItems:"center"}}>
              <div onClick={handleManualRefresh} style={{cursor:refreshing?"default":"pointer",color:C.white,display:"flex",animation:refreshing?"spin 1s linear infinite":"none"}}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
              </div>
              <div onClick={()=>changeTab("messages")} style={{cursor:"pointer",color:C.white,display:"flex"}}><I.Msg/></div>
            </div>
          </div>

          <div style={{display:"flex",gap:14,padding:"14px 16px",overflowX:"auto"}}>
            <div onClick={()=>{
                if(!auth){setShowAuthPrompt("post");return;}
                const myGroupIdx=storyGroups.findIndex(g=>g.isMe);
                if(myGroupIdx>=0)openStoryGroup(myGroupIdx);
                else setShowNewStory(true);
              }} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:5,cursor:"pointer",flexShrink:0}}>
              <div style={{position:"relative",width:60,height:60}}>
                {(()=>{
                  const myGroup=storyGroups.find(g=>g.isMe);
                  return myGroup
                    ?<div style={{width:60,height:60,borderRadius:"50%",padding:2,background:myGroup.allSeen?C.border:"linear-gradient(135deg,"+C.accent+","+C.light+")"}}>
                        <img src={myGroup.stories[0].image} alt="" style={{width:"100%",height:"100%",borderRadius:"50%",objectFit:"cover",display:"block",border:"2px solid "+C.navy}}/>
                      </div>
                    :<Avatar src={auth&&auth.avatar||""} name={auth?auth.username:"?"} size={60} border={C.border}/>;
                })()}
                <div onClick={(e)=>{e.stopPropagation();auth?setShowNewStory(true):setShowAuthPrompt("post");}} style={{position:"absolute",bottom:-2,right:-2,width:20,height:20,borderRadius:"50%",background:C.accent,display:"flex",alignItems:"center",justifyContent:"center",border:"2px solid "+C.navy,color:"#fff",fontSize:13,fontWeight:800}}>+</div>
              </div>
              <span style={{fontSize:11,color:C.w3}}>Ta story</span>
            </div>
            {storyGroups.map((g,i)=>!g.isMe&&(
              <div key={i} onClick={()=>openStoryGroup(i)} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:5,cursor:"pointer",flexShrink:0}}>
                <div style={{width:60,height:60,borderRadius:"50%",padding:2,background:g.allSeen?C.border:"linear-gradient(135deg,"+C.accent+","+C.light+")"}}>
                  <img src={g.stories[0].image} alt="" style={{width:"100%",height:"100%",borderRadius:"50%",objectFit:"cover",display:"block",border:"2px solid "+C.navy}}/>
                </div>
                <span style={{fontSize:11,color:C.w3,maxWidth:60,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{g.author}</span>
              </div>
            ))}
          </div>

          <div style={{padding:"0 0 70px"}}>
            {loadingPosts&&posts.length===0?(
              <div style={{textAlign:"center",padding:60,color:C.w3}}><I.Spin/></div>
            ):scoredPosts.length===0?(
              <div style={{textAlign:"center",padding:60,color:C.w3}}>{t("noPostYet")}</div>
            ):(
              scoredPosts.map((p,i)=>(
                <PostCard key={p.id||i} post={p} user={currentUser} onProfile={openProfile} showToast={showToast} onRequireAuth={requireAuth} onOpenVideo={(vids,idx)=>setVideoOverlay({videos:vids,startIdx:idx})} followingUsernames={followingUsernames}/>
              ))
            )}
          </div>
        </>
      )}

      {tab==="explore"&&(
        <div style={{minHeight:"100dvh",paddingBottom:70}}>
          <div style={{position:"sticky",top:0,zIndex:50,background:C.navy,borderBottom:"1px solid "+C.border,padding:"14px 16px"}}>
            <div style={{display:"flex",alignItems:"center",background:C.w5,borderRadius:12,padding:"10px 14px",gap:8,border:"1px solid "+C.border}}>
              <I.Search a={false}/>
              <input value={searchQuery} onChange={e=>setSearchQuery(e.target.value)} placeholder={t("search")} style={{background:"none",border:"none",outline:"none",flex:1,fontSize:14,color:C.white}}/>
            </div>
          </div>
          {searchQuery.trim()?(
            <div style={{padding:16}}>
              {searchResults.length===0&&searchGroupResults.length===0?(
                <div style={{textAlign:"center",padding:40,color:C.w3}}>{t("noResults")} "{searchQuery}"</div>
              ):(
                <>
                  {searchGroupResults.length>0&&(
                    <>
                      <div style={{color:C.w3,fontSize:12,fontWeight:700,textTransform:"uppercase",marginBottom:6}}>Groupes</div>
                      {searchGroupResults.map((g,i)=>(
                        <div key={i} onClick={()=>setViewingGroupId(g.id)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:"1px solid "+C.border,cursor:"pointer"}}>
                          <div style={{width:44,height:44,borderRadius:10,backgroundImage:g.cover?"url("+g.cover+")":"linear-gradient(135deg,"+C.accent+",#1e4d8c)",backgroundSize:"cover",backgroundPosition:"center",flexShrink:0}}/>
                          <div>
                            <div style={{color:C.white,fontWeight:700,fontSize:14}}>{g.name}</div>
                            <div style={{color:C.w3,fontSize:12}}>👥 {g.privacy==="private"?"Groupe privé":"Groupe public"} · {fmt(g.members_count)} membre{g.members_count>1?"s":""}</div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                  {searchResults.length>0&&(
                    <>
                      {searchGroupResults.length>0&&<div style={{color:C.w3,fontSize:12,fontWeight:700,textTransform:"uppercase",margin:"14px 0 6px"}}>Comptes</div>}
                      {searchResults.map((u,i)=>(
                        <div key={i} onClick={()=>openProfile(u.username,u.avatar)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:"1px solid "+C.border,cursor:"pointer"}}>
                          <Avatar src={u.avatar||""} name={u.username} size={44}/>
                          <div>
                            <div style={{display:"flex",alignItems:"center",gap:5}}>
                              <span style={{color:C.white,fontWeight:700,fontSize:14}}>{u.display_name||u.username}</span>
                              {isBadgeActive(u)&&(
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="#3897f0" style={{flexShrink:0}}>
                                  <path d="M12 1l2.5 2.5L18 2l1 3.5L22.5 6l-1 3.5L24 12l-2.5 2.5L22.5 18 19 19l-1 3.5L14.5 21 12 23.5 9.5 21 6 22.5 5 19l-3.5-1L2.5 14.5 0 12l2.5-2.5L1.5 6 5 5l1-3.5L9.5 2.5 12 1z"/>
                                  <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              )}
                            </div>
                            <div style={{color:C.w3,fontSize:12}}>@{u.username}</div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}
            </div>
          ):(
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:2,padding:2}}>
              {[...visiblePosts].sort(()=>Math.random()-0.5).map((p,i)=>(
                <div key={i} onClick={()=>{
                  if(p.type==="video"){
                    const vids=visiblePosts.filter(x=>x.type==="video");
                    setVideoOverlay({videos:vids,startIdx:vids.indexOf(p)});
                    return;
                  }
                  setSelectedExplorePost(p);
                }} style={{aspectRatio:"1/1",overflow:"hidden",cursor:"pointer",position:"relative",background:"#000"}}>
                  {p.type==="text"
                    ?<div style={{width:"100%",height:"100%",background:p.text_bg||("linear-gradient(135deg,"+C.accent+",#1e4d8c)"),display:"flex",alignItems:"center",justifyContent:"center",padding:8,boxSizing:"border-box"}}>
                        <div style={{color:"#fff",fontSize:10,fontWeight:700,lineHeight:1.3,textAlign:"center",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:5,WebkitBoxOrient:"vertical"}}>{p.caption}</div>
                      </div>
                    :p.type==="poll"
                    ?<div style={{width:"100%",height:"100%",background:"linear-gradient(135deg,#2f6fed,#1e4d8c)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:8,boxSizing:"border-box"}}>
                        <div style={{fontSize:20,marginBottom:4}}>📊</div>
                        <div style={{color:"#fff",fontSize:10,fontWeight:700,lineHeight:1.3,textAlign:"center",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:3,WebkitBoxOrient:"vertical"}}>{p.caption}</div>
                      </div>
                    :p.type==="video"
                    ?<img src={cloudinaryVideoThumbnail(p.image)} alt="" style={{width:"100%",height:"100%",objectFit:"cover",display:"block",background:"#000"}}/>
                    :<GridThumbnail src={p.image}/>
                  }
                  {p.type==="video"&&<div style={{position:"absolute",top:4,right:4,background:"rgba(0,0,0,0.5)",borderRadius:"50%",width:20,height:20,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:"white"}}>▶</div>}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {(tab==="reels"||tab==="video")&&(
        <div style={{height:"100dvh",paddingBottom:0}}>
          <button onClick={()=>setTab("home")} style={{position:"absolute",top:14,left:16,zIndex:70,background:"none",border:"none",cursor:"pointer",color:"#fff",filter:"drop-shadow(0 1px 3px rgba(0,0,0,0.6))",display:"flex"}}>
            <I.Back/>
          </button>
          <div style={{position:"absolute",top:14,left:0,right:0,zIndex:60,display:"flex",justifyContent:"center",gap:24}}>
            <span onClick={()=>setTab("reels")} style={{color:tab==="reels"?"#fff":"rgba(255,255,255,0.5)",fontWeight:800,fontSize:16,cursor:"pointer",textShadow:"0 1px 3px rgba(0,0,0,0.5)"}}>{t("reels")}</span>
            <span onClick={()=>setTab("video")} style={{color:tab==="video"?"#fff":"rgba(255,255,255,0.5)",fontWeight:800,fontSize:16,cursor:"pointer",textShadow:"0 1px 3px rgba(0,0,0,0.5)"}}>Suivis</span>
          </div>
          <ReelsScreen posts={visiblePosts} currentUser={currentUser} onProfile={openProfile} showToast={showToast} onRequireAuth={requireAuth} tabMode={tab==="video"?"suivis":"reels"} onOpenSound={(track)=>setSoundDetail(track)} followingUsernames={followingUsernames}/>
        </div>
      )}

      {tab==="messages"&&(
        <MessagesTab currentUser={currentUser} onBack={()=>setTab("home")} onOpenChat={(r)=>setActiveChat(r)} onProfile={openProfile} showToast={showToast}/>
      )}

      {tab==="notifications"&&(
        <NotificationsTab currentUser={currentUser} onBack={()=>setTab("home")} onProfile={openProfile} showToast={showToast} onOpenGroup={(id)=>setViewingGroupId(id)}/>
      )}

      {tab==="profile"&&auth&&(
        <ProfileScreen username={auth.username} avatar={auth.avatar} bio={auth.bio} displayName={auth.displayName} isMe={true} currentUser={auth} inTab={true}
          onSettings={(panel)=>{setSettingsInitialPanel(panel||null);setShowSettings(true);}}
          onCertification={()=>setShowCertification(true)}
          onWallet={()=>setShowWallet(true)}
          onUpdateAvatar={(url)=>setAuth(a=>({...a,avatar:url}))}
          onUpdateProfile={(u)=>setAuth(a=>({...a,...u}))}
          showToast={showToast}
          onOpenVideo={(vids,idx)=>setVideoOverlay({videos:vids,startIdx:idx})}
        />
      )}
      {tab==="profile"&&!auth&&guestMode&&(
        <div style={{minHeight:"100dvh",display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:48,marginBottom:16}}>👤</div>
            <div style={{color:C.white,fontWeight:700,fontSize:17,marginBottom:8}}>{t("needAccount")}</div>
            <div style={{color:C.w3,fontSize:14,marginBottom:20}}>{t("needAccountDesc")}</div>
            <button onClick={()=>setShowAuthPrompt("login")} style={{padding:"12px 28px",borderRadius:12,border:"none",background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",color:"#fff",fontWeight:700,cursor:"pointer"}}>{t("login")}</button>
          </div>
        </div>
      )}

      {tab==="profile_other"&&viewProfile&&(
        <ProfileScreen username={viewProfile.username} avatar={viewProfile.avatar} isMe={false} currentUser={currentUser} inTab={true}
          onMessage={(r)=>setActiveChat(r)}
          showToast={showToast}
          onOpenVideo={(vids,idx)=>setVideoOverlay({videos:vids,startIdx:idx})}
        />
      )}

      {tab!=="reels"&&tab!=="video"&&(
        <div style={{position:"fixed",bottom:0,left:0,right:0,maxWidth:480,margin:"0 auto",background:C.navy,borderTop:"1px solid "+C.border,display:"flex",justifyContent:"space-around",padding:"10px 0 22px",zIndex:100}}>
          {[
            {key:"home",icon:<I.Home a={tab==="home"}/>},
            {key:"explore",icon:<I.Search a={tab==="explore"}/>},
            {key:"add",icon:<I.Plus/>,special:true},
            {key:"reels",icon:<I.Play a={tab==="reels"||tab==="video"}/>},
            {key:"notifications",icon:<I.Bell a={tab==="notifications"}/>},
            {key:"profile",icon:auth?<Avatar src={auth.avatar||""} name={auth.username} size={26} border={tab==="profile"?C.accent:C.border}/>:<I.User a={tab==="profile"}/>},
          ].map(item=>(
            <div key={item.key} onClick={()=>item.key==="add"?setShowAddMenu(true):changeTab(item.key)} style={{color:tab===item.key?C.accent:C.w2,cursor:"pointer",padding:"4px 14px",display:"flex",alignItems:"center",justifyContent:"center",borderTop:tab===item.key?"2px solid "+C.accent:"2px solid transparent"}}>
              {item.icon}
            </div>
          ))}
        </div>
      )}

      {showAddMenu&&(
        <div style={{position:"fixed",inset:0,zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div onClick={()=>setShowAddMenu(false)} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)"}}/>
          <div style={{position:"relative",background:C.navy2,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:"20px 16px 32px",border:"1px solid "+C.border}}>
            <div style={{width:36,height:4,borderRadius:2,background:C.w4,margin:"6px auto 20px"}}/>
            {addMenuButtons.map((b,i)=>(
              <button key={i} onClick={b.action} style={{width:"100%",display:"flex",alignItems:"center",gap:14,padding:"14px 12px",background:C.w5,borderRadius:14,border:"none",cursor:"pointer",textAlign:"left",marginBottom:10}}>
                <div style={{width:44,height:44,borderRadius:12,background:b.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{b.icon}</div>
                <span style={{fontSize:15,color:C.white,fontWeight:700}}>{b.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {showCamera&&<CameraCapture sound={presetSound} onClose={()=>{setShowCamera(false);setPresetSound(null);}} onCaptured={(file)=>{setShowCamera(false);setCapturedVideoFile(file);setShowNewPost(true);}}/>}
      {showNewPost&&auth&&<NewPost user={auth} onBack={()=>{setShowNewPost(false);setPresetSound(null);setPostAsPage(null);setCapturedVideoFile(null);}} onDone={postDone} showToast={showToast} presetSound={presetSound} postAsPage={postAsPage} initialVideoFile={capturedVideoFile} initialMutedOriginal={!!capturedVideoFile}/>}
      {showNewStory&&auth&&<NewStory user={auth} onBack={()=>setShowNewStory(false)} onDone={storyDone}/>}
      {showNewTextPost&&auth&&<TextPost user={auth} onBack={()=>{setShowNewTextPost(false);setPostAsPage(null);}} onDone={postDone} showToast={showToast} postAsPage={postAsPage}/>}
      {showNewPoll&&auth&&<NewPoll user={auth} onBack={()=>{setShowNewPoll(false);setPostAsPage(null);}} onDone={postDone} showToast={showToast} postAsPage={postAsPage}/>}

      {showSettings&&auth&&<Settings user={auth} onBack={()=>{setShowSettings(false);setSettingsInitialPanel(null);}} onLogout={handleLogout}
        onCertification={()=>{setShowSettings(false);setShowCertification(true);}}
        onWallet={()=>{setShowSettings(false);setShowWallet(true);}}
        onAdminFinance={()=>{setShowSettings(false);setShowAdminFinance(true);}}
        showToast={showToast} initialPanel={settingsInitialPanel}
        onSwitchAccount={handleSwitchAccount}
        onAddAccount={()=>{setShowSettings(false);setAuth(null);_currentUserToken=null;_currentRefreshToken=null;}}
        onCreatePage={()=>{setShowSettings(false);setShowCreatePage(true);}}
        onOpenPage={(pageUsername)=>{setShowSettings(false);openProfile(pageUsername,"");}}
        onSwitchToPage={(pageProfile)=>{setShowSettings(false);switchToPage(pageProfile);}}
        onExitPageMode={()=>{setShowSettings(false);exitPageMode();}}
        onCreateGroup={()=>{setShowSettings(false);setShowCreateGroup(true);}}
        onOpenGroup={(groupId)=>{setShowSettings(false);setViewingGroupId(groupId);}}
      />}
      {showCreatePage&&auth&&<CreatePageScreen user={auth} onBack={()=>setShowCreatePage(false)} onCreated={(page)=>{setShowCreatePage(false);switchToPage(page);}} showToast={showToast}/>}
      {showCreateGroup&&auth&&<CreateGroupScreen user={auth} onBack={()=>setShowCreateGroup(false)} onCreated={(group)=>{setShowCreateGroup(false);if(group)setViewingGroupId(group.id);}} showToast={showToast}/>}
      {viewingGroupId&&<GroupScreen groupId={viewingGroupId} currentUser={currentUser} onBack={()=>setViewingGroupId(null)} onProfile={openProfile} showToast={showToast} onOpenVideo={(vids,idx)=>setVideoOverlay({videos:vids,startIdx:idx})}/>}
      {showCertification&&auth&&<CertificationFlow user={auth} onClose={()=>setShowCertification(false)} onCertified={(until)=>setAuth(a=>({...a,verified:true,verified_until:until}))} showToast={showToast}/>}
      {showWallet&&auth&&<WalletScreen user={auth} onClose={()=>setShowWallet(false)} onBalanceUpdate={(fields)=>setAuth(a=>({...a,...fields}))} showToast={showToast}/>}
      {showAdminFinance&&auth&&<AdminFinanceScreen username={auth.username} onClose={()=>setShowAdminFinance(false)}/>}

      {showAuthPrompt&&(
        <GuestPrompt onClose={()=>setShowAuthPrompt(null)} onAuth={()=>{setShowAuthPrompt(null);setGuestMode(false);setAuth(null);try{localStorage.removeItem("bl_guest_mode");}catch{}}}/>
      )}

      {activeChat&&currentUser&&<ChatScreen currentUser={currentUser} receiver={activeChat} onBack={()=>setActiveChat(null)} showToast={showToast}/>}

      {storyGroupToView&&<StoryViewer allGroups={storyGroupToView.allGroups} startGroupIdx={storyGroupToView.startGroupIdx} onClose={()=>setStoryGroupToView(null)} currentUser={currentUser} onProfile={openProfile}/>}

      {videoOverlay&&<VideoOverlayPlayer videos={videoOverlay.videos} startIdx={videoOverlay.startIdx} onClose={()=>setVideoOverlay(null)} onProfile={openProfile} showToast={showToast} onRequireAuth={requireAuth} user={currentUser} onOpenSound={(track)=>setSoundDetail(track)} followingUsernames={followingUsernames}/>}

      {selectedExplorePost&&(
        <div style={{position:"fixed",inset:0,background:C.navy,zIndex:600,maxWidth:480,margin:"0 auto",display:"flex",flexDirection:"column",overflowY:"auto"}}>
          <div style={{display:"flex",alignItems:"center",padding:"14px",background:C.navy2,borderBottom:"1px solid "+C.border,position:"sticky",top:0,zIndex:2}}>
            <button onClick={()=>setSelectedExplorePost(null)} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
          </div>
          <PostCard post={selectedExplorePost} user={currentUser} onProfile={(u,a)=>{setSelectedExplorePost(null);openProfile(u,a);}} showToast={showToast} onRequireAuth={requireAuth} onOpenVideo={(vids,idx)=>setVideoOverlay({videos:vids,startIdx:idx})} followingUsernames={followingUsernames}/>
        </div>
      )}

      {soundDetail&&<SoundDetailScreen audioId={soundDetail.id} audioTitle={soundDetail.title} onClose={()=>setSoundDetail(null)} onProfile={openProfile} onUseSound={(track)=>{setSoundDetail(null);setPresetSound(track);setShowCamera(true);}}/>}

      {liveSession&&auth&&<LiveScreen user={auth} mode={liveSession.mode} streamUsername={liveSession.streamUsername} onClose={()=>setLiveSession(null)} showToast={showToast}/>}
    </div>
  );
}

function MessagesTab({currentUser,onBack,onOpenChat,onProfile,showToast}){
  const [conversations,setConversations]=useState([]);
  const [loading,setLoading]=useState(true);
  const safeUser=currentUser||{username:"",isGuest:true};

  useEffect(()=>{
    if(!safeUser.username||safeUser.isGuest){setLoading(false);return;}
    (async()=>{
      try{
        const d=await db("/messages?or=(sender.eq."+encodeURIComponent(safeUser.username)+",receiver.eq."+encodeURIComponent(safeUser.username)+")&order=created_at.desc&limit=300");
        if(!Array.isArray(d)){setLoading(false);return;}
        const byPartner={};
        d.forEach(m=>{
          const partner=m.sender===safeUser.username?m.receiver:m.sender;
          if(!byPartner[partner])byPartner[partner]=m;
        });
        const partners=Object.keys(byPartner);
        let profilesByUsername={};
        if(partners.length>0){
          const profiles=await db("/profiles?username=in.("+partners.join(",")+")&select=username,avatar,display_name").catch(()=>[]);
          if(Array.isArray(profiles))profiles.forEach(p=>{profilesByUsername[p.username]=p;});
        }
        const list=partners.map(partner=>({
          username:partner,
          avatar:(profilesByUsername[partner]&&profilesByUsername[partner].avatar)||"",
          displayName:(profilesByUsername[partner]&&profilesByUsername[partner].display_name)||partner,
          lastMessage:byPartner[partner].text,
          lastTime:byPartner[partner].created_at,
          isMine:byPartner[partner].sender===safeUser.username
        })).sort((a,b)=>new Date(b.lastTime)-new Date(a.lastTime));
        setConversations(list);
      }catch(e){console.warn("conversations:",e);}
      setLoading(false);
    })();
  },[safeUser.username]);

  return(
    <div style={{minHeight:"100dvh",paddingBottom:70}}>
      <div style={{position:"sticky",top:0,zIndex:50,background:C.navy,borderBottom:"1px solid "+C.border,padding:"14px 16px",display:"flex",alignItems:"center",gap:12}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white}}>Messages</span>
      </div>
      {!safeUser.username||safeUser.isGuest?(
        <div style={{textAlign:"center",padding:50,color:C.w3}}>Connecte-toi pour voir tes messages</div>
      ):loading?(
        <div style={{textAlign:"center",padding:50,color:C.w3}}><I.Spin/></div>
      ):conversations.length===0?(
        <div style={{textAlign:"center",padding:50,color:C.w3}}>Aucune conversation pour l'instant</div>
      ):(
        conversations.map((c,i)=>(
          <div key={i} onClick={()=>onOpenChat({username:c.username,avatar:c.avatar,displayName:c.displayName})} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 16px",borderBottom:"1px solid "+C.border,cursor:"pointer"}}>
            <Avatar src={c.avatar} name={c.username} size={48}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{color:C.white,fontWeight:700,fontSize:14}}>{c.displayName}</div>
              <div style={{color:C.w3,fontSize:13,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.isMine?"Toi: ":""}{c.lastMessage}</div>
            </div>
            <div style={{color:C.w3,fontSize:11,flexShrink:0}}>{ago(c.lastTime)}</div>
          </div>
        ))
      )}
    </div>
  );
}

function NotificationsTab({currentUser,onBack,onProfile,showToast,onOpenGroup}){
  const [notifs,setNotifs]=useState([]);
  const [loading,setLoading]=useState(true);
  const [respondedInvites,setRespondedInvites]=useState({});
  const safeUser=currentUser||{username:"",isGuest:true};

  useEffect(()=>{
    if(!safeUser.username||safeUser.isGuest){setLoading(false);return;}
    (async()=>{
      try{
        const d=await db("/notifications?receiver=eq."+encodeURIComponent(safeUser.username)+"&order=created_at.desc&limit=100");
        setNotifs(Array.isArray(d)?d:[]);
        const unseenIds=Array.isArray(d)?d.filter(n=>!n.seen).map(n=>n.id):[];
        if(unseenIds.length>0){
          db("/notifications?receiver=eq."+encodeURIComponent(safeUser.username)+"&seen=eq.false",{method:"PATCH",body:JSON.stringify({seen:true})}).catch(()=>{});
        }
      }catch(e){console.warn("notifications:",e);}
      setLoading(false);
    })();
  },[safeUser.username]);

  async function respondToAdminInvite(pageUsername,accept,notifKey){
    try{
      await callRpc(accept?"accept_page_admin":"decline_page_admin",{p_page_username:pageUsername});
      setRespondedInvites(r=>({...r,[notifKey]:accept?"accepted":"declined"}));
      showToast&&showToast(accept?"✅ Tu es maintenant administrateur":"Invitation refusée");
    }catch(e){
      showToast&&showToast("⚠️ "+(e.message||"Échec, réessaie"));
    }
  }

  return(
    <div style={{minHeight:"100dvh",paddingBottom:70}}>
      <div style={{position:"sticky",top:0,zIndex:50,background:C.navy,borderBottom:"1px solid "+C.border,padding:"14px 16px",display:"flex",alignItems:"center",gap:12}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white}}>Notifications</span>
      </div>
      {!safeUser.username||safeUser.isGuest?(
        <div style={{textAlign:"center",padding:50,color:C.w3}}>Connecte-toi pour voir tes notifications</div>
      ):loading?(
        <div style={{textAlign:"center",padding:50,color:C.w3}}><I.Spin/></div>
      ):notifs.length===0?(
        <div style={{textAlign:"center",padding:50,color:C.w3}}>Aucune notification pour l'instant</div>
      ):(
        groupNotifications(notifs).map((g,i)=>{
          const first=g.items[0];
          const allSeen=g.items.every(n=>n.seen);
          const isAdminInvite=g.type==="page_admin_invite";
          const isGroupInvite=g.type==="group_invite"||g.type==="group_approved";
          const responded=respondedInvites[i];
          function handleClick(){
            if(isAdminInvite)return;
            if(isGroupInvite&&first.ref_id&&onOpenGroup){onOpenGroup(first.ref_id);return;}
            if(first.sender&&first.sender!=="Blue Life"&&onProfile)onProfile(first.sender,"");
          }
          return (
            <div key={i} onClick={handleClick} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 16px",borderBottom:"1px solid "+C.border,cursor:!isAdminInvite&&first.sender&&first.sender!=="Blue Life"?"pointer":"default",background:allSeen?"transparent":C.accent+"0a"}}>
              <div style={{width:40,height:40,borderRadius:"50%",background:C.w5,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{notifIcon(g.type)}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{color:C.white,fontSize:13,lineHeight:1.4}}>{groupedNotifText(g)}</div>
                <div style={{color:C.w3,fontSize:11,marginTop:2}}>{ago(first.created_at)}</div>
                {isAdminInvite&&!responded&&(
                  <div style={{display:"flex",gap:8,marginTop:8}} onClick={e=>e.stopPropagation()}>
                    <button onClick={()=>respondToAdminInvite(first.ref_id,true,i)} style={{padding:"7px 14px",borderRadius:8,border:"none",background:C.accent,color:"#fff",fontWeight:700,fontSize:12,cursor:"pointer"}}>Accepter</button>
                    <button onClick={()=>respondToAdminInvite(first.ref_id,false,i)} style={{padding:"7px 14px",borderRadius:8,border:"1px solid "+C.border,background:"transparent",color:C.w3,fontWeight:700,fontSize:12,cursor:"pointer"}}>Refuser</button>
                  </div>
                )}
                {isAdminInvite&&responded&&(
                  <div style={{color:responded==="accepted"?C.accent2:C.w3,fontSize:12,fontWeight:600,marginTop:6}}>
                    {responded==="accepted"?"✅ Acceptée":"Refusée"}
                  </div>
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}

function WalletScreen({user,onClose,onBalanceUpdate,showToast}){
  const [walletBalance,setWalletBalance]=useState(user.wallet_balance||0);
  const [coinsBalance,setCoinsBalance]=useState(user.coins_balance||0);
  const [giftCoinsBalance,setGiftCoinsBalance]=useState(user.gift_coins_balance||0);
  const [earningsBalance,setEarningsBalance]=useState(user.earnings_balance||0);
  const [loading,setLoading]=useState(true);
  const [screen,setScreen]=useState(null);
  const [transactions,setTransactions]=useState([]);

  useEffect(()=>{
    (async()=>{
      try{
        const rows=await db("/profiles?username=eq."+encodeURIComponent(user.username)+"&select=wallet_balance,coins_balance,gift_coins_balance,earnings_balance&limit=1");
        if(Array.isArray(rows)&&rows[0]){
          setWalletBalance(rows[0].wallet_balance||0);
          setCoinsBalance(rows[0].coins_balance||0);
          setGiftCoinsBalance(rows[0].gift_coins_balance||0);
          setEarningsBalance(rows[0].earnings_balance||0);
        }
        const tx=await db("/wallet_transactions?username=eq."+encodeURIComponent(user.username)+"&order=created_at.desc&limit=40");
        setTransactions(Array.isArray(tx)?tx:[]);
      }catch(e){console.warn("wallet load:",e);}
      setLoading(false);
    })();
  },[]);

  function refreshAll(){
    db("/profiles?username=eq."+encodeURIComponent(user.username)+"&select=wallet_balance,coins_balance,gift_coins_balance,earnings_balance&limit=1").then(rows=>{
      if(Array.isArray(rows)&&rows[0]){
        setWalletBalance(rows[0].wallet_balance||0);
        setCoinsBalance(rows[0].coins_balance||0);
        setGiftCoinsBalance(rows[0].gift_coins_balance||0);
        setEarningsBalance(rows[0].earnings_balance||0);
        onBalanceUpdate&&onBalanceUpdate(rows[0]);
      }
    }).catch(()=>{});
    db("/wallet_transactions?username=eq."+encodeURIComponent(user.username)+"&order=created_at.desc&limit=40").then(tx=>{
      setTransactions(Array.isArray(tx)?tx:[]);
    }).catch(()=>{});
  }

  if(screen==="recharge")return <RechargeWallet user={user} currentBalance={walletBalance} onClose={()=>setScreen(null)} onSuccess={(nb)=>{setWalletBalance(nb);onBalanceUpdate&&onBalanceUpdate({wallet_balance:nb});setScreen(null);refreshAll();}} showToast={showToast}/>;
  if(screen==="buyCoins")return <BuyCoinsScreen user={user} walletBalance={walletBalance} coinsBalance={coinsBalance} onClose={()=>setScreen(null)} onSuccess={(nw,nc)=>{setWalletBalance(nw);setCoinsBalance(nc);onBalanceUpdate&&onBalanceUpdate({wallet_balance:nw,coins_balance:nc});setScreen(null);refreshAll();}} showToast={showToast}/>;
  if(screen==="withdraw")return <WithdrawEarnings user={user} walletBalance={walletBalance} earningsBalance={earningsBalance} onClose={()=>setScreen(null)} onSuccess={(nw,ne)=>{setWalletBalance(nw);setEarningsBalance(ne);onBalanceUpdate&&onBalanceUpdate({wallet_balance:nw,earnings_balance:ne});setScreen(null);refreshAll();}} showToast={showToast}/>;

  return(
    <div style={{position:"fixed",inset:0,background:C.navy,zIndex:850,overflowY:"auto",maxWidth:480,margin:"0 auto",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{display:"flex",alignItems:"center",padding:"16px",borderBottom:"1px solid "+C.border,gap:12,position:"sticky",top:0,background:C.navy,zIndex:10}}>
        <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:C.white}}><I.Back/></button>
        <span style={{fontWeight:700,fontSize:17,color:C.white,flex:1}}>💼 Mon solde</span>
      </div>

      <div style={{padding:20}}>
        <div style={{background:"linear-gradient(135deg,"+C.accent+",#1e4d8c)",borderRadius:20,padding:22,marginBottom:16,textAlign:"center"}}>
          <div style={{color:"rgba(255,255,255,0.8)",fontSize:12,marginBottom:4}}>Solde du portefeuille</div>
          <div style={{color:"#fff",fontWeight:800,fontSize:32}}>{loading?"...":fmtUSD(walletBalance)}</div>
          <button onClick={()=>setScreen("recharge")} style={{marginTop:14,padding:"10px 22px",borderRadius:12,border:"1px solid rgba(255,255,255,0.4)",background:"rgba(255,255,255,0.15)",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer"}}>+ Recharger</button>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
          <div onClick={()=>setScreen("buyCoins")} style={{background:C.w5,borderRadius:16,padding:16,border:"1px solid "+C.border,cursor:"pointer"}}>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}><CoinIcon size={18}/><span style={{color:C.w3,fontSize:12}}>Blue Coins</span></div>
            <div style={{color:"#f0b90b",fontWeight:800,fontSize:19}}>{loading?"...":fmt(coinsBalance)}</div>
          </div>
          <div style={{background:C.w5,borderRadius:16,padding:16,border:"1px solid "+C.border}}>
            <div style={{color:C.w3,fontSize:12,marginBottom:6}}>🎁 Cadeaux reçus</div>
            <div style={{color:"#f0b90b",fontWeight:800,fontSize:19}}>{loading?"...":fmt(giftCoinsBalance)}</div>
          </div>
        </div>

        {giftCoinsBalance>0&&(
          <button onClick={()=>setScreen("convertGift")} style={{width:"100%",padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:600,fontSize:13,cursor:"pointer",marginBottom:10}}>Convertir tes cadeaux reçus en gains</button>
        )}
        {coinsBalance>0&&(
          <button onClick={()=>setScreen("convertCoins")} style={{width:"100%",padding:"13px",borderRadius:12,border:"1px solid "+C.border,background:C.w5,color:C.white,fontWeight:600,fontSize:13,cursor:"pointer",marginBottom:16}}>Reconvertir tes Blue Coins en solde</button>
        )}

        <div style={{background:"rgba(46,204,113,0.1)",borderRadius:16,padding:18,marginBottom:20,border:"1px solid rgba(46,204,113,0.3)"}}>
          <div style={{color:C.w3,fontSize:12,marginBottom:4}}>Gains disponibles pour retrait</div>
          <div style={{color:"#2ecc71",fontWeight:800,fontSize:24,marginBottom:12}}>{loading?"...":fmtUSD(earningsBalance)}</div>
          <button onClick={()=>setScreen("withdraw")} disabled={earningsBalance<=0&&walletBalance<=0} style={{width:"100%",padding:"13px",borderRadius:12,border:"none",background:(earningsBalance<=0&&walletBalance<=0)?"rgba(10,10,10,0.15)":"linear-gradient(135deg,#2ecc71,#25a35a)",color:"#fff",fontWeight:700,fontSize:14,cursor:(earningsBalance<=0&&walletBalance<=0)?"not-allowed":"pointer"}}>💸 Retirer</button>
        </div>

        <div style={{color:C.w3,fontSize:12,fontWeight:700,textTransform:"uppercase",marginBottom:10}}>Historique</div>
        {transactions.length===0?(
          <div style={{textAlign:"center",color:C.w3,padding:20,fontSize:13}}>Aucune transaction pour l'instant</div>
        ):(
          transactions.map((tx,i)=>(
            <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:"1px solid "+C.border}}>
              <div>
                <div style={{color:C.white,fontSize:13,fontWeight:600}}>{tx.description||txLabel(tx.type)}</div>
                <div style={{color:C.w3,fontSize:11,marginTop:2}}>{ago(tx.created_at)}</div>
              </div>
              <div style={{textAlign:"right"}}>
                {tx.amount_xaf!==undefined&&tx.amount_xaf!==null&&tx.amount_xaf!==0&&(
                  <div style={{color:tx.amount_xaf>0?"#2ecc71":"#f87171",fontWeight:700,fontSize:13}}>{tx.amount_xaf>0?"+":""}{fmtUSD(Math.abs(tx.amount_xaf))}</div>
                )}
                {tx.amount_coins!==undefined&&tx.amount_coins!==null&&tx.amount_coins!==0&&(
                  <div style={{color:"#f0b90b",fontSize:11,display:"flex",alignItems:"center",gap:3,justifyContent:"flex-end"}}>{tx.amount_coins>0?"+":""}{fmt(Math.abs(tx.amount_coins))} <CoinIcon size={11}/></div>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {screen==="convertGift"&&<ConvertGiftCoins user={user} giftCoinsBalance={giftCoinsBalance} onClose={()=>setScreen(null)} onSuccess={(earningsAdded)=>{const ne=earningsBalance+earningsAdded;setEarningsBalance(ne);setGiftCoinsBalance(0);onBalanceUpdate&&onBalanceUpdate({earnings_balance:ne,gift_coins_balance:0});refreshAll();}} showToast={showToast}/>}
      {screen==="convertCoins"&&<ConvertPurchasedCoins user={user} coinsBalance={coinsBalance} onClose={()=>setScreen(null)} onSuccess={(walletAdded)=>{const nw=walletBalance+walletAdded;setWalletBalance(nw);setCoinsBalance(0);onBalanceUpdate&&onBalanceUpdate({wallet_balance:nw,coins_balance:0});refreshAll();}} showToast={showToast}/>}
    </div>
  );
}
